/**
 * @license AngularJS v1.5.7
 * (c) 2010-2016 Google, Inc. http://angularjs.org
 * License: MIT
 */
PaypalDepositController.$inject = ['$routeParams', '$document', '$window', '$q', '$timeout', 'Utilities', 'NotificationService', 'paypalService', 'UserActionEventsService', 'ConfigurationFac', 'ApiDepositsGTMFac', '$scope', '$rootScope', '$log', 'DepositSrv'];
ApplePayDepositController.$inject = ['$routeParams', '$document', '$window', '$q', '$timeout', 'NotificationService', 'applepayService', 'ApiDepositsGTMFac', 'ApplePayFac', '$scope', '$rootScope'];
(function(window, angular) {'use strict';

/* jshint ignore:start */
// this code is in the core, but not in angular-messages.js
var isArray = angular.isArray;
var forEach = angular.forEach;
var isString = angular.isString;
var jqLite = angular.element;
/* jshint ignore:end */

/**
 * @ngdoc module
 * @name ngMessages
 * @description
 *
 * The `ngMessages` module provides enhanced support for displaying messages within templates
 * (typically within forms or when rendering message objects that return key/value data).
 * Instead of relying on JavaScript code and/or complex ng-if statements within your form template to
 * show and hide error messages specific to the state of an input field, the `ngMessages` and
 * `ngMessage` directives are designed to handle the complexity, inheritance and priority
 * sequencing based on the order of how the messages are defined in the template.
 *
 * Currently, the ngMessages module only contains the code for the `ngMessages`, `ngMessagesInclude`
 * `ngMessage` and `ngMessageExp` directives.
 *
 * # Usage
 * The `ngMessages` directive allows keys in a key/value collection to be associated with a child element
 * (or 'message') that will show or hide based on the truthiness of that key's value in the collection. A common use
 * case for `ngMessages` is to display error messages for inputs using the `$error` object exposed by the
 * {@link ngModel ngModel} directive.
 *
 * The child elements of the `ngMessages` directive are matched to the collection keys by a `ngMessage` or
 * `ngMessageExp` directive. The value of these attributes must match a key in the collection that is provided by
 * the `ngMessages` directive.
 *
 * Consider the following example, which illustrates a typical use case of `ngMessages`. Within the form `myForm` we
 * have a text input named `myField` which is bound to the scope variable `field` using the {@link ngModel ngModel}
 * directive.
 *
 * The `myField` field is a required input of type `email` with a maximum length of 15 characters.
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Enter text:
 *     <input type="email" ng-model="field" name="myField" required maxlength="15" />
 *   </label>
 *   <div ng-messages="myForm.myField.$error" role="alert">
 *     <div ng-message="required">Please enter a value for this field.</div>
 *     <div ng-message="email">This field must be a valid email address.</div>
 *     <div ng-message="maxlength">This field can be at most 15 characters long.</div>
 *   </div>
 * </form>
 * ```
 *
 * In order to show error messages corresponding to `myField` we first create an element with an `ngMessages` attribute
 * set to the `$error` object owned by the `myField` input in our `myForm` form.
 *
 * Within this element we then create separate elements for each of the possible errors that `myField` could have.
 * The `ngMessage` attribute is used to declare which element(s) will appear for which error - for example,
 * setting `ng-message="required"` specifies that this particular element should be displayed when there
 * is no value present for the required field `myField` (because the key `required` will be `true` in the object
 * `myForm.myField.$error`).
 *
 * ### Message order
 *
 * By default, `ngMessages` will only display one message for a particular key/value collection at any time. If more
 * than one message (or error) key is currently true, then which message is shown is determined by the order of messages
 * in the HTML template code (messages declared first are prioritised). This mechanism means the developer does not have
 * to prioritise messages using custom JavaScript code.
 *
 * Given the following error object for our example (which informs us that the field `myField` currently has both the
 * `required` and `email` errors):
 *
 * ```javascript
 * <!-- keep in mind that ngModel automatically sets these error flags -->
 * myField.$error = { required : true, email: true, maxlength: false };
 * ```
 * The `required` message will be displayed to the user since it appears before the `email` message in the DOM.
 * Once the user types a single character, the `required` message will disappear (since the field now has a value)
 * but the `email` message will be visible because it is still applicable.
 *
 * ### Displaying multiple messages at the same time
 *
 * While `ngMessages` will by default only display one error element at a time, the `ng-messages-multiple` attribute can
 * be applied to the `ngMessages` container element to cause it to display all applicable error messages at once:
 *
 * ```html
 * <!-- attribute-style usage -->
 * <div ng-messages="myForm.myField.$error" ng-messages-multiple>...</div>
 *
 * <!-- element-style usage -->
 * <ng-messages for="myForm.myField.$error" multiple>...</ng-messages>
 * ```
 *
 * ## Reusing and Overriding Messages
 * In addition to prioritization, ngMessages also allows for including messages from a remote or an inline
 * template. This allows for generic collection of messages to be reused across multiple parts of an
 * application.
 *
 * ```html
 * <script type="text/ng-template" id="error-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <div ng-messages="myForm.myField.$error" role="alert">
 *   <div ng-messages-include="error-messages"></div>
 * </div>
 * ```
 *
 * However, including generic messages may not be useful enough to match all input fields, therefore,
 * `ngMessages` provides the ability to override messages defined in the remote template by redefining
 * them within the directive container.
 *
 * ```html
 * <!-- a generic template of error messages known as "my-custom-messages" -->
 * <script type="text/ng-template" id="my-custom-messages">
 *   <div ng-message="required">This field is required</div>
 *   <div ng-message="minlength">This field is too short</div>
 * </script>
 *
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            id="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <!-- any ng-message elements that appear BEFORE the ng-messages-include will
 *        override the messages present in the ng-messages-include template -->
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <!-- this required message has overridden the template message -->
 *     <div ng-message="required">You did not enter your email address</div>
 *
 *     <!-- this is a brand new message and will appear last in the prioritization -->
 *     <div ng-message="email">Your email address is invalid</div>
 *
 *     <!-- and here are the generic error messages -->
 *     <div ng-messages-include="my-custom-messages"></div>
 *   </div>
 * </form>
 * ```
 *
 * In the example HTML code above the message that is set on required will override the corresponding
 * required message defined within the remote template. Therefore, with particular input fields (such
 * email addresses, date fields, autocomplete inputs, etc...), specialized error messages can be applied
 * while more generic messages can be used to handle other, more general input errors.
 *
 * ## Dynamic Messaging
 * ngMessages also supports using expressions to dynamically change key values. Using arrays and
 * repeaters to list messages is also supported. This means that the code below will be able to
 * fully adapt itself and display the appropriate message when any of the expression data changes:
 *
 * ```html
 * <form name="myForm">
 *   <label>
 *     Email address
 *     <input type="email"
 *            name="myEmail"
 *            ng-model="email"
 *            minlength="5"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message="required">You did not enter your email address</div>
 *     <div ng-repeat="errorMessage in errorMessages">
 *       <!-- use ng-message-exp for a message whose key is given by an expression -->
 *       <div ng-message-exp="errorMessage.type">{{ errorMessage.text }}</div>
 *     </div>
 *   </div>
 * </form>
 * ```
 *
 * The `errorMessage.type` expression can be a string value or it can be an array so
 * that multiple errors can be associated with a single error message:
 *
 * ```html
 *   <label>
 *     Email address
 *     <input type="email"
 *            ng-model="data.email"
 *            name="myEmail"
 *            ng-minlength="5"
 *            ng-maxlength="100"
 *            required />
 *   </label>
 *   <div ng-messages="myForm.myEmail.$error" role="alert">
 *     <div ng-message-exp="'required'">You did not enter your email address</div>
 *     <div ng-message-exp="['minlength', 'maxlength']">
 *       Your email must be between 5 and 100 characters long
 *     </div>
 *   </div>
 * ```
 *
 * Feel free to use other structural directives such as ng-if and ng-switch to further control
 * what messages are active and when. Be careful, if you place ng-message on the same element
 * as these structural directives, Angular may not be able to determine if a message is active
 * or not. Therefore it is best to place the ng-message on a child element of the structural
 * directive.
 *
 * ```html
 * <div ng-messages="myForm.myEmail.$error" role="alert">
 *   <div ng-if="showRequiredError">
 *     <div ng-message="required">Please enter something</div>
 *   </div>
 * </div>
 * ```
 *
 * ## Animations
 * If the `ngAnimate` module is active within the application then the `ngMessages`, `ngMessage` and
 * `ngMessageExp` directives will trigger animations whenever any messages are added and removed from
 * the DOM by the `ngMessages` directive.
 *
 * Whenever the `ngMessages` directive contains one or more visible messages then the `.ng-active` CSS
 * class will be added to the element. The `.ng-inactive` CSS class will be applied when there are no
 * messages present. Therefore, CSS transitions and keyframes as well as JavaScript animations can
 * hook into the animations whenever these classes are added/removed.
 *
 * Let's say that our HTML code for our messages container looks like so:
 *
 * ```html
 * <div ng-messages="myMessages" class="my-messages" role="alert">
 *   <div ng-message="alert" class="some-message">...</div>
 *   <div ng-message="fail" class="some-message">...</div>
 * </div>
 * ```
 *
 * Then the CSS animation code for the message container looks like so:
 *
 * ```css
 * .my-messages {
 *   transition:1s linear all;
 * }
 * .my-messages.ng-active {
 *   // messages are visible
 * }
 * .my-messages.ng-inactive {
 *   // messages are hidden
 * }
 * ```
 *
 * Whenever an inner message is attached (becomes visible) or removed (becomes hidden) then the enter
 * and leave animation is triggered for each particular element bound to the `ngMessage` directive.
 *
 * Therefore, the CSS code for the inner messages looks like so:
 *
 * ```css
 * .some-message {
 *   transition:1s linear all;
 * }
 *
 * .some-message.ng-enter {}
 * .some-message.ng-enter.ng-enter-active {}
 *
 * .some-message.ng-leave {}
 * .some-message.ng-leave.ng-leave-active {}
 * ```
 *
 * {@link ngAnimate Click here} to learn how to use JavaScript animations or to learn more about ngAnimate.
 */
angular.module('ngMessages', [])

  /**
   * @ngdoc directive
   * @module ngMessages
   * @name ngMessages
   * @restrict AE
   *
   * @description
   * `ngMessages` is a directive that is designed to show and hide messages based on the state
   * of a key/value object that it listens on. The directive itself complements error message
   * reporting with the `ngModel` $error object (which stores a key/value state of validation errors).
   *
   * `ngMessages` manages the state of internal messages within its container element. The internal
   * messages use the `ngMessage` directive and will be inserted/removed from the page depending
   * on if they're present within the key/value object. By default, only one message will be displayed
   * at a time and this depends on the prioritization of the messages within the template. (This can
   * be changed by using the `ng-messages-multiple` or `multiple` attribute on the directive container.)
   *
   * A remote template can also be used to promote message reusability and messages can also be
   * overridden.
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {string} ngMessages an angular expression evaluating to a key/value object
   *                 (this is typically the $error object on an ngModel instance).
   * @param {string=} ngMessagesMultiple|multiple when set, all messages will be displayed with true
   *
   * @example
   * <example name="ngMessages-directive" module="ngMessagesExample"
   *          deps="angular-messages.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <form name="myForm">
   *       <label>
   *         Enter your name:
   *         <input type="text"
   *                name="myName"
   *                ng-model="name"
   *                ng-minlength="5"
   *                ng-maxlength="20"
   *                required />
   *       </label>
   *       <pre>myForm.myName.$error = {{ myForm.myName.$error | json }}</pre>
   *
   *       <div ng-messages="myForm.myName.$error" style="color:maroon" role="alert">
   *         <div ng-message="required">You did not enter a field</div>
   *         <div ng-message="minlength">Your field is too short</div>
   *         <div ng-message="maxlength">Your field is too long</div>
   *       </div>
   *     </form>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngMessagesExample', ['ngMessages']);
   *   </file>
   * </example>
   */
  .directive('ngMessages', ['$animate', function($animate) {
    var ACTIVE_CLASS = 'ng-active';
    var INACTIVE_CLASS = 'ng-inactive';

    return {
      require: 'ngMessages',
      restrict: 'AE',
      controller: ['$element', '$scope', '$attrs', function($element, $scope, $attrs) {
        var ctrl = this;
        var latestKey = 0;
        var nextAttachId = 0;

        this.getAttachId = function getAttachId() { return nextAttachId++; };

        var messages = this.messages = {};
        var renderLater, cachedCollection;

        this.render = function(collection) {
          collection = collection || {};

          renderLater = false;
          cachedCollection = collection;

          // this is true if the attribute is empty or if the attribute value is truthy
          var multiple = isAttrTruthy($scope, $attrs.ngMessagesMultiple) ||
                         isAttrTruthy($scope, $attrs.multiple);

          var unmatchedMessages = [];
          var matchedKeys = {};
          var messageItem = ctrl.head;
          var messageFound = false;
          var totalMessages = 0;

          // we use != instead of !== to allow for both undefined and null values
          while (messageItem != null) {
            totalMessages++;
            var messageCtrl = messageItem.message;

            var messageUsed = false;
            if (!messageFound) {
              forEach(collection, function(value, key) {
                if (!messageUsed && truthy(value) && messageCtrl.test(key)) {
                  // this is to prevent the same error name from showing up twice
                  if (matchedKeys[key]) return;
                  matchedKeys[key] = true;

                  messageUsed = true;
                  messageCtrl.attach();
                }
              });
            }

            if (messageUsed) {
              // unless we want to display multiple messages then we should
              // set a flag here to avoid displaying the next message in the list
              messageFound = !multiple;
            } else {
              unmatchedMessages.push(messageCtrl);
            }

            messageItem = messageItem.next;
          }

          forEach(unmatchedMessages, function(messageCtrl) {
            messageCtrl.detach();
          });

          unmatchedMessages.length !== totalMessages
              ? $animate.setClass($element, ACTIVE_CLASS, INACTIVE_CLASS)
              : $animate.setClass($element, INACTIVE_CLASS, ACTIVE_CLASS);
        };

        $scope.$watchCollection($attrs.ngMessages || $attrs['for'], ctrl.render);

        // If the element is destroyed, proactively destroy all the currently visible messages
        $element.on('$destroy', function() {
          forEach(messages, function(item) {
            item.message.detach();
          });
        });

        this.reRender = function() {
          if (!renderLater) {
            renderLater = true;
            $scope.$evalAsync(function() {
              if (renderLater) {
                cachedCollection && ctrl.render(cachedCollection);
              }
            });
          }
        };

        this.register = function(comment, messageCtrl) {
          var nextKey = latestKey.toString();
          messages[nextKey] = {
            message: messageCtrl
          };
          insertMessageNode($element[0], comment, nextKey);
          comment.$$ngMessageNode = nextKey;
          latestKey++;

          ctrl.reRender();
        };

        this.deregister = function(comment) {
          var key = comment.$$ngMessageNode;
          delete comment.$$ngMessageNode;
          removeMessageNode($element[0], comment, key);
          delete messages[key];
          ctrl.reRender();
        };

        function findPreviousMessage(parent, comment) {
          var prevNode = comment;
          var parentLookup = [];

          while (prevNode && prevNode !== parent) {
            var prevKey = prevNode.$$ngMessageNode;
            if (prevKey && prevKey.length) {
              return messages[prevKey];
            }

            // dive deeper into the DOM and examine its children for any ngMessage
            // comments that may be in an element that appears deeper in the list
            if (prevNode.childNodes.length && parentLookup.indexOf(prevNode) === -1) {
              parentLookup.push(prevNode);
              prevNode = prevNode.childNodes[prevNode.childNodes.length - 1];
            } else if (prevNode.previousSibling) {
              prevNode = prevNode.previousSibling;
            } else {
              prevNode = prevNode.parentNode;
              parentLookup.push(prevNode);
            }
          }
        }

        function insertMessageNode(parent, comment, key) {
          var messageNode = messages[key];
          if (!ctrl.head) {
            ctrl.head = messageNode;
          } else {
            var match = findPreviousMessage(parent, comment);
            if (match) {
              messageNode.next = match.next;
              match.next = messageNode;
            } else {
              messageNode.next = ctrl.head;
              ctrl.head = messageNode;
            }
          }
        }

        function removeMessageNode(parent, comment, key) {
          var messageNode = messages[key];

          var match = findPreviousMessage(parent, comment);
          if (match) {
            match.next = messageNode.next;
          } else {
            ctrl.head = messageNode.next;
          }
        }
      }]
    };

    function isAttrTruthy(scope, attr) {
     return (isString(attr) && attr.length === 0) || //empty attribute
            truthy(scope.$eval(attr));
    }

    function truthy(val) {
      return isString(val) ? val.length : !!val;
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessagesInclude
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessagesInclude` is a directive with the purpose to import existing ngMessage template
   * code from a remote template and place the downloaded template code into the exact spot
   * that the ngMessagesInclude directive is placed within the ngMessages container. This allows
   * for a series of pre-defined messages to be reused and also allows for the developer to
   * determine what messages are overridden due to the placement of the ngMessagesInclude directive.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-messages-include="remoteTplString">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-messages-include src="expressionValue1">...</ng-messages-include>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {string} ngMessagesInclude|src a string value corresponding to the remote template.
   */
  .directive('ngMessagesInclude',
    ['$templateRequest', '$document', '$compile', function($templateRequest, $document, $compile) {

    return {
      restrict: 'AE',
      require: '^^ngMessages', // we only require this for validation sake
      link: function($scope, element, attrs) {
        var src = attrs.ngMessagesInclude || attrs.src;
        $templateRequest(src).then(function(html) {
          if ($scope.$$destroyed) return;

          if (isString(html) && !html.trim()) {
            // Empty template - nothing to compile
            replaceElementWithMarker(element, src);
          } else {
            // Non-empty template - compile and link
            $compile(html)($scope, function(contents) {
              element.after(contents);
              replaceElementWithMarker(element, src);
            });
          }
        });
      }
    };

    // Helpers
    function replaceElementWithMarker(element, src) {
      // A comment marker is placed for debugging purposes
      var comment = $compile.$$createComment ?
          $compile.$$createComment('ngMessagesInclude', src) :
          $document[0].createComment(' ngMessagesInclude: ' + src + ' ');
      var marker = jqLite(comment);
      element.after(marker);

      // Don't pollute the DOM anymore by keeping an empty directive element
      element.remove();
    }
  }])

  /**
   * @ngdoc directive
   * @name ngMessage
   * @restrict AE
   * @scope
   *
   * @description
   * `ngMessage` is a directive with the purpose to show and hide a particular message.
   * For `ngMessage` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * More information about using `ngMessage` can be found in the
   * {@link module:ngMessages `ngMessages` module documentation}.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression" role="alert">
   *   <ANY ng-message="stringValue">...</ANY>
   *   <ANY ng-message="stringValue1, stringValue2, ...">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression" role="alert">
   *   <ng-message when="stringValue">...</ng-message>
   *   <ng-message when="stringValue1, stringValue2, ...">...</ng-message>
   * </ng-messages>
   * ```
   *
   * @param {expression} ngMessage|when a string value corresponding to the message key.
   */
  .directive('ngMessage', ngMessageDirectiveFactory())


  /**
   * @ngdoc directive
   * @name ngMessageExp
   * @restrict AE
   * @priority 1
   * @scope
   *
   * @description
   * `ngMessageExp` is a directive with the purpose to show and hide a particular message.
   * For `ngMessageExp` to operate, a parent `ngMessages` directive on a parent DOM element
   * must be situated since it determines which messages are visible based on the state
   * of the provided key/value map that `ngMessages` listens on.
   *
   * @usage
   * ```html
   * <!-- using attribute directives -->
   * <ANY ng-messages="expression">
   *   <ANY ng-message-exp="expressionValue">...</ANY>
   * </ANY>
   *
   * <!-- or by using element directives -->
   * <ng-messages for="expression">
   *   <ng-message when-exp="expressionValue">...</ng-message>
   * </ng-messages>
   * ```
   *
   * {@link module:ngMessages Click here} to learn more about `ngMessages` and `ngMessage`.
   *
   * @param {expression} ngMessageExp|whenExp an expression value corresponding to the message key.
   */
  .directive('ngMessageExp', ngMessageDirectiveFactory());

function ngMessageDirectiveFactory() {
  return ['$animate', function($animate) {
    return {
      restrict: 'AE',
      transclude: 'element',
      priority: 1, // must run before ngBind, otherwise the text is set on the comment
      terminal: true,
      require: '^^ngMessages',
      link: function(scope, element, attrs, ngMessagesCtrl, $transclude) {
        var commentNode = element[0];

        var records;
        var staticExp = attrs.ngMessage || attrs.when;
        var dynamicExp = attrs.ngMessageExp || attrs.whenExp;
        var assignRecords = function(items) {
          records = items
              ? (isArray(items)
                  ? items
                  : items.split(/[\s,]+/))
              : null;
          ngMessagesCtrl.reRender();
        };

        if (dynamicExp) {
          assignRecords(scope.$eval(dynamicExp));
          scope.$watchCollection(dynamicExp, assignRecords);
        } else {
          assignRecords(staticExp);
        }

        var currentElement, messageCtrl;
        ngMessagesCtrl.register(commentNode, messageCtrl = {
          test: function(name) {
            return contains(records, name);
          },
          attach: function() {
            if (!currentElement) {
              $transclude(function(elm, newScope) {
                $animate.enter(elm, null, element);
                currentElement = elm;

                // Each time we attach this node to a message we get a new id that we can match
                // when we are destroying the node later.
                var $$attachId = currentElement.$$attachId = ngMessagesCtrl.getAttachId();

                // in the event that the element or a parent element is destroyed
                // by another structural directive then it's time
                // to deregister the message from the controller
                currentElement.on('$destroy', function() {
                  if (currentElement && currentElement.$$attachId === $$attachId) {
                    ngMessagesCtrl.deregister(commentNode);
                    messageCtrl.detach();
                  }
                  newScope.$destroy();
                });
              });
            }
          },
          detach: function() {
            if (currentElement) {
              var elm = currentElement;
              currentElement = null;
              $animate.leave(elm);
            }
          }
        });
      }
    };
  }];

  function contains(collection, key) {
    if (collection) {
      return isArray(collection)
          ? collection.indexOf(key) >= 0
          : collection.hasOwnProperty(key);
    }
  }
}


})(window, window.angular);

angular.module('TVG.Paypal.Common', ['ngMessages', 'TVG.DMA.Common', 'TVG.Configuration']);

angular.module('TVG.Paypal.Deposits', [
  'TVG.Paypal.Common',
  'UserActionEvents'
]);

angular.module('TVG.Paypal.Withdrawals', ['TVG.Paypal.Common']);

/*
 * The Official Acronym is 'PAY'
 * Min Deposit is:
 * Max Deposit is:
 * There are fees, these are provided by the backend
 * On the CMS the tabs are defined in:
   * deposit Config Available Options
   * DepositWidthrawAvailableOptions
 * All CSS should be placed in the closest position from its direction
 * It should follow the component structure where files are coupled according to features.
 */


/**
 * Screens
 *
 *  - Input Amount
 *  - Paypal Login + Paypal Confirmation
 *  - Confirmation and Pay
 *  - Input Amount (with feedback)
 *
 */
angular.module('TVG.Paypal', [
  'TVG.Paypal.Common',
  'TVG.Paypal.Deposits',
  'TVG.Paypal.Withdrawals'
]);

/* eslint angular/no-service-method: 0 */
(function () {
  'use strict';
  PaypalService.$inject = ['ConfigurationFac', 'Utilities', '$q', '$http', '$filter', '$location', '$log', 'DepositPath', '$window', '$rootScope'];
  function PaypalService(
    ConfigurationFac,
    Utilities,
    $q,
    $http,
    $filter,
    $location,
    $log,
    DepositPath,
    $window,
    $rootScope
  ) {
    var self = this;

    /* endpoint
     * Give the endpoint resources, build the final URI.
     * @param {string} ...resources One or more resources
     * @return {string} URI
     */
    var endpoint = function (base, service, version) {
      version = version || 'v1';
      return function (/* resources */) {
        var separator = '/';
        var resources = [].slice.call(arguments, 0);
        return [base, service, version].concat(resources).join(separator);
      };
    };

    var paypalEndpoint = endpoint(ConfigurationFac.getBaseServiceUrl(), 'pay');
    var walletEndpoint = endpoint(ConfigurationFac.getBaseServiceUrl(), 'uwt');

    var checkError = function (response) {
      return $q(function (resolve, reject) {
        return reject(self.createApiError([{
          message: _.get(response, 'data.message'),
          code: response.status,
          data: response.data
        }]));
      });
    };

    /**
     * Create an API error instance
     * Try to fetch an error message from the CMS (using the error code)
     * If none is found, use the error.message as a fallback
     *
     * @param  {Array} errors [description]
     * @return {Error}     [description]
     */
    self.createApiError = function (data) {
      var apiError = new Error();
      var error = data[0] || {};
      var paypalError = self.getFromCMS(error.code);

      apiError.message = paypalError || error.message;
      apiError.code = error.code;
      apiError.data = error.data || {};
      return apiError;
    };

    /**
     * request
     * @param  {Object} data
     * @param  {string} data.url
     * @param  {string} data.method
     * @param  {Object} data.data
     *
     * @return {Promise}
     */
    self.request = function (params) {
      var defaults = {
        headers: self.addHeaders(),
        method: 'POST'
      };

      return $http(_.extend({}, defaults, params))
        .catch(function (err) {
          return checkError(err);
        })
        .then(function (response) {
          response.data = _.assign({}, response.data, { statusCode: response.status });
          return response;
        })
        .then(Utilities.prop('data'));
    };

    self.createDepositRequest = function (depositInfo) {
      return new DepositRequest(depositInfo);
    };

    self.getAccountInfo = function (accountNumber) {
      var path = 'users/' + accountNumber + '/account-info';

      return self.request({
        url: paypalEndpoint(path),
        method: 'GET'
      });
    };

    /**
     * Retrieve an authorization token for the given payment
     * @return {String} Authorization token
     */
    self.getToken = function (depositInfo, accountNumber) {
      var path = 'users/' + accountNumber + '/token';

      return self.request({
        url: paypalEndpoint(path),
        data: self.createDepositRequest(depositInfo)
      })
      .then(Utilities.prop('token'));
    };

    /**
     * Add the headers needed to perform API calls
     *
     * @return {object}: Header Object
     */
    self.addHeaders = function (options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext())
      };

      if (Utilities.prop('cache', options)) {
        headers = _.extend({}, {
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }, headers);
      }
      return headers;
    };

    /**
     * Get labels from CMS
     * @param  {[string]} name [label Name]
     * @return {[string]}      [label]
     */
    self.getFromCMS = function (name) {
      return $filter('CMSLabels')(name, 'paypalLabels');
    };

    self.getMessage = function (key, namespace) {
      return $filter('CMSLabels')(key, namespace);
    };

    self.getBaseUrl = function (replaceState) {
      var product = ConfigurationFac.getApplicationContextItem('product');
      var location = ConfigurationFac.getApplicationContextItem('location');
      var callback = $location.search().callback && decodeURIComponent($location.search().callback);
      var path = (!replaceState && !$rootScope.fullPage && DepositPath[product])
        || $window.location.pathname;

      var qs = {
        njx: '?location=nj&product=njx',
        ios: '?product=ios&location=' + location,
        ios2: '?product=ios2&location=' + location + '&callback=' + callback,
        touch3:
          '?product=touch3&location=' + location + '&callback=' + callback,
        fdrmobile:
          '?product=fdrmobile&location=' + location + '&callback=' + callback,
        fdrios:
          '?product=fdrios&location=' + location + '&callback=' + callback,
        fdrandroid:
          '?product=fdrandroid&location=' + location + '&callback=' + callback,
        iosnative:
          '?product=iosnative&location=' + location + '&callback=' + callback,
        androidnative:
          '?product=androidnative&location=' + location + '&callback=' + callback,
        androidwrapper:
          '?product=androidwrapper&location=' + location + '&callback=' + callback,
        tvgandroid:
          '?product=tvgandroid&location=' + location + '&callback=' + callback
      };

      var finalUrl;

      if ($rootScope.fullPage && path.indexOf('/registration') > -1) {
        path = path.replace('/registration', '/deposit/deposit');
      }

      finalUrl = Utilities.supplant('{protocol}://{host}{port}{path}', {
        protocol: $location.protocol(),
        host: !replaceState && callback ? callback.split('/')[0] : $location.host(),
        port: !replaceState && callback ? '' : ':' + $location.port(),
        path: (replaceState && _.has(qs, product)) ? path.concat(qs[product]) : path
      });

      $log.info(finalUrl);

      return finalUrl;
    };

    function DepositRequest(depositInfo) {
      var originTab = depositInfo.originTab || 'Deposit';
      var callback = $location.search().callback && encodeURIComponent($location.search().callback);
      var deviceQuery = $location.search().device && '&device=' + $location.search().device;
      var tab = Utilities.returnToTab('paypal+' + originTab, $rootScope.fullPage ?
        '&wrapper=true&fullPage=true' + deviceQuery + '&userCancelled=true&callback='
        + callback : '&userCancelled=true');
      var payConfirm = Utilities.returnToTab('paypal+' + originTab, $rootScope.fullPage ?
        '&wrapper=true&fullPage=true' + deviceQuery + '&isPaymentConfirmation=true&callback='
        + callback : '&isPaymentConfirmation=true');

      this.returnUrl = depositInfo.returnUrl.concat(payConfirm);
      this.cancelUrl = depositInfo.cancelUrl.concat(tab);
      this.orderAmount = depositInfo.orderAmount;
    }

    /**
     * Get all pending deposits
     * @return {[promise]}
     */
    self.getPendingDeposits = function () {
      return self.request({
        url: paypalEndpoint('deposit/list'),
        method: 'GET'
      })
      .then(Utilities.prop('deposits'));
    };

    /**
     * Deposit money from Paypal to TVG
     *
     * @return {[type]}      [description]
     */
    self.deposit = function (data, accountNumber) {
      var path = 'users/' + accountNumber + '/deposits/' + data.token;

      var requestData = { url: paypalEndpoint(path) };

      return self.request(requestData)
        .then(function (deposit) {
          return deposit;
        });
    };

    self.getDepositStatus = function (accountNumber, depositUUID) {
      return self.request({
        url: walletEndpoint('users/' + accountNumber + '/deposits/' + depositUUID + '/status'),
        method: 'GET'
      });
    };

    /**
     * Withdraw money from TVG to Paypal
     *
     * @return {Promise}      [description]
     */
    self.withdraw = function (amount, accountNumber) {
      var postData = {
        amount: amount
      };

      return self.request({
        url: paypalEndpoint('users/' + accountNumber + '/withdrawals'),
        method: 'POST',
        data: postData
      });
    };

    /**
     * getPaymentDetails
     * @param  {String} token
     * @return {Promise<PaymentDetails, Error>}
     */
    self.getPaymentDetails = function (token) {
      return self.request({
        url: paypalEndpoint('expressCheckout', token),
        method: 'GET'
      })
      .then(function (details) {
        var responseDetails = details.getExpressCheckoutDetailsResponseDetails;
        var orderTotal = responseDetails.paymentDetails[0].orderTotal.value;
        var amount = parseFloat(orderTotal);
        var fee = responseDetails.custom || '';
        var email = responseDetails.payerInfo.payer;
        self.LastFee = parseFloat(Utilities.parseQueryString(fee).fee);
        return {
          email: email,
          fee: self.LastFee,
          token: token,
          orderAmount: (amount - self.LastFee),
          invoiceId: responseDetails.invoiceID
        };
      });
    };

    self.getDepositFee = function (amount, accountNumber) {
      var path = 'users/' + accountNumber + '/deposits/fee?amount=' + amount;

      var requestOptions = {
        url: paypalEndpoint(path),
        method: 'GET'
      };

      return self.request(requestOptions);
    };
  }

  angular
    .module('TVG.Paypal.Common')
    .service('paypalService', PaypalService);
}());

angular
  .module('TVG.Paypal.Deposits')
  .component('depositButton', {
    controller: 'depositButtonController',
    bindings: {
      onPaypalDeposit: '&',
      isDisabled: '<'
    },
    templateUrl: 'src/paypal/deposits/deposit-button/deposit-button.template.html'
  });

/* eslint angular/controller-as-vm: 0 */
(function () {
  'use strict';

  function DepositButtonController() {
    var self = this;

    self.onDeposit = function ($event) {
      self.onPaypalDeposit({ $event: $event });
    };
  }

  angular
    .module('TVG.Paypal.Deposits')
    .controller('depositButtonController', DepositButtonController);
}());

angular
  .module('TVG.Paypal.Deposits')
  .component('paypalDeposit', {
    templateUrl: 'src/paypal/deposits/deposit.template.html',
    controller: 'paypalDepositController',
    bindings: {
      minAmount: '<',
      maxAmount: '<',
      amountOptions: '<',
      depositAmount: '<',
      isPaymentConfirmation: '<',
      userCancelled: '<',
      onAmountChange: '&',
      onPaymentComplete: '&'
    }
  });

/* eslint angular/controller-as-vm: "off" */

/**
 * This controllers' use case is mostly to know when to load
 * each screen and which properties it should pass to each component
 */
function PaypalDepositController(
  $routeParams,
  $document,
  $window,
  $q,
  $timeout,
  Utilities,
  NotificationService,
  paypalService,
  UserActionEventsService,
  ConfigurationFac,
  ApiDepositsGTMFac,
  $scope,
  $rootScope,
  $log,
  DepositSrv
) {
  var SUCCESS_MODAL_LABELS = {
    title: 'Successful Deposit!',
    textTemplate: 'Your $@@@deposit_amount@@@ are now available!',
    buttonText: 'Let\'s bet!'
  };


  var successModalOnOpenCallback = function () {
    ApiDepositsGTMFac.sendGTMEvent('siteClick', {
      event: 'siteClick',
      gaEventCategory: 'Site click',
      gaEventAction: 'seen',
      gaEventLabel: undefined,
      module: 'deposit success modal',
      tag: undefined,
      microApp: undefined
    });
  };

  var successModalButtonCallback = function () {
    ApiDepositsGTMFac.sendGTMEvent('navigation', {
      event: 'navigation',
      gaEventCategory: 'Navigation',
      gaEventAction: 'Navigated To',
      gaEventLabel: SUCCESS_MODAL_LABELS.buttonText,
      module: 'deposit success modal',
      tag: undefined,
      menu: undefined,
      sport: 'Horse Racing',
      destinationUrl: 'https://www.tvg.com/'
    });

    if ($window && $window.handleNativeMessages) {
      $window.handleNativeMessages('CLOSE_DMA');
    }
  };


  var successModalCloseCallback = function () {
    ApiDepositsGTMFac.sendGTMEvent('siteClick', {
      event: 'siteClick',
      gaEventCategory: 'Site click',
      gaEventAction: 'close',
      gaEventLabel: undefined,
      module: 'deposit success modal',
      tag: undefined,
      microApp: undefined
    });
  };

  var self = this;

  self.loading = true;
  self.fees = { loading: false, isFeePaid: $window.localStorage.getItem('isFeePaid') === 'true' };
  self.accountNumber = _.get($scope, '$parent.accountDetails.accountDetails.accountNumber', '') ||
    ($rootScope.user && $rootScope.user.accountNumber);
  self.feeRequestFailed = false;

  self.$onInit = function () {
    var token = $routeParams.token;
    var messageStatusMap = {
      200: {
        type: 'success',
        namespace: 'payDepositMessages',
        key: 'scenario5'
      },
      202: {
        type: 'warning',
        namespace: 'payDepositMessages',
        key: 'scenario3b'
      },
      207: {
        type: 'warning',
        namespace: 'payDepositMessages',
        key: 'scenario3a'
      }
    };

    var getMessageForStatus = function (statusCode) {
      return messageStatusMap[statusCode] || {
        type: 'error',
        key: 'scenario1',
        namespace: 'payDepositMessages'
      };
    };

    if (self.isPaymentConfirmation) {
      UserActionEventsService.emit('paypalSubmitDeposit');

      return paypalService.deposit({ token: token }, self.accountNumber)
        .then(function (response) {
          var messageForCode = getMessageForStatus(response.statusCode);
          var fromOption = _.get($scope, '$parent.fromOption.tla', '');

          if ($rootScope.activeFeatures.isDMAInjectDepositSuccessModalEnabled) {
            if ($window.ReactInjector) {
              $window.ReactInjector.renderDepositSuccess(
                    document.getElementById('injected-modal'),// eslint-disable-line
                {
                  title: SUCCESS_MODAL_LABELS.title,
                  text: SUCCESS_MODAL_LABELS.textTemplate.replace(
                    '@@@deposit_amount@@@',
                    response && response.amount),
                  buttonText: SUCCESS_MODAL_LABELS.buttonText,
                  sharedState: { isOpen: true },
                  buttonCallback: successModalButtonCallback,
                  closeCallback: successModalCloseCallback,
                  onOpenCallback: successModalOnOpenCallback
                }
              );
            }
          }

          UserActionEventsService.emit('depositSuccessPayPal', {
            amount: undefined,
            fee: undefined,
            defaultAmount: undefined,
            isFeePaid: self.fees.isFeePaid
          });

          switch (response.statusCode) {
            case 202:
              NotificationService[messageForCode.type](
                null,
                paypalService.getMessage(
                  messageForCode.key,
                  messageForCode.namespace
                )
              );

              // deposit in progress, start back off request on deposit status
              Utilities.backOff(function (next, stop) {
                paypalService
                  .getDepositStatus(self.accountNumber, response.transactionUUID)
                  .then(function (res) {
                    if (res.status === 'FINISH_DEPOSIT_SUCCESS' ||
                      $window.FINISH_DEPOSIT_SUCCESS) {
                      // deposit is finished, show success message
                      stop(messageStatusMap[200]);
                    } else if (res.status === 'FINISH_DEPOSIT_ERROR' ||
                      $window.FINISH_DEPOSIT_ERROR) {
                      // deposit error, show warning message
                      stop(messageStatusMap[207]);
                    } else {
                      // continue to try
                      next();
                    }
                  });
              }, 10000)
                .then(function (msg) {
                  // the backOff ended, show the message
                  NotificationService[msg.type](
                    null,
                    paypalService.getMessage(msg.key, msg.namespace)
                  );
                })
                .catch(function () {
                  //eslint-disable-next-line
                  console.log($scope,$rootScope, self);
                  // timeout on the backOff, show error
                  NotificationService.warning(
                    null,
                    paypalService.getMessage('scenario3c', 'payDepositMessages')
                  );
                })
                .finally(function () {
                  delete $window.FINISH_DEPOSIT_ERROR;
                  delete $window.FINISH_DEPOSIT_SUCCESS;
                });
              break;
            case 207:
              if (response[1] &&
                _.get(response[1], 'body.exception') === 'PAY_TOTE_DEPOSIT_FAILED') {
                // tote error, show warning
                NotificationService.warning(null,
                  paypalService.getMessage(
                    messageStatusMap[207].key,
                    messageStatusMap[207].namespace
                  )
                );
              }
              break;
            default:
              // any other case, fetch the message for the status code from the code map and display it
              // (the code will end up here almost every time for success case)
              if ($rootScope.activeFeatures &&
                $rootScope.activeFeatures.showDepositSuccessModal &&
                fromOption !== 'registration' &&
                response.statusCode === 200) {
                $timeout(function () {
                  DepositSrv.getSuccessDepositModal(false);
                }, 100);
              } else {
                NotificationService[messageForCode.type](
                  null,
                  paypalService.getMessage(
                    messageForCode.key,
                    messageForCode.namespace
                  )
                );
              }
          }

          if (response.balance) {
            $rootScope.$emit('accountBalance_changed', parseFloat(response.balance));
          }
        })
        .then(self.notifyOnPaymentComplete)
        .catch(function (err) {
          var errorMessage =
            paypalService.getMessage(err.data.exception, 'payDepositExceptions') ||
            paypalService.getMessage('generic', 'payDepositExceptions');

          UserActionEventsService.emit('depositErrorPayPal', {
            amount: undefined,
            fee: undefined,
            message: errorMessage
          });

          // big error trying to make the deposit, show exception message
          NotificationService.error(
            null,
            errorMessage
          );
        })
        .finally(function () {
          self.resetURL();
          self.getEmail();
        });
    }

    if (self.userCancelled) {
      UserActionEventsService.emit('paypalCancelDeposit');
      self.resetURL();
      self.getEmail();
    } else {
      self.getEmail();
    }
  };

  self.$postLink = function () {
    if (self.depositAmount) {
      self.paypalDeposits.$setSubmitted();
      if (self.depositAmount >= self.minAmount &&
          self.depositAmount <= self.maxAmount) {
        self.fetchFees(self.depositAmount);
      }
    }
  };

  // Event Handlers
  self.handleOnAmountChange = function ($event) {
    self.fees = {};
    self.depositAmount = $event.amount;
    self.fetchFees($event.amount);
    self.onAmountChange({ $event: $event.amount });
  };

  self.notifyOnPaymentComplete = function () {
    if (self.onPaymentComplete) {
      self.onPaymentComplete({ $event: {} });
    }
  };

  self.handlePaymentConfirmationFailure = function (error) {
    UserActionEventsService.emit('depositErrorPayPal', error);

    switch (error.message) {
      case 'BACKOFF_TIMEOUT':
        NotificationService.warning(
          null,
          paypalService.getFromCMS('processingTimeout')
        );
        break;
      case 'PAYMENT_FAILED':
        NotificationService.error(
          paypalService.getFromCMS('error'),
          paypalService.getFromCMS('processingError')
        );
        break;
      default:
        NotificationService.error(
          paypalService.getFromCMS('error'),
          (
            paypalService.getFromCMS(error.status || error.code) ||
            paypalService.getFromCMS('defaultError')
          )
        );
    }
  };

  // Public methods

  /**
   * [deposit description]
   * @param  {String} payerId
   * @param  {Object} options
   * @param  {String} options.token
   * @param  {Number} options.amount
   * @return {Promise<Any, Error>}
   */
  self.depositPayment = _.curry(function (payerId, options) {
    var data = angular.extend({}, { payerId: payerId }, options);

    return paypalService.deposit(data)
      .then(Utilities.tap(function (params) {
        UserActionEventsService.emit('depositSuccessPayPal', {
          amount: params.amount - params.fee,
          fee: params.fee,
          defaultAmount: self.amountOptions.indexOf(params.amount) !== -1
        });
      }));
  });


  /**
   * Get users email
   * @return {[type]} [description]
   */
  self.getEmail = function () {
    paypalService.getAccountInfo(
      self.accountNumber
    ).then(function (response) {
      if (response) {
        self.email = response.email;
      }
      self.loading = false;
    }).catch(function () {
      self.loading = false;
    });
  };

  /**
   * [waitForConfirmation description]
   * @param  {Object} options
   * @param  {Number} options.timeout
   * @param  {Number} options.depositId
   * @return {Promise}         [description]
   */
  self.waitForConfirmation = function (options) {
    var getDeposit = _.curry(function (depositId, pendingDeposits) {
      pendingDeposits = pendingDeposits || [];
      return pendingDeposits.filter(function (deposit) {
        return deposit.depositId === options.depositId;
      });
    });

    options = _.assign({}, options, { timeout: 20000 });

    return Utilities.backOff(function (next, stop) {
      return paypalService.getPendingDeposits()
        .then(getDeposit(options.depositId))
        .then(function (deposits) {
          if (!deposits.length) {
            stop(deposits);
          } else if (deposits[0].status === 'Failed') {
            stop(new Error('PAYMENT_FAILED'));
          } else {
            next();
          }
        })
        .catch(stop);
    }, options.timeout)
    .then(Utilities.tap(function () {
      NotificationService.success(
        paypalService.getFromCMS('success'),
        paypalService.getFromCMS('transactionSuccessful')
      );
    }));
  };

  self.fetchFees = function (amount) {
    self.fees.loading = true;

    // stop if no amount is inserted
    // (amount is undefined if the value is not valid)
    if (!amount) {
      return $q.reject(paypalService.getFromCMS('invalid'));
    }

    self.feeRequestFailed = false;
    NotificationService.clearBanner();

    return paypalService.getDepositFee(
      amount,
      self.accountNumber
    )
      .then(function (data) {
        var feeTotalAmount = parseFloat(data.feeTotalAmount || 0);
        var feeAmount = parseFloat(data.feeAmount || 0);
        var feeRefundAmount = parseFloat(data.feeRefundAmount || 0);

        var feeValues = {
          netAmount: amount,
          fee: feeTotalAmount,
          feeAmount: feeAmount,
          feeRefundAmount: feeRefundAmount,
          transactionTotal: amount + feeTotalAmount
        };

        self.fees = _.assign({}, self.fees, feeValues);
        return self.fees;
      })
      .then(Utilities.tap(function (fees) {
        $window.localStorage.setItem('isFeePaid', fees.feeAmount > 0);
        UserActionEventsService.emit('amountChange', {
          params: self.defaultParams,
          amount: amount,
          fee: fees.fee,
          feeAmount: fees.feeAmount,
          feeRefundAmount: fees.feeRefundAmount,
          defaultAmount: self.amountOptions.indexOf(amount) !== -1
        });
      }))
      .catch(function () {
        self.feeRequestFailed = true;

        NotificationService.error(
          paypalService.getFromCMS('error'),
          paypalService.getFromCMS('feesError')
        );
      })
      .finally(function () {
        self.fees.loading = false;
      });
  };
  /**
   * Reset all values from the form
   * @param {[boolean]} changeScreen [should the screen be changed ?]
   * @param {[boolean]} resetAmount  [should we reset the amount]
   */
  self.resetURL = function () {
    $log.info(paypalService.getBaseUrl(true));

    return $timeout(function () {
      var device = $rootScope.brazeDevice ||
      (new URLSearchParams($window.location.search)).get('device');

      $window.history.replaceState(null,
        $document.title,
        $rootScope.fullPage ? paypalService.getBaseUrl(true)
          + '&wrapper=true&device=' + device +
          '&fullPage=' + $rootScope.fullPage : paypalService.getBaseUrl(true)
      );
    }, 0);
  };

  self.shouldDisablePaypalButton = function () {
    var min = self.minAmount;
    var max = self.maxAmount;
    var amount = self.depositAmount || 0;
    var isCalculatingFees = !!self.fees.loading;

    return (isCalculatingFees || amount < min || amount > max || self.feeRequestFailed);
  };

  /**
   * Replace variable of CMS Messages
   * @param {[ApiError]} error
   * @return {[string]} CMSMessage
   */
  self.replaceVariableCMS = function (error, CMSMessage) {
    var limit;
    var floatRegex = new RegExp(/\d*\.\d*/g);
    var message = CMSMessage;
    var isRGLimitsExceededException = 119407;
    if (error.code === isRGLimitsExceededException) {
      limit = Number(error.message.match(floatRegex)[0]).toFixed(2);
      message = CMSMessage.replace('[limit]', limit);
    }
    return message;
  };

  /**
   * Makes the first call to the API so the user can login
   * and agree to pay in the paypal website
   * @return redirect
   */
  self.makePaypalDeposit = function (event) {
    var baseUrl = paypalService.getBaseUrl(false);
    var errorMessage = paypalService.getFromCMS('error');
    var requestData;

    requestData = {
      returnUrl: baseUrl,
      cancelUrl: baseUrl
    };

    if (event) { event.preventDefault(); }

    self.paypalDeposits.$submitted = true;
    self.disabled = true;

    UserActionEventsService.emit('depositAttemptPayPal', {
      amount: self.depositAmount,
      fee: self.fees.fee,
      defaultAmount: self.amountOptions.indexOf(self.depositAmount) !== -1
    });

    if (self.paypalDeposits.$valid && !self.feeRequestFailed) {
      requestData.orderAmount = self.depositAmount;

      self.loading = true;

      paypalService.getToken(requestData, self.accountNumber)
        .then(function (response) {
          UserActionEventsService.emit('paypalDepositRedirect', {
            amount: self.depositAmount,
            fee: self.fees.fee
          });

          return response;
        })
        .then(function (token) {
          var url = ConfigurationFac.getPaypal('baseURL') + '&token=' + token;
          if (ConfigurationFac.getApplicationContextItem('wrapper') &&
            !_.get($rootScope.activeFeatures, 'enableDepositOnSinglePage', false) &&
            !$window.location.pathname.match(/\/registration\/.*/g)) {
            $window.parent.postMessage({
              type: 'paypal_redirect',
              payload: url
            }, '*');
          } else {
            $window.location = url;
          }
        })
        .catch(function (error) {
          var message;
          self.loading = false;
          self.depositAmount = null;
          self.paypalDeposits.$setPristine();
          message = self.replaceVariableCMS(error.data,
               paypalService.getMessage(error.data.exception, 'payDepositExceptions')
            || paypalService.getMessage('generic', 'payDepositExceptions'));
          NotificationService.error(
            null,
            message
          );
        });
    } else {
      NotificationService.error(
        errorMessage,
        paypalService.getFromCMS('defaultError')
      );
    }

    $scope.$on('$destroy', function () {
      var eventHandlers = _.keys(UserActionEventsService.eventHandlers);
      eventHandlers.map(function (eventName) {
        return UserActionEventsService.off(eventName);
      });
    });
  };
}

angular
  .module('TVG.Paypal.Deposits')
  .controller('paypalDepositController', PaypalDepositController);

angular
  .module('TVG.Paypal.Deposits')
  .component('selectAmount', {
    controller: 'selectAmountController',
    bindings: {
      form: '=',
      amount: '<',
      amounts: '<',
      minAmount: '<',
      maxAmount: '<',
      onAmountChange: '&'
    },
    templateUrl: 'src/paypal/deposits/select-amount/select-amount.template.html'
  });

/* eslint angular/controller-as-vm: "off" */
(function () {
  'use strict';

  SelectAmountController.$inject = ['UserActionEventsService', '$timeout'];
  function SelectAmountController(UserActionEventsService, $timeout) {
    var self = this;

    self.change = function (amount) {
      if (self.form.$error) {
        $timeout(function () {
          UserActionEventsService.emit('payPalFill', self.form.$error);
        }, 200);
      }
      self.amount = amount;
      if (self.onAmountChange) {
        self.onAmountChange({ $event: { amount: amount } });
      }
    };
  }

  angular
    .module('TVG.Paypal.Deposits')
    .controller('selectAmountController', SelectAmountController);
}());

angular
  .module('TVG.Paypal.Deposits')
  .component('totalCost', {
    bindings: {
      data: '<',
      email: '<'
    },
    templateUrl: 'src/paypal/deposits/total-cost/total-cost.template.html'
  });

angular.module('TVG.MoneyPak',
  [
    'TVG.DMA.Common',
    'TVG.Configuration',
    'ui.mask',
    'UserActionEvents'
  ]);

 angular
  .module('TVG.MoneyPak')
  .component('moneypak', {
    controller: 'MoneyPakController',
    templateUrl: 'src/moneypak/moneypak.template.html'
  });

(function () {
  'use strict';

  MoneyPakController.$inject = ['ModalDialogService', 'MoneyPakService', 'NotificationService', 'UserActionEventsService', 'ApiDepositsGTMFac', '$window', '$rootScope', '$scope', '$filter', 'Utilities', 'DepositSrv', '$timeout'];
  function MoneyPakController(
    ModalDialogService,
    MoneyPakService,
    NotificationService,
    UserActionEventsService,
    ApiDepositsGTMFac,
    $window,
    $rootScope,
    $scope,
    $filter,
    Utilities,
    DepositSrv,
    $timeout
  ) {
    var vm = this;
    var modalTitle;
    var modalBody;

    var isNative = false;

    var mpakDepositMessagesMock = {
      scenario1: 'Oops, something went wrong.',
      scenario2: 'Oops, something went wrong',
      scenario3a:
        'Almost done, your deposit of {depositAmount} is taking a ' +
        'little longer to reach your TVG account than normal',
      scenario3b:
        'Success! Your deposit of {depositAmount} is being ' +
        'processed and your balance will update in a moment.',
      scenario3c:
        'Almost done, your deposit of {depositAmount} is taking ' +
        'a little longer to reach your TVG account than normal.',
      scenario4:
        'Almost done, your deposit of {depositAmount} is taking ' +
        'a little longer to reach your TVG account than normal.',
      scenario5:
        'Success! Your deposit of {depositAmount} is now available ' +
        'for wagering.'
    };

    var SUCCESS_MODAL_LABELS = {
      title: 'Successful Deposit!',
      textTemplate: 'Your $@@@deposit_amount@@@ are now available!',
      buttonText: 'Let\'s bet!'
    };

    var successModalOnOpenCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'siteClick',
        gaEventCategory: 'Site click',
        gaEventAction: 'seen',
        gaEventLabel: undefined,
        module: 'deposit success modal',
        tag: undefined,
        microApp: undefined
      });
    };

    var successModalButtonCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('navigation', {
        event: 'navigation',
        gaEventCategory: 'Navigation',
        gaEventAction: 'Navigated To',
        gaEventLabel: SUCCESS_MODAL_LABELS.buttonText,
        module: 'deposit success modal',
        tag: undefined,
        menu: undefined,
        sport: 'Horse Racing',
        destinationUrl: 'https://www.tvg.com/'
      });

      if ($window && $window.handleNativeMessages) {
        $window.handleNativeMessages('CLOSE_DMA');
      }
    };


    var successModalCloseCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'siteClick',
        gaEventCategory: 'Site click',
        gaEventAction: 'close',
        gaEventLabel: undefined,
        module: 'deposit success modal',
        tag: undefined,
        microApp: undefined
      });
    };

    if ($rootScope.product) {
      isNative = $rootScope.product.indexOf('native') !== -1;
    }

    function handleAction() {
      if (!vm.moneyPakDepositForm.$valid) {
        return false;
      }

      NotificationService.clearBanner();

      return true;
    }
    function getAccountId() {
      return (DepositSrv && DepositSrv.accountId) ||
        ($scope.$parent.accountDetails &&
          $scope.$parent.accountDetails.accountDetails &&
          $scope.$parent.accountDetails.accountDetails.accountNumber);
    }

    function makeMoneypakDeposit() {
      vm.loading = true;

      function _initiateDepositStatusPoller(data, successCb, errorCb) {
        Utilities.depositStatusPoller(
          function () {
            vm.activePoller = true;
            return DepositSrv.getDepositStatus(data.headers('Location'))
              .then(function (response) {
                return response.status;
              })
              .catch(errorCb);
          },
          10000,
          2000
        )
          .then(successCb)
          .catch(errorCb)
          .finally(function () {
            vm.activePoller = false;
          });
      }

      function _mpakSuccessPollerCb(messages, data, success) {
        if (success) {
          handleDepositSuccess(
            data.data,
            Utilities.supplant(messages.scenario5, {
              depositAmount: $filter('currency')(data.data.amount)
            })
          );
        } else {
          handleDepositError(
            data.data,
            Utilities.supplant(messages.scenario3a, {
              depositAmount: $filter('currency')(data.data.amount)
            }),
            'warning'
          );
        }
      }

      function _mpakErrorPollerCb(messages, data) {
        NotificationService.warning(
          'Deposit Poller',
          Utilities.supplant(messages.scenario3c, {
            depositAmount: $filter('currency')(data.data.amount)
          }),
          null,
          null,
          true
        );
      }

      function handleDepositSuccess(response, messageToDisplay, type) {
        var fromOption = _.get($scope, '$parent.fromOption.tla', '');
        if (type === 'success' || !type) {
          vm.responsibleGamingDelay = true;
          $timeout(function () {
            vm.responsibleGamingDelay = false;
          }, parseInt($filter('CMSValue')('debounceAfterDeposit'), 10) || 0);

          if ($rootScope.activeFeatures &&
            $rootScope.activeFeatures.showDepositSuccessModal &&
            fromOption !== 'registration'
          ) {
            DepositSrv.getSuccessDepositModal(false);
          } else {
            NotificationService.success(null, messageToDisplay, null, null, true);
          }
        } else if (type === 'warning') {
          NotificationService.warning(null, messageToDisplay, null, null, true);
        } else if (type === 'error') {
          NotificationService.error(null, messageToDisplay, null, null, true);
        }
        UserActionEventsService.emit('depositSuccessMoneyPak', response.amount, !!response.feePaid);

        if (isNative) {
          if ($window && $window.handleNativeMessages) {
            $window.handleNativeMessages('UPDATE_BALANCE');
          }
        }

        if ($rootScope.activeFeatures.isDMAInjectDepositSuccessModalEnabled) {
          if ($window.ReactInjector) {
            $window.ReactInjector.renderDepositSuccess(
                document.getElementById('injected-modal'),// eslint-disable-line
              {
                title: SUCCESS_MODAL_LABELS.title,
                text: SUCCESS_MODAL_LABELS.textTemplate.replace(
                  '@@@deposit_amount@@@',
                  response && response.amount),
                buttonText: SUCCESS_MODAL_LABELS.buttonText,
                sharedState: { isOpen: true },
                buttonCallback: successModalButtonCallback,
                closeCallback: successModalCloseCallback,
                onOpenCallback: successModalOnOpenCallback
              }
            );
          }
        }


        vm.mpakNumber = '';
        vm.moneyPakDepositForm.$setPristine();
        vm.moneyPakDepositForm.$setUntouched();
      }

      function handleDepositError(response, messageToDisplay, type) {
        if (type === 'error' || !type) {
          NotificationService.error(null, messageToDisplay, null, null, true);
        } else if (type === 'warning') {
          NotificationService.warning(null, messageToDisplay, null, null, true);
        } else if (type === 'success') {
          NotificationService.success(null, messageToDisplay, null, null, true);
        }
        UserActionEventsService.emit('depositErrorMoneyPak', messageToDisplay);
      }
      //eslint-disable-next-line
      return MoneyPakService.depositNewFlow(
        { cardNumber: vm.mpakNumber },
        getAccountId()
      )
        .then(function (data) {
          var statusCode = data.status;
          var messages = {};
          var messagesObj = $filter('CMSValue')('mpakDepositMessages');
          if ($scope.isRGAvailable) {
            vm.updateRGLimits(+data.data.amount);
          }
          try {
            messages = angular.fromJson(messagesObj);
          } catch (err) {
            // Prevent test failure
          }

          switch (statusCode) {
            case 200:
              if (data.data && data.data.balance) {
                $rootScope.$emit('accountBalance_changed', data.data.balance);
              }
              handleDepositSuccess(
                data.data,
                Utilities.supplant(
                  messages.scenario5 || mpakDepositMessagesMock.scenario5,
                  {
                    depositAmount: $filter('currency')(data.data.amount)
                  }
                )
              );
              break;
            case 202:
              NotificationService.warning(
                'Poller!',
                Utilities.supplant(
                  messages.scenario3b || mpakDepositMessagesMock.scenario3b,
                  {
                    depositAmount: $filter('currency')(data.data.amount)
                  }
                ),
                null,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                // eslint-disable-next-line
                _mpakSuccessPollerCb.bind(this, messages, data),
                // eslint-disable-next-line
                _mpakErrorPollerCb.bind(this, messages, data)
              );
              break;
            case 207:
              //eslint-disable-next-line
              var mpakDeposit = data.data.filter(function(item) {
                return item.id === 'MPAK_WITHDRAWAL';
              });
              //eslint-disable-next-line
              var amount = "";
              if (
                mpakDeposit[0] &&
                mpakDeposit[0].body &&
                mpakDeposit[0].body.amount
              ) {
                amount = mpakDeposit[0].body.amount;
              }

              NotificationService.warning(
                'Poller!',
                Utilities.supplant(
                  messages.scenario3a || mpakDepositMessagesMock.scenario3a,
                  {
                    depositAmount: $filter('currency')(amount)
                  }
                ),
                null,
                null,
                true
              );

              break;
            default:
              break;
          }
          DepositSrv._setHasMadeInitialDeposit(true);
          DepositSrv.updateCustomerStatus();
        })
        .catch(function (error) {
          var messagesObjExceptions = $filter('CMSValue')(
            'mpakDepositExceptions'
          );
          var mpakDepositExceptions = {};
          var statusCode = error.status;
          var genericMessage =
            'An error occurred while processing your deposit.';
          var errorMessage = 'error';
          //eslint-disable-next-line
          console.log(error);

          try {
            mpakDepositExceptions = angular.fromJson(messagesObjExceptions);
          } catch (err) {
            // Prevent test failure
          }

          if (
            $scope.isRGAvailable &&
            error.data &&
            error.data.code === 112703
          ) {
            sessionStorage.setItem('IS_SUSPENDED', 'true');
            $window.location = '/';
            // STOP HERE!!!
            // THIS IS A PRECISELY PLACED HAMMER 🔨
            if ($rootScope.layout === 'desktop') {
              $window.mediator.dispatch('TVG_LOGIN:DO_LOGOUT', {});
            }
          }

          switch (statusCode) {
            case 422:
              errorMessage =
                error.data &&
                error.data.message &&
                mpakDepositExceptions &&
                mpakDepositExceptions[error.data.message]
                  ? mpakDepositExceptions[error.data.message]
                  : genericMessage;
              NotificationService.error(
                'Poller!',
                errorMessage,
                null,
                null,
                true
              );

              UserActionEventsService.emit(
                'depositErrorMoneyPak',
                errorMessage
              );
              break;
            default:
              errorMessage = mpakDepositExceptions.generic || genericMessage;
              NotificationService.error(
                'Poller!',
                errorMessage,
                null,
                null,
                true
              );
              UserActionEventsService.emit(
                'depositErrorMoneyPak',
                errorMessage
              );
              break;
          }
        })
        .finally(function () {
          vm.loading = false;
        });
    }
    function checkRGLimitReached() {
      $scope.rgLimitReached = $scope.rgMoneypakAvailableDepositAmount === 0;
      return $scope.rgLimitReached;
    }

    function alertRGLimit(limitAmount) {
      if (!!limitAmount) {
        $scope.messageWithRemainingAmount = angular.fromJson(
          $filter('CMSValue')('moneyPakLabels').replace(
            '#AMOUNT_REMAINING',
            '$' + limitAmount.toLocaleString()
          )
        ).DMARGLimitRemaining;
      }
    }

    vm.getRGLimits = function () {
      var paymentOptionsResponse = MoneyPakService.getDepositOptions({}, getAccountId());
      paymentOptionsResponse.then(function (response) {
        $scope.rgMoneypakAvailableDepositAmount = response.data.remainingDepositLimit;
        checkRGLimitReached();
        alertRGLimit($scope.rgMoneypakAvailableDepositAmount);
      }).catch(function () {
        // ERROR SCENARIO
      });
    };

    vm.updateRGLimits = function (depositedValue) {
      if (!!$scope.rgMoneypakAvailableDepositAmount) {
        $scope.rgMoneypakAvailableDepositAmount -= depositedValue;
      }
      checkRGLimitReached();
      alertRGLimit($scope.rgMoneypakAvailableDepositAmount);
    };

    vm.$onInit = function () {
      vm.loading = false;
      vm.makingDeposit = false;
      vm.mpakNumber = '';

      $scope.isRGAvailable = angular.isDefined(
        $rootScope.activeFeatures.isRGAvailableOnDMA
      )
        ? $rootScope.activeFeatures.isRGAvailableOnDMA
        : false;

      $scope.isFDRApp = angular.isDefined($rootScope.isFdrApp)
        ? $rootScope.isFdrApp
        : false;
      modalTitle = MoneyPakService.getLabelFromCMS('faqTitle') || '';
      modalBody = MoneyPakService.getValueFromCMS('moneyPakFaqTemplate') || '';
      if ($scope.isRGAvailable) {
        vm.getRGLimits();
      }
    };

    vm.openModal = function (event) {
      if (event) {
        event.preventDefault();
      }
      UserActionEventsService.emit('moneyPakFAQ');
      return ModalDialogService.openLarge(modalTitle, modalBody);
    };

    vm.update = function (value) {
      vm.mpakNumber = value;
    };

    vm.handleFormSubmit = function () {
      UserActionEventsService.emit('depositAttemptMoneyPak', vm.mpakNumber);
      return handleAction() && makeMoneypakDeposit();
    };

    $scope.$on('$destroy', function () {
      var eventHandlers = _.keys(UserActionEventsService.eventHandlers);
      eventHandlers.map(function (eventName) {
        return UserActionEventsService.off(eventName);
      });
    });
  }

  angular
    .module('TVG.MoneyPak')
    .controller('MoneyPakController', MoneyPakController);
}());

(function () {
  'use strict';

  MoneyPakService.$inject = ['ConfigurationFac', '$filter', '$http', '$q', 'Utilities'];
  function MoneyPakService(ConfigurationFac, $filter, $http, $q, Utilities) {
    var self = {};

    var moneypakEndpoint = function (params) {
      return ConfigurationFac.getBaseServiceUrl().concat('/mpak/v1/' + params);
    };

    var moneypakEndpointNewFlow = function (accountId) {
      return ConfigurationFac.getBaseServiceUrl().concat(
        '/mpak/v1/users/' + accountId + '/deposit'
      );
    };

    var depositOptionsURL = function (accountId) {
      return ConfigurationFac.getBaseServiceUrl().concat(
        '/uwt/v1/users/' + accountId + '/limits/responsible-gaming'
      );
    };

    /**
     * checkTransaction
     * Check if the transaction failed, although the request did not return
     * any error status code.
     *
     * @param  {$httpResponse} response the response object from the $http call
     * @return {Promise}
     */
    var checkTransaction = function (response) {
      return $q(function (resolve, reject) {
        var errors = Utilities.prop('data.errors', response);
        if (errors) {
          return reject(self.createApiError(errors));
        }

        return resolve(response);
      });
    };

    var checkError = function (response) {
      return $q(function (resolve, reject) {
        return reject(
          self.createApiError([
            {
              message: response.data,
              code: response.status
            }
          ])
        );
      });
    };

    /**
     * Create an API error instance
     * Try to fetch an error message from the CMS (using the error code)
     * If none is found, use the error.message as a fallback
     *
     * @param  {Array} data [description]
     * @return {Error}     [description]
     */
    self.createApiError = function (data) {
      var apiError = new Error();
      var error = (data && data[0]) || {};
      var moneyPakError = self.getLabelFromCMS(error.code);

      apiError.message = moneyPakError || error.message;
      apiError.code = error.code;
      return apiError;
    };

    self.request = function (params) {
      return $http({
        url: moneypakEndpoint(params.url),
        method: params.method,
        data: params.body,
        headers: self.addHeaders()
      })
        .catch(checkError)
        .then(checkTransaction)
        .then(Utilities.prop('data.response'));
    };

    self.requestNewFlow = function (params, accountId) {
      return $http({
        url: moneypakEndpointNewFlow(accountId),
        method: params.method,
        data: params.body,
        headers: self.addHeaders()
      });
    };

    self.requestDepositOptions = function (params, accountId) {
      return $http({
        url: depositOptionsURL(accountId),
        method: params.method,
        data: params.body,
        headers: self.addHeaders()
      });
    };

    /**
     * Add the headers needed to perform API calls
     *
     * @return {object}: Header Object
     */
    self.addHeaders = function (options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext())
      };

      if (Utilities.prop('cache', options)) {
        headers = angular.extend(
          {},
          {
            'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
          },
          headers
        );
      }
      return headers;
    };

    /**
     * Get labels from CMS
     * @param  {string} name label Name
     * @return {string}      label
     */
    self.getLabelFromCMS = function (name) {
      return $filter('CMSLabels')(name, 'moneyPakLabels');
    };

    /**
     * Get value from CMS
     * @param  {string} name value Name
     * @return {string}      CMS value
     */
    self.getValueFromCMS = function (name) {
      return $filter('CMSValue')(name);
    };

    self.deposit = function (data) {
      var maxTime = self.getLabelFromCMS(
        'checkDepositStatusIntervalDurationInMilliseconds'
      );

      return self
        .request({
          url: 'deposit',
          method: 'POST',
          body: data
        })
        .then(function (response) {
          if (response.errors) {
            return $q.reject(response);
          }

          return Utilities.backOff(function (next, stop) {
            return self
              .getDepositState(response.depositId)
              .then(function (depositData) {
                if (depositData.status === 'Completed') {
                  stop(depositData);
                } else {
                  next();
                }
              });
          }, maxTime).catch(function (error) {
            var newError = error;
            if (newError.message === 'BACKOFF_TIMEOUT') {
              newError.code = '9';
            }
            return $q.reject(newError);
          });
        });
    };

    self.depositNewFlow = function (data, accountId) {
      return self.requestNewFlow(
        {
          method: 'POST',
          body: data
        },
        accountId
      );
    };

    self.getDepositState = function (depositId) {
      return self.request({
        url: 'deposit/' + depositId,
        method: 'GET'
      });
    };

    self.getDepositOptions = function (data, accountId) {
      return self.requestDepositOptions(
        {
          method: 'GET'
        },
        accountId
      );
    };

    return self;
  }

  angular.module('TVG.MoneyPak').factory('MoneyPakService', MoneyPakService);
}());

angular.module('TVG.MoneyPak')
  .component('limitsTable', {
    bindings: {
      contentObj: '<'
    },
    controller: 'LimitsTableController as vm',
    templateUrl: 'src/moneypak/limits-table/limits-table.template.html'
  });

(function () {
  'use strict';

  LimitsTableController.$inject = ['$log'];
  function LimitsTableController($log) {
    var vm = this;

    vm.$onInit = function () {
      try {
        vm.content = angular.fromJson(vm.contentObj);
      } catch (e) {
        vm.content = [];

        $log.error('LimitsTableController - error parsing JSON "' + vm.contentObj +
          '": "' + e.message + '"');
      }
    };
  }

  angular.module('TVG.MoneyPak')
    .controller('LimitsTableController', LimitsTableController);
}());

angular.module('TVG.MoneyPak')
  .component('moneypakActivationNumberInput', {
    bindings: {
      mpakNumber: '<',
      form: '<',
      onUpdate: '&'
    },
    controller: 'MoneyPakActivationNumberController',
    templateUrl: 'src/moneypak/moneypak-activation-number-input/moneypak-activation-number-input.template.html'
  });

(function () {
  'use strict';

  MoneyPakActivationNumberController.$inject = ['UserActionEventsService'];
  function MoneyPakActivationNumberController(UserActionEventsService) {
    var vm = this;
    vm.firstTime = true;

    vm.update = function () {
      if (vm.form.$error) {
        UserActionEventsService.emit('moneyPakFill', vm.form.$error);
      }
      if (vm.mpakNumber) {
        vm.onUpdate({ value: vm.mpakNumber });
      }
    };

    vm.startDeposit = function () {
      if (vm.firstTime) {
        UserActionEventsService.emit('moneyPakStart');
        vm.firstTime = false;
      }
    };

    vm.openTooltip = function () {
      UserActionEventsService.emit('moneyPakTooltip');
    };

    vm.$onChanges = function (changesObj) {
      vm.mpakNumber = _.get(changesObj, 'mpakNumber.currentValue');
    };
  }

  angular
    .module('TVG.MoneyPak')
    .controller('MoneyPakActivationNumberController', MoneyPakActivationNumberController);
}());

(function () {
  'use strict';

  DMATogglesRun.$inject = ['DmaTvg4FeatureTogglesSvc', 'DMAFeatureTogglesHashContainerSvc'];
  angular.module('TVG.DMAToggles', []);
  angular.module('TVG.Deposit', [
    'TVG.Content',
    'TVG.DMAToggles',
    'TVG.Paypal.Deposits',
    'TVG.ApplePay.Deposits',
    'TVG.MoneyPak',
    'ui.bootstrap',
    'angular.filter',
    'TVG.DMA.Common',
    'UserActionEvents',
  ]);
  angular.module('TVG.Withdraw', [
    'TVG.Content',
    'TVG.Deposit',
    'TVG.DMAToggles',
    'TVG.Paypal.Withdrawals',
    'TVG.DMA.Common'
  ]);
  angular.module('TVG.Transfer', [
    'TVG.Content',
    'TVG.DMAToggles',
    'TVG.DMA.Common'
  ]);
  angular.module('TVG.ManagePaymentMethods', [
    'TVG.Deposit',
    'TVG.Content',
    'TVG.DMAToggles',
    'TVG.DMA.Common'
  ]);

  angular.module('TVG.DMAToggles').run(DMATogglesRun);

  function DMATogglesRun(
          DmaTvg4FeatureTogglesSvc,
          DMAFeatureTogglesHashContainerSvc) {
    DMAFeatureTogglesHashContainerSvc.registerAsDefault(DmaTvg4FeatureTogglesSvc);
  }
}());

angular.module('TVG.Deposit').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/templates/deposit/deposit-error.html',
    "<div class=\"handler-error-container\"><span class=\"image\"></span><h1 class=\"title\">Error!</h1><div class=\"message-container\"><h2><strong>This method of payment doesn't seem to be going through.</strong></h2><p class=\"customer_service\" ng-bind-html=\"('depositsErrorDefault'| CMSValue : null) | trust\"></p></div></div>"
  );


  $templateCache.put('src/templates/deposit/deposit-success-modal.html',
    "<div class=\"tvg-dialog dma-redesign sightline-redirect-modal\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" style=\"text-transform: uppercase; display: block; margin-top: 3px;\" ng-bind=\"('depositLabelSuccessTitleModal' | CMSLabels: 'dmaManagementLabels' | trust)\" data-qa-label=\"depositSuccessTitleModal\"></span> <a href class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$close()\" data-qa-label=\"depositSuccessCloseModal\"><i class=\"tvg-icon-close\"></i></a></div><div class=\"tvg-dialog-dma-redesign-body\" style=\"padding: 16px;\"><div style=\"margin-bottom: 10px\"><span class=\"depositSuccessLabel\" ng-class=\"{depositSuccessLabelACH: !isACH}\" ng-bind=\"('depositLabelSuccessTextModal' | CMSLabels: 'dmaManagementLabels' | trust)\"></span> <span ng-if=\"isACH\" ng-bind=\"('depositLabelACHTextModal' | CMSLabels: 'dmaManagementLabels' | trust)\"></span></div><div><button class=\"proceed-btn\" ng-click=\"betNow($close)\" data-qa-label=\"depositSuccessBetNowButton\" ng-bind=\"('depositSuccessBetNowButton' | CMSLabels: 'dmaManagementLabels' | trust)\"></button></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/deposit-success.html',
    "<div class=\"handler-success-container\"><span class=\"image\"></span><h1 class=\"title\">Success!</h1><div class=\"message-container\"><h2><strong>Your transaction was successful.</strong></h2><p class=\"message\">{{'globalDepositSuccess' | CMSValue : {depositamount:(depositData.requestedAmount | currency), availabledate:depositData.depositAvailableDate} }}</p></div></div>"
  );


  $templateCache.put('src/templates/deposit/deposit.html',
    "<div class=\"tvg-deposit\" ng-controller=\"DepositController\" ng-class=\"{loading: data.loading, 'njx-deposit': njxIntegration}\"><div ng-show=\"!data.showingFallback\"><welcome-dialog-fdr ng-if=\"$root.isFdrApp && !data.loading && $root.newUser && !data.errorLoadingData\"></welcome-dialog-fdr><dw-info-dialog ng-if=\"data.errorLoadingData && !data.loading && !$root.isFdrApp\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'depositInitialDataErrorMessage' | CMSValue : null}}</dw-info-dialog><dw-info-dialog-fdr ng-if=\"data.errorLoadingData && !data.loading && $root.isFdrApp\" heading-text=\"Something went wrong\" button-text=\"Refresh Page\" button-action=\"location.reload()\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'depositInitialDataErrorMessage' | CMSValue : null}}</dw-info-dialog-fdr><dw-info-dialog ng-if=\"data.errorDepositRestrictions && !data.loading\" ng-bind-html=\"'error-deposit-restrictions' | CMSLabels: 'error-deposit-restrictions' | trust\"></dw-info-dialog><form id=\"sightline__user-form\" ng-if=\"displays.isSightlineIframeVisible() || isAddingFunds\" action=\"{{data.slnIframeURL}}\" name=\"sightline__user-form\" target=\"sightline__iframe\" method=\"post\" autocomplete=\"off\"><input id=\"{{key}}\" type=\"hidden\" ng-repeat=\"(key, val) in sglUser\" name=\"{{key}}\" value=\"{{val}}\"></form><form id=\"cardsForm_id\" ng-show=\"!data.errorLoadingData && !data.loading && !data.errorDepositRestrictions\" class=\"deposit-form\" name=\"depositFrm\" ng-submit=\"events.makeDeposit(depositFrm)\" ng-class=\"{loading: !!(data.makingDeposit || data.fetchingInfo || data.activePoller)}\" novalidate><deposit-type-selector></deposit-type-selector><div class=\"methods-wrapper\" ng-switch on=\"data.selectedPayOption.ftype\"><!-- GreenDot eCash--><div ng-switch-when=\"ECSH\"><div ng-include=\"'src/templates/deposit/types/greendot_ecash.html'\"></div></div><!-- GreenDot MoneyPak--><div ng-switch-when=\"MPAK\"><moneypak ng-if=\"!displays.isTVG3()\"></moneypak><div class=\"disclaimer mpak-disclaimer\" ng-if=\"displays.isTVG3()\" ng-bind-html=\"'tvg3Message' | CMSLabels: 'moneyPakLabels'\"></div></div><!-- Sightline --><div ng-switch-when=\"SLN\" ng-class=\"{'loading': !$root.sightlineLoaded && !$root.sightlineFlowVersion}\"><react-sightline ng-if=\"$root.sightlineFlowVersion && $root.sightlineFlowVersion === '2'\"></react-sightline><div ng-if=\"$root.sightlineFlowVersion && $root.sightlineFlowVersion === '1'\" ng-include=\"'src/templates/deposit/types/sightline/sightline.html'\"></div><div ng-if=\"$root.sightlineFlowVersion && $root.sightlineFlowVersion === 'SLN version error' ||\n" +
    "                      ($root.sightlineFlowVersion !== '1' && $root.sightlineFlowVersion !== '2') && $root.sightlineLoaded\" ng-include=\"'src/templates/deposit/deposit-error.html'\"></div></div><!-- Pay Near Me--><div ng-switch-when=\"PNM\"><div ng-include=\"'src/templates/deposit/types/payNearMe/paynearme.html'\"></div></div><div ng-switch-when=\"PAY\"><paypal-deposit ng-if=\"!displays.isTVG3() && !njxIntegration\" min-amount=\"::PaypalDepositConfig.min\" max-amount=\"::PaypalDepositConfig.max\" amount-options=\"::data.availableAmountOptions\" deposit-amount=\"depositDataModel.amount\" is-payment-confirmation=\"::fromOption.isPaymentConfirmation\" user-cancelled=\"::fromOption.userCancelled\" on-payment-complete=\"events.handleBalanceUpdate($event)\" on-amount-change=\"events.handlePaypalAmountChange($event)\"></paypal-deposit><div class=\"disclaimer paypal-disclaimer\" ng-if=\"displays.isTVG3() && !njxIntegration\" ng-bind-html=\"'tvg3Message' | CMSLabels: 'paypalLabels'\"></div><div class=\"disclaimer paypal-disclaimer\" ng-if=\"njxIntegration\">Coming Soon</div></div><!-- Apple Pay--><div ng-switch-when=\"APPL\"><applepay-deposit ng-if=\"!displays.isTVG3()\" min-amount=\"depositDataModel.min\" max-amount=\"depositDataModel.max\" amount-options=\"::data.availableAmountOptions\" ng-init=\"events.setDepositTypeLimits(data.selectedPayOption.ftype)\" deposit-amount=\"depositDataModel.amount\" on-payment-complete=\"events.handleBalanceUpdate($event)\"></applepay-deposit></div><!-- Other payment methods --><div ng-switch-when=\"OTHER\"><div qa-label=\"otherPayment\" class=\"other-payments\" ng-bind-html=\"('depositsOtherPayments'| CMSValue : null ) | trust\"></div></div><!-- Other--><div ng-switch-default><div class=\"alert-box error clearfix expired-card-error\" qa-label=\"expiredCardMessage\" ng-if=\"events.anyCardsExpired()\"><i class=\"tvg-icon-error\"></i><div class=\"content\">It seems your card has expired please update your credit card info.</div></div><ach-description-text ng-if=\"data.selectedPayOption.ftype=='IBC'\"></ach-description-text><card-description-text ng-if=\"data.selectedPayOption.ftype=='CC'\"></card-description-text><section-title class=\"first-title\" qalabel=\"depositAmountTitle\" title=\"{{'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\" index=\"1\"></section-title><deposit-amount-input ng-if=\"(depositDataModel.isAvailable != false) || events.existsOnFile()\"></deposit-amount-input><section-title class=\"cards-section-title\" qalabel=\"accountSectionTitle\" title=\"{{ displays.toggleTitles() | CMSLabels: 'dmaDepositLabels' | trust }}\" index=\"2\"></section-title><toggle-new-onfile ng-if=\"((depositDataModel.isAvailable != false || events.existsOnFile()) &&\n" +
    "                          data.selectedPayOption.ftype!='IBC')\"><toggle-option qa-label=\"cardsOnFileButton\" ng-show=\"data.depositSection==='NEW' && data.selectedPayOption.onFile.length > 0\" ng-click=\"depositFrm.cardCvn.$setPristine();\n" +
    "                              events.toggleNewStoredMethods('STORED');\n" +
    "                              events.clearCVN();\n" +
    "                              events.resetAllModels()\" ng-class=\"{selected: data.depositSection=='STORED'}\" ng-bind-html=\"'deposit-list-cards' | CMSLabels: 'dmaDepositLabels' | trust\"></toggle-option><toggle-option qa-label=\"addNewCardButton\" ng-show=\"data.depositSection==='STORED'\" ng-click=\"depositFrm.cardCvn.$setPristine();\n" +
    "                              events.toggleNewStoredMethods('NEW');\n" +
    "                              events.clearCVN();\n" +
    "                              events.resetAllModels()\" ng-class=\"{selected: data.depositSection=='NEW'}\" ng-bind-html=\"'deposit-new-card' | CMSLabels: 'dmaDepositLabels' | trust\"></toggle-option></toggle-new-onfile><toggle-new-onfile ng-if=\"(depositDataModel.isAvailable != false || events.existsOnFile()) &&\n" +
    "                          data.selectedPayOption.onFile.length &&\n" +
    "                          data.selectedPayOption.ftype=='IBC' &&\n" +
    "                          data.selectedPayOption.bothACHAndIBCAvailable == true &&\n" +
    "                          !data.achDepositLimitExceeded || displays.unableToFetchBankAccounts()\"><toggle-option qa-label=\"accountsOnFile\" ng-show=\"data.depositSection==='NEW'\" ng-click=\"depositFrm.cardCvn.$setPristine();\n" +
    "                              events.toggleNewStoredMethods('STORED');\n" +
    "                              events.clearCVN();\n" +
    "                              events.resetAllModels()\" ng-bind-html=\"'deposit-list-accounts' | CMSLabels: 'dmaDepositLabels' | trust\"></toggle-option><toggle-option qa-label=\"addNewAccount\" ng-show=\"data.depositSection==='STORED'\" ng-click=\"depositFrm.cardCvn.$setPristine();\n" +
    "                              events.toggleNewStoredMethods('NEW');\n" +
    "                              events.clearCVN();\n" +
    "                              events.resetAllModels()\" ng-bind-html=\"'deposit-new-account' | CMSLabels: 'dmaDepositLabels' | trust\"></toggle-option></toggle-new-onfile><div ng-if=\"displays.isDepositFormVisible()\"><div qa-label=\"depositFormSection\" ng-if=\"data.selectedPayOption.ftype=='IBC' && !data.achDepositLimitExceeded\"><div ng-if=\"displays.isIBCValidVisible()\"><div ng-if=\"!events.existsOnFile()\" ng-init=\"events.setDepositTypeLimits(data.selectedPayOption.ftype)\"></div><div class=\"form-fields\" ng-repeat=\"field in data.forms[data.depositSection][data.selectedPayOption.ftype]\"><div ng-include=\"'src/templates/deposit/fields/'+field+'.html'\"></div></div></div><div class=\"deposit-card-options\" ng-if=\"data.depositSection === 'STORED' && events.existsOnFile()\" qa-label=\"accountsOnFileSection\"><label ng-bind-html=\"'deposit-betcash-cards-subtitle' | CMSLabels: 'dmaDepositLabels' | trust\" class=\"form-header\"></label><ul qa-label=\"bankAccountsList\" ng-init=\"depositDataModel.selectedOnFile = data.selectedPayOption.onFile[data.selectedCard];\n" +
    "                                         events.selectOnFileChanged(depositDataModel.selectedOnFile)\"><li ng-repeat=\"card in data.selectedPayOption.onFile track by card.achId\" class=\"card\" qa-label=\"betcash-card-onfile\"><label ng-class=\"{'active': depositDataModel.selectedOnFile === card ||\n" +
    "                                        ((card.ftype === 'IBC'|| card.ftype === 'ACH') && depositDataModel.selectedOnFile.achId === card.achId)}\"><strong ng-bind=\"::($root.isFdrApp ? card.bankName.toLowerCase() : card.bankName)\"></strong><div>*****{{(events.slicedCard(card.bankAccNumber))}}</div><input type=\"radio\" ng-model=\"depositDataModel.selectedOnFile\" ng-change=\"events.registerAccountSelectionOnGTM(card.bankName)\" ng-value=\"card\"></label></li></ul></div></div><div ng-if=\"displays.isIBCInvalidVisible()\"><div><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositBetCashPendingMessageText' | CMSValue : null}}</dw-info-dialog></div></div><div ng-if=\"data.depositSection === 'NEW' && data.selectedPayOption.ftype=='CC'\"><div class=\"form-fields\" ng-repeat=\"field in data.forms[data.depositSection][data.selectedPayOption.ftype]\"><div ng-include=\"'src/templates/deposit/fields/'+field+'.html'\"></div></div></div><div class=\"deposit-card-options\" ng-if=\" data.selectedPayOption.ftype === 'CC' && data.depositSection === 'STORED' && !displays.unableToFetchCardsOnFile()\"><label class=\"form-header\" qa-label=\"preAuthorizedCards\" ng-bind-html=\"'depositAchOnFileCardsSelectionLabel' | CMSValue : null\"></label><ul qa-label=\"cardsList\" ng-init=\"depositDataModel.selectedOnFile = data.selectedPayOption.onFile[data.selectedCard]; events.selectOnFileChanged(depositDataModel.selectedOnFile)\"><li qa-label=\"ccCardsOnFile\" ng-repeat=\"card in data.selectedPayOption.onFile track by card.id\" class=\"card\"><label qa-label=\"cardInfo\" ng-class=\"{'active': depositDataModel.selectedOnFile === card ||\n" +
    "                                    (card.ftype === 'CC' && depositDataModel.selectedOnFile.id === card.id) }\"><strong ng-bind=\"::card.typeName + ' Card'\"></strong><div><span ng-if=\"card.isExpired\" class=\"expired-card-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-bind=\"::card.cardNumberExt\"></span> (<span ng-bind=\"::card.expirationDate\"></span>)</div><input qa-label=\"cardSelection\" type=\"radio\" ng-model=\"depositDataModel.selectedOnFile\" ng-change=\"events.changeCard(depositDataModel.selectedOnFile)\" ng-value=\"card\"></label></li></ul><div ng-if=\"data.selectedPayOption.ftype === 'CC' && data.depositSection === 'STORED'\" ng-include=\"'src/templates/deposit/fields/card-verification-number.html'\"></div></div><div ng-if=\"depositDataModel.isPending == true\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositBetCashPendingMessageText' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"displays.isNotIBCValidVisible()\"><section-title title=\"Review and Authorize\" qalabel=\"reviewTitle\" index=\"{{ displays.hasThreeTitles() ? 3 : 4 }}\"></section-title><deposit-total-cost ng-if=\"displays.isPendingNotCalculatingVisible()\"></deposit-total-cost><div class=\"form-fields terms-conditions\" qa-label=\"terms-conditions\" ng-if=\"data.depositSection=='NEW' && data.selectedPayOption.ftype=='IBC'\"><span class=\"terms-subtitle\">By selecting {{'depositExecuteButton' | CMSValue : null}} I accept <span class=\"link-text\" qa-label=\"termsAndCondsLink\" ng-click=\"events.openTerms()\">terms and conditions</span> {{'depositAuthorizationAgreement' | CMSValue : null}}</span></div><div ng-if=\"depositDataModel.isPending != true\" class=\"field\"><button qa-label=\"submit-button\" class=\"submit add-funds\" ng-disabled=\"(data.disabledCard || data.makingDeposit || data.fetchingInfo || data.activePoller || data.fee.calculatingFees || !depositDataModel.depositTypeId || events.anyCardsExpired() || data.responsibleGamingDelay)\" type=\"submit\"><i class=\"tvg-icon tvg-icon-lock\"></i> <strong ng-bind=\"'depositExecuteButton' | CMSValue : null\"></strong></button><div ng-if=\"!notifyErrors\" qa-label=\"invalidFormMessage\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered tvg-tooltip-ctn general-form-error\"><p qa-label=\"incompleteFormErrorMessage\" ng-bind-html=\"'deposit-authorize-error-message' | CMSLabels: 'dmaDepositLabels' | trust\"></p></div></div></div></div><div ng-if=\"displays.isIBCValidExceededVisible()\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsBetcashPeriodLimitExceeded' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"displays.unableToFetchBankAccounts()\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsBetcashUnableToFetchBankAccounts' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"displays.unableToFetchCardsOnFile()\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsCCUnableToFetchCardsOnFile' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"depositDataModel.isAvailable == false && !events.existsOnFile()\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsBetcashPeriodLimitExceeded' | CMSValue : null}}</dw-info-dialog></div></div></div></form></div><dw-info-dialog ng-if=\"!data.loading && !$root.isFdrApp && data.showingFallback\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'depositNoPaymentMethodsAvailable' | CMSValue : null}}</dw-info-dialog></div>"
  );


  $templateCache.put('src/templates/deposit/fields/account-pin-pwd.html',
    "<div class=\"field\" qa-label=\"pin-password\"><div class=\"field-label\"><label qa-label=\"tvgPinPassLabel\" for=\"pinPass\" ng-bind=\"'depositPasswordPinLabel' | CMSValue : null\"></label></div><div class=\"field-input\"><span class=\"input-container\"><input name=\"fakepassword\" type=\"password\" style=\"position: absolute; left: -9999px;\" tabindex=\"-1\"> <input qa-label=\"tvgPinPassInput\" name=\"pinPass\" id=\"pinPass\" type=\"password\" autocomplete=\"off\" ng-model=\"depositDataModel.pinPass\" ng-blur=\"events.completedFieldAndBlursAway('TVG Password/PIN', depositFrm.pinPass)\" ng-required=\"true\" ng-model-options=\"{ updateOn: 'blur', debounce: { 'blur': 0 } }\"></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"data.showIBCInvalidPinOrPasswordMessage || (depositFrm.pinPass.$invalid && (depositFrm.pinPass.$touched || depositFrm.$submitted))\" ng-init=\"events.newAccountFieldError('TVG Password/PIN', 'depositInvalidPasswordPinText' | CMSValue)\"><p ng-bind=\"'depositInvalidPasswordPinText' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/ach-description-text.html',
    "<div class=\"disclaimer\" ng-bind-html=\"'depositRoutingNumberInfo' | CMSLabels: 'dmaDepositLabels' | trust\" qa-label=\"betcash-intro-disclaimer\"></div>"
  );


  $templateCache.put('src/templates/deposit/fields/applepay-description-text.html',
    "<div class=\"disclaimer\" qa-label=\"applepay-intro-disclaimer\" ng-bind-html=\"(('applepayDebitInformation' | CMSLabels: 'dmaDepositLabels' | trust))\"><span ng-if=\"$root.isFdrApp\">{{'depositCardsAccepted' | CMSLabels: 'dmaDepositLabels'}}</span></div>"
  );


  $templateCache.put('src/templates/deposit/fields/bank-account-number.html',
    "<div class=\"field\" qa-label=\"bank-account-number\" ng-class=\"{ focused: bankNumberFocus && !(depositFrm.accountNumber.$invalid && (depositFrm.accountNumber.$touched || depositFrm.$submitted))}\"><div class=\"field-label\"><label qa-label=\"accountNumberLabel\" for=\"accountNumber\" ng-bind=\"'depositCheckingAccountNumber' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.accountNumber.$invalid && (depositFrm.accountNumber.$touched || depositFrm.$submitted)}\"></label></div><div class=\"field-input\"><span class=\"input-container\"><input qa-label=\"accountNumberInput\" name=\"accountNumber\" id=\"accountNumber\" ng-model=\"depositDataModel.accountNumber\" ng-focus=\"bankNumberFocus = true\" ng-blur=\"events.completedFieldAndBlursAway('Account Number', depositFrm.accountNumber); bankNumberFocus = false\" ng-pattern=\"data.numberPattern\" ng-model-options=\"{ updateOn: 'blur', debounce: { 'blur': 0 } }\" ng-required=\"true\" minlength=\"3\" autocomplete=\"off\" ng-keypress=\"events.onlyNumbers($event)\" type=\"tel\"></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.accountNumber.$invalid && (depositFrm.accountNumber.$touched || depositFrm.$submitted)\" ng-init=\"events.newAccountFieldError('Account Number', 'depositCheckingAccountNumberInvalid' | CMSValue)\"><p qa-label=\"checkingAccountNumberInvalidMessage\" ng-bind=\"'depositCheckingAccountNumberInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/bank-name.html',
    "<div class=\"field\" qa-label=\"bank-name\" ng-class=\"{ focused: bankNameFocus && !(depositFrm.bankName.$invalid && data.errorBankName) }\"><div class=\"field-label\"><label qa-label=\"bankNameLabel\" for=\"bankName\" ng-bind=\"'depositBankNameLabel' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.bankName.$invalid && data.errorBankName}\"></label></div><div class=\"field-input\"><span class=\"input-container\"><input name=\"bankName\" id=\"bankName\" ng-model=\"depositDataModel.bankName\" ng-class=\"{'bank-name-input-invalid': depositFrm.bankName.$invalid && data.errorBankName}\" ng-blur=\"events.completedFieldAndBlursAway('Bank Name', depositFrm.bankName); bankNameFocus = false\" ng-focus=\"bankNameFocus = true\" ng-disabled=\"data.bankNameDisabled\" ng-model-options=\"{ updateOn: 'blur', debounce: { 'blur': 0 } }\" ng-required=\"depositFrm.routingNumber.$valid\" type=\"text\"></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn\" ng-class=\"{'error-tooltip': data.errorBankName}\" ng-if=\"depositFrm.bankName.$invalid\" ng-init=\"events.newAccountFieldError('Bank Name', 'depositCheckingBankNameInvalid' | CMSValue)\"><p qa-label=\"checkingBankNameInvalidMessage\" ng-bind=\"'depositCheckingBankNameInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/bank-routing-number.html',
    "<div class=\"field\" qa-label=\"bank-routing-number\" ng-class=\"{focused: bankRoutingFocus && !(depositFrm.routingNumber.$invalid && (depositFrm.routingNumber.$touched || depositFrm.$submitted))}\"><div class=\"field-label\"><label qa-label=\"bankRoutingNumber\" for=\"routingNumber\" ng-bind=\"'depositRoutingNumberLabel' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.routingNumber.$invalid && (depositFrm.routingNumber.$touched || depositFrm.$submitted)}\"></label></div><div class=\"field-input field-input-banking-number\"><span class=\"input-container\"><input qa-label=\"bankRoutingNumberInput\" name=\"routingNumber\" id=\"routingNumber\" ng-model=\"depositDataModel.routingNumber\" ng-change=\"events.routingNumberOnChange(depositDataModel.routingNumber)\" ng-model-options=\"{ updateOn: 'blur', debounce: { 'blur': 0 } }\" ng-pattern=\"data.numberPattern\" ng-focus=\"bankRoutingFocus = true\" ng-blur=\"events.completedFieldAndBlursAway('Routing Number', depositFrm.routingNumber); bankRoutingFocus = false\" ng-required=\"true\" ng-keypress=\"events.onlyNumbers($event)\" minlength=\"9\" maxlength=\"9\" autocomplete=\"off\" type=\"tel\"></span><additional-info><span qa-label=\"bankRoutingNumberHelperImage\" class=\"card-imgs routing\"></span></additional-info></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.routingNumber.$invalid && (depositFrm.routingNumber.$touched || depositFrm.$submitted)\" ng-init=\"events.newAccountFieldError('Routing Number', 'depositRoutingNumberInvalid' | CMSValue)\"><p qa-label=\"bankRoutingNumberInvalidMessage\" ng-bind=\"'depositRoutingNumberInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/card-description-text.html',
    "<div class=\"disclaimer\" qa-label=\"credit-debit-card-intro-disclaimer\">{{'depositCreditDebitInformation' | CMSValue: 'dmaDepositLabels' | trust}} <span ng-if=\"$root.isFdrApp\">{{'depositCardsAccepted' | CMSLabels: 'dmaDepositLabels'}}</span></div>"
  );


  $templateCache.put('src/templates/deposit/fields/card-exp-date-and-cvn.html',
    "<div><div class=\"field\" qa-label=\"card-expiration-date\"><div class=\"field-label\"><label qa-label=\"cardExpirationDateLabel\" for=\"cardExpirationMonth\" ng-bind=\"'depositNewCardExpirationDateLabel' | CMSValue : null\" ng-class=\"{errorLabel: (depositFrm.cardExpMonth.$invalid && depositFrm.cardExpMonth.$touched) || (depositFrm.cardExpYr.$invalid && depositFrm.cardExpYr.$touched), focused: (expMonthFocused || expYearFocused) && !((depositFrm.cardExpMonth.$invalid && depositFrm.cardExpMonth.$touched) || (depositFrm.cardExpYr.$invalid && depositFrm.cardExpYr.$touched))}\"></label></div><div class=\"field-input card-exp\"><span class=\"input-container\"><input qa-label=\"cardExpirationMonthInput\" id=\"cardExpirationMonth\" class=\"tiny\" name=\"cardExpMonth\" ng-focus=\"expMonthFocused = true\" placeholder=\"MM\" ng-required=\"true\" pattern=\"(12|([0][1-9])|([1][0-2]|([1-9])))\" minlength=\"1\" maxlength=\"2\" tvg-limit-to=\"2\" type=\"number\" ng-blur=\"events.FieldFilled(depositFrm.cardExpMonth); expMonthFocused = false \" ng-keypress=\"events.onlyNumbers($event)\" ng-model=\"depositDataModel.expirationMonth\"> <span>/</span> <input qa-label=\"cardExpirationYearInput\" id=\"cardExpirationYear\" class=\"tiny\" name=\"cardExpYr\" ng-focus=\"expYearFocused = true\" placeholder=\"YY\" ng-required=\"true\" min=\"{{data.expirationDateValues.min}}\" max=\"{{data.expirationDateValues.max}}\" minlength=\"2\" maxlength=\"2\" tvg-limit-to=\"2\" ng-blur=\"events.FieldFilled(depositFrm.cardExpYr); expYearFocused = false\" type=\"number\" ng-keypress=\"events.onlyNumbers($event)\" pattern=\"\\d*\" ng-model=\"depositDataModel.expirationYear\"></span></div><div class=\"field-tooltip card-exp\"><div qa-label=\"invalidMonthMessage\" class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.cardExpMonth.$invalid && (depositFrm.cardExpMonth.$touched || depositFrm.$submitted)\"><p ng-bind=\"('depositNewCardExpirationDateMonthInvalid' | CMSValue : null)\"></p></div><div qa-label=\"invalidYearMessage\" class=\"tvg-tooltip-ctn error-tooltip error-tooltip-year\" ng-if=\"depositFrm.cardExpYr.$invalid && depositFrm.cardExpYr.$touched && !(depositFrm.cardExpMonth.$invalid && (depositFrm.cardExpMonth.$touched || depositFrm.$submitted))\"><p ng-bind=\"('depositNewCardExpirationDateYearInvalid' | CMSValue : {startYear:currentYear, endYear:(currentYear +50)})\"></p></div></div></div><div class=\"field field-cvv\" ng-class=\"{focused: ccvFocused && !(depositFrm.cardCvn.$invalid && (depositFrm.cardCvn.$touched || depositFrm.$submitted))}\"><div class=\"field-label\"><label qa-label=\"ccCvvLabel\" for=\"cardCvv\" ng-bind=\"'depositCardVerificationNumberLabel' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.cardCvn.$invalid && (depositFrm.cardCvn.$touched || depositFrm.$submitted)}\"></label></div><div qa-label=\"securityNumberSection\" class=\"field-input cardCvn\"><span class=\"input-container\"><input qa-label=\"ccCvvInput\" id=\"cardCvv\" class=\"small\" name=\"cardCvn\" ng-required=\"true\" maxlength=\"3\" minlength=\"3\" tvg-limit-to=\"3\" ng-pattern=\"data.numberPattern\" ng-focus=\"ccvFocused = true\" ng-model=\"depositDataModel.cardSecurityNumber\" ng-model-options=\"{ updateOn: 'blur', debounce: { blur: 0 } }\" type=\"tel\" ng-blur=\"events.FieldFilled(depositFrm.cardCvn, 'new'); ccvFocused = false\" ng-keypress=\"events.onlyNumbers($event)\" pattern=\"\\d*\"><additional-info><span qa-label=\"ccCvvImage\" class=\"card-imgs cvv\"></span></additional-info></span></div><div class=\"field-tooltip cardCvn\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.cardCvn.$invalid && (depositFrm.cardCvn.$touched || depositFrm.$submitted)\"><p qa-label=\"ccInvalidCvvErrorMessage\" ng-bind=\"'depositNewCardCvnInvalid' | CMSValue : null\"></p></div></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/card-number-input.html',
    "<div class=\"field\" qa-label=\"card-number\" ng-class=\"{focused: bankNameFocus && !(depositFrm.cardNumber.$invalid && (depositFrm.cardNumber.$touched || depositFrm.$submitted))}\"><div class=\"field-label\"><label qa-label=\"cardNumberLabel\" for=\"cardNumber\" ng-bind=\"'depositNewCardNumberLabel' | CMSValue : null\" ng-class=\"{ errorLabel: depositFrm.cardNumber.$invalid && (depositFrm.cardNumber.$touched || depositFrm.$submitted)}\"></label></div><div class=\"field-input\"><span class=\"input-container\"><input qa-label=\"cardNumberInput\" autocomplete=\"cc-number\" class=\"cardNumber\" id=\"cardNumber\" name=\"cardNumber\" ng-required=\"true\" maxlength=\"16\" minlength=\"16\" tvg-limit-to=\"16\" type=\"tel\" ng-focus=\"bankNameFocus = true\" ng-blur=\"events.FieldFilled(depositFrm.cardNumber); bankNameFocus = false\" ng-pattern=\"!data.editCardForm ? data.numberPattern : ''\" ng-keypress=\"events.onlyNumbers($event)\" ng-keyup=\"events.scrollOnkeyPress($event)\" ng-model=\"depositDataModel.cardNumber\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" ng-readonly=\"data.editCardForm\" ng-disabled=\"data.editCardForm\"></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.cardNumber.$invalid && (depositFrm.cardNumber.$touched || depositFrm.$submitted)\"><p qa-label=\"invalidCardNumberMessage\" ng-bind=\"'depositNewCardNumberInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/card-type-selector.html',
    "<div class=\"field\" qa-label=\"card-type\"><div class=\"field-label\"><label qa-label=\"ccCardTypeLabel\" ng-bind=\"'depositNewCardTypeLabel' | CMSValue : null\"></label></div><div><span class=\"input-container minw270\"><toggle-options class=\"cards\"><button type=\"button\" class=\"card-type-button\" qa-label=\"type-{{card.name}}\" ng-repeat=\"card in data.selectedPayOption.subTypes track by $index\" ng-click=\"events.subTypeCardChanged(card)\" ng-class=\"{selected: depositDataModel.selectedCardType.name == card.name}\">{{card.name}}</button></toggle-options><span class=\"cc-img-cards\"><span class=\"visa-icon\"></span> <span class=\"mastercard-icon\"></span></span></span></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/card-verification-number.html',
    "<section-title title=\"{{('cvv-section-title' | CMSLabels: 'dmaDepositLabels')}}\" index=\"3\" qalabel=\"securityNumberTitle\"></section-title><div qa-label=\"securityNumberSection\" class=\"field cardCvn-ctn\"><div class=\"field-label\"><label qa-label=\"ccCvvLabel\" ng-class=\"{errorLabel: depositFrm.cardCvn.$invalid && (depositFrm.cardCvn.$touched || depositFrm.$submitted)}\" for=\"cardCvn\" ng-bind=\"'depositCardVerificationNumberLabel' | CMSValue : null\"></label></div><div class=\"field-input cardCvn\"><span class=\"input-container\"><input qa-label=\"ccCvvInput\" git id=\"cardCvn\" name=\"cardCvn\" ng-required=\"true\" maxlength=\"3\" minlength=\"3\" ng-pattern=\"data.numberPattern\" ng-blur=\"events.FieldFilled(depositFrm.cardCvn, 'added')\" ng-model=\"depositDataModel.cardSecurityNumber\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 500, blur: 0 } }\" type=\"text\" pattern=\"\\d*\"></span><additional-info><span qa-label=\"ccCvvImage\" class=\"card-imgs cvv\"></span></additional-info></div><div class=\"field-tooltip cardCvn\"><div class=\"tvg-tooltip-ctn error-tooltip\" ng-if=\"depositFrm.cardCvn.$invalid && (depositFrm.cardCvn.$touched || depositFrm.$submitted)\"><p qa-label=\"ccInvalidCvvErrorMessage\" ng-bind=\"'depositNewCardCvnInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/deposit-amount-input.html',
    "<div class=\"dma-amount-ctn\" qa-label=\"deposit-amount\"><div class=\"dma-amount-table\"><div class=\"row\"><span class=\"cell w155\"><toggle-options><button ng-repeat=\"amountOption in data.availableAmountOptions track by $index\" ng-class=\"{selected: depositDataModel.amount == amountOption}\" class=\"amount-button\" type=\"button\" qa-label=\"amount-button-{{amountOption}}\" ng-click=\"events.handleDefaultAmountButtonClick(amountOption)\">${{amountOption}}</button></toggle-options></span><span class=\"cell minw30 amount-divider\">or <span class=\"amount-dollar-label\">$</span></span> <span class=\"cell align-right amount-input-ctn\"><input qa-label=\"amount-input\" money-formater class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other amount\" ng-min=\"{{depositDataModel.min||0}}\" ng-max=\"{{events.getMax()}}\" num-length=\"5\" step=\"any\" ng-model=\"depositDataModel.amount\" ng-model-options=\"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 }}\" ng-required=\"true\" ng-change=\"events.handleAmountInputChange()\" ng-blur=\"events.handleAmountInputBlur(); inputIsNowFocused = false\" restrict-chars ng-focus=\"inputIsNowFocused = true\" ng-class=\"{\n" +
    "                        inputIsInvalid: $root.isFdrApp && depositFrm.amount.$invalid && depositFrm.$submitted,\n" +
    "                        inputIsFocused:\n" +
    "                            ($root.isFdrApp && !depositFrm.amount.$invalid && !!inputIsNowFocused)\n" +
    "                            || (!$depositFrm.amount.$dirty && !!inputIsNowFocused)\n" +
    "                    }\"></span></div></div><div class=\"row non-table amount-errors-ctn\"><div ng-init=\"events.sendOtherAmountErrorToGTM('Minimum', 'min')\" qa-label=\"error-minimum\" ng-if=\"depositFrm.amount.$error.min && depositDataModel.min > 0 && !depositDataModel.maxOverflow\" class=\"js-error-label error-label minimum\" ng-class=\"{invalidAmount: depositFrm.amount.$invalid && (depositFrm.amount.$touched || depositFrm.$submitted)}\">Minimum {{(depositDataModel.min) | currency}}</div><div ng-init=\"events.sendOtherAmountErrorToGTM('Maximum', 'max')\" qa-label=\"error-maximum\" ng-if=\"depositFrm.amount.$error.max && depositDataModel.max > 0 &&\n" +
    "            !depositDataModel.maxOverflow && !depositFrm.amount.$error.min && (!events.isSightlinePayment() || (events.isSightlinePayment() && !depositDataModel.sightlineNoBalance && !events.isSightlineInvalid()))\" class=\"js-error-label error-label maximum\" ng-class=\"{invalidAmount: depositFrm.amount.$invalid && (depositFrm.amount.$touched || depositFrm.$submitted)}\">Maximum {{(events.getMax()) | currency}}</div><div ng-init=\"events.sendOtherAmountErrorToGTM('Maximum amount reached')\" ng-if=\"depositFrm.amount.$error.max && ((depositDataModel.max == 0 || depositDataModel.maxOverflow) && !events.isSightlinePayment())\" qa-label=\"error-maximum-amount\" class=\"js-error-label error-label maximum\" ng-class=\"{invalidAmount: depositFrm.amount.$invalid && (depositFrm.amount.$touched || depositFrm.$submitted)}\">Maximum amount reached</div><div ng-init=\"events.sendOtherAmountErrorToGTM('Maximum amount reached')\" ng-if=\"(depositFrm.amount.$error.max || depositFrm.amount.$error.min) && events.isSightlinePayment() && (!!depositDataModel.sightlineNoBalance || events.isSightlineInvalid()) \" qa-label=\"error-maximum-amount\" class=\"js-error-label error-label maximum\" ng-class=\"{invalidAmount: depositFrm.amount.$invalid && (depositFrm.amount.$touched || depositFrm.$submitted)}\">The amount entered is greater than your available balance.</div><div ng-init=\"events.sendOtherAmountErrorToGTM('Required Field')\" qa-label=\"error-required\" ng-if=\"!depositFrm.amount.$error.max && !depositFrm.amount.$error.min && depositFrm.amount.$invalid && (depositFrm.amount.$touched || depositFrm.$submitted)\" class=\"js-error-label error-label\">Required Field</div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/deposit-total-cost.html',
    "<label ng-if=\"data.fee.calculatingFees && !$root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label> <label ng-if=\"data.retryFetchingFees && !$root.isFdrApp\" ng-click=\"events.updateTotalCosts(depositDataModel, true)\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees-error' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"deposit-summary\" class=\"deposit__summary\"><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('deposit-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                      ((data.fee.netAmount | currency: '$') || '$--') | trust )\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('deposit-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                      ((data.fee.fee | currency: '$') || '$--') | trust ) + ('</span>')\" ng-class=\"{ 'red bold': displays.sightlineBalanceExceeded()}\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-discount\" ng-bind-html=\"(('deposit-summary-discount' | CMSLabels: 'dmaDepositLabels' | trust) + ' ' +\n" +
    "                      ((data.fee.feeDiscount | currency: '$') || '$--') | trust )\"></li><li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('deposit-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                              ((data.fee.transactionTotal | currency: '$') || '$--') | trust ) + ('</span>')\" ng-class=\"{ red: displays.sightlineBalanceExceeded()}\"></strong></li></ul><label ng-if=\"data.fee.calculatingFees && $root.isFdrApp\" class=\"activity-info fee fee-calculating\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label> <label ng-if=\"data.retryFetchingFees && $root.isFdrApp\" ng-click=\"events.updateTotalCosts(depositDataModel, true)\" class=\"activity-info fee fee-error\" ng-bind-html=\"'deposit-summary-calculation-fees-error' | CMSLabels: 'dmaDepositLabels' | trust\"></label>"
  );


  $templateCache.put('src/templates/deposit/fields/deposit-type-selector.html',
    "<deposit-options-container class=\"dma-nav dma-nav-tabs\" qa-label=\"deposit-options\"><deposit-option ng-repeat=\"option in data.depositOptions track by $index\" ng-click=\"events.selectOption(option)\" ng-class=\"{selected:data.selectedPayOption.ftype === option.ftype}\"><span><p ng-class=\"{bold:data.selectedPayOption.ftype === option.ftype}\" qa-label=\"{{::option.ftype}}\">{{option.name}}</p></span></deposit-option></deposit-options-container>"
  );


  $templateCache.put('src/templates/deposit/fields/driver-license-number.html',
    "<div class=\"field\" qa-label=\"driver-license-number\" ng-class=\"{focused: driverLicenceNumber && !(depositFrm.licenseNumber.$invalid && (depositFrm.licenseNumber.$touched || depositFrm.$submitted))}\"><div class=\"field-label\"><label qa-label=\"driverLicenceLabel\" for=\"licenseNumber\" ng-bind=\"'depositDriverLicenseNumberLabel' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.licenseNumber.$invalid && (depositFrm.licenseNumber.$touched || depositFrm.$submitted)}\"></label></div><div class=\"field-input\"><span class=\"input-container\"><!-- Avoid Chrome autofill --> <input name=\"fakeusername\" type=\"text\" style=\"position: absolute; left: -9999px;\" tabindex=\"-1\"> <input qa-label=\"driverLicenceInput\" name=\"licenseNumber\" id=\"licenseNumber\" ng-model=\"depositDataModel.licenseNumber\" ng-focus=\"driverLicenceNumber = true\" ng-blur=\"events.completedFieldAndBlursAway('Driver License Number', depositFrm.licenseNumber); driverLicenceNumber = false\" pattern=\"^[a-zA-Z0-9]+(-?[a-zA-Z0-9])*$\" ng-model-options=\"{ updateOn: 'blur', debounce: { 'blur': 0 } }\" ng-required=\"true\" minlength=\"3\" autocomplete=\"off\" type=\"text\"></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" qa-label=\"invalidLicenseNr\" ng-if=\"depositFrm.licenseNumber.$invalid && (depositFrm.licenseNumber.$touched || depositFrm.$submitted)\" ng-init=\"events.newAccountFieldError('Driver License Number', 'depositDriverLicenseNumberInvalid' | CMSValue)\"><p ng-bind=\"'depositDriverLicenseNumberInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/driver-license-state.html',
    "<div class=\"field\" qa-label=\"driver-license-state\"><div class=\"field-label\"><label qa-label=\"driverLicenceStateLabel\" for=\"licenseState\" ng-bind=\"'depositDriverLicenseStateLabel' | CMSValue : null\" ng-class=\"{errorLabel: depositFrm.licenseState.$invalid && depositFrm.$submitted, focused: stateSelectedOptionFocused}\"></label></div><div class=\"field-input\"><span class=\"input-container\"><select-container qa-label=\"dlStateContainer\" class=\"others\" ng-class=\"{'focused': stateSelectedOptionFocused, 'select-error': depositFrm.$submitted && depositFrm.licenseState.$invalid}\"><select qa-label=\"driverLicenceStateSelect\" class=\"card\" id=\"licenseState\" name=\"licenseState\" ng-model=\"depositDataModel.stateSelectedOption\" ng-focus=\"stateSelectedOptionFocused = true\" ng-blur=\"stateSelectedOptionFocused = false\" ng-options=\"state.name for state in data.states\" ng-required=\"true\"><option value=\"\" disabled=\"disabled\">-- Please select a state --</option></select> <span qa-label=\"driverLicenceStateInputContent\" ng-bind=\"depositDataModel.stateSelectedOption.name || ('depositDriverLicenseStateLabel' | CMSValue : null)\"></span></select-container></span></div><div class=\"field-tooltip\"><div class=\"tvg-tooltip-ctn error-tooltip\" qa-label=\"invalidLicenseState\" ng-if=\"depositFrm.licenseState.$invalid && depositFrm.$submitted\" ng-init=\"events.newAccountFieldError('Driver License State', 'depositDriverLicenseInvalid' | CMSValue)\"><p ng-bind=\"'depositDriverLicenseStateInvalid' | CMSValue : null\"></p></div></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/quick-deposit-default.html',
    "<div class=\"field\" qa-label=\"quick-deposit-default\"><div class=\"field-label\"><label for=\"quickDefaultMethod\" qa-label=\"quick-deposit-default-label\" ng-bind=\"'depositDataModelDepositDefault' | CMSValue : null\"></label></div><div class=\"field-input quick-default-select\"><span class=\"input-container\"><select-container class=\"deposits-default-payment-container\"><select qa-label=\"quick-deposit-default-select\" class=\"deposits-default-payment\" id=\"quickDefaultMethod\" name=\"quickDefaultMethod\" ng-model=\"depositDataModel.isDefaultPayment\" ng-options=\"options.value as options.name for options in data.defaultPaymentValues\" ng-change=\"events.defaultPaymentChanged(depositDataModel.isDefaultPayment)\"></select> <span ng-bind=\"depositDataModel.isDefaultPayment ? 'Yes' : 'No'\"></span></select-container></span></div></div>"
  );


  $templateCache.put('src/templates/deposit/fields/quick-deposit-selector.html',
    "<div class=\"field\"><span class=\"input-container quick-deposit-selector\"><ul class=\"deposit-card-options quick-deposit-options\" qa-label=\"quick-deposit-options\"><li class=\"quick-deposit-options--title\" ng-repeat=\"(key, card) in data.depositOptions | orderBy:['isDefaultPayment', '-lastUsedDate'] track by $index\" ng-class=\"{'sightline-card-ctn': key === 'TVG Prepaid Card' && data.depositOptions.length > 1 }\" ng-if=\"(card.ftype === 'APPL' && displays.isApplePayInQuickDepositEnabled()) || card.ftype !== 'APPL'\" qa-label=\"payment-type-cards-list\"><span ng-bind=\"key\"></span><div class=\"card\" qa-label=\"quick-deposit-card\"><label ng-class=\"{\n" +
    "                                        'disabled': events.isSLNDeclinedCard(card),\n" +
    "                                        'expired': card.isExpired, 'active': depositDataModel.selectedOnFile === card ||\n" +
    "                                        ((card.ftype === 'IBC'|| card.ftype === 'ACH') && depositDataModel.selectedOnFile.achId === card.achId) ||\n" +
    "                                        ((card.ftype === 'CC') && depositDataModel.selectedOnFile.id === card.id), 'option-with-image': displays.getCardImage(card) !== '' }\"><div class=\"card-icon\" ng-class=\"displays.getCardImage(card)\"></div><div ng-if=\"card.ftype === 'APPL'\" class=\"card-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 165.5 106\"><defs/><path d=\"M150.7 0H13.1a71 71 0 00-4.5.3A10.5 10.5 0 003 3.1 10 10 0 00.3 8.6 20.6 20.6 0 000 13v79.7a70.3 70.3 0 00.3 4.6 10.5 10.5 0 002.8 5.5 9.9 9.9 0 005.5 2.8 21 21 0 004.5.3H152.4a79.7 79.7 0 004.5-.3 10.5 10.5 0 005.5-2.8 10 10 0 002.8-5.5 20.6 20.6 0 00.3-4.6v-78-1.7a63 63 0 00-.3-4.5 10.4 10.4 0 00-2.8-5.5A10 10 0 00157 .3a20.8 20.8 0 00-4.5-.3h-1.7z\"/><path fill=\"#FFF\" d=\"M150.7 3.5h1.7a67.4 67.4 0 014 .3 6.4 6.4 0 015.4 5.4 17.6 17.6 0 01.2 4v79.6a59.7 59.7 0 01-.3 4 6.9 6.9 0 01-1.8 3.6 6.4 6.4 0 01-3.6 1.8 18 18 0 01-4 .2H13.2a75 75 0 01-3.9-.2 7 7 0 01-3.6-1.8 6.4 6.4 0 01-1.8-3.6 17.5 17.5 0 01-.3-4V13.1a66.6 66.6 0 01.3-3.9 7 7 0 011.8-3.6 6.4 6.4 0 013.6-1.8 17.6 17.6 0 014-.3h137.5\"/><path d=\"M45.2 35.6a9.2 9.2 0 002.1-6.5 9.2 9.2 0 00-8.2 9.4c2.3.2 4.6-1.1 6-2.9M47.3 39c-3.4-.2-6.3 1.9-7.9 1.9-1.6 0-4-1.8-6.8-1.8a10 10 0 00-8.4 5.2c-3.7 6.2-1 15.5 2.5 20.6 1.8 2.6 3.8 5.3 6.6 5.2 2.5 0 3.5-1.6 6.7-1.6 3.1 0 4 1.6 6.7 1.6 2.9 0 4.6-2.5 6.3-5 2-3 2.8-5.7 2.9-5.9 0 0-5.5-2-5.5-8.3 0-5.2 4.2-7.7 4.4-7.8a9.7 9.7 0 00-7.5-4.1M76.7 32c7.4 0 12.5 5 12.5 12.4S84 56.9 76.5 56.9h-8v13h-6v-38h14.2zm-8.3 20h6.8c5 0 8-2.8 8-7.6s-3-7.5-8-7.5h-6.8v15zM90.7 62c0-4.9 3.7-7.8 10.3-8.2l7.6-.4v-2.2c0-3-2.1-4.9-5.6-4.9-3.3 0-5.3 1.6-5.8 4h-5.4c.4-5 4.6-8.6 11.4-8.6 6.7 0 11 3.6 11 9v19.1h-5.4v-4.5h-.2c-1.6 3-5 5-8.7 5-5.4 0-9.2-3.4-9.2-8.3zm17.9-2.5v-2.2l-6.8.4c-3.4.3-5.3 1.8-5.3 4.1 0 2.4 2 4 5 4 4 0 7-2.7 7-6.3zM119.3 80v-4.6l1.9.1c2.6 0 4-1.1 4.9-4l.5-1.6-10-27.7h6.2l7 22.5 7-22.5h6l-10.3 29c-2.4 6.8-5.1 9-10.8 9l-2.4-.2z\"/></svg></div><div ng-class=\"(displays.getCardImage(card) !== '' || card.ftype === 'APPL') && 'card-data-container'\"><strong ng-if=\"card.ftype === 'APPL'\" class=\"center-applepay\" qa-label=\"applepay-card-type\" ng-bind=\"('quickDepositName' | CMSLabels: 'applepayLabels' | trust)\"></strong> <strong ng-if=\"card.ftype === 'CC'\" qa-label=\"cc-card-type\" ng-bind=\"::card.typeName + ' Card'\"></strong> <strong ng-if=\"card.ftype === 'IBC' || card.ftype === 'ACH'\" qa-label=\"bc-bank-name\" ng-bind=\"::$root.isFdrApp ? card.bankName.toLowerCase() : card.bankName\"></strong> <strong ng-if=\"card.ftype === 'SLN'\" qa-label=\"slp-card-label\" ng-bind=\"::displays.getSLPLabel(card)\"></strong><div ng-if=\"card.ftype === 'ACH' || card.ftype === 'IBC'\" qa-label=\"bc-bank-acc-number\">****{{(events.slicedCard(card.bankAccNumber))}}</div><div ng-if=\"card.ftype === 'CC' || card.ftype === 'SLN'\"><span ng-if=\"card.isExpired\" class=\"expired-card-label\" qa-label=\"cc-expired-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-bind=\"::card.cardNumberExt\" qa-label=\"cc-card-number\"></span> (<span ng-bind=\"::card.expirationDate\" qa-label=\"cc-card-date\"></span>) <span ng-if=\"card.ftype === 'SLN'\" qa-label=\"cc-card-date\">through TVG Pre Paid Card</span></div><input type=\"radio\" ng-if=\"!events.isSLNDeclinedCard(card)\" ng-model=\"depositDataModel.selectedOnFile\" ng-click=\"events.selectAccount(card)\" ng-change=\"events.selectOnFileChanged(depositDataModel.selectedOnFile)\" ng-value=\"card\" qa-label=\"card-radio\"></div></label></div></li><li class=\"card paypal-add-funds\" ng-if=\"displays.isPaypalInQuickDepositEnabled()\" qa-label=\"quick-deposit-paypal-card\"><label qa-label=\"paypal-add-funds\" ng-click=\"events.addQuickDepositFunds('PAY')\"><div class=\"card-icon paypal-card\" ng-if=\"displays.getCardImage('PAYPAL') !== ''\"></div><div ng-class=\"displays.getCardImage('PAYPAL') !== '' && 'card-data-container'\"><strong>PayPal</strong><div>Deposit With PayPal</div></div></label></li></ul></span></div>"
  );


  $templateCache.put('src/templates/deposit/quick-deposit.html',
    "<div class=\"tvg-deposit quick-deposit\" ng-controller=\"DepositController\" ng-init=\"data.isQuickDeposit=true\" ng-class=\"{loading: data.loading}\" qa-label=\"quick-deposit-modal\"><div class=\"alert-box error clearfix\" ng-if=\"events.anyCardsExpired()\" qa-label=\"expiredCardMessage\"><i class=\"tvg-icon-error\"></i><div class=\"content\" qa-label=\"credit-card-expired-message\">It seems your card has expired please update your credit card info.</div></div><div class=\"alert-box warning clearfix\" ng-if=\"displays.isDepositLoaded() && events.allCardsDeclined()\" qa-label=\"declinedCardMessage\"><i class=\"tvg-icon-warning\"></i><div class=\"content ng-scope\" qa-label=\"credit-card-declined-message\"><!-- Show only in betSlip --><p ng-if=\"events.isBetslip() || events.isIos()\" class=\"d-inline\" ng-bind=\"('betSlipAllCardDeclinedWarning' | CMSLabels: 'cardErrorRedirect' | trust)\" qa-label=\"credit-card-declined-message-body\"></p><!-- Default template--><p ng-if=\"!events.isBetslip() && !events.isIos()\" class=\"d-inline\" ng-bind=\"('dmaAllCardDeclinedWarning' | CMSLabels: 'cardErrorRedirect' | trust)\" qa-label=\"credit-card-declined-message-body\"></p><p ng-if=\"!events.isBetslip() && !events.isIos()\" class=\"d-inline fake-link\" ng-click=\"events.goToFullDeposit()\" ng-bind=\"('dmaAllCardDeclinedWarningLink' | CMSLabels: 'cardErrorRedirect' | trust)\" qa-label=\"credit-card-declined-message-link\"></p></div></div><dw-info-dialog ng-bind=\"'depositInitialDataErrorMessage' | CMSValue : null\" ng-if=\"!data.loading && (displays.isAllRequestCardsFailed() || !displays.isDepositLoaded()) && !$root.isFdrApp\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\" qa-label=\"quick-deposit-error-message\"></dw-info-dialog><dw-info-dialog-fdr ng-if=\"!data.loading && (displays.isAllRequestCardsFailed() || !displays.isDepositLoaded()) && $root.isFdrApp\" heading-text=\"Something went wrong\" button-text=\"Refresh Page\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\" button-action=\"location.reload()\">{{'depositInitialDataErrorMessage' | CMSValue : null}}</dw-info-dialog-fdr><div id=\"inject-no-payment-methods\" ng-if=\"!$root.isFdrApp && !data.depositOptions.length && !events.isBetslip() && !events.isIos() && !displays.isAllRequestCardsFailed() && displays.isDMAInjectNoPaymentQuickDepositEnabled()\"></div><dw-info-dialog ng-if=\"!$root.isFdrApp && displays.isDepositLoaded() && !data.depositOptions.length && !events.isBetslip() && !events.isIos() && !displays.isAllRequestCardsFailed() && !displays.isDMAInjectNoPaymentQuickDepositEnabled()\" action=\"events.goToFullDeposit\" action-text=\"Add New Deposit Options\" qa-label=\"quick-deposit-no-options\">You Don't Have Any Deposit Options On File.</dw-info-dialog><dw-info-dialog-fdr ng-if=\"$root.isFdrApp && displays.isDepositLoaded() && !data.depositOptions.length && !events.isBetslip() && !events.isIos() && !displays.isAllRequestCardsFailed()\" button-action=\"events.goToFullDeposit\" heading-text=\"No Results\" button-text=\"Add New Deposit Options\" qa-label=\"quick-deposit-no-options\" class=\"quick-deposit-no-options\">You don't have any deposit options on file.</dw-info-dialog-fdr><dw-info-dialog ng-if=\"displays.isDepositLoaded() && !data.depositOptions.length && (events.isBetslip() || events.isIos()) && !displays.isAllRequestCardsFailed()\" qa-label=\"quick-deposit-no-options\">You Don't Have Any Deposit Options On File. {{'quickDepositNoRedirect' | CMSValue : null}}</dw-info-dialog><form ng-show=\"displays.isDepositLoaded() && data.depositOptions.length\" class=\"deposit-form\" name=\"depositFrm\" ng-submit=\"depositDataModel.selectedOnFile.ftype ==='APPL' ?\n" +
    "            events.onApplePayDeposit() :\n" +
    "            events.makeDeposit(depositFrm)\" ng-class=\"{loading: (data.makingDeposit || data.fetchingInfo || data.activePoller)}\" novalidate qa-label=\"quick-deposit-form\"><section-title index=\"1\" title=\"{{'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\" qalabel=\"depositAmountTitle\" class=\"first-title\"></section-title><deposit-amount-input></deposit-amount-input><div class=\"alert-box warning clearfix\" ng-if=\"displays.isBetcashLimitExceeded()\"><i class=\"tvg-icon-error\"></i><div class=\"content\" qa-label=\"no-further-deposits-message\">No further BetCash deposits are permitted for this period.</div></div><div class=\"link-text\" ng-click=\"events.goToFullDeposit()\" ng-if=\"displays.isAddNewDepositOptionsVisible()\" qa-label=\"link-to-deposits\">Add New Deposit Options</div><div ng-if=\"depositDataModel.isAvailable != false\"><div ng-if=\"depositDataModel.isPending == true\"><dw-info-dialog ng-bind=\"'depositBetCashPendingMessageText' | CMSValue : null\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\" qa-label=\"betcash-pending-message\"></dw-info-dialog></div><section-title index=\"2\" title=\"{{'select-quick-deposit-account-title' | CMSLabels: 'dmaDepositLabels'}}\" qalabel=\"quickDepositAccountTitle\" class=\"first-title\"></section-title><quick-deposit-selector></quick-deposit-selector><quick-deposit-default></quick-deposit-default><div ng-if=\"data.showAchDepositLimitExceeded\"><dw-info-dialog ng-bind=\"'depositsBetcashPeriodLimitExceeded' | CMSValue : null\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\" qa-label=\"betcash-period-exceed-message\"></dw-info-dialog></div><div ng-if=\"!data.showAchDepositLimitExceeded\"><div ng-repeat=\"field in data.forms[depositDataModel.selectedOnFile.ftype || depositDataModel.selectedOnFile]\"><div ng-include=\"'src/templates/deposit/fields/' + field + '.html'\" data-qa-label=\"{{field + '-section'}}\" ng-class=\"{cardCvv: field === 'card-verification-number'}\"></div></div><div class=\"sightline sightline--quick-deposit clearfix\" ng-if=\"depositDataModel.selectedOnFile.ftype === 'SLN'\"><div class=\"sightline--quick-deposit__error alert-box error clearfix\" ng-if=\"quickDepositSightlineError\"><i class=\"tvg-icon-error\"></i><div class=\"content\" qa-label=\"slp-error-message\">We're having some troubles with TVG Pre Paid Card right now. Please try again.</div></div></div><section-title ng-if=\"!$root.isFdrApp\" index=\"{{ depositDataModel.selectedOnFile.ftype === 'CC' || depositDataModel.selectedCardType.type === 'SLN'? '4' : '3' }}\" qalabel=\"reviewTitle\" title=\"{{'review-and-authorize-title' | CMSLabels: 'dmaDepositLabels'}}\"></section-title><deposit-total-cost ng-if=\"!data.calculatingFees && depositDataModel.isPending != true && !quickDepositSightlineError && !$root.isFdrApp\"></deposit-total-cost><div class=\"field l100 vertical-spacing\" ng-if=\"depositDataModel.isAvailable != false && depositDataModel.isPending != true && depositDataModel.selectedOnFile.ftype !=='APPL'\"><button class=\"submit yellow add-funds\" ng-class=\"{disabled: depositFrm.amount.$invalid}\" ng-disabled=\"data.disabledCard || displays.allCardsDeclined() || displays.disableQuickDepositButton() || events.anyCardsExpired() || displays.isBetcashLimitExceeded() || data.responsibleGamingDelay\" type=\"submit\" qa-label=\"authorize-button\"><i class=\"tvg-icon tvg-icon-lock\"></i> <strong>{{'depositExecuteButton' | CMSValue : null}}</strong></button></div><div class=\"field l100 vertical-spacing\" ng-if=\"depositDataModel.selectedOnFile.ftype ==='APPL'\"><button qa-label=\"applepayButton\" type=\"submit\" ng-disabled=\"events.shouldDisableApplePayButton()\" class=\"applepay-deposit__button pa_0\" qa-label=\"authorize-button\" ng-bind-html=\"(('depositButton' | CMSLabels: 'applepayLabels' | trust))\"></button></div></div></div></form><div ng-if=\"displays.isDepositLoaded() && depositDataModel.isAvailable == false\"><dw-info-dialog ng-bind=\"'depositsBetcashPeriodLimitExceeded' | CMSValue : null\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\" qa-label=\"betcash-period-exceed-message\"></dw-info-dialog></div></div>"
  );


  $templateCache.put('src/templates/deposit/types/payNearMe/locations-modal.html',
    "<tvg-dma-modal class=\"paynearme__modal\" title=\"Nearest Location For Cash Deposit\" body=\"{{locationsTemplate}}\" close=\"closeLocationsModal()\"></tvg-dma-modal>"
  );


  $templateCache.put('src/templates/deposit/types/payNearMe/paynearme.html',
    "<div qa-label=\"pnm-container\" class=\"payNearMe__container\" ng-controller=\"PayNearMeCtrl as pnmCtrl\" ng-class=\"{'loading' : data.loading}\"><div class=\"before-notification\"></div><div ng-if=\"!data.showPnmIframe && !data.loading\"><section-title qalabel=\"pnmFundTitle\" title=\"Fund your account with a cash deposit at 7-Eleven or Family Dollar!\" index=\"1\"></section-title><p qa-label=\"pnmDisclaimer\" class=\"paynearme__container__info\" ng-bind-html=\"'payNearMeText' | CMSLabels: 'dmaPayNearMeLabels' | trust\"></p><p qa-label=\"pnmFaqsLabel\">Click below to get your PayNearMe PayCode. For more information, check out our <a qa-label=\"pnmFaqsLink\" ng-click=\"events.toggleFaq()\" class=\"colored__label\">PayNearMe FAQ.</a></p><button qa-label=\"pnmEnrollButton\" class=\"submit\" type=\"button\" ng-click=\"events.createPayNearMeId()\">Get PayNearMe PayCode</button><p qa-label=\"pnmNotAuthorizedStates\" ng-bind-html=\"'unauthorizedStates' | CMSLabels: 'dmaPayNearMeLabels' | trust\"></p><div qa-label=\"pnmLogo\" class=\"container-fluid paynearme__logos\"><img ng-src=\"{{data.payNearMeLogoUrl}}\"><div class=\"right__container\"><span qa-label=\"pnmFundYourAccLabel\">Fund your account with cash at</span><div class=\"paynearme__stores\"><img qa-label=\"pnm711Logo\" ng-src=\"{{data.sevenElevenLogoUrl}}\"> <span>&</span> <img qa-label=\"pnmFamilyDollarLogo\" ng-src=\"{{data.familyDollarLogoUrl}}\"></div></div></div></div><div ng-if=\"data.showPnmIframe\"><iframe qa-label=\"pnmIframe\" class=\"iframe__container\" ng-src=\"{{data.orderTrackingUrl}}\"></iframe></div></div>"
  );


  $templateCache.put('src/templates/deposit/types/sightline/enrollment.html',
    "<div class=\"sightline-enrollment__content\" ng-class=\"{'loading' : data.sightlineLoading}\"><section ng-show=\"!data.sightlineLoading\"><div class=\"alert-box blue clearfix no-padding\"><span class=\"bold show-mobile title\">How does it work ?</span> <i class=\"tvg-icon-info\"></i><div qa-label=\"sightlineEnrollmentTutorial\" class=\"content\" ng-bind-html=\"('sightlineEnrollmentTutorial'| CMSValue : null) | trust\"></div></div><div class=\"sightline-enrollment__faq tvg-icon-arrow-right\" ng-click=\"$root.isFdrApp ? events.openModals('sightlineFaqTitle', 'sightlineFaqTemplate') : null\"><span qa-label=\"sightlineFaq\">Please refer to the <a qa-label=\"sightlineFaqLink\" href=\"\" ng-click=\"!$root.isFdrApp ? events.openModals('sightlineFaqTitle', 'sightlineFaqTemplate') : null\">FAQ </a>if you have any questions about your Pre Paid Card.</span></div><div class=\"sightline-enrollment__block\"><h2 qa-label=\"sightlineHeader\" class=\"sightline-enrollment__title\">Register</h2><div class=\"flex-center\"><label qa-label=\"sightlineTermsAndCondsLabel\" class=\"checkbox blue\"><input qa-label=\"sightline-accept-terms\" type=\"checkbox\" id=\"sightline-accepted-terms\" name=\"sightline-accepted-terms\" ng-required=\"true\" ng-attr-tabindex=\"1\" ng-model=\"data.areTermsAccepted\" ng-change=\"events.toggleSightlineTerms(data.areTermsAccepted)\"> <span><i qa-label=\"sightlineCheckbox\" class=\"tvg-icon-check blue\"></i></span></label> <label for=\"sightline-accepted-terms\" class=\"inline-checkbox\"><b ng-if=\"!$root.isFdrApp\">I agree with the TVG Pre Paid Card</b> <b ng-if=\"$root.isFdrApp\">I agree with the FanDuel Pre Paid Card</b> <a qa-label=\"sightlineTerms\" target=\"_blank\" href=\"https://betfair.mycardplace.com/cholder/showContent.action?page=TVGTERMS\" class=\"external-link\">Terms and Conditions </a><b>and</b> <a qa-label=\"sightlinePrivacy\" href=\"\" class=\"external-link\" ng-click=\"events.openModals('sightlinePrivacyTitle', 'sightlinePrivacyTemplate')\">Privacy Disclosure </a>.</label></div></div><button qa-label=\"sightlineEnrollButton\" type=\"button\" class=\"btn submit-btn\" ng-disabled=\"!data.areTermsAccepted || data.isEnrollingCard\" ng-click=\"events.enrolCard()\"><i class=\"tvg-icon tvg-icon-lock\"></i> Enroll</button></section></div>"
  );


  $templateCache.put('src/templates/deposit/types/sightline/sightline.html',
    "<section qa-label=\"sln-container\" class=\"sightline_ctn\" ng-class=\"{'sightline_ctn--loading': data.sightlineLoading, 'loading': data.sightlineLoading}\"><section class=\"sightline-enrollment__content\" ng-if=\"firstTimeAddFunds\"><div qa-label=\"alert-box\" class=\"alert-box clearfix success\"><i class=\"tvg-icon-success\"></i><div qa-label=\"alert-box-content\" class=\"content\"><span class=\"bold\">Congratulations!</span> Your Pre Paid account has been approved!</div></div><h2 qa-label=\"sightlineHeader\" class=\"sightline-enrollment__title\">Fund your Card</h2></section><div class=\"sightline__newuser\" ng-if=\"isNewUser === true || isAddingFunds\"><iframe qa-label=\"slnIframe\" ng-src=\"\" ng-if=\"isAddingFunds\" name=\"sightline__iframe\" ng-show=\"loadSightlineiFrame\" class=\"sightline__iframe\"></iframe><sightline-enrollment ng-controller=\"SightlineController\" qa-label=\"sln-api-enrollment\" ng-if=\"!isAddingFunds\" ng-class=\"{'loading': data.isEnrollingCard}\"></sightline-enrollment></div><div class=\"sightline_ctn__content\" ng-if=\"isNewUser === false && !isAddingFunds\"><div class=\"sightline\"><section-title qalabel=\"prePaidCardTitle\" class=\"first-title\" title=\"Pre Paid card funds\" index=\"1\"></section-title><div class=\"flex align-center balance-wrapper\"><button qa-label=\"slnAddFunds\" type=\"button\" class=\"sightline__add-funds button__add-funds\" ng-click=\"events.addSightlineFunds()\">Fund Card</button><p class=\"sightline-balance\" qa-label=\"slnBalanceLabel\">Pre Paid Card balance: <span qa-label=\"slnBalance\" class=\"bold balance\">${{sightlineBalance}}</span></p></div></div><section-title qalabel=\"depositAmountTitle\" title=\"{{'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\" index=\"2\"></section-title><deposit-amount-input qa-label=\"deposit-amount-input\" ng-if=\"(depositDataModel.isAvailable != false) || events.existsOnFile()\"></deposit-amount-input><section-title qalabel=\"reviewTitle\" title=\"Review and Authorize\" index=\"3\"></section-title><deposit-total-cost></deposit-total-cost><div ng-if=\"depositDataModel.isPending != true\" class=\"field\"><button qa-label=\"submit-deposit\" class=\"submit authorize-deposit\" ng-disabled=\"data.makingDeposit || data.activePoller || data.responsibleGamingDelay\" type=\"submit\"><i class=\"tvg-icon tvg-icon-lock\"></i> <strong>{{'depositExecuteButton' | CMSValue : null}}</strong></button><div ng-if=\"!notifyErrors\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered tvg-tooltip-ctn general-form-error\"><p qa-label=\"incompleteFormErrorMessage\" ng-bind-html=\"'deposit-authorize-error-message' | CMSLabels: 'dmaDepositLabels' | trust\"></p></div></div></div></section>"
  );


  $templateCache.put('src/templates/deposit/utils/modal-content-directive.html',
    "<div class=\"modal-header\" qa-label=\"deposits-modal-header\"><span qa-label=\"deposits-modal-title\" class=\"modal-title\" ng-bind=\"::title\"></span> <i qa-label=\"deposits-modal-close\" class=\"icons__item\" ng-click=\"close()\">&#215;</i></div><div qa-label=\"deposits-modal-content\" class=\"modal-body\" ng-bind-html=\"::body | trust\"></div>"
  );


  $templateCache.put('src/templates/additional-info.html',
    "<span class=\"question-mark\" click-outside=\"events.closeInfo()\" ng-click=\"events.toggleInfo()\" qa-label=\"helperButton\"></span><div class=\"additionalContainer\" ng-class=\"{expanded: data.infoState}\"><div class=\"info-container\"><div class=\"additionalMessage\"><div ng-transclude></div></div></div></div>"
  );


  $templateCache.put('src/templates/banner.html',
    "<div qa-label=\"alert-box\" class=\"alert-box clearfix\" ng-class=\"vm.type\"><i class=\"tvg-icon-{{vm.type}}\"></i><alert-content qa-label=\"alert-box-content\" class=\"content\"></alert-content><div class=\"btn-group\" ng-if=\"vm.isConfirmBanner()\"><button class=\"btn btn-sm btn-primary ok\" ng-click=\"vm.close(true)\">OK</button> <button class=\"btn btn-sm btn-default cancel\" ng-click=\"vm.close()\">Cancel</button></div><i qa-label=\"alert-box-close\" class=\"tvg-icon-times close-button\" ng-click=\"vm.close()\"></i></div>"
  );


  $templateCache.put('src/templates/ccp_sightline_redirect.html',
    "<div class=\"tvg-dialog dma-redesign sightline-redirect-modal\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" style=\"text-transform: uppercase; display: block; margin-top: 3px;\" ng-bind=\"('sightlineCcpRedirectTitle' | CMSLabels: 'dmaManagementLabels' | trust)\" data-qa-label=\"slpRedirectTitle\"></span> <a href class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$close()\" data-qa-label=\"slpRedirectClose\"><i class=\"tvg-icon-close\"></i></a></div><div class=\"tvg-dialog-dma-redesign-body\" style=\"padding: 16px;\"><div style=\"margin-bottom: 20px\"><p style=\"display: inline\" ng-bind=\"('sightlineCcpRedirectText' | CMSLabels: 'dmaManagementLabels' | trust)\" data-qa-label=\"slpRedirectInfo\"></p>.</div><div class=\"sightline-enrollment__content\" style=\"margin-bottom: 10px\"><label class=\"checkbox blue\" style=\"line-height: 14px; margin-right: 10px;\"><input type=\"checkbox\" style=\"margin-right: 10px\" id=\"sightline-redirect-terms\" name=\"sightline-redirect-terms\" ng-required=\"true\" ng-attr-tabindex=\"1\" ng-model=\"areTermsAccepted\" data-qa-label=\"slpRedirectCheckbox\"> <span><i class=\"tvg-icon-check blue\"></i></span></label> <label for=\"sightline-redirect-terms\" class=\"inline-checkbox\" style=\"line-height: 14px\" data-qa-label=\"slpRedirectTermsText\"><span ng-bind=\"('sightlineCcpRedirectTerms' | CMSLabels: 'dmaManagementLabels' | trust)\"></span> <button ng-click=\"openTermsConditions($event)\" class=\"external-link link\" data-qa-label=\"slpRedirectTermsLink\">Terms and Conditions</button> <span>and</span> <button ng-click=\"openPrivacyPolicy($event)\" class=\"link\" data-qa-label=\"slpRedirectPrivacyButton\">Privacy Disclosure</button></label></div><div><button class=\"proceed-btn\" ng-disabled=\"!areTermsAccepted\" ng-click=\"proceed($close)\" data-qa-label=\"slpRedirectConfirmButton\" ng-bind=\"('sightlineCcpRedirectButtonLabel' | CMSLabels: 'dmaManagementLabels' | trust)\"></button></div><div qa-label=\"slpRedirectFees\" class=\"tvg-dialog-dma-redesign-fees\" ng-bind-html=\"'sightlineCcpRedirectFees'| CMSValue : null\"></div></div></div>"
  );


  $templateCache.put('src/templates/ccp_visa_sightline_redirect.html',
    "<div class=\"tvg-dialog dma-redesign sightline-redirect-modal\" style=\"max-width: 390px !important;\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" style=\"text-transform: uppercase; display: block; margin-top: 3px;\" ng-bind=\"('modalTitle' | CMSLabels: 'cardErrorRedirect' | trust)\" data-qa-label=\"slpVisaRedirectTitle\"></span> <a href class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$close()\" data-qa-label=\"slpRedirectClose\"><i class=\"tvg-icon-close\"></i></a></div><div class=\"tvg-dialog-dma-redesign-body card-declined-body\"><p data-qa-label=\"slpVisaRedirectDescription\" ng-bind=\"('modalDescription' | CMSLabels: 'cardErrorRedirect' | trust)\" class=\"card-declined-description\"></p><div class=\"card-declined-option-list\"><button ng-click=\"changeType('CC')\" ng-class=\"{'selected': type === 'CC'}\" class=\"card-declined-option\" data-qa-label=\"slpAnotherCardButton\"><span class=\"card-declined-option-circle\"><svg ng-if=\"type === 'CC'\" width=\"18\" height=\"13\" data-qa-label=\"slpAnotherCardButtonIcon\" viewBox=\"0 0 18 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#3574D4\" d=\"M1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM16.6863 1H17.4363C17.4363 0.585786 17.1005 0.25 16.6863 0.25V1ZM16.6863 12V12.75C17.1005 12.75 17.4363 12.4142 17.4363 12H16.6863ZM1 12H0.25C0.25 12.4142 0.585786 12.75 1 12.75L1 12ZM1 1.75H16.6863V0.25H1V1.75ZM15.9363 1V12H17.4363V1H15.9363ZM16.6863 11.25H1V12.75H16.6863V11.25ZM1.75 12V1H0.25V12H1.75ZM1 5.95588L17 5.95588V4.45588L1 4.45588L1 5.95588ZM2.5686 9.19119H8.84311V7.69119H2.5686V9.19119Z\"/></svg> <svg ng-if=\"type !== 'CC'\" width=\"18\" height=\"13\" data-qa-label=\"slpAnotherCardButtonIcon\" viewBox=\"0 0 18 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#668FB8\" d=\"M1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM16.6863 1H17.4363C17.4363 0.585786 17.1005 0.25 16.6863 0.25V1ZM16.6863 12V12.75C17.1005 12.75 17.4363 12.4142 17.4363 12H16.6863ZM1 12H0.25C0.25 12.4142 0.585786 12.75 1 12.75L1 12ZM1 1.75H16.6863V0.25H1V1.75ZM15.9363 1V12H17.4363V1H15.9363ZM16.6863 11.25H1V12.75H16.6863V11.25ZM1.75 12V1H0.25V12H1.75ZM1 5.95588L17 5.95588V4.45588L1 4.45588L1 5.95588ZM2.5686 9.19119H8.84311V7.69119H2.5686V9.19119Z\"/></svg> </span><span ng-bind=\"('AnotherCard' | CMSLabels: 'cardErrorRedirect' | trust)\"></span></button> <button ng-if=\"depositOptions.includes('IBC')\" ng-click=\"changeType('IBC')\" ng-class=\"{'selected': type === 'IBC'}\" class=\"card-declined-option\" data-qa-label=\"slpBetCashButton\"><span class=\"card-declined-option-circle\"><svg ng-if=\"type === 'IBC'\" width=\"18\" height=\"13\" data-qa-label=\"slpBetCashButtonIcon\" viewBox=\"0 0 18 13\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#3574D4\" d=\"M1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM16.6863 1H17.4363C17.4363 0.585786 17.1005 0.25 16.6863 0.25V1ZM16.6863 12V12.75C17.1005 12.75 17.4363 12.4142 17.4363 12H16.6863ZM1 12H0.25C0.25 12.4142 0.585786 12.75 1 12.75L1 12ZM1 1.75H16.6863V0.25H1V1.75ZM15.9363 1V12H17.4363V1H15.9363ZM16.6863 11.25H1V12.75H16.6863V11.25ZM1.75 12V1H0.25V12H1.75ZM2.5686 9.19119H8.84311V7.69119H2.5686V9.19119ZM2.5686 5.19119H12.8431V3.69119H2.5686V5.19119Z\"/></svg> <svg ng-if=\"type !== 'IBC'\" width=\"18\" height=\"13\" data-qa-label=\"slpBetCashButtonIcon\" viewBox=\"0 0 18 13\" fill=\"#3574D4\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#668FB8\" d=\"M1 1V0.25C0.585786 0.25 0.25 0.585786 0.25 1L1 1ZM16.6863 1H17.4363C17.4363 0.585786 17.1005 0.25 16.6863 0.25V1ZM16.6863 12V12.75C17.1005 12.75 17.4363 12.4142 17.4363 12H16.6863ZM1 12H0.25C0.25 12.4142 0.585786 12.75 1 12.75L1 12ZM1 1.75H16.6863V0.25H1V1.75ZM15.9363 1V12H17.4363V1H15.9363ZM16.6863 11.25H1V12.75H16.6863V11.25ZM1.75 12V1H0.25V12H1.75ZM2.5686 9.19119H8.84311V7.69119H2.5686V9.19119ZM2.5686 5.19119H12.8431V3.69119H2.5686V5.19119Z\"/></svg> </span><span class=\"card-declined-option-text\" ng-bind=\"('eCheck' | CMSLabels: 'cardErrorRedirect' | trust)\"></span></button> <button ng-if=\"depositOptions.includes('PAY')\" ng-click=\"changeType('PAY')\" ng-class=\"{'selected': type === 'PAY'}\" class=\"card-declined-option\" data-qa-label=\"slpPayPalButton\"><span class=\"card-declined-option-circle\"><svg ng-if=\"type === 'PAY'\" width=\"14\" height=\"16\" data-qa-label=\"slpPayPalButtonIcon\" viewBox=\"0 0 14 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#3574D4\" d=\"M6.57264 8.55129C8.9534 8.52313 10.7497 7.5757 11.5069 5.37098C12.2677 3.22963 12.074 1.25029 9.95722 0.429627C8.58719 -0.102178 8.13636 0.0281341 2.7724 0.0281341C2.42372 0.0281341 2.12084 0.285252 2.06795 0.623342L0.00413528 13.7216C-0.0310731 13.9787 0.162607 14.2111 0.430246 14.2111H3.05764C3.12809 14.2111 3.15271 14.1865 3.1633 14.1231C3.30768 13.232 3.79729 10.0798 3.92052 9.40362C4.12486 8.30476 5.0441 8.57602 6.57264 8.55129Z\"/><path fill=\"#3574D4\" d=\"M12.5741 4.33554C12.5107 4.28974 12.486 4.2721 12.4684 4.38127C12.398 4.78283 12.2888 5.17373 12.1585 5.56471C10.7532 9.57269 6.85786 9.22404 4.95599 9.22404C4.74113 9.22404 4.60026 9.34029 4.57206 9.55509C3.77613 14.4999 3.61762 15.5319 3.61762 15.5319C3.58238 15.7819 3.74088 15.9862 3.99095 15.9862H6.22741C6.53029 15.9862 6.78036 15.7643 6.84026 15.4615C6.86488 15.2712 6.80154 15.6763 7.34741 12.2459C7.50939 11.4711 7.85102 11.5521 8.37932 11.5521C10.88 11.5521 12.8311 10.5378 13.4122 7.59693C13.6412 6.37123 13.5743 5.08217 12.5741 4.33554Z\"/></svg> <svg ng-if=\"type !== 'PAY'\" width=\"14\" height=\"16\" data-qa-label=\"slpPayPalButtonIcon\" viewBox=\"0 0 14 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#668FB8\" d=\"M6.57264 8.55129C8.9534 8.52313 10.7497 7.5757 11.5069 5.37098C12.2677 3.22963 12.074 1.25029 9.95722 0.429627C8.58719 -0.102178 8.13636 0.0281341 2.7724 0.0281341C2.42372 0.0281341 2.12084 0.285252 2.06795 0.623342L0.00413528 13.7216C-0.0310731 13.9787 0.162607 14.2111 0.430246 14.2111H3.05764C3.12809 14.2111 3.15271 14.1865 3.1633 14.1231C3.30768 13.232 3.79729 10.0798 3.92052 9.40362C4.12486 8.30476 5.0441 8.57602 6.57264 8.55129Z\"/><path fill=\"#668FB8\" d=\"M12.5741 4.33554C12.5107 4.28974 12.486 4.2721 12.4684 4.38127C12.398 4.78283 12.2888 5.17373 12.1585 5.56471C10.7532 9.57269 6.85786 9.22404 4.95599 9.22404C4.74113 9.22404 4.60026 9.34029 4.57206 9.55509C3.77613 14.4999 3.61762 15.5319 3.61762 15.5319C3.58238 15.7819 3.74088 15.9862 3.99095 15.9862H6.22741C6.53029 15.9862 6.78036 15.7643 6.84026 15.4615C6.86488 15.2712 6.80154 15.6763 7.34741 12.2459C7.50939 11.4711 7.85102 11.5521 8.37932 11.5521C10.88 11.5521 12.8311 10.5378 13.4122 7.59693C13.6412 6.37123 13.5743 5.08217 12.5741 4.33554Z\"/></svg> </span><span ng-bind=\"('Paypal' | CMSLabels: 'cardErrorRedirect' | trust)\"></span></button></div><hr style=\"margin-bottom: 16px;\"><div ng-if=\"type === 'CC'\" data-qa-label=\"slpCardDeclinedDescription\"><p style=\"margin-bottom: 16px;\" class=\"card-declined-description\" ng-bind=\"('otherCardDescription' | CMSLabels: 'cardErrorRedirect' | trust)\"></p><h3 class=\"card-declined-sub-title\" ng-bind=\"('otherCardTitle' | CMSLabels: 'cardErrorRedirect' | trust)\"></h3><ul class=\"card-declined-cards-list\"><li ng-repeat=\"cardItem in cardList track by $index\">{{ cardItem }}</li></ul></div><div ng-if=\"type === 'IBC'\" data-qa-label=\"slpCardDeclinedDescription\"><h3 class=\"card-declined-sub-title\" ng-bind=\"('eCheckTitle' | CMSLabels: 'cardErrorRedirect' | trust)\"></h3><ul class=\"card-declined-cards-list\"><li ng-bind=\"('eCheckDescription' | CMSLabels: 'cardErrorRedirect' | trust)\"></li></ul></div><div ng-if=\"type === 'PAY'\" data-qa-label=\"slpCardDeclinedDescription\"><h3 class=\"card-declined-sub-title\" ng-bind=\"('paypalTitle1' | CMSLabels: 'cardErrorRedirect' | trust)\"></h3><ul class=\"card-declined-cards-list\"><li ng-bind=\"('paypalDescription1' | CMSLabels: 'cardErrorRedirect' | trust)\"></li></ul><h3 class=\"card-declined-sub-title\" style=\"margin-top: 8px !important;\" ng-bind=\"('paypalTitle2' | CMSLabels: 'cardErrorRedirect' | trust)\"></h3><ul class=\"card-declined-cards-list\"><li ng-bind=\"('paypalDescription2' | CMSLabels: 'cardErrorRedirect' | trust)\"></li></ul></div><div class=\"card-declined-button\"><button ng-if=\"type === 'CC'\" ng-bind=\"('modalButtonOtherCard' | CMSLabels: 'cardErrorRedirect' | trust)\" ng-click=\"redirectTo($close)\" data-qa-label=\"slpCardDeclinedSubmitButton\"></button> <button ng-if=\"type === 'IBC'\" ng-bind=\"('modalButtonEcheck' | CMSLabels: 'cardErrorRedirect' | trust)\" ng-click=\"redirectTo($close, 'IBC')\" data-qa-label=\"slpCardDeclinedSubmitButton\"></button> <button ng-if=\"type === 'PAY'\" ng-bind=\"('modalButtonPaypal' | CMSLabels: 'cardErrorRedirect' | trust)\" ng-click=\"redirectTo($close, 'PAY')\" data-qa-label=\"slpCardDeclinedSubmitButton\"></button></div></div></div>"
  );


  $templateCache.put('src/templates/customer-info.html',
    "<span ng-bind-html=\"data.htmlContent\"></span>"
  );


  $templateCache.put('src/templates/customer-options.html',
    "<tvg-collapse class=\"support\" ng-repeat=\"option in data.optionsConfig\" ng-attr-title=\"{{option.name}}\"><span ng-repeat=\"itemOption in option.values\"><a ng-if=\"itemOption.url.lastIndexOf('cms:') !== 0 && itemOption.onclick\" onclick=\"window.webkit && window.webkit.messageHandlers['OPEN_EXTERNAL_APP'].postMessage({\n" +
    "                        type: 'OPEN_EXTERNAL_APP',\n" +
    "                        payload: { openExternalApp: ''+window.location.protocol+'/' + window.location.host + '/redirectengine?type=messageus'}\n" +
    "                    })\" class=\"{{itemOption.class}}\">{{itemOption.name}}</a> <a ng-if=\"itemOption.url.lastIndexOf('cms:') !== 0 && itemOption.url\" class=\"{{itemOption.class}}\" href=\"{{itemOption.url}}\" target=\"_blank\">{{itemOption.name}}</a> <a ng-if=\"itemOption.url.lastIndexOf('cms:') === 0\" class=\"{{itemOption.class}}\" ng-click=\"$emit('more_info', itemOption.url.substr(4,itemOption.url.length-4))\" target=\"_blank\">{{itemOption.name}}</a></span></tvg-collapse>"
  );


  $templateCache.put('src/templates/dw-info-dialog-fdr.html',
    "<div class=\"container\"><div class=\"info-icon\" qa-label=\"info-icon\"></div><h2 qa-label=\"heading-text\">{{ headingText }}</h2><div class=\"text\" ng-transclude qa-label=\"dialog-text\"></div><div ng-if=\"actionUrl && !livePerson\"><a class=\"text-green\" href=\"tel:1-888-752-9884\" qa-label=\"dialog-action-url\">{{ actionText }}</a></div><div ng-if=\"action && !livePerson\"><span class=\"support-phone\" ng-click=\"action()\" qa-label=\"dialog-action\">{{ actionText }}</span></div><div ng-if=\"livePerson\" ng-bind-html=\"livePerson\"></div><button ng-click=\"buttonAction()\" qa-label=\"button-action\">{{ buttonText }}</button></div>"
  );


  $templateCache.put('src/templates/dw-info-dialog.html',
    "<div class=\"container\"><div class=\"square\"><div class=\"text\" ng-transclude qa-label=\"dialog-text\"></div></div><div ng-if=\"actionUrl && !livePerson\"><a class=\"text-green\" href=\"{{actionUrl}}\" qa-label=\"dialog-action-url\">{{actionText}}</a></div><div ng-if=\"action && !livePerson\"><span class=\"clickable text-green\" ng-click=\"action()\" qa-label=\"dialog-action\">{{actionText}}</span></div><div ng-if=\"livePerson\" ng-bind-html=\"livePerson | trust\"></div></div>"
  );


  $templateCache.put('src/templates/dw-info-message.html',
    "<div class=\"info-container\"><h4 qa-label=\"dw-info-title\">{{title}}</h4><p qa-label=\"dw-info-message\">{{message}}</p></div>"
  );


  $templateCache.put('src/templates/footer-links.html',
    "<div class=\"footer-links\"><div><span class=\"link\">Privacy Policy</span> | <span class=\"link\">Terms & conditions</span></div><div><span class=\"link\">Wager responsibly</span> | <span class=\"link\">Contact us</span></div></div>"
  );


  $templateCache.put('src/templates/modal-window.html',
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"tvgmodal fade in\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\"><div class=\"tvgmodal-dismiss no-click-feedback\" ng-click=\"close($event)\"></div><div class=\"tvgmodal-dialog\"><div class=\"tvgmodal-content\" ng-transclude></div></div></div>"
  );


  $templateCache.put('src/templates/notification_delete_card.html',
    "<div class=\"tvg-dialog-filter\"></div><div class=\"tvg-dialog dma-redesign dialog-{{type}}\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" ng-bind=\"('removeCardTitle' | CMSLabels: 'dmaManagementLabels' | trust)\"></span> <a href class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$close()\"><i class=\"tvg-icon-close\"></i></a></div><div class=\"tvg-dialog-dma-redesign-body\"><div class=\"tvg-dialog-dma-redesign-warning\"><i class=\"tvg-dialog-dma-redesign-warning-icon tvg-icon-info\"></i> <span class=\"tvg-dialog-dma-redesign-warning-message\" ng-bind=\"('removeCardMessage' | CMSLabels: 'dmaManagementLabels' | trust)\"></span></div><div class=\"tvg-dialog-dma-redesign-card\"><div class=\"tvg-dialog-dma-card-icon\"></div><ul><li><strong ng-bind=\"selectedCard.typeName + ' Card'\"></strong></li><li>{{\"xxxx-xxxx-xxxx-\" + selectedCard.cardNumber}}</li><li>Expires {{selectedCard.expirationDate}}</li></ul></div><div><a href class=\"tvg-dma-button__secondary tvg-dialog-dma-redesign-button__cancel\" ng-click=\"$close()\">Cancel</a> <a href class=\"tvg-dma-button__delete tvg-dialog-dma-redesign-button__confirm\" ng-click=\"$close(selectedCard)\">Delete</a></div></div></div>"
  );


  $templateCache.put('src/templates/notification_edit_card.html',
    "<div class=\"tvg-dialog-filter\"></div><div class=\"tvg-dialog dma-redesign\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" ng-bind=\"('editCardTitle' | CMSLabels: 'dmaManagementLabels' | trust)\"></span> <a href class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$close()\"><i class=\"tvg-icon-close\"></i></a></div><div class=\"tvg-dialog-dma-redesign-body\"><div class=\"tvg-dialog-dma-redesign-warning\" ng-if=\"message\"><i class=\"tvg-dialog-dma-redesign-warning-icon tvg-icon-info\"></i> <span class=\"tvg-dialog-dma-redesign-warning-message\" ng-bind-html=\"message\"></span></div><div class=\"tvg-dialog-dma-redesign-card\"><div class=\"tvg-dialog-dma-card-icon\"></div><ul><li><strong ng-bind=\"selectedCard.typeName + ' Card'\"></strong></li><li>{{\"xxxx-xxxx-xxxx-\" + selectedCard.cardNumber}}</li></ul></div><form name=\"editCardRedesignForm\"><p>Expiry Date</p><input class=\"tiny\" name=\"cardExpMonth\" placeholder=\"MM\" ng-required=\"true\" min=\"1\" max=\"12\" minlength=\"1\" maxlength=\"2\" type=\"number\" pattern=\"\\d*\" ng-model=\"selectedCard.expirationMonth\"> <span>/</span> <input id=\"cardExpirationYear\" class=\"tiny\" name=\"cardExpYr\" placeholder=\"YY\" ng-required=\"true\" minlength=\"2\" maxlength=\"2\" type=\"number\" pattern=\"\\d*\" ng-model=\"selectedCard.expirationYear\"></form><div><a href class=\"tvg-dma-button__secondary tvg-dialog-dma-redesign-button__cancel\" ng-click=\"$close()\">Cancel</a> <a href class=\"tvg-dma-button__primary tvg-dialog-dma-redesign-button__confirm\" ng-click=\"editCardRedesignForm.$valid && $close(selectedCard)\">Save</a></div></div></div>"
  );


  $templateCache.put('src/templates/section-title.html',
    "<div qa-label=\"{{qalabel || sectionTitle}}\" class=\"section-title\"><span ng-bind=\"index\"></span> <span ng-if=\"index\">-</span> <span ng-bind=\"title\"></span></div>"
  );


  $templateCache.put('src/templates/toggle-component.html',
    "<span class=\"checkinput\"><input id=\"chk-store-card\" type=\"checkbox\" ng-model=\"savein\"> <span class=\"thumb\"></span> </span><label class=\"chk-store-card-text\"><h3 class=\"title\">{{title}}</h3><p class=\"subtitle\">{{subtitle}}</p></label>"
  );


  $templateCache.put('src/templates/tvg-collapse.html',
    "<button ng-init=\"expanded = false\" ng-click=\"expanded = !expanded; scrollDown()\" ng-class=\"{expanded: expanded}\" type=\"button\">{{title}}</button><div ng-class=\"{expanded: expanded}\" class=\"content-ctnr\"><div class=\"content\" ng-transclude></div></div>"
  );


  $templateCache.put('src/templates/welcome-dialog-fdr.html',
    "<div class=\"dialog-welcome-wrapper\"><div class=\"dialog-welcome-inner\"><div class=\"header\"><h2>Fund your account</h2><span class=\"dismiss\" ng-click=\"dismiss()\"></span></div><div class=\"content\"><div class=\"success\"><h3>Account Created!</h3><p>{{'accountDetailsEmailSent' | CMSValue : null}} {{ $root.user.emailAddress ? $root.user.emailAddress : 'your email address' }}</p></div><div class=\"disclaimer\">Fund your account so you can start betting with FanDuel Racing. Click continue below to get started.</div><button ng-click=\"dismiss()\">Make first deposit</button></div></div></div>"
  );


  $templateCache.put('src/applepay/deposits/deposit-button/deposit-button.template.html',
    "<div class=\"field\"><button type=\"button\" qa-label=\"applepayButton\" class=\"applepay-deposit__button pa_0\" ng-disabled=\"$ctrl.isDisabled\" ng-click=\"$ctrl.onDeposit($event)\" ng-bind-html=\"::('depositButton' | CMSLabels: 'applepayLabels')\"></button></div>"
  );


  $templateCache.put('src/applepay/deposits/deposit.template.html',
    "<div ng-class=\"{loading: $ctrl.loading}\" class=\"applepay applepay-deposit\"><ng-form name=\"$ctrl.applepayDeposits\" ng-show=\"!$ctrl.loading\"><div class=\"disclaimer\" qa-label=\"applepayDisclaimer\" ng-bind-html=\"::('tutorial' | CMSLabels: 'applepayLabels')\"></div><section-title class=\"first-title\" qalabel=\"applepay-depositAmountTitle\" title=\"{{::'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\"></section-title><applepay-select-amount form=\"::$ctrl.applepayDeposits\" amount=\"$ctrl.applepayAmount\" min-amount=\"$ctrl.minAmount\" max-amount=\"$ctrl.maxAmount\" amounts=\"::$ctrl.amountOptions\" on-amount-change=\"::$ctrl.handleApplePayAmountChange($event)\"></applepay-select-amount><section-title class=\"second-title\" title=\"Review and Authorize\" qalabel=\"applepay-reviewTitle\"></section-title><applepay-total-cost ng-if=\"!$ctrl.unableToFetchBraintreeClient\" data=\"$ctrl.fees\" email=\"$ctrl.email\" handle-fetch-fees=\"$ctrl.fetchFees($ctrl.depositAmount)\"></applepay-total-cost><div ng-if=\"$ctrl.unableToFetchBraintreeClient\" ng-style=\"{ 'margin-bottom': '24px' }\"><dw-info-dialog>{{'braintreeClientFailMessage' | CMSLabels: 'applepayLabels'}}</dw-info-dialog></div><applepay-deposit-button ng-if=\"!$ctrl.unableToFetchBraintreeClient\" is-disabled=\"$ctrl.shouldDisableApplePayButton()\" on-apple-pay-deposit=\"$ctrl.onApplePayDeposit()\"></applepay-deposit-button></ng-form></div>"
  );


  $templateCache.put('src/applepay/deposits/select-amount/select-amount.template.html',
    "<div class=\"dma-amount-ctn\" qa-label=\"deposit-amount\"><div class=\"dma-amount-table\"><div class=\"row\"><div class=\"cell w155\"><toggle-options><button qa-label=\"amount-button-{{amountOption}}\" ng-repeat=\"amountOption in $ctrl.amounts track by $index\" ng-class=\"{selected: $ctrl.amount == amountOption}\" class=\"amount-button\" type=\"button\" qa-label=\"amount-button-{{amountOption}}\" ng-click=\"$ctrl.change(amountOption)\">${{amountOption}}</button></toggle-options></div><span class=\"cell minw30 amount-divider\">or <span class=\"amount-dollar-label\">$</span></span><div class=\"cell align-right amount-input-ctn\"><input qa-label=\"amount-input\" money-formater class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other amount\" ng-min=\"{{$ctrl.minAmount||0}}\" ng-max=\"{{$ctrl.maxAmount||100000}}\" ng-model-options=\"{ allowInvalid: true, updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" num-length=\"5\" step=\"any\" ng-model=\"$ctrl.amount\" ng-required=\"true\" ng-change=\"$ctrl.change($ctrl.amount)\" restrict-chars ng-blur=\"inputIsNowFocused = false\" ng-focus=\"inputIsNowFocused = true\" ng-class=\"{\n" +
    "                        inputIsInvalid: $root.isFdrApp && $ctrl.form.amount.$invalid && $ctrl.form.$submitted,\n" +
    "                        inputIsFocused: ($root.isFdrApp && !$ctrl.form.amount.$invalid && !!inputIsNowFocused)\n" +
    "                            || ($root.isFdrApp && !$ctrl.form.amount.$dirty && !!inputIsNowFocused)\n" +
    "                    }\"></div></div></div><div class=\"row non-table amount-errors-ctn\" ng-if=\"$ctrl.form.amount.$touched || $ctrl.form.$submitted || $ctrl.form.amount.$dirty\"><div ng-messages=\"$ctrl.form.amount.$error\"><div class=\"js-error-label error-label\" ng-if=\"$ctrl.maxAmount !== 0\" ng-message=\"min\" ng-bind-html=\"(('minimum' | CMSLabels: 'applepayLabels') + ' ' + ($ctrl.minAmount | currency) | trust )\"></div><div qa-label=\"error-required\" class=\"js-error-label error-label\" ng-message=\"required\" ng-bind-html=\"('required' | CMSLabels: 'applepayLabels' | trust )\"></div><div class=\"js-error-label error-label\" ng-message=\"max\" ng-bind-html=\"(('maximum' | CMSLabels: 'applepayLabels') + ' ' + ($ctrl.maxAmount | currency) | trust )\"></div><div ng-init=\"events.sendOtherAmountErrorToGTM('Maximum amount reached')\" ng-if=\"$ctrl.maxAmount === 0\" qa-label=\"error-maximum-amount\" class=\"js-error-label error-label\">Maximum amount reached</div></div></div></div>"
  );


  $templateCache.put('src/applepay/deposits/total-cost/total-cost.template.html',
    "<label ng-if=\"$ctrl.data.loading && !$root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label> <label ng-if=\"$ctrl.data.retryFetchingFees\" ng-click=\"$ctrl.handleFetchFees()\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees-error' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"deposit-summary\" class=\"deposit__summary\"><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('deposit-summary-amount' | CMSLabels: 'dmaDepositLabels') + (' <span>') +\n" +
    "                      (($ctrl.data.netAmount | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('deposit-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                      (($ctrl.data.fee | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li ng-if=\"!$root.isFdrApp && $ctrl.data.feeDiscount\" qa-label=\"deposit-summary-discount\" ng-bind-html=\"(('deposit-summary-discount' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                      (($ctrl.data.feeDiscount | currency: '-$') || '$--') | trust ) + ('</span>')\"></li><li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('deposit-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') + (($ctrl.data.transactionTotal | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></li></ul><label ng-if=\"$ctrl.data.loading && $root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label>"
  );


  $templateCache.put('src/common/modal-dialog/modal-dialog.template.html',
    "<div class=\"tvg-dialog dma-redesign\" ng-class=\"::$ctrl.klass\"><div class=\"tvg-dialog-dma-redesign-header\"><span class=\"tvg-dialog-dma-redesign-title\" ng-bind=\"::$ctrl.title\"></span> <button class=\"tvg-dialog-dma-redesign-close-icon\" ng-click=\"$ctrl.close()\"><i class=\"tvg-icon-close\"></i></button></div><div class=\"tvg-dialog-dma-redesign-body\" data-add-click-listener-to=\"::$ctrl.body\" data-add-to-all=\"true\" data-click-listener=\"$ctrl.scrollToSection(event)\"></div></div>"
  );


  $templateCache.put('src/common/modal-dialog/modal-window.html',
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"tvgmodal fade in\" ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\"><div class=\"tvgmodal-dismiss no-click-feedback\" ng-click=\"close($event)\"></div><div class=\"tvgmodal-dialog\"><div class=\"tvgmodal-content\" ng-transclude></div></div></div>"
  );


  $templateCache.put('src/moneypak/limits-table/limits-table.template.html',
    "<div class=\"limits-table-container\"><table><thead><tr><th ng-repeat=\"header in vm.content.headers track by $index\" ng-bind=\"header\"></th></tr></thead><tbody><tr ng-repeat=\"row in vm.content.rows track by $index\"><td ng-repeat=\"data in row track by $index\" ng-bind=\"data\"></td></tr></tbody></table></div>"
  );


  $templateCache.put('src/moneypak/moneypak-activation-number-input/moneypak-activation-number-input.template.html',
    "<div class=\"mpak-number-container field\" ng-class=\"{fieldInvalid: $ctrl.form.mpakNumber.$touched && $ctrl.form.mpakNumber.$invalid, inputFocused: inputNumberFocused}\"><div class=\"field-label\"><label for=\"mpak-number\" qa-label=\"mpInputLabel\" ng-bind-html=\"::('moneypakNumberLabel' | CMSLabels: 'moneyPakLabels')\"></label></div><div class=\"field-input mpak-number\"><span class=\"input-container\"><input type=\"text\" qa-label=\"mpInput\" class=\"form-control mpak-number\" id=\"mpak-number\" placeholder=\"{{::('moneypakNumberPlaceholder' | CMSLabels: 'moneyPakLabels')}}\" autocomplete=\"off\" name=\"mpakNumber\" ng-model=\"$ctrl.mpakNumber\" ui-mask=\"999 999 9999 9?9?9?9\" ng-focus=\"$ctrl.startDeposit(); inputNumberFocused= true;\" ui-mask-placeholder ui-mask-placeholder-char=\" \" ng-blur=\"inputNumberFocused = false\" ui-options=\"{ clearOnBlur: false, allowInvalidValue: true }\" ng-change=\"$ctrl.update()\" ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }\" required></span></div><additional-info ng-click=\"$ctrl.openTooltip()\"><span class=\"card-imgs mpak\" qa-label=\"mpHelperImage\"></span></additional-info><div class=\"row non-table amount-errors-ctn clearfix\" ng-if=\"$ctrl.form.mpakNumber.$touched || $ctrl.form.$submitted\"><div ng-messages=\"$ctrl.form.mpakNumber.$error\"><div qa-label=\"error-required\" class=\"js-error-label error-label\" ng-message=\"required\" ng-bind-html=\"::('required' | CMSLabels: 'moneyPakLabels' | trust )\"></div><div qa-label=\"error-invalid\" class=\"js-error-label error-label\" ng-message=\"mask\" ng-bind-html=\"::('invalidCard' | CMSLabels: 'moneyPakLabels')\"></div></div></div></div>"
  );


  $templateCache.put('src/moneypak/moneypak.template.html',
    "<div ng-class=\"{loading: $ctrl.loading || $ctrl.activePoller}\" class=\"moneypak\"><form name=\"$ctrl.moneyPakDepositForm\" ng-submit=\"$ctrl.handleFormSubmit($event)\" novalidate><div class=\"disclaimer\" qa-label=\"moneyPakDisclaimer\" ng-bind-html=\"::('tutorial' | CMSLabels: 'moneyPakLabels')\"></div><section-title qalabel=\"mpak-depositLimitsTitle\" class=\"first-title\" title=\"{{::'depositLimitsTitle' | CMSLabels: 'moneyPakLabels'}}\"></section-title><div class=\"disclaimer\" qa-label=\"mPtableLimitsDisclaimer\" ng-bind-html=\"::('depositLimitsText' | CMSLabels: 'moneyPakLabels')\"></div><limits-table content-obj=\"::('depositLimitsTable' | CMSLabels: 'moneyPakLabels')\"></limits-table><section-title qalabel=\"mpak-authorizeTitle\" title=\"{{::'redeemAndAuthorizeTitle' | CMSLabels: 'moneyPakLabels'}}\"></section-title><div class=\"disclaimer\" qa-label=\"mpRedeemAuthorizeDisclaimer\" ng-bind-html=\"::('redeemAndAuthorizeText' | CMSLabels: 'moneyPakLabels')\"></div><moneypak-activation-number-input ng-if=\"isRGAvailable && !rgLimitReached || !isRGAvailable\" class=\"mb_20\" data-mpak-number=\"$ctrl.mpakNumber\" form=\"$ctrl.moneyPakDepositForm\" on-update=\"$ctrl.update(value)\"></moneypak-activation-number-input><div ng-if=\"isRGAvailable && !rgLimitReached && rgMoneypakAvailableDepositAmount\" class=\"warningMessage\"><div></div><span>{{messageWithRemainingAmount}}</span></div><button ng-if=\"isRGAvailable && !rgLimitReached || !isRGAvailable\" qa-label=\"submitDeposit\" class=\"submit authorize-deposit mb_20\" ng-disabled=\"$ctrl.loading || $ctrl.moneyPakDepositForm.$invalid || $ctrl.activePoller || $ctrl.responsibleGamingDelay\" type=\"submit\"><i class=\"tvg-icon tvg-icon-lock\"></i> <strong ng-bind=\"::'depositExecuteButton' | CMSValue\"></strong></button><div ng-if=\"isRGAvailable && rgLimitReached\" class=\"warningMessage\"><div></div><span>{{::'DMARGLimitReached' | CMSLabels: 'moneyPakLabels'}}</span></div><div class=\"disclaimer\" qa-label=\"mpFaqDisclaimer\" data-add-click-listener-to=\"::('faqText' | CMSLabels: 'moneyPakLabels')\" data-click-listener=\"$ctrl.openModal(event)\"></div></form></div>"
  );


  $templateCache.put('src/paypal/deposits/deposit-button/deposit-button.template.html',
    "<div class=\"field\"><div ng-if=\"!$root.isFdrApp\" class=\"paypal-deposit__message disclaimer pv_10\" qa-label=\"payPalDepositMessageDisclaimerPv_10\"><p class=\"pb_5\" ng-bind-html=\"::('clickMessage' | CMSLabels: 'paypalLabels')\"></p><p class=\"pb_5\" ng-bind-html=\"::('accountMessage' | CMSLabels: 'paypalLabels')\"></p><p ng-bind-html=\"::('connectedAcount' | CMSLabels: 'paypalLabels')\"></p></div><div ng-if=\"$root.isFdrApp\" class=\"paypal-deposit__message disclaimer pv_10\" qa-label=\"payPalDepositMessageDisclaimerPv_10\">{{'clickMessage' | CMSLabels: 'paypalLabels'}} {{'accountMessage' | CMSLabels: 'paypalLabels'}} {{'connectedAcount' | CMSLabels: 'paypalLabels'}}</div><button qa-label=\"payPalButton\" class=\"paypal-deposit__button pa_0\" ng-click=\"$ctrl.onDeposit($event)\" ng-disabled=\"$ctrl.isDisabled\"><img src=\"https://www.paypalobjects.com/webstatic/en_US/i/btn/png/blue-rect-paypal-44px.png\" alt=\"PayPal Checkout\"></button></div>"
  );


  $templateCache.put('src/paypal/deposits/deposit.template.html',
    "<div ng-class=\"{loading: $ctrl.loading}\" class=\"paypal paypal-deposit\"><ng-form name=\"$ctrl.paypalDeposits\" ng-show=\"!$ctrl.loading\"><div class=\"disclaimer\" qa-label=\"payPalDisclaimer\" ng-bind-html=\"::('tutorial' | CMSLabels: 'paypalLabels')\"></div><section-title ng-if=\"$root.isFdrApp && $ctrl.email\" title=\"PayPal Account Details\" qalabel=\"paypal-accountDetails\" index=\"0\"></section-title><div ng-if=\"$root.isFdrApp && $ctrl.email\" qa-label=\"paypal-accountDetails-email\" email=\"$ctrl.email\" class=\"paypal-account-details\">Email address set to: <strong class=\"paypal-user-email\">{{ $ctrl.email }}</strong></div><section-title class=\"first-title\" qalabel=\"paypal-depositAmountTitle\" title=\"{{::'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\" index=\"1\"></section-title><select-amount form=\"::$ctrl.paypalDeposits\" amount=\"$ctrl.depositAmount\" min-amount=\"::$ctrl.minAmount\" max-amount=\"::$ctrl.maxAmount\" amounts=\"::$ctrl.amountOptions\" on-amount-change=\"::$ctrl.handleOnAmountChange($event)\"></select-amount><section-title title=\"Review and Authorize\" qalabel=\"paypal-reviewTitle\" index=\"2\"></section-title><total-cost data=\"$ctrl.fees\" email=\"$ctrl.email\"></total-cost><deposit-button is-disabled=\"$ctrl.shouldDisablePaypalButton()\" on-paypal-deposit=\"$ctrl.makePaypalDeposit($event)\"></deposit-button></ng-form></div>"
  );


  $templateCache.put('src/paypal/deposits/select-amount/select-amount.template.html',
    "<div class=\"dma-amount-ctn\" qa-label=\"deposit-amount\"><div class=\"dma-amount-table\"><div class=\"row\"><div class=\"cell w155\"><toggle-options><button qa-label=\"amount-button-{{amountOption}}\" ng-repeat=\"amountOption in $ctrl.amounts track by $index\" ng-class=\"{selected: $ctrl.amount == amountOption}\" class=\"amount-button\" type=\"button\" qa-label=\"amount-button-{{amountOption}}\" ng-click=\"$ctrl.change(amountOption)\">${{amountOption}}</button></toggle-options></div><span class=\"cell minw30 amount-divider\">or <span class=\"amount-dollar-label\">$</span></span><div class=\"cell align-right amount-input-ctn\"><input qa-label=\"amount-input\" money-formater class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other amount\" ng-min=\"{{$ctrl.minAmount||0}}\" ng-max=\"{{$ctrl.maxAmount||100000}}\" ng-model-options=\"{ allowInvalid: true, updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" num-length=\"5\" step=\"any\" ng-model=\"$ctrl.amount\" ng-required=\"true\" ng-change=\"$ctrl.change($ctrl.amount)\" restrict-chars ng-blur=\"inputIsNowFocused = false\" ng-focus=\"inputIsNowFocused = true\" ng-class=\"{\n" +
    "                        inputIsInvalid: $root.isFdrApp && $ctrl.form.amount.$invalid && $ctrl.form.$submitted,\n" +
    "                        inputIsFocused: ($root.isFdrApp && !$ctrl.form.amount.$invalid && !!inputIsNowFocused)\n" +
    "                            || ($root.isFdrApp && !$ctrl.form.amount.$dirty && !!inputIsNowFocused)\n" +
    "                    }\"></div></div></div><div class=\"row non-table amount-errors-ctn\" ng-if=\"$ctrl.form.amount.$touched || $ctrl.form.$submitted || $ctrl.form.amount.$dirty\"><div ng-messages=\"$ctrl.form.amount.$error\"><div class=\"js-error-label error-label\" ng-message=\"min\" ng-bind-html=\"(('minimum' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.minAmount | currency) | trust )\"></div><div qa-label=\"error-required\" class=\"js-error-label error-label\" ng-message=\"required\" ng-bind-html=\"('required' | CMSLabels: 'paypalLabels' | trust )\"></div><div class=\"js-error-label error-label\" ng-message=\"max\" ng-bind-html=\"(('maximum' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.maxAmount | currency) | trust )\"></div></div></div></div>"
  );


  $templateCache.put('src/paypal/deposits/total-cost/total-cost.template.html',
    "<label ng-if=\"$ctrl.data.loading && !$root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"deposit-summary\" class=\"deposit__summary\"><li ng-if=\"!$root.isFdrApp\" qa-label=\"paypal-email\" ng-if=\"$ctrl.email && !$root.isFdrApp\" ng-bind-html=\"(('email' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.email  | trust ))\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('deposit-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                      (($ctrl.data.netAmount | currency: '$') || '$--') | trust )\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee-amount\" ng-bind-html=\"(('deposit-summary-fee-amount' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                      (($ctrl.data.feeAmount | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee-refund\" ng-bind-html=\"(('deposit-summary-fee-refund' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                    (($ctrl.data.feeRefundAmount | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('deposit-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') + (($ctrl.data.transactionTotal | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></li></ul><label ng-if=\"$ctrl.data.loading && $root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/deposit-limits.html',
    "<div class=\"field\"><h2 class=\"dma-section-title\"><span ng-bind=\"('depositLimitsTitle' | CMSLabels: 'dmaManagementLabels' | trust)\"></span></h2><div class=\"limits\" ng-if=\"(!events.unableToFetchLimits() || !(data.selectedPayOption.ftype === 'IBC' || data.selectedPayOption.ftype === 'ACH' || data.selectedPayOption.ftype === 'CC' || data.selectedPayOption.ftype === 'APPL'))\"><div class=\"limits-table\"><div class=\"header\"><div class=\"header-row\"><div class=\"header-cell\"><span ng-if=\"data.selectedPayOption.ftype === 'APPL'\">Card Type</span> <span ng-if=\"data.selectedPayOption.ftype === 'CC'\">Card Type</span> <span ng-if=\"data.selectedPayOption.ftype === 'IBC'\">Account Type</span></div><div class=\"header-cell\"><span>Daily Limit</span></div><div class=\"header-cell\"><span>Monthly Limit</span></div></div></div><div class=\"body\"><div class=\"body-row\" ng-repeat=\"limitType in data.selectedPayOption.paymentLimits\"><div class=\"body-cell card-type-cell\" qa-label=\"cardTypeCell\"><span>{{limitType.typeName}}</span></div><div class=\"body-cell\"><div class=\"image-row\"><span class=\"image-cell\" qa-label=\"dailyLimitCell\">{{limitType.limitInterval.Daily.Effective | noFractionCurrency}}</span> <button class=\"edit\" ng-click=\"events.editLimit(true, limitType)\" qa-label=\"dailyLimitEditButton\"><strong>Edit</strong></button></div><div ng-if=\"limitType.limitInterval.Daily.ShowFuture\" class=\"image-row\"><span class=\"schedule image-cell\" qa-label=\"dailyLimitFutureCell\">Scheduled to change to {{limitType.limitInterval.Daily.Future | noFractionCurrency}} on {{limitType.limitInterval.Daily.FutureDateStr}}</span></div></div><div class=\"body-cell\"><div class=\"image-row\"><span class=\"image-cell\" qa-label=\"monthlyLimitCell\">{{limitType.limitInterval.Monthly.Effective | noFractionCurrency}}</span> <button class=\"edit\" ng-click=\"events.editLimit(false, limitType)\" qa-label=\"monthlyLimitEditButton\"><strong>Edit</strong></button></div><div ng-if=\"limitType.limitInterval.Monthly.ShowFuture\" class=\"image-row\"><span class=\"schedule image-cell\" qa-label=\"monthlyLimitFutureCell\">Scheduled to change to {{limitType.limitInterval.Monthly.Future | noFractionCurrency}} on {{limitType.limitInterval.Monthly.FutureDateStr}}</span></div></div></div></div></div><div class=\"tvg-dialog-filter\" ng-if=\"data.limitEditor\"></div><limit-editor ng-if=\"data.limitEditor\"><edit-info><span class=\"cell\"></span><div class=\"cell\"><span><strong>Edit - {{depositLimitModel.depositLimitTypeName}} Card</strong></span><div class=\"limit-notification\"><span class=\"icon-input-error\" ng-if=\"data.limitError\"></span> <span ng-if=\"data.limitError\">{{data.limitErrorMessage}}</span></div></div></edit-info><edit-input><span class=\"cell\"><strong>$</strong></span><div class=\"cell\"><div class=\"align-left\"><input class=\"limit-amount\" name=\"limit-value\" ng-min=\"{{depositLimitModel.min||0}}\" ng-model=\"depositLimitModel.amount\" ng-required=\"true\" ng-change=\"events.validateLimitAmount()\" ng-enter=\"events.saveLimit()\" qa-label=\"depositLimitModelInput\"></div><div class=\"align-right\"><button class=\"cancel\" ng-click=\"events.cancelLimitEdition()\" qa-label=\"depositLimitModelCancelButton\"><strong>Cancel</strong></button> <button class=\"save\" ng-disabled=\"data.limitError\" ng-click=\"events.saveLimit()\" qa-label=\"depositLimitModelSaveButton\"><strong>Save</strong></button></div></div></edit-input></limit-editor></div><div ng-if=\"events.unableToFetchLimits() && (data.selectedPayOption.ftype === 'IBC' || data.selectedPayOption.ftype === 'ACH' || data.selectedPayOption.ftype === 'CC' || data.selectedPayOption.ftype === 'APPL')\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchLimits' | CMSValue : null}}</dw-info-dialog></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/new-payment-method.html',
    "<div class=\"table\"><div class=\"row\"><new-method-add class=\"cell\"><button name=\"add-card\" ng-click=\"data.newCardForm = true\"><span class=\"add\"></span> <span>Add a new credit or debit card</span></button></new-method-add><new-method-option class=\"cell\"><span>We accept</span><div class=\"row\"><span class=\"visa-icon\"></span> <span class=\"mastercard-icon\"></span></div></new-method-option></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-card.html',
    "<div class=\"payment-management-option-main payment-management-block-grid\"><div class=\"payment-management-icon\"><div class=\"credit-card__placeholder\"></div></div><div class=\"payment-management-info\"><ul><li><strong ng-if=\"$ctrl.card.ftype === 'CC'\" ng-bind=\"$ctrl.card.typeName + ' Card'\"></strong> <strong ng-if=\"$ctrl.card.ftype === 'ACH'\" ng-bind=\"::$ctrl.card.bankName\"></strong></li><li ng-if=\"$ctrl.card.ftype === 'CC'\">{{\"xxxx-xxxx-xxxx-\" + $ctrl.card.cardNumber}}</li><li ng-if=\"$ctrl.card.ftype === 'ACH'\">*****{{$ctrl.sliceCard({number: $ctrl.card.bankAccNumber})}}</li><li ng-if=\"$ctrl.card.ftype === 'CC'\">Expires {{$ctrl.card.expirationDate}}</li></ul></div><a ng-if=\"$ctrl.card.ftype === 'CC'\" class=\"payment-management-close\" href ng-click=\"$ctrl.removeCard({card: card})\"><i class=\"tvg-icon-close\"></i></a></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-on-file-list.html',
    "<div class=\"field\"><payment-method-on-file-option ng-attr-card=\"card\" ng-attr-on-edit-card-action=\"events.showEditCardConfirmModal(card)\" ng-attr-on-go-to-deposit=\"events.goToDeposit(card, $index)\" ng-attr-on-remove-card-action=\"events.showRemoveCardConfirmModal(card)\" ng-attr-index=\"$index\" ng-repeat=\"card in data.selectedPayOption.onFile track by $index\"></payment-method-on-file-option><div ng-if=\"data.selectedPayOption.onFile.length === 0\"><p class=\"text-center\" ng-if=\"data.selectedPayOption.ftype === 'IBC'\" ng-bind=\"('noAccountsFound' | CMSLabels: 'dmaManagementLabels')\"></p><p class=\"text-center\" ng-if=\"data.selectedPayOption.ftype === 'CC'\" ng-bind=\"('no-cards-found' | CMSLabels: 'dmaDepositLabels')\"></p></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-on-file-option.html',
    "<div class=\"payment-management-option\" ng-class=\"{'payment-management-option--expired': card.isExpired}\" ng-controller=\"ManagePaymentMethodsController\" qa-label=\"paymentManagementOption\"><span ng-if=\"card.isExpired\" class=\"expired-card-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-if=\"card.IsPending\" class=\"expired-card-label\">{{'pendingAccount' | CMSLabels: 'dmaManagementLabels'}}</span><payment-method-card card=\"card\" remove-card=\"onRemoveCardAction(card)\" slice-card=\"events.slicedCard(number)\"></payment-method-card><ul class=\"payment-management-action-list\"><li><a href class=\"payment-management-action payment-management-action--primary\" ng-click=\"onGoToDeposit({index: index, card: card})\" qa-label=\"paymentManagementActionDepositButton\">Deposit</a></li><li ng-if=\"card.ftype === 'CC'\"><a href class=\"payment-management-action payment-management-action--secondary\" ng-click=\"onEditCardAction({card: card})\" qa-label=\"paymentManagementActionEditDetailsButton\">Edit Details</a></li></ul></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-methods-type-selector.html',
    "<payment-methods-options-container><payment-methods-option ng-repeat=\"option in data.paymentMethodsOptions\" ng-click=\"data.selectedPayOption = option; events.resetDataModel()\" ng-class=\"{selected:data.selectedPayOption.name == option.name}\">{{option.name}}</payment-methods-option></payment-methods-options-container>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/titles.html',
    "<h2 class=\"dma-section-title\" ng-if=\"$ctrl.type === 'CC'\"><span ng-bind=\"('creditCardTitle' | CMSLabels: 'dmaManagementLabels')\"></span> <a class=\"dma-section-link\" href ng-click=\"$ctrl.redirectAdd({type: $ctrl.type})\" ng-bind=\"('addNewCardLink' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"addNewCCardLink\"></a></h2><h2 class=\"dma-section-title\" ng-if=\"$ctrl.type === 'IBC'\"><span ng-bind=\"('betCashTitle' | CMSLabels: 'dmaManagementLabels')\"></span><div class=\"dma-section-link\"><a href ng-click=\"events.redirectToAddNewCard($ctrl.type)\" ng-bind=\"('addNewAccountLink' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"addNewAccountLink\"></a> <span ng-if=\"!njxIntegration\" ng-bind=\"('submit' | CMSLabels: 'dmaManagementLabels')\"></span> <a ng-if=\"!njxIntegration\" target=\"_blank\" ng-href=\"{{('linkBetcash' | CMSLabels: 'dmaManagementLabels')}}\" ng-bind=\"('BetcashAgreement' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"BetcashAgreementLink\"></a><div></div></div></h2><p ng-if=\"$ctrl.type === 'IBC' && $ctrl.length > 0\" class=\"disclaimer\" ng-bind-html=\"('callSupport' | CMSLabels: 'dmaManagementLabels')\"></p>"
  );


  $templateCache.put('src/templates/managePaymentMethods/manage-payment-methods.html',
    "<div class=\"tvg-deposit\" name=\"managePaymentMethodsDiv\" ng-controller=\"ManagePaymentMethodsController\" ng-class=\"{loading: data.loading}\"><deposit-options-container class=\"dma-nav dma-nav-tabs\"><deposit-option ng-repeat=\"option in data.paymentMethodsOptions track by $index\" ng-click=\"events.selectOption(option)\" ng-class=\"{selected:data.selectedPayOption.ftype === option.ftype}\"><span qa-label=\"{{::option.ftype}}\">{{::option.name}}</span></deposit-option></deposit-options-container><div class=\"before-notification\"></div><dw-info-dialog ng-if=\"data.errorPaymentRestrictions && !data.loading\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'depositInitialDataErrorMessage' | CMSValue : null}}</dw-info-dialog><form class=\"deposit-form\" name=\"depositFrm\" ng-if=\"!data.errorPaymentRestrictions && !data.loading\" ng-submit=\"data.newCardForm ? events.addNewCard(depositFrm): data.editCardForm ? events.editCard(depositFrm) : null\" novalidate><payment-titles type=\"data.selectedPayOption.ftype\" length=\"data.selectedPayOption.onFile.length\" redirect-add=\"events.redirectToAddNewCard(type)\"></payment-titles><div class=\"payment-method-container\"><payment-method-on-file-list ng-if=\"(data.selectedPayOption.ftype !== 'IBC' || !data.unableToFetchBankAccounts)\n" +
    "     && (data.selectedPayOption.ftype !== 'CC' || !data.unableToFetchCardsOnFile)\"></payment-method-on-file-list><div ng-if=\"data.selectedPayOption.ftype === 'IBC' && data.unableToFetchBankAccounts\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchBankAccounts' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"data.selectedPayOption.ftype === 'CC' && data.unableToFetchCardsOnFile\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchCardsOnFile' | CMSValue : null}}</dw-info-dialog></div><deposit-limits ng-if=\"data.showLimits\"></deposit-limits></div><div ng-if=\"data.editCardForm\" class=\"payment-method-container\"><div class=\"form-fields\" ng-repeat=\"field in data.forms['NEW']['CC']\"><div ng-include=\"'src/templates/deposit/fields/'+field+'.html'\"></div></div><div class=\"field\"><button class=\"submit add-payment\" ng-disabled=\"data.savingCard\" type=\"submit\"><strong>Edit credit card details</strong></button><p ng-if=\"!notifyErrors\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered\">This form contains errors. Please fix all errors before continuing.</p></div></div></form></div>"
  );


  $templateCache.put('src/templates/transfer/fields/transfer-amount-input.html',
    "<div class=\"table\" ng-class=\"{ 'dma-amount-table' : $root.product == 'njx' }\" qa-label=\"dmaAmountTable\"><div class=\"row\"><span class=\"cell title\">I want to transfer $</span> <span class=\"cell\"></span> <span class=\"cell\"><div ng-if=\"transferFrm.amount.$error.min\" class=\"js-error-label error-label minimum\" ng-class=\"{invalidAmount: transferFrm.amount.$invalid && transferFrm.amount.$dirty}\">Minimum {{(transferDataModel.min) | currency}}</div><div ng-if=\"transferFrm.amount.$error.max\" class=\"js-error-label error-label maximum\" ng-class=\"{invalidAmount: transferFrm.amount.$invalid && transferFrm.amount.$dirty}\">Maximum {{(transferDataModel.max) | currency}}</div></span></div><div class=\"row\"><span class=\"cell w160\"><toggle-options><button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[0]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[0];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[0]}}</button> <button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[1]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[1];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[1]}}</button> <button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[2]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[2];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[2]}}</button></toggle-options></span><span class=\"cell minw30\">or <span class=\"amount-dollar-label\">$</span></span> <span class=\"cell\"><input class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other Amount\" min=\"{{transferDataModel.min}}\" max=\"{{transferDataModel.max}}\" maxlength=\"9\" step=\"0.01\" ng-model=\"transferDataModel.amount\" ng-model-options=\"{debounce: 500}\" ng-required=\"true\" ng-disable=\"data.loading\" restrict-chars qa-label=\"transferFundsExchange\"></span></div></div>"
  );


  $templateCache.put('src/templates/transfer/fields/transfer-source-destination.html',
    "<div class=\"form-fields\"><div class=\"field\"><span class=\"input-container\"><select-container class=\"others\"><select class=\"card\" name=\"slcOrigin\" ng-disable=\"data.loading\" ng-model=\"transferDataModel.source\" ng-options=\"option.label for option in data.optionsAccounts\" ng-change=\"events.selectSource()\" qa-label=\"exchangeFromSelect\"><option value=\"\" disabled=\"disabled\">{{'depositAchOnFileSelectionLabel' | CMSValue : null}}</option></select> <span qa-label=\"transferSourceLabel\">{{transferDataModel.source.label || 'From' }}</span></select-container></span></div><div class=\"field\"><select-container><select class=\"ng-pristine ng-valid ng-touched\" name=\"slcDestination\" ng-disable=\"data.loading\" ng-model=\"transferDataModel.destination\" ng-options=\"option.label for option in data.optionsAccounts\" ng-change=\"events.selectDestination()\" qa-label=\"exchangeToSelect\"><option value=\"\" disabled=\"disabled\">{{'depositAchOnFileSelectionLabel' | CMSValue : null}}</option></select> <span qa-label=\"transferDestinationLabel\">{{transferDataModel.destination.label || 'To' }}</span></select-container></div></div>"
  );


  $templateCache.put('src/templates/transfer/transfer.html',
    "<div class=\"tvg-deposit tvg-deposit-transfer\" ng-controller=\"TransferController\"><div ng-class=\"{'loading': data.loading}\"></div><dw-info-dialog ng-if=\"data.errorDepositRestrictions\" ng-bind=\"data.message\"></dw-info-dialog><form ng-if=\"!data.errorDepositRestrictions\" class=\"deposit-form\" name=\"transferFrm\" ng-submit=\"events.makeTransfer(transferFrm)\" ng-class=\"{loading: data.makingTransfer}\"><transfer-amount-input></transfer-amount-input><div class=\"disclaimer\">Although you can access both 4NJbets and the Betfair Exchange, you'll need to transfer funds between them in order to bet.</div><transfer-source-destination></transfer-source-destination><div ng-if=\"transferDataModel.isPending != true\" class=\"field\"><button class=\"submit add-funds\" ng-disabled=\"(data.makingTransfer || !transferDataModel.source || !transferDataModel.destination || !transferDataModel.amount || !transferFrm.$valid || data.loading)\" type=\"submit\"><strong>Transfer funds</strong></button><p ng-if=\"!notifyErrors\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered\">This form contains errors. Please fix all errors before continuing.</p></div></form></div>"
  );


  $templateCache.put('src/templates/withdraw/desktop/pendingWithdrawals/pending-withdraw-element.html',
    "<li qa-label=\"pending-withdrawal-element\"><!-- Cancel Confirmation --><div class=\"pending-messages warning-message\" qa-label=\"pending-withdrawal-cancel-confirmation\" ng-show=\"showConfirmation\"><div class=\"warning-info\" qa-label=\"pending-withdrawal-cancel-confirmation-message\"><i class=\"tvg-icon-warning-2\"></i> <strong>Are you sure you want to cancel this withdraw?</strong></div><div class=\"action-buttons\"><button class=\"warning-message-cancel\" ng-click=\"undoCancel()\" qa-label=\"pending-withdrawal-cancel-button\" ng-disabled=\"loading\">Cancel</button> <button class=\"warning-message-confirm\" ng-click=\"cancelPendingWithdraw()(item.withdrawalId)\" qa-label=\"pending-withdrawal-confirm-button\" ng-disabled=\"loading\">Confirm</button></div></div><!-- Messages --><div class=\"pending-messages feedback-message animate-hide\" qa-label=\"pending-withdrawal-feedback-message\" ng-show=\"showMessage\" ng-class=\"{'error-message': isError || isCriticalError, 'success-message': isSuccess, 'warning-message': isWarning}\"><i class=\"tvg-icon-success animate-hide\" ng-show=\"isSuccess\"></i> <i class=\"tvg-icon-danger animate-hide\" ng-show=\"isError || isWarning\"></i><div qa-label=\"pending-withdrawal-feedback-error-message\" class=\"animate-hide\" ng-show=\"isError\" ng-bind-html=\"errorMessage\"></div><div qa-label=\"pending-withdrawal-feedback-success-message\" class=\"animate-hide\" ng-show=\"isSuccess\">{{successMessage}}</div><div qa-label=\"pending-withdrawal-feedback-warning-message\" class=\"animate-hide\" ng-show=\"isWarning\">{{warningMessage}}</div><i class=\"tvg-icon-times close-button\" ng-click=\"onRemoveMessage()\" qa-label=\"pending-withdrawal-feedback-message-close\"></i></div><!-- Withdrawal content --><div qa-label=\"pending-withdrawal-element-date\" class=\"pending-withdraw-datetime\" ng-bind=\"item.DateInitiated | date :'MM/dd/yyyy'\"></div><div qa-label=\"pending-withdrawal-element-type\" class=\"pending-withdraw-type\" ng-bind=\"getBetTypeName(item.paymentType)\"></div><div ng-if=\"!njxIntegration\" qa-label=\"pending-withdrawal-element-accNumber\" class=\"pending-withdraw-account\" ng-bind=\"$root.user.accountNumber\"></div><div qa-label=\"pending-withdrawal-element-amount\" class=\"pending-withdraw-amount\" ng-bind=\"'$' + item.amount\"></div><div class=\"pending-withdraw-cancel\"><button qa-label=\"pending-withdrawal-element-cancel-button\" id=\"cancelWithdraw\" class=\"pending-withdrawals-button\" ng-show=\"!showConfirmation && showCancelButton && !item.processing\" ng-click=\"onCancel()\">Cancel Withdraw</button></div></li>"
  );


  $templateCache.put('src/templates/withdraw/desktop/pendingWithdrawals/withdraw-pending-requests.html',
    "<div class=\"panel\" qa-label=\"withdraw-pending-requests\" ng-if=\"showPendingWithdrawls\" ng-controller=\"WithdrawCancelController\" ng-class=\"{'component-loading': model.isLoading}\"><h2>Pending Request</h2><div class=\"panel-body\"><table class=\"table pending-requests-table no-margin\" ng-if=\"model.withdrawPendingList.length && !model.errorFetchingPending\"><thead><tr><th>Date</th><th>Type</th><th ng-if=\"!njxIntegration\">Account #</th><th>Amount</th><th></th></tr></thead></table><ul qa-label=\"pending-withdrawals-elements-container\" class=\"pending-withdrawals-information\" ng-if=\"model.withdrawPendingList.length && !model.errorFetchingPending\"><pending-withdraw-element ng-repeat=\"item in model.withdrawPendingList track by item.withdrawalId\" item=\"item\" loading=\"model.isLoading\" cancel-pending-withdraw=\"events.cancelPendingWithdraw\"></pending-withdraw-element></ul><!-- Message with no withdrawals --> <label qa-label=\"pending-withdrawals-no-elements\" class=\"centered-label\" ng-if=\"model.withdrawPendingList.length == 0 && !model.isLoading && !model.errorFetchingPending\">No more pending withdrawals</label><!-- Error message when there's an error fetching the pending withdrawals--> <label qa-label=\"pending-withdrawals-error-fetching\" class=\"centered-label\" ng-if=\"model.errorFetchingPending\">An error occurred while fetching your pending withdrawals</label></div></div><h2 ng-if=\"showPendingWithdrawls\">New Request</h2><!-- This should disappear when the withdraws section is remade for desktop version-->"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-account-info.html',
    "<!-- Account info --><div ng-if=\"!isDesktop\"><div class=\"account-info table\"><div class=\"row\" ng-if=\"!$root.isFdrApp\"><span class=\"cell\">Account #</span> <span class=\"cell\">Balance</span> <span class=\"cell\">Available to Withdraw</span></div><div class=\"row\" ng-if=\"$root.isFdrApp\"><span class=\"cell\">Account</span> <span class=\"cell\">Balance</span> <span class=\"cell\">Valid Withdraw</span></div><div class=\"row\"><span qa-label=\"account-number\" class=\"cell\">{{ data.accountId || \"N/A\" }}</span> <span qa-label=\"account-balance\" class=\"cell\">{{ data.balance || \"$--\" }}</span> <span qa-label=\"available-balance\" class=\"cell\">{{ (data.availableBalance | currency: '$') || \"$--\" }}</span></div></div><tvg-collapse qa-label=\"max-withdraw-info\" ng-if=\"data.balance && data.balance !== (data.availableBalance | currency: '$')\" class=\"info-message\" ng-attr-title=\"{{'maxWithdrawLessTotalBalanceTitle' | CMSLabels: 'withdrawLabels'}}\"><p qa-label=\"max-withdraw-info-message\" ng-bind-html=\"'maxWithdrawLessTotalBalance' | CMSLabels: 'withdrawLabels' | trust\"></p></tvg-collapse></div><div ng-if=\"isDesktop\"><dw-info-message qa-label=\"max-withdraw-info\" ng-if=\"data.balance && data.balance !== (data.availableBalance | currency: '$')\" ng-attr-title=\"{{'maxWithdrawLessTotalBalanceTitle' | CMSLabels: 'withdrawLabels'}}\" ng-attr-message=\"{{'maxWithdrawLessTotalBalance' | CMSLabels: 'withdrawLabels'}}\"></dw-info-message><dw-info-message qa-label=\"withdrawNoCardsAvailable-info\" ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD' && data.cardsOnFile.length === 0\" ng-attr-title=\"{{'withdrawNoCardsAvailableTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'withdrawNoCardsAvailable' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><dw-info-message qa-label=\"chequeRequestProcessing-info\" ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\" ng-attr-title=\"{{'chequeRequestProcessingTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'chequeRequestProcessing' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><div class=\"account-info table dma-account-info\"><table><thead><tr><th ng-bind-html=\"'balanceLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-bind-html=\"'availableToWithdrawLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'BETCASH'\" ng-bind-html=\"'tvgBetCashAccountLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\" ng-bind-html=\"'addressLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\" ng-bind-html=\"'debitCardLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'PAY' && data.providerEmail\" ng-bind-html=\"providerEmailLabel\"></th><th ng-bind-html=\"'withdrawAmountLabel' | CMSLabels: 'withdrawLabels' | trust\"></th></tr></thead><tbody><tr qa-label=\"error-message\" ng-if=\"withdrawFrm.newAmount.$invalid && (withdrawFrm.newAmount.$touched || withdrawFrm.$submitted)\" class=\"error-row\"><td colspan=\"{{ showThreeColumns() ? '3' : '4' }}\"><span class=\"alert-box red\" ng-bind=\"getInvalidWithdrawalMessage(withdrawFrm.newAmount, data.minWithdraw)\"></span></td></tr><tr><td qa-label=\"account-balance\" ng-bind=\"data.balance || '$--'\"></td><td qa-label=\"available-balance\" ng-bind=\"(data.availableBalance | currency: '$') || '$--'\"></td><td ng-if=\"data.selectedWithdrawOption.id === 'PAY' && data.providerEmail\"><div qa-label=\"paypal-email-value\">{{data.providerEmail}}</div></td><td ng-if=\"!showAddressForPayment()\" class=\"select-cell\"><!-- tvg bet cash accounts select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'BETCASH'\"><span ng-if=\"data.availableBetCashAccounts.length > 0\"><select-container><select qa-label=\"betcash-bank-selector\" ng-model=\"data.selectedBetCashAccount\" ng-options=\"option.name for option in data.availableBetCashAccounts\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\" ng-change=\"events.setCurrentBetCash(data.selectedBetCashAccount)\"></select> <span ng-bind=\"data.selectedBetCashAccount.name\"></span></select-container></span><span ng-if=\"data.availableBetCashAccounts.length == 0\">No Bet Cash Accounts Available.</span></div><!-- check addresses select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\"><span ng-if=\"data.availableCheckOptions.length > 0\"><select-container><select qa-label=\"check-address-selector\" ng-model=\"data.selectedAddressSection\" ng-options=\"option.name for option in data.availableCheckOptions\" ng-change=\"events.toggleHomeMailMethods(data.selectedAddressSection)\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\"></select> <span ng-bind=\"data.selectedAddressSection.name\"></span></select-container></span><span ng-if=\"data.availableCheckOptions.length == 0\" ng-bind-html=\"'noAddressAvailableLabel' | CMSLabels: 'withdrawLabels' | trust\"></span></div><!-- tvg credit card select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\"><span ng-if=\"data.cardsOnFile.length > 0\"><select-container><select qa-label=\"betcash-bank-selector\" ng-model=\"data.selectedCardOnFile\" ng-options=\"option.name for option in data.cardsOnFile\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\" ng-change=\"events.setCurrentCardOnFile(data.selectedCardOnFile)\"></select> <span ng-bind=\"data.selectedCardOnFile.name\"></span></select-container></span></div></td><td class=\"amount-cell\"><div class=\"field amount-input\"><div class=\"input-container\"><input qa-label=\"withdraw-amount\" class=\"withdraw-amount-input\" name=\"newAmount\" type=\"number\" max=\"{{ getMaxWithdrawValue() }}\" min=\"{{ data.minWithdraw }}\" step=\"0.01\" num-length=\"30\" ng-model=\"withdrawDataModel.amount\" ng-model-options=\"{ debounce: 300 }\" ng-required=\"true\" pattern=\"^\\d+(?:\\.\\d{1,2})?$\" placeholder=\"$0.00\" ng-blur=\"events.changeAmount(withdrawFrm.amount.$touched, withdrawFrm.amount.$valid)\"></div></div><div class=\"btn-container\"><button qa-label=\"withdraw-button\" class=\"submit withdraw-btn\" type=\"submit\" ng-if=\"(data.selectedWithdrawOption.id !== 'BETCASH' || data.availableBetCashAccounts.length > 0)\"><strong><i class=\"tvg-icon-login\"></i> <span ng-bind-html=\"'authorizeWithdrawalBtn' | CMSLabels: 'withdrawLabels' | trust\"></span></strong></button></div></td></tr><tr ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\"><td></td><td></td><td class=\"check-address\"><p qa-label=\"check-address-selected\" ng-if=\"data.selectedAddressSection\" ng-bind=\"data.selectedAddressSection.address\"></p></td><td></td></tr><tr ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\"><td></td><td></td><td></td><td><label class=\"fee\" ng-bind-html=\"'withdraw-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"withdraw-summary\" class=\"deposit__summary\"><li qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('withdraw-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                            ((withdrawDataModel.amount | currency: '$') || '$--') | trust )\"></li><li qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('withdraw-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                            ((0 | currency: '$') || '$--') | trust ) + ('</span>')\"></li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('withdraw-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                            ((withdrawDataModel.amount | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></ul></td></tr></tbody></table></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-amount-input.html',
    "<div class=\"field withdraw-input-ctn withdraw-amount-input clearfix\" ng-if=\"!isDesktop\" ng-class=\"{\n" +
    "      inputIsInvalid: $root.isFdrApp && withdrawFrm.amount.$invalid && (withdrawFrm.amount.$touched || withdrawFrm.$submitted),\n" +
    "      inputIsFocused: $root.isFdrApp && inputIsFocused\n" +
    "    }\"><div class=\"label withdraw-amount-label\"><span>Withdraw amount (min. $2)</span></div><div class=\"input-container\"><span>$</span> <input qa-label=\"withdraw-amount\" class=\"withdraw-amount-input\" name=\"amount\" type=\"number\" max=\"{{getMaxWithdrawValue()}}\" min=\"{{data.minWithdraw}}\" step=\"0.01\" num-length=\"30\" ng-model=\"withdrawDataModel.amount\" ng-required=\"true\" ng-pattern=\"data.numberPattern\" placeholder=\"00.00\" money-formater restrict-chars ng-focus=\"inputIsFocused = true; events.started()\"></div><span qa-label=\"error-message\" class=\"js-error-label error-label\" ng-if=\"withdrawFrm.amount.$invalid && (withdrawFrm.amount.$touched || withdrawFrm.$submitted)\" ng-bind=\"getInvalidWithdrawalMessage(withdrawFrm.amount, data.minWithdraw)\"></span></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-betcash-selector.html',
    "<div ng-if=\"!isDesktop\"><section-title ng-if=\"!$root.isFdrApp\" title=\"BetCash Accounts\" index=\"\"></section-title><section-title ng-if=\"$root.isFdrApp\" title=\"Echeck Accounts\" index=\"\"></section-title><div qa-label=\"betcash-bank-selector\" class=\"deposit-card-options\" ng-if=\"data.availableBetCashAccounts.length > 0\"><ul><li qa-label=\"betcash-bank-option\" ng-repeat=\"card in data.availableBetCashAccounts track by card.achId\" class=\"card\"><label ng-class=\"{'active': data.selectedBetCashAccount === card}\"><strong ng-bind=\"::($root.isFdrApp ? card.bankName.toLowerCase() : card.bankName)\"></strong><div ng-bind=\"::card.name\"></div><input type=\"radio\" ng-model=\"data.selectedBetCashAccount\" ng-change=\"events.setCurrentBetCash(data.selectedBetCashAccount)\" ng-value=\"card\"></label></li></ul></div><div class=\"field\" ng-if=\"data.availableBetCashAccounts.length === 0\"><span>{{ $root.isFdrApp ? 'No Echeck Accounts Available.' : 'No Bet Cash Accounts Available.'}}</span></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-card-selector.html',
    "<div ng-if=\"!isDesktop\"><section-title title=\"Select debit card\" index=\"\"></section-title><div qa-label=\"withdraw-card-selector\" class=\"deposit-card-options\" ng-if=\"data.cardsOnFile.length > 0\"><ul qa-label=\"cardsList\" ng-init=\"data.pageSetFromParams ? null : data.selectedCardOnFile = data.cardsOnFile[0]; events.setCurrentCardOnFile(data.selectedCardOnFile) \"><li qa-label=\"ccCardsOnFile\" ng-repeat=\"card in data.cardsOnFile track by card.id\" class=\"card\"><label qa-label=\"cardInfo\" ng-class=\"{'active': data.selectedCardOnFile === card ||\n" +
    "                                    (card.ftype === 'CC' && data.selectedCardOnFile.id === card.id) }\"><strong ng-bind=\"::card.network\"></strong><div><span ng-if=\"card.isExpired\" class=\"expired-card-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-bind=\"::card.cardNumberExt\"></span> (<span ng-bind=\"::card.expirationDate\"></span>)</div><input qa-label=\"cardSelection\" type=\"radio\" ng-model=\"data.selectedCardOnFile\" ng-change=\"events.setCurrentCardOnFile(card)\" ng-value=\"card\"></label></li></ul></div><dw-info-message qa-label=\"withdrawNoCardsAvailable-info\" ng-if=\"data.cardsOnFile.length === 0\" ng-attr-title=\"{{'withdrawNoCardsAvailableTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'withdrawNoCardsAvailable' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-home-mail-selector.html',
    "<section-title index=\"\" title=\"Select Address\" ng-if=\"!isDesktop\"></section-title><div ng-if=\"!isDesktop\"><dw-info-message qa-label=\"chequeRequestProcessing-info\" ng-attr-title=\"{{'chequeRequestProcessingTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'chequeRequestProcessing' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><div qa-label=\"check-address-selector\" class=\"deposit-card-options\" ng-if=\"data.availableCheckOptions.length > 0\"><ul><li qa-label=\"check-address-option\" ng-repeat=\"card in data.availableCheckOptions\" class=\"card\" ng-if=\"card.address && card.address.length\"><label ng-class=\"{'active': data.selectedAddressSection.id == card.id}\"><strong ng-bind=\"::card.name\"></strong><div ng-bind=\"::card.address\"></div><input type=\"radio\" ng-model=\"data.selectedAddressSection\" ng-change=\"events.toggleHomeMailMethods(card)\" ng-value=\"card\"></label></li></ul></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-provider-email.html',
    "<div ng-if=\"(data.selectedWithdrawOption.id === 'PAY' && data.providerEmail) && !isDesktop\" class=\"paypal-account-details\"><section-title title=\"{{$root.isFdrApp ? 'Paypal Account Details' : 'Details' }}\" index=\"\"></section-title><div qa-label=\"provider-email\"><strong ng-if=\"!$root.isFdrApp\" ng-bind-html=\"'email' | CMSLabels: 'paypalLabels' | trust\"></strong> <strong ng-if=\"$root.isFdrApp\">Email address set to: </strong>{{ data.providerEmail }}</div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-total-cost.html',
    "<div ng-if=\"!isDesktop\"><section-title title=\"{{'withdraw-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust}}\" index=\"\"></section-title><ul qa-label=\"withdraw-summary\" class=\"deposit__summary disabled_fdr_styles withdraw-left-padding\"><li qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('withdraw-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                          ((withdrawDataModel.amount | currency: '$') || '$--') | trust )\"></li><li qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('withdraw-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                          ((0 | currency: '$') || '$--') | trust ) + ('</span>')\"></li><strong qa-label=\"deposit-summary-total\" class=\"bold\" ng-bind-html=\"(('withdraw-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                          ((withdrawDataModel.amount | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></ul></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-type-selector.html',
    "<withdraw-options-container class=\"dma-nav dma-nav-tabs\"><withdraw-option ng-repeat=\"option in data.withdrawOptions\" qa-label=\"{{option.qalabel}}\" ng-click=\"events.toggleWithdrawOptions(option)\" ng-class=\"{selected:data.selectedWithdrawOption == option}\"><span ng-bind=\"option.name\"></span></withdraw-option></withdraw-options-container>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-cancel.html',
    "<div class=\"tvg-deposit\" ng-controller=\"WithdrawCancelController\" ng-class=\"{loading: data.isLoading}\"><div class=\"before-notification\"></div><div class=\"withdraw-cancel-container\" ng-if=\"!data.isLoading\"><dw-info-dialog><p>Changed your mind?</p>Cancel pending withdrawals for immediate access to your funds.</dw-info-dialog><table class=\"table-withdrawals\" ng-if=\"data.withdrawPendingList.length\"><tr><th>DATE</th><th>TYPE</th><th>AMOUNT</th><th>ACTION</th></tr><tr ng-repeat=\"item in data.withdrawPendingList\"><td ng-bind=\"item.transactionDate | date :'MM/dd/yyyy'\"></td><td ng-bind=\"item.paymentType\"></td><td ng-bind=\"item.amount | currency\"></td><td><button class=\"red\" ng-click=\"cancelPendingWithdraw(item.withdrawalId)\">Cancel</button></td></tr></table><label class=\"no-withdrawals-message\" ng-if=\"!data.withdrawPendingList.length\">No more pending withdrawals</label></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-error.html',
    "<div class=\"handler-error-container\"><span class=\"image\"></span><h1 class=\"title\">Error!</h1><div class=\"message-container\"><h2><strong>This method of withdrawal doesn't seem to be going through.</strong></h2><p class=\"customer_service\" ng-bind-html=\"('widthdrawErrorDefault'| CMSValue : null) | trust\"></p></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-success.html',
    "<div class=\"handler-success-container\"><span class=\"image\"></span><h1 class=\"title\">Success!</h1><div class=\"message-container\"><h2><strong>Withdrawal Request Successful.</strong></h2><p class=\"message\">{{withdraw.description}}<!--TODO: CMS--></p></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw.html',
    "<withdraw-pending-requests qa-label=\"pending-withdrawals\" class=\"withdraw-pending-requests-desktop\" ng-if=\"showPendingWithdrawals &&\n" +
    "        !data.isLoading && !data.errorFetchingData\"></withdraw-pending-requests><div ng-show=\"!data.showingFallback\" class=\"tvg-deposit\" ng-class=\"{loading: data.isLoading, 'njx-deposit': njxIntegration}\"><!-- Toggles between CHECK and BetCash option --><withdraw-type-selector></withdraw-type-selector><section ng-if=\"!data.unableToFetchProfile\" ng-class=\"{'loading sightline-loading': sightlineLoading}\"><sightline-enrollment ng-if=\"displays.isSightlineApiEnrollmentVisible()\" ng-controller=\"SightlineController\" qa-label=\"sln-api-enrollment\" ng-class=\"{'loading': data.isEnrollingCard}\"></sightline-enrollment></section><form novalidate qa-label=\"withdraw-form\" name=\"withdrawFrm\" ng-submit=\"events.withdraw(withdrawFrm)\" ng-if=\"(!data.isLoading && !data.errorFetchingData &&\n" +
    "            data.selectedWithdrawOption.id !== 'SLN' ||\n" +
    "            data.hasSightlineAccount) &&\n" +
    "            !payPalTVG3() &&\n" +
    "            !payPalNJX() &&\n" +
    "            !(data.selectedWithdrawOption.id === 'BETCASH' && data.unableToFetchBankAccounts) &&\n" +
    "            !(data.selectedWithdrawOption.id === 'CHECK' && data.unableToFetchProfile)\"><!-- Dynamically render fields depending on selected withdraw option --><div ng-repeat=\"field in data.forms[data.selectedWithdrawOption.id]\"><div ng-include=\"'src/templates/withdraw/fields/' + field + '.html'\"></div></div><!-- Withdraw button --> <button qa-label=\"withdraw-button\" ng-if=\"(data.selectedWithdrawOption.id != 'BETCASH' || data.availableBetCashAccounts.length > 0) && !isDesktop\" class=\"submit withdraw-btn\" type=\"submit\"><strong><i class=\"tvg-icon-lock\"></i> Authorize Withdrawal</strong></button></form><div ng-if=\"payPalTVG3()\" class=\"disclaimer paypal-disclaimer\" ng-bind-html=\"'tvg3Message' | CMSLabels: 'paypalLabels'\"></div><div class=\"disclaimer paypal-disclaimer\" ng-if=\"payPalNJX()\">Coming Soon</div><dw-info-dialog qa-label=\"fetching-error-message\" ng-if=\"!data.isLoading && (data.errorFetchingData || (data.selectedWithdrawOption.id === 'BETCASH' && data.unableToFetchBankAccounts))\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsBetcashUnableToFetchBankAccounts' | CMSValue : null}}</dw-info-dialog><dw-info-dialog qa-label=\"fetching-error-message\" ng-if=\"!data.isLoading && (data.errorFetchingData ||\n" +
    "        ((data.selectedWithdrawOption.id === 'CHECK' || data.selectedWithdrawOption.id === 'SLN') && data.unableToFetchProfile))\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'withdrawUnableToFetchProfile' | CMSValue : null}}</dw-info-dialog></div><dw-info-dialog ng-if=\"!data.loading && !$root.isFdrApp && data.showingFallback\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'withdrawalNoPaymentMethodsAvailable' | CMSValue : null}}</dw-info-dialog>"
  );

}]);

angular.module('TVG.Withdraw').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/templates/withdraw/desktop/pendingWithdrawals/pending-withdraw-element.html',
    "<li qa-label=\"pending-withdrawal-element\"><!-- Cancel Confirmation --><div class=\"pending-messages warning-message\" qa-label=\"pending-withdrawal-cancel-confirmation\" ng-show=\"showConfirmation\"><div class=\"warning-info\" qa-label=\"pending-withdrawal-cancel-confirmation-message\"><i class=\"tvg-icon-warning-2\"></i> <strong>Are you sure you want to cancel this withdraw?</strong></div><div class=\"action-buttons\"><button class=\"warning-message-cancel\" ng-click=\"undoCancel()\" qa-label=\"pending-withdrawal-cancel-button\" ng-disabled=\"loading\">Cancel</button> <button class=\"warning-message-confirm\" ng-click=\"cancelPendingWithdraw()(item.withdrawalId)\" qa-label=\"pending-withdrawal-confirm-button\" ng-disabled=\"loading\">Confirm</button></div></div><!-- Messages --><div class=\"pending-messages feedback-message animate-hide\" qa-label=\"pending-withdrawal-feedback-message\" ng-show=\"showMessage\" ng-class=\"{'error-message': isError || isCriticalError, 'success-message': isSuccess, 'warning-message': isWarning}\"><i class=\"tvg-icon-success animate-hide\" ng-show=\"isSuccess\"></i> <i class=\"tvg-icon-danger animate-hide\" ng-show=\"isError || isWarning\"></i><div qa-label=\"pending-withdrawal-feedback-error-message\" class=\"animate-hide\" ng-show=\"isError\" ng-bind-html=\"errorMessage\"></div><div qa-label=\"pending-withdrawal-feedback-success-message\" class=\"animate-hide\" ng-show=\"isSuccess\">{{successMessage}}</div><div qa-label=\"pending-withdrawal-feedback-warning-message\" class=\"animate-hide\" ng-show=\"isWarning\">{{warningMessage}}</div><i class=\"tvg-icon-times close-button\" ng-click=\"onRemoveMessage()\" qa-label=\"pending-withdrawal-feedback-message-close\"></i></div><!-- Withdrawal content --><div qa-label=\"pending-withdrawal-element-date\" class=\"pending-withdraw-datetime\" ng-bind=\"item.DateInitiated | date :'MM/dd/yyyy'\"></div><div qa-label=\"pending-withdrawal-element-type\" class=\"pending-withdraw-type\" ng-bind=\"getBetTypeName(item.paymentType)\"></div><div ng-if=\"!njxIntegration\" qa-label=\"pending-withdrawal-element-accNumber\" class=\"pending-withdraw-account\" ng-bind=\"$root.user.accountNumber\"></div><div qa-label=\"pending-withdrawal-element-amount\" class=\"pending-withdraw-amount\" ng-bind=\"'$' + item.amount\"></div><div class=\"pending-withdraw-cancel\"><button qa-label=\"pending-withdrawal-element-cancel-button\" id=\"cancelWithdraw\" class=\"pending-withdrawals-button\" ng-show=\"!showConfirmation && showCancelButton && !item.processing\" ng-click=\"onCancel()\">Cancel Withdraw</button></div></li>"
  );


  $templateCache.put('src/templates/withdraw/desktop/pendingWithdrawals/withdraw-pending-requests.html',
    "<div class=\"panel\" qa-label=\"withdraw-pending-requests\" ng-if=\"showPendingWithdrawls\" ng-controller=\"WithdrawCancelController\" ng-class=\"{'component-loading': model.isLoading}\"><h2>Pending Request</h2><div class=\"panel-body\"><table class=\"table pending-requests-table no-margin\" ng-if=\"model.withdrawPendingList.length && !model.errorFetchingPending\"><thead><tr><th>Date</th><th>Type</th><th ng-if=\"!njxIntegration\">Account #</th><th>Amount</th><th></th></tr></thead></table><ul qa-label=\"pending-withdrawals-elements-container\" class=\"pending-withdrawals-information\" ng-if=\"model.withdrawPendingList.length && !model.errorFetchingPending\"><pending-withdraw-element ng-repeat=\"item in model.withdrawPendingList track by item.withdrawalId\" item=\"item\" loading=\"model.isLoading\" cancel-pending-withdraw=\"events.cancelPendingWithdraw\"></pending-withdraw-element></ul><!-- Message with no withdrawals --> <label qa-label=\"pending-withdrawals-no-elements\" class=\"centered-label\" ng-if=\"model.withdrawPendingList.length == 0 && !model.isLoading && !model.errorFetchingPending\">No more pending withdrawals</label><!-- Error message when there's an error fetching the pending withdrawals--> <label qa-label=\"pending-withdrawals-error-fetching\" class=\"centered-label\" ng-if=\"model.errorFetchingPending\">An error occurred while fetching your pending withdrawals</label></div></div><h2 ng-if=\"showPendingWithdrawls\">New Request</h2><!-- This should disappear when the withdraws section is remade for desktop version-->"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-account-info.html',
    "<!-- Account info --><div ng-if=\"!isDesktop\"><div class=\"account-info table\"><div class=\"row\" ng-if=\"!$root.isFdrApp\"><span class=\"cell\">Account #</span> <span class=\"cell\">Balance</span> <span class=\"cell\">Available to Withdraw</span></div><div class=\"row\" ng-if=\"$root.isFdrApp\"><span class=\"cell\">Account</span> <span class=\"cell\">Balance</span> <span class=\"cell\">Valid Withdraw</span></div><div class=\"row\"><span qa-label=\"account-number\" class=\"cell\">{{ data.accountId || \"N/A\" }}</span> <span qa-label=\"account-balance\" class=\"cell\">{{ data.balance || \"$--\" }}</span> <span qa-label=\"available-balance\" class=\"cell\">{{ (data.availableBalance | currency: '$') || \"$--\" }}</span></div></div><tvg-collapse qa-label=\"max-withdraw-info\" ng-if=\"data.balance && data.balance !== (data.availableBalance | currency: '$')\" class=\"info-message\" ng-attr-title=\"{{'maxWithdrawLessTotalBalanceTitle' | CMSLabels: 'withdrawLabels'}}\"><p qa-label=\"max-withdraw-info-message\" ng-bind-html=\"'maxWithdrawLessTotalBalance' | CMSLabels: 'withdrawLabels' | trust\"></p></tvg-collapse></div><div ng-if=\"isDesktop\"><dw-info-message qa-label=\"max-withdraw-info\" ng-if=\"data.balance && data.balance !== (data.availableBalance | currency: '$')\" ng-attr-title=\"{{'maxWithdrawLessTotalBalanceTitle' | CMSLabels: 'withdrawLabels'}}\" ng-attr-message=\"{{'maxWithdrawLessTotalBalance' | CMSLabels: 'withdrawLabels'}}\"></dw-info-message><dw-info-message qa-label=\"withdrawNoCardsAvailable-info\" ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD' && data.cardsOnFile.length === 0\" ng-attr-title=\"{{'withdrawNoCardsAvailableTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'withdrawNoCardsAvailable' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><dw-info-message qa-label=\"chequeRequestProcessing-info\" ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\" ng-attr-title=\"{{'chequeRequestProcessingTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'chequeRequestProcessing' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><div class=\"account-info table dma-account-info\"><table><thead><tr><th ng-bind-html=\"'balanceLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-bind-html=\"'availableToWithdrawLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'BETCASH'\" ng-bind-html=\"'tvgBetCashAccountLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\" ng-bind-html=\"'addressLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\" ng-bind-html=\"'debitCardLabel' | CMSLabels: 'withdrawLabels' | trust\"></th><th ng-if=\"data.selectedWithdrawOption.id === 'PAY' && data.providerEmail\" ng-bind-html=\"providerEmailLabel\"></th><th ng-bind-html=\"'withdrawAmountLabel' | CMSLabels: 'withdrawLabels' | trust\"></th></tr></thead><tbody><tr qa-label=\"error-message\" ng-if=\"withdrawFrm.newAmount.$invalid && (withdrawFrm.newAmount.$touched || withdrawFrm.$submitted)\" class=\"error-row\"><td colspan=\"{{ showThreeColumns() ? '3' : '4' }}\"><span class=\"alert-box red\" ng-bind=\"getInvalidWithdrawalMessage(withdrawFrm.newAmount, data.minWithdraw)\"></span></td></tr><tr><td qa-label=\"account-balance\" ng-bind=\"data.balance || '$--'\"></td><td qa-label=\"available-balance\" ng-bind=\"(data.availableBalance | currency: '$') || '$--'\"></td><td ng-if=\"data.selectedWithdrawOption.id === 'PAY' && data.providerEmail\"><div qa-label=\"paypal-email-value\">{{data.providerEmail}}</div></td><td ng-if=\"!showAddressForPayment()\" class=\"select-cell\"><!-- tvg bet cash accounts select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'BETCASH'\"><span ng-if=\"data.availableBetCashAccounts.length > 0\"><select-container><select qa-label=\"betcash-bank-selector\" ng-model=\"data.selectedBetCashAccount\" ng-options=\"option.name for option in data.availableBetCashAccounts\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\" ng-change=\"events.setCurrentBetCash(data.selectedBetCashAccount)\"></select> <span ng-bind=\"data.selectedBetCashAccount.name\"></span></select-container></span><span ng-if=\"data.availableBetCashAccounts.length == 0\">No Bet Cash Accounts Available.</span></div><!-- check addresses select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\"><span ng-if=\"data.availableCheckOptions.length > 0\"><select-container><select qa-label=\"check-address-selector\" ng-model=\"data.selectedAddressSection\" ng-options=\"option.name for option in data.availableCheckOptions\" ng-change=\"events.toggleHomeMailMethods(data.selectedAddressSection)\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\"></select> <span ng-bind=\"data.selectedAddressSection.name\"></span></select-container></span><span ng-if=\"data.availableCheckOptions.length == 0\" ng-bind-html=\"'noAddressAvailableLabel' | CMSLabels: 'withdrawLabels' | trust\"></span></div><!-- tvg credit card select --><div class=\"field select-field\" ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\"><span ng-if=\"data.cardsOnFile.length > 0\"><select-container><select qa-label=\"betcash-bank-selector\" ng-model=\"data.selectedCardOnFile\" ng-options=\"option.name for option in data.cardsOnFile\" ng-init=\"events.initDropdown(data.selectedWithdrawOption.id)\" ng-change=\"events.setCurrentCardOnFile(data.selectedCardOnFile)\"></select> <span ng-bind=\"data.selectedCardOnFile.name\"></span></select-container></span></div></td><td class=\"amount-cell\"><div class=\"field amount-input\"><div class=\"input-container\"><input qa-label=\"withdraw-amount\" class=\"withdraw-amount-input\" name=\"newAmount\" type=\"number\" max=\"{{ getMaxWithdrawValue() }}\" min=\"{{ data.minWithdraw }}\" step=\"0.01\" num-length=\"30\" ng-model=\"withdrawDataModel.amount\" ng-model-options=\"{ debounce: 300 }\" ng-required=\"true\" pattern=\"^\\d+(?:\\.\\d{1,2})?$\" placeholder=\"$0.00\" ng-blur=\"events.changeAmount(withdrawFrm.amount.$touched, withdrawFrm.amount.$valid)\"></div></div><div class=\"btn-container\"><button qa-label=\"withdraw-button\" class=\"submit withdraw-btn\" type=\"submit\" ng-if=\"(data.selectedWithdrawOption.id !== 'BETCASH' || data.availableBetCashAccounts.length > 0)\"><strong><i class=\"tvg-icon-login\"></i> <span ng-bind-html=\"'authorizeWithdrawalBtn' | CMSLabels: 'withdrawLabels' | trust\"></span></strong></button></div></td></tr><tr ng-if=\"data.selectedWithdrawOption.id === 'CHECK'\"><td></td><td></td><td class=\"check-address\"><p qa-label=\"check-address-selected\" ng-if=\"data.selectedAddressSection\" ng-bind=\"data.selectedAddressSection.address\"></p></td><td></td></tr><tr ng-if=\"data.selectedWithdrawOption.id === 'DEBIT_CARD'\"><td></td><td></td><td></td><td><label class=\"fee\" ng-bind-html=\"'withdraw-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"withdraw-summary\" class=\"deposit__summary\"><li qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('withdraw-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                            ((withdrawDataModel.amount | currency: '$') || '$--') | trust )\"></li><li qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('withdraw-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                            ((0 | currency: '$') || '$--') | trust ) + ('</span>')\"></li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('withdraw-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                            ((withdrawDataModel.amount | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></ul></td></tr></tbody></table></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-amount-input.html',
    "<div class=\"field withdraw-input-ctn withdraw-amount-input clearfix\" ng-if=\"!isDesktop\" ng-class=\"{\n" +
    "      inputIsInvalid: $root.isFdrApp && withdrawFrm.amount.$invalid && (withdrawFrm.amount.$touched || withdrawFrm.$submitted),\n" +
    "      inputIsFocused: $root.isFdrApp && inputIsFocused\n" +
    "    }\"><div class=\"label withdraw-amount-label\"><span>Withdraw amount (min. $2)</span></div><div class=\"input-container\"><span>$</span> <input qa-label=\"withdraw-amount\" class=\"withdraw-amount-input\" name=\"amount\" type=\"number\" max=\"{{getMaxWithdrawValue()}}\" min=\"{{data.minWithdraw}}\" step=\"0.01\" num-length=\"30\" ng-model=\"withdrawDataModel.amount\" ng-required=\"true\" ng-pattern=\"data.numberPattern\" placeholder=\"00.00\" money-formater restrict-chars ng-focus=\"inputIsFocused = true; events.started()\"></div><span qa-label=\"error-message\" class=\"js-error-label error-label\" ng-if=\"withdrawFrm.amount.$invalid && (withdrawFrm.amount.$touched || withdrawFrm.$submitted)\" ng-bind=\"getInvalidWithdrawalMessage(withdrawFrm.amount, data.minWithdraw)\"></span></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-betcash-selector.html',
    "<div ng-if=\"!isDesktop\"><section-title ng-if=\"!$root.isFdrApp\" title=\"BetCash Accounts\" index=\"\"></section-title><section-title ng-if=\"$root.isFdrApp\" title=\"Echeck Accounts\" index=\"\"></section-title><div qa-label=\"betcash-bank-selector\" class=\"deposit-card-options\" ng-if=\"data.availableBetCashAccounts.length > 0\"><ul><li qa-label=\"betcash-bank-option\" ng-repeat=\"card in data.availableBetCashAccounts track by card.achId\" class=\"card\"><label ng-class=\"{'active': data.selectedBetCashAccount === card}\"><strong ng-bind=\"::($root.isFdrApp ? card.bankName.toLowerCase() : card.bankName)\"></strong><div ng-bind=\"::card.name\"></div><input type=\"radio\" ng-model=\"data.selectedBetCashAccount\" ng-change=\"events.setCurrentBetCash(data.selectedBetCashAccount)\" ng-value=\"card\"></label></li></ul></div><div class=\"field\" ng-if=\"data.availableBetCashAccounts.length === 0\"><span>{{ $root.isFdrApp ? 'No Echeck Accounts Available.' : 'No Bet Cash Accounts Available.'}}</span></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-card-selector.html',
    "<div ng-if=\"!isDesktop\"><section-title title=\"Select debit card\" index=\"\"></section-title><div qa-label=\"withdraw-card-selector\" class=\"deposit-card-options\" ng-if=\"data.cardsOnFile.length > 0\"><ul qa-label=\"cardsList\" ng-init=\"data.pageSetFromParams ? null : data.selectedCardOnFile = data.cardsOnFile[0]; events.setCurrentCardOnFile(data.selectedCardOnFile) \"><li qa-label=\"ccCardsOnFile\" ng-repeat=\"card in data.cardsOnFile track by card.id\" class=\"card\"><label qa-label=\"cardInfo\" ng-class=\"{'active': data.selectedCardOnFile === card ||\n" +
    "                                    (card.ftype === 'CC' && data.selectedCardOnFile.id === card.id) }\"><strong ng-bind=\"::card.network\"></strong><div><span ng-if=\"card.isExpired\" class=\"expired-card-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-bind=\"::card.cardNumberExt\"></span> (<span ng-bind=\"::card.expirationDate\"></span>)</div><input qa-label=\"cardSelection\" type=\"radio\" ng-model=\"data.selectedCardOnFile\" ng-change=\"events.setCurrentCardOnFile(card)\" ng-value=\"card\"></label></li></ul></div><dw-info-message qa-label=\"withdrawNoCardsAvailable-info\" ng-if=\"data.cardsOnFile.length === 0\" ng-attr-title=\"{{'withdrawNoCardsAvailableTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'withdrawNoCardsAvailable' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-home-mail-selector.html',
    "<section-title index=\"\" title=\"Select Address\" ng-if=\"!isDesktop\"></section-title><div ng-if=\"!isDesktop\"><dw-info-message qa-label=\"chequeRequestProcessing-info\" ng-attr-title=\"{{'chequeRequestProcessingTitle' | CMSLabels: 'withdrawLabels' | trust}}\" ng-attr-message=\"{{'chequeRequestProcessing' | CMSLabels: 'withdrawLabels' | trust}}\"></dw-info-message><div qa-label=\"check-address-selector\" class=\"deposit-card-options\" ng-if=\"data.availableCheckOptions.length > 0\"><ul><li qa-label=\"check-address-option\" ng-repeat=\"card in data.availableCheckOptions\" class=\"card\" ng-if=\"card.address && card.address.length\"><label ng-class=\"{'active': data.selectedAddressSection.id == card.id}\"><strong ng-bind=\"::card.name\"></strong><div ng-bind=\"::card.address\"></div><input type=\"radio\" ng-model=\"data.selectedAddressSection\" ng-change=\"events.toggleHomeMailMethods(card)\" ng-value=\"card\"></label></li></ul></div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-provider-email.html',
    "<div ng-if=\"(data.selectedWithdrawOption.id === 'PAY' && data.providerEmail) && !isDesktop\" class=\"paypal-account-details\"><section-title title=\"{{$root.isFdrApp ? 'Paypal Account Details' : 'Details' }}\" index=\"\"></section-title><div qa-label=\"provider-email\"><strong ng-if=\"!$root.isFdrApp\" ng-bind-html=\"'email' | CMSLabels: 'paypalLabels' | trust\"></strong> <strong ng-if=\"$root.isFdrApp\">Email address set to: </strong>{{ data.providerEmail }}</div></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-total-cost.html',
    "<div ng-if=\"!isDesktop\"><section-title title=\"{{'withdraw-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust}}\" index=\"\"></section-title><ul qa-label=\"withdraw-summary\" class=\"deposit__summary disabled_fdr_styles withdraw-left-padding\"><li qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('withdraw-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                          ((withdrawDataModel.amount | currency: '$') || '$--') | trust )\"></li><li qa-label=\"deposit-summary-fee\" ng-bind-html=\"(('withdraw-summary-fee' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                          ((0 | currency: '$') || '$--') | trust ) + ('</span>')\"></li><strong qa-label=\"deposit-summary-total\" class=\"bold\" ng-bind-html=\"(('withdraw-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                          ((withdrawDataModel.amount | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></ul></div>"
  );


  $templateCache.put('src/templates/withdraw/fields/withdraw-type-selector.html',
    "<withdraw-options-container class=\"dma-nav dma-nav-tabs\"><withdraw-option ng-repeat=\"option in data.withdrawOptions\" qa-label=\"{{option.qalabel}}\" ng-click=\"events.toggleWithdrawOptions(option)\" ng-class=\"{selected:data.selectedWithdrawOption == option}\"><span ng-bind=\"option.name\"></span></withdraw-option></withdraw-options-container>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-cancel.html',
    "<div class=\"tvg-deposit\" ng-controller=\"WithdrawCancelController\" ng-class=\"{loading: data.isLoading}\"><div class=\"before-notification\"></div><div class=\"withdraw-cancel-container\" ng-if=\"!data.isLoading\"><dw-info-dialog><p>Changed your mind?</p>Cancel pending withdrawals for immediate access to your funds.</dw-info-dialog><table class=\"table-withdrawals\" ng-if=\"data.withdrawPendingList.length\"><tr><th>DATE</th><th>TYPE</th><th>AMOUNT</th><th>ACTION</th></tr><tr ng-repeat=\"item in data.withdrawPendingList\"><td ng-bind=\"item.transactionDate | date :'MM/dd/yyyy'\"></td><td ng-bind=\"item.paymentType\"></td><td ng-bind=\"item.amount | currency\"></td><td><button class=\"red\" ng-click=\"cancelPendingWithdraw(item.withdrawalId)\">Cancel</button></td></tr></table><label class=\"no-withdrawals-message\" ng-if=\"!data.withdrawPendingList.length\">No more pending withdrawals</label></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-error.html',
    "<div class=\"handler-error-container\"><span class=\"image\"></span><h1 class=\"title\">Error!</h1><div class=\"message-container\"><h2><strong>This method of withdrawal doesn't seem to be going through.</strong></h2><p class=\"customer_service\" ng-bind-html=\"('widthdrawErrorDefault'| CMSValue : null) | trust\"></p></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw-success.html',
    "<div class=\"handler-success-container\"><span class=\"image\"></span><h1 class=\"title\">Success!</h1><div class=\"message-container\"><h2><strong>Withdrawal Request Successful.</strong></h2><p class=\"message\">{{withdraw.description}}<!--TODO: CMS--></p></div></div>"
  );


  $templateCache.put('src/templates/withdraw/withdraw.html',
    "<withdraw-pending-requests qa-label=\"pending-withdrawals\" class=\"withdraw-pending-requests-desktop\" ng-if=\"showPendingWithdrawals &&\n" +
    "        !data.isLoading && !data.errorFetchingData\"></withdraw-pending-requests><div ng-show=\"!data.showingFallback\" class=\"tvg-deposit\" ng-class=\"{loading: data.isLoading, 'njx-deposit': njxIntegration}\"><!-- Toggles between CHECK and BetCash option --><withdraw-type-selector></withdraw-type-selector><section ng-if=\"!data.unableToFetchProfile\" ng-class=\"{'loading sightline-loading': sightlineLoading}\"><sightline-enrollment ng-if=\"displays.isSightlineApiEnrollmentVisible()\" ng-controller=\"SightlineController\" qa-label=\"sln-api-enrollment\" ng-class=\"{'loading': data.isEnrollingCard}\"></sightline-enrollment></section><form novalidate qa-label=\"withdraw-form\" name=\"withdrawFrm\" ng-submit=\"events.withdraw(withdrawFrm)\" ng-if=\"(!data.isLoading && !data.errorFetchingData &&\n" +
    "            data.selectedWithdrawOption.id !== 'SLN' ||\n" +
    "            data.hasSightlineAccount) &&\n" +
    "            !payPalTVG3() &&\n" +
    "            !payPalNJX() &&\n" +
    "            !(data.selectedWithdrawOption.id === 'BETCASH' && data.unableToFetchBankAccounts) &&\n" +
    "            !(data.selectedWithdrawOption.id === 'CHECK' && data.unableToFetchProfile)\"><!-- Dynamically render fields depending on selected withdraw option --><div ng-repeat=\"field in data.forms[data.selectedWithdrawOption.id]\"><div ng-include=\"'src/templates/withdraw/fields/' + field + '.html'\"></div></div><!-- Withdraw button --> <button qa-label=\"withdraw-button\" ng-if=\"(data.selectedWithdrawOption.id != 'BETCASH' || data.availableBetCashAccounts.length > 0) && !isDesktop\" class=\"submit withdraw-btn\" type=\"submit\"><strong><i class=\"tvg-icon-lock\"></i> Authorize Withdrawal</strong></button></form><div ng-if=\"payPalTVG3()\" class=\"disclaimer paypal-disclaimer\" ng-bind-html=\"'tvg3Message' | CMSLabels: 'paypalLabels'\"></div><div class=\"disclaimer paypal-disclaimer\" ng-if=\"payPalNJX()\">Coming Soon</div><dw-info-dialog qa-label=\"fetching-error-message\" ng-if=\"!data.isLoading && (data.errorFetchingData || (data.selectedWithdrawOption.id === 'BETCASH' && data.unableToFetchBankAccounts))\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'depositsBetcashUnableToFetchBankAccounts' | CMSValue : null}}</dw-info-dialog><dw-info-dialog qa-label=\"fetching-error-message\" ng-if=\"!data.isLoading && (data.errorFetchingData ||\n" +
    "        ((data.selectedWithdrawOption.id === 'CHECK' || data.selectedWithdrawOption.id === 'SLN') && data.unableToFetchProfile))\" live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'withdrawUnableToFetchProfile' | CMSValue : null}}</dw-info-dialog></div><dw-info-dialog ng-if=\"!data.loading && !$root.isFdrApp && data.showingFallback\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'withdrawalNoPaymentMethodsAvailable' | CMSValue : null}}</dw-info-dialog>"
  );

}]);

angular.module('TVG.Transfer').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/templates/transfer/fields/transfer-amount-input.html',
    "<div class=\"table\" ng-class=\"{ 'dma-amount-table' : $root.product == 'njx' }\" qa-label=\"dmaAmountTable\"><div class=\"row\"><span class=\"cell title\">I want to transfer $</span> <span class=\"cell\"></span> <span class=\"cell\"><div ng-if=\"transferFrm.amount.$error.min\" class=\"js-error-label error-label minimum\" ng-class=\"{invalidAmount: transferFrm.amount.$invalid && transferFrm.amount.$dirty}\">Minimum {{(transferDataModel.min) | currency}}</div><div ng-if=\"transferFrm.amount.$error.max\" class=\"js-error-label error-label maximum\" ng-class=\"{invalidAmount: transferFrm.amount.$invalid && transferFrm.amount.$dirty}\">Maximum {{(transferDataModel.max) | currency}}</div></span></div><div class=\"row\"><span class=\"cell w160\"><toggle-options><button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[0]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[0];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[0]}}</button> <button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[1]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[1];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[1]}}</button> <button ng-class=\"{selected: transferDataModel.amount == data.availableAmountOptions[2]}\" class=\"amount-button\" type=\"button\" ng-click=\"transferDataModel.amount=data.availableAmountOptions[2];\" ng-disable=\"data.loading\">${{data.availableAmountOptions[2]}}</button></toggle-options></span><span class=\"cell minw30\">or <span class=\"amount-dollar-label\">$</span></span> <span class=\"cell\"><input class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other Amount\" min=\"{{transferDataModel.min}}\" max=\"{{transferDataModel.max}}\" maxlength=\"9\" step=\"0.01\" ng-model=\"transferDataModel.amount\" ng-model-options=\"{debounce: 500}\" ng-required=\"true\" ng-disable=\"data.loading\" restrict-chars qa-label=\"transferFundsExchange\"></span></div></div>"
  );


  $templateCache.put('src/templates/transfer/fields/transfer-source-destination.html',
    "<div class=\"form-fields\"><div class=\"field\"><span class=\"input-container\"><select-container class=\"others\"><select class=\"card\" name=\"slcOrigin\" ng-disable=\"data.loading\" ng-model=\"transferDataModel.source\" ng-options=\"option.label for option in data.optionsAccounts\" ng-change=\"events.selectSource()\" qa-label=\"exchangeFromSelect\"><option value=\"\" disabled=\"disabled\">{{'depositAchOnFileSelectionLabel' | CMSValue : null}}</option></select> <span qa-label=\"transferSourceLabel\">{{transferDataModel.source.label || 'From' }}</span></select-container></span></div><div class=\"field\"><select-container><select class=\"ng-pristine ng-valid ng-touched\" name=\"slcDestination\" ng-disable=\"data.loading\" ng-model=\"transferDataModel.destination\" ng-options=\"option.label for option in data.optionsAccounts\" ng-change=\"events.selectDestination()\" qa-label=\"exchangeToSelect\"><option value=\"\" disabled=\"disabled\">{{'depositAchOnFileSelectionLabel' | CMSValue : null}}</option></select> <span qa-label=\"transferDestinationLabel\">{{transferDataModel.destination.label || 'To' }}</span></select-container></div></div>"
  );


  $templateCache.put('src/templates/transfer/transfer.html',
    "<div class=\"tvg-deposit tvg-deposit-transfer\" ng-controller=\"TransferController\"><div ng-class=\"{'loading': data.loading}\"></div><dw-info-dialog ng-if=\"data.errorDepositRestrictions\" ng-bind=\"data.message\"></dw-info-dialog><form ng-if=\"!data.errorDepositRestrictions\" class=\"deposit-form\" name=\"transferFrm\" ng-submit=\"events.makeTransfer(transferFrm)\" ng-class=\"{loading: data.makingTransfer}\"><transfer-amount-input></transfer-amount-input><div class=\"disclaimer\">Although you can access both 4NJbets and the Betfair Exchange, you'll need to transfer funds between them in order to bet.</div><transfer-source-destination></transfer-source-destination><div ng-if=\"transferDataModel.isPending != true\" class=\"field\"><button class=\"submit add-funds\" ng-disabled=\"(data.makingTransfer || !transferDataModel.source || !transferDataModel.destination || !transferDataModel.amount || !transferFrm.$valid || data.loading)\" type=\"submit\"><strong>Transfer funds</strong></button><p ng-if=\"!notifyErrors\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered\">This form contains errors. Please fix all errors before continuing.</p></div></form></div>"
  );

}]);

angular.module('TVG.ManagePaymentMethods').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/templates/managePaymentMethods/fields/deposit-limits.html',
    "<div class=\"field\"><h2 class=\"dma-section-title\"><span ng-bind=\"('depositLimitsTitle' | CMSLabels: 'dmaManagementLabels' | trust)\"></span></h2><div class=\"limits\" ng-if=\"(!events.unableToFetchLimits() || !(data.selectedPayOption.ftype === 'IBC' || data.selectedPayOption.ftype === 'ACH' || data.selectedPayOption.ftype === 'CC' || data.selectedPayOption.ftype === 'APPL'))\"><div class=\"limits-table\"><div class=\"header\"><div class=\"header-row\"><div class=\"header-cell\"><span ng-if=\"data.selectedPayOption.ftype === 'APPL'\">Card Type</span> <span ng-if=\"data.selectedPayOption.ftype === 'CC'\">Card Type</span> <span ng-if=\"data.selectedPayOption.ftype === 'IBC'\">Account Type</span></div><div class=\"header-cell\"><span>Daily Limit</span></div><div class=\"header-cell\"><span>Monthly Limit</span></div></div></div><div class=\"body\"><div class=\"body-row\" ng-repeat=\"limitType in data.selectedPayOption.paymentLimits\"><div class=\"body-cell card-type-cell\" qa-label=\"cardTypeCell\"><span>{{limitType.typeName}}</span></div><div class=\"body-cell\"><div class=\"image-row\"><span class=\"image-cell\" qa-label=\"dailyLimitCell\">{{limitType.limitInterval.Daily.Effective | noFractionCurrency}}</span> <button class=\"edit\" ng-click=\"events.editLimit(true, limitType)\" qa-label=\"dailyLimitEditButton\"><strong>Edit</strong></button></div><div ng-if=\"limitType.limitInterval.Daily.ShowFuture\" class=\"image-row\"><span class=\"schedule image-cell\" qa-label=\"dailyLimitFutureCell\">Scheduled to change to {{limitType.limitInterval.Daily.Future | noFractionCurrency}} on {{limitType.limitInterval.Daily.FutureDateStr}}</span></div></div><div class=\"body-cell\"><div class=\"image-row\"><span class=\"image-cell\" qa-label=\"monthlyLimitCell\">{{limitType.limitInterval.Monthly.Effective | noFractionCurrency}}</span> <button class=\"edit\" ng-click=\"events.editLimit(false, limitType)\" qa-label=\"monthlyLimitEditButton\"><strong>Edit</strong></button></div><div ng-if=\"limitType.limitInterval.Monthly.ShowFuture\" class=\"image-row\"><span class=\"schedule image-cell\" qa-label=\"monthlyLimitFutureCell\">Scheduled to change to {{limitType.limitInterval.Monthly.Future | noFractionCurrency}} on {{limitType.limitInterval.Monthly.FutureDateStr}}</span></div></div></div></div></div><div class=\"tvg-dialog-filter\" ng-if=\"data.limitEditor\"></div><limit-editor ng-if=\"data.limitEditor\"><edit-info><span class=\"cell\"></span><div class=\"cell\"><span><strong>Edit - {{depositLimitModel.depositLimitTypeName}} Card</strong></span><div class=\"limit-notification\"><span class=\"icon-input-error\" ng-if=\"data.limitError\"></span> <span ng-if=\"data.limitError\">{{data.limitErrorMessage}}</span></div></div></edit-info><edit-input><span class=\"cell\"><strong>$</strong></span><div class=\"cell\"><div class=\"align-left\"><input class=\"limit-amount\" name=\"limit-value\" ng-min=\"{{depositLimitModel.min||0}}\" ng-model=\"depositLimitModel.amount\" ng-required=\"true\" ng-change=\"events.validateLimitAmount()\" ng-enter=\"events.saveLimit()\" qa-label=\"depositLimitModelInput\"></div><div class=\"align-right\"><button class=\"cancel\" ng-click=\"events.cancelLimitEdition()\" qa-label=\"depositLimitModelCancelButton\"><strong>Cancel</strong></button> <button class=\"save\" ng-disabled=\"data.limitError\" ng-click=\"events.saveLimit()\" qa-label=\"depositLimitModelSaveButton\"><strong>Save</strong></button></div></div></edit-input></limit-editor></div><div ng-if=\"events.unableToFetchLimits() && (data.selectedPayOption.ftype === 'IBC' || data.selectedPayOption.ftype === 'ACH' || data.selectedPayOption.ftype === 'CC' || data.selectedPayOption.ftype === 'APPL')\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchLimits' | CMSValue : null}}</dw-info-dialog></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/new-payment-method.html',
    "<div class=\"table\"><div class=\"row\"><new-method-add class=\"cell\"><button name=\"add-card\" ng-click=\"data.newCardForm = true\"><span class=\"add\"></span> <span>Add a new credit or debit card</span></button></new-method-add><new-method-option class=\"cell\"><span>We accept</span><div class=\"row\"><span class=\"visa-icon\"></span> <span class=\"mastercard-icon\"></span></div></new-method-option></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-card.html',
    "<div class=\"payment-management-option-main payment-management-block-grid\"><div class=\"payment-management-icon\"><div class=\"credit-card__placeholder\"></div></div><div class=\"payment-management-info\"><ul><li><strong ng-if=\"$ctrl.card.ftype === 'CC'\" ng-bind=\"$ctrl.card.typeName + ' Card'\"></strong> <strong ng-if=\"$ctrl.card.ftype === 'ACH'\" ng-bind=\"::$ctrl.card.bankName\"></strong></li><li ng-if=\"$ctrl.card.ftype === 'CC'\">{{\"xxxx-xxxx-xxxx-\" + $ctrl.card.cardNumber}}</li><li ng-if=\"$ctrl.card.ftype === 'ACH'\">*****{{$ctrl.sliceCard({number: $ctrl.card.bankAccNumber})}}</li><li ng-if=\"$ctrl.card.ftype === 'CC'\">Expires {{$ctrl.card.expirationDate}}</li></ul></div><a ng-if=\"$ctrl.card.ftype === 'CC'\" class=\"payment-management-close\" href ng-click=\"$ctrl.removeCard({card: card})\"><i class=\"tvg-icon-close\"></i></a></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-on-file-list.html',
    "<div class=\"field\"><payment-method-on-file-option ng-attr-card=\"card\" ng-attr-on-edit-card-action=\"events.showEditCardConfirmModal(card)\" ng-attr-on-go-to-deposit=\"events.goToDeposit(card, $index)\" ng-attr-on-remove-card-action=\"events.showRemoveCardConfirmModal(card)\" ng-attr-index=\"$index\" ng-repeat=\"card in data.selectedPayOption.onFile track by $index\"></payment-method-on-file-option><div ng-if=\"data.selectedPayOption.onFile.length === 0\"><p class=\"text-center\" ng-if=\"data.selectedPayOption.ftype === 'IBC'\" ng-bind=\"('noAccountsFound' | CMSLabels: 'dmaManagementLabels')\"></p><p class=\"text-center\" ng-if=\"data.selectedPayOption.ftype === 'CC'\" ng-bind=\"('no-cards-found' | CMSLabels: 'dmaDepositLabels')\"></p></div></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-method-on-file-option.html',
    "<div class=\"payment-management-option\" ng-class=\"{'payment-management-option--expired': card.isExpired}\" ng-controller=\"ManagePaymentMethodsController\" qa-label=\"paymentManagementOption\"><span ng-if=\"card.isExpired\" class=\"expired-card-label\">{{'expired-card' | CMSLabels: 'dmaDepositLabels'}} </span><span ng-if=\"card.IsPending\" class=\"expired-card-label\">{{'pendingAccount' | CMSLabels: 'dmaManagementLabels'}}</span><payment-method-card card=\"card\" remove-card=\"onRemoveCardAction(card)\" slice-card=\"events.slicedCard(number)\"></payment-method-card><ul class=\"payment-management-action-list\"><li><a href class=\"payment-management-action payment-management-action--primary\" ng-click=\"onGoToDeposit({index: index, card: card})\" qa-label=\"paymentManagementActionDepositButton\">Deposit</a></li><li ng-if=\"card.ftype === 'CC'\"><a href class=\"payment-management-action payment-management-action--secondary\" ng-click=\"onEditCardAction({card: card})\" qa-label=\"paymentManagementActionEditDetailsButton\">Edit Details</a></li></ul></div>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/payment-methods-type-selector.html',
    "<payment-methods-options-container><payment-methods-option ng-repeat=\"option in data.paymentMethodsOptions\" ng-click=\"data.selectedPayOption = option; events.resetDataModel()\" ng-class=\"{selected:data.selectedPayOption.name == option.name}\">{{option.name}}</payment-methods-option></payment-methods-options-container>"
  );


  $templateCache.put('src/templates/managePaymentMethods/fields/titles.html',
    "<h2 class=\"dma-section-title\" ng-if=\"$ctrl.type === 'CC'\"><span ng-bind=\"('creditCardTitle' | CMSLabels: 'dmaManagementLabels')\"></span> <a class=\"dma-section-link\" href ng-click=\"$ctrl.redirectAdd({type: $ctrl.type})\" ng-bind=\"('addNewCardLink' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"addNewCCardLink\"></a></h2><h2 class=\"dma-section-title\" ng-if=\"$ctrl.type === 'IBC'\"><span ng-bind=\"('betCashTitle' | CMSLabels: 'dmaManagementLabels')\"></span><div class=\"dma-section-link\"><a href ng-click=\"events.redirectToAddNewCard($ctrl.type)\" ng-bind=\"('addNewAccountLink' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"addNewAccountLink\"></a> <span ng-if=\"!njxIntegration\" ng-bind=\"('submit' | CMSLabels: 'dmaManagementLabels')\"></span> <a ng-if=\"!njxIntegration\" target=\"_blank\" ng-href=\"{{('linkBetcash' | CMSLabels: 'dmaManagementLabels')}}\" ng-bind=\"('BetcashAgreement' | CMSLabels: 'dmaManagementLabels')\" qa-label=\"BetcashAgreementLink\"></a><div></div></div></h2><p ng-if=\"$ctrl.type === 'IBC' && $ctrl.length > 0\" class=\"disclaimer\" ng-bind-html=\"('callSupport' | CMSLabels: 'dmaManagementLabels')\"></p>"
  );


  $templateCache.put('src/templates/managePaymentMethods/manage-payment-methods.html',
    "<div class=\"tvg-deposit\" name=\"managePaymentMethodsDiv\" ng-controller=\"ManagePaymentMethodsController\" ng-class=\"{loading: data.loading}\"><deposit-options-container class=\"dma-nav dma-nav-tabs\"><deposit-option ng-repeat=\"option in data.paymentMethodsOptions track by $index\" ng-click=\"events.selectOption(option)\" ng-class=\"{selected:data.selectedPayOption.ftype === option.ftype}\"><span qa-label=\"{{::option.ftype}}\">{{::option.name}}</span></deposit-option></deposit-options-container><div class=\"before-notification\"></div><dw-info-dialog ng-if=\"data.errorPaymentRestrictions && !data.loading\" live-person=\"{{'depositInitialDataErrorActionText'| CMSValue : null}}\">{{'depositInitialDataErrorMessage' | CMSValue : null}}</dw-info-dialog><form class=\"deposit-form\" name=\"depositFrm\" ng-if=\"!data.errorPaymentRestrictions && !data.loading\" ng-submit=\"data.newCardForm ? events.addNewCard(depositFrm): data.editCardForm ? events.editCard(depositFrm) : null\" novalidate><payment-titles type=\"data.selectedPayOption.ftype\" length=\"data.selectedPayOption.onFile.length\" redirect-add=\"events.redirectToAddNewCard(type)\"></payment-titles><div class=\"payment-method-container\"><payment-method-on-file-list ng-if=\"(data.selectedPayOption.ftype !== 'IBC' || !data.unableToFetchBankAccounts)\n" +
    "     && (data.selectedPayOption.ftype !== 'CC' || !data.unableToFetchCardsOnFile)\"></payment-method-on-file-list><div ng-if=\"data.selectedPayOption.ftype === 'IBC' && data.unableToFetchBankAccounts\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchBankAccounts' | CMSValue : null}}</dw-info-dialog></div><div ng-if=\"data.selectedPayOption.ftype === 'CC' && data.unableToFetchCardsOnFile\"><dw-info-dialog live-person=\"{{'depositBetCashAvailabilityActionText'| CMSValue : null}}\">{{'ManagementBetcashUnableToFetchCardsOnFile' | CMSValue : null}}</dw-info-dialog></div><deposit-limits ng-if=\"data.showLimits\"></deposit-limits></div><div ng-if=\"data.editCardForm\" class=\"payment-method-container\"><div class=\"form-fields\" ng-repeat=\"field in data.forms['NEW']['CC']\"><div ng-include=\"'src/templates/deposit/fields/'+field+'.html'\"></div></div><div class=\"field\"><button class=\"submit add-payment\" ng-disabled=\"data.savingCard\" type=\"submit\"><strong>Edit credit card details</strong></button><p ng-if=\"!notifyErrors\" ng-show=\"data.showInvalidFormMessage\" ng-class=\"{show: data.showInvalidFormMessage}\" class=\"js-error-label error-label fade-msg text-centered\">This form contains errors. Please fix all errors before continuing.</p></div></div></form></div>"
  );

}]);

angular.module('TVG.Paypal').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/paypal/deposits/deposit-button/deposit-button.template.html',
    "<div class=\"field\"><div ng-if=\"!$root.isFdrApp\" class=\"paypal-deposit__message disclaimer pv_10\" qa-label=\"payPalDepositMessageDisclaimerPv_10\"><p class=\"pb_5\" ng-bind-html=\"::('clickMessage' | CMSLabels: 'paypalLabels')\"></p><p class=\"pb_5\" ng-bind-html=\"::('accountMessage' | CMSLabels: 'paypalLabels')\"></p><p ng-bind-html=\"::('connectedAcount' | CMSLabels: 'paypalLabels')\"></p></div><div ng-if=\"$root.isFdrApp\" class=\"paypal-deposit__message disclaimer pv_10\" qa-label=\"payPalDepositMessageDisclaimerPv_10\">{{'clickMessage' | CMSLabels: 'paypalLabels'}} {{'accountMessage' | CMSLabels: 'paypalLabels'}} {{'connectedAcount' | CMSLabels: 'paypalLabels'}}</div><button qa-label=\"payPalButton\" class=\"paypal-deposit__button pa_0\" ng-click=\"$ctrl.onDeposit($event)\" ng-disabled=\"$ctrl.isDisabled\"><img src=\"https://www.paypalobjects.com/webstatic/en_US/i/btn/png/blue-rect-paypal-44px.png\" alt=\"PayPal Checkout\"></button></div>"
  );


  $templateCache.put('src/paypal/deposits/deposit.template.html',
    "<div ng-class=\"{loading: $ctrl.loading}\" class=\"paypal paypal-deposit\"><ng-form name=\"$ctrl.paypalDeposits\" ng-show=\"!$ctrl.loading\"><div class=\"disclaimer\" qa-label=\"payPalDisclaimer\" ng-bind-html=\"::('tutorial' | CMSLabels: 'paypalLabels')\"></div><section-title ng-if=\"$root.isFdrApp && $ctrl.email\" title=\"PayPal Account Details\" qalabel=\"paypal-accountDetails\" index=\"0\"></section-title><div ng-if=\"$root.isFdrApp && $ctrl.email\" qa-label=\"paypal-accountDetails-email\" email=\"$ctrl.email\" class=\"paypal-account-details\">Email address set to: <strong class=\"paypal-user-email\">{{ $ctrl.email }}</strong></div><section-title class=\"first-title\" qalabel=\"paypal-depositAmountTitle\" title=\"{{::'deposit-amount-title' | CMSLabels: 'dmaDepositLabels'}}\" index=\"1\"></section-title><select-amount form=\"::$ctrl.paypalDeposits\" amount=\"$ctrl.depositAmount\" min-amount=\"::$ctrl.minAmount\" max-amount=\"::$ctrl.maxAmount\" amounts=\"::$ctrl.amountOptions\" on-amount-change=\"::$ctrl.handleOnAmountChange($event)\"></select-amount><section-title title=\"Review and Authorize\" qalabel=\"paypal-reviewTitle\" index=\"2\"></section-title><total-cost data=\"$ctrl.fees\" email=\"$ctrl.email\"></total-cost><deposit-button is-disabled=\"$ctrl.shouldDisablePaypalButton()\" on-paypal-deposit=\"$ctrl.makePaypalDeposit($event)\"></deposit-button></ng-form></div>"
  );


  $templateCache.put('src/paypal/deposits/select-amount/select-amount.template.html',
    "<div class=\"dma-amount-ctn\" qa-label=\"deposit-amount\"><div class=\"dma-amount-table\"><div class=\"row\"><div class=\"cell w155\"><toggle-options><button qa-label=\"amount-button-{{amountOption}}\" ng-repeat=\"amountOption in $ctrl.amounts track by $index\" ng-class=\"{selected: $ctrl.amount == amountOption}\" class=\"amount-button\" type=\"button\" qa-label=\"amount-button-{{amountOption}}\" ng-click=\"$ctrl.change(amountOption)\">${{amountOption}}</button></toggle-options></div><span class=\"cell minw30 amount-divider\">or <span class=\"amount-dollar-label\">$</span></span><div class=\"cell align-right amount-input-ctn\"><input qa-label=\"amount-input\" money-formater class=\"amount\" name=\"amount\" type=\"number\" placeholder=\"Other amount\" ng-min=\"{{$ctrl.minAmount||0}}\" ng-max=\"{{$ctrl.maxAmount||100000}}\" ng-model-options=\"{ allowInvalid: true, updateOn: 'default blur', debounce: { default: 1000, blur: 0 } }\" num-length=\"5\" step=\"any\" ng-model=\"$ctrl.amount\" ng-required=\"true\" ng-change=\"$ctrl.change($ctrl.amount)\" restrict-chars ng-blur=\"inputIsNowFocused = false\" ng-focus=\"inputIsNowFocused = true\" ng-class=\"{\n" +
    "                        inputIsInvalid: $root.isFdrApp && $ctrl.form.amount.$invalid && $ctrl.form.$submitted,\n" +
    "                        inputIsFocused: ($root.isFdrApp && !$ctrl.form.amount.$invalid && !!inputIsNowFocused)\n" +
    "                            || ($root.isFdrApp && !$ctrl.form.amount.$dirty && !!inputIsNowFocused)\n" +
    "                    }\"></div></div></div><div class=\"row non-table amount-errors-ctn\" ng-if=\"$ctrl.form.amount.$touched || $ctrl.form.$submitted || $ctrl.form.amount.$dirty\"><div ng-messages=\"$ctrl.form.amount.$error\"><div class=\"js-error-label error-label\" ng-message=\"min\" ng-bind-html=\"(('minimum' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.minAmount | currency) | trust )\"></div><div qa-label=\"error-required\" class=\"js-error-label error-label\" ng-message=\"required\" ng-bind-html=\"('required' | CMSLabels: 'paypalLabels' | trust )\"></div><div class=\"js-error-label error-label\" ng-message=\"max\" ng-bind-html=\"(('maximum' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.maxAmount | currency) | trust )\"></div></div></div></div>"
  );


  $templateCache.put('src/paypal/deposits/total-cost/total-cost.template.html',
    "<label ng-if=\"$ctrl.data.loading && !$root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label><ul qa-label=\"deposit-summary\" class=\"deposit__summary\"><li ng-if=\"!$root.isFdrApp\" qa-label=\"paypal-email\" ng-if=\"$ctrl.email && !$root.isFdrApp\" ng-bind-html=\"(('email' | CMSLabels: 'paypalLabels') + ' ' + ($ctrl.email  | trust ))\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-amount\" ng-bind-html=\"(('deposit-summary-amount' | CMSLabels: 'dmaDepositLabels') + ' ' +\n" +
    "                      (($ctrl.data.netAmount | currency: '$') || '$--') | trust )\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee-amount\" ng-bind-html=\"(('deposit-summary-fee-amount' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                      (($ctrl.data.feeAmount | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li ng-if=\"!$root.isFdrApp\" qa-label=\"deposit-summary-fee-refund\" ng-bind-html=\"(('deposit-summary-fee-refund' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') +\n" +
    "                    (($ctrl.data.feeRefundAmount | currency: '$') || '$--') | trust ) + ('</span>')\"></li><li><strong qa-label=\"deposit-summary-total\" ng-bind-html=\"(('deposit-summary-total' | CMSLabels: 'dmaDepositLabels' | trust) + (' <span>') + (($ctrl.data.transactionTotal | currency: '$') || '$--') | trust ) + ('</span>')\"></strong></li></ul><label ng-if=\"$ctrl.data.loading && $root.isFdrApp\" class=\"activity-info fee\" ng-bind-html=\"'deposit-summary-calculation-fees' | CMSLabels: 'dmaDepositLabels' | trust\"></label>"
  );

}]);

angular.module('TVG.MoneyPak').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('src/moneypak/moneypak.template.html',
    "<div ng-class=\"{loading: $ctrl.loading || $ctrl.activePoller}\" class=\"moneypak\"><form name=\"$ctrl.moneyPakDepositForm\" ng-submit=\"$ctrl.handleFormSubmit($event)\" novalidate><div class=\"disclaimer\" qa-label=\"moneyPakDisclaimer\" ng-bind-html=\"::('tutorial' | CMSLabels: 'moneyPakLabels')\"></div><section-title qalabel=\"mpak-depositLimitsTitle\" class=\"first-title\" title=\"{{::'depositLimitsTitle' | CMSLabels: 'moneyPakLabels'}}\"></section-title><div class=\"disclaimer\" qa-label=\"mPtableLimitsDisclaimer\" ng-bind-html=\"::('depositLimitsText' | CMSLabels: 'moneyPakLabels')\"></div><limits-table content-obj=\"::('depositLimitsTable' | CMSLabels: 'moneyPakLabels')\"></limits-table><section-title qalabel=\"mpak-authorizeTitle\" title=\"{{::'redeemAndAuthorizeTitle' | CMSLabels: 'moneyPakLabels'}}\"></section-title><div class=\"disclaimer\" qa-label=\"mpRedeemAuthorizeDisclaimer\" ng-bind-html=\"::('redeemAndAuthorizeText' | CMSLabels: 'moneyPakLabels')\"></div><moneypak-activation-number-input ng-if=\"isRGAvailable && !rgLimitReached || !isRGAvailable\" class=\"mb_20\" data-mpak-number=\"$ctrl.mpakNumber\" form=\"$ctrl.moneyPakDepositForm\" on-update=\"$ctrl.update(value)\"></moneypak-activation-number-input><div ng-if=\"isRGAvailable && !rgLimitReached && rgMoneypakAvailableDepositAmount\" class=\"warningMessage\"><div></div><span>{{messageWithRemainingAmount}}</span></div><button ng-if=\"isRGAvailable && !rgLimitReached || !isRGAvailable\" qa-label=\"submitDeposit\" class=\"submit authorize-deposit mb_20\" ng-disabled=\"$ctrl.loading || $ctrl.moneyPakDepositForm.$invalid || $ctrl.activePoller || $ctrl.responsibleGamingDelay\" type=\"submit\"><i class=\"tvg-icon tvg-icon-lock\"></i> <strong ng-bind=\"::'depositExecuteButton' | CMSValue\"></strong></button><div ng-if=\"isRGAvailable && rgLimitReached\" class=\"warningMessage\"><div></div><span>{{::'DMARGLimitReached' | CMSLabels: 'moneyPakLabels'}}</span></div><div class=\"disclaimer\" qa-label=\"mpFaqDisclaimer\" data-add-click-listener-to=\"::('faqText' | CMSLabels: 'moneyPakLabels')\" data-click-listener=\"$ctrl.openModal(event)\"></div></form></div>"
  );


  $templateCache.put('src/moneypak/limits-table/limits-table.template.html',
    "<div class=\"limits-table-container\"><table><thead><tr><th ng-repeat=\"header in vm.content.headers track by $index\" ng-bind=\"header\"></th></tr></thead><tbody><tr ng-repeat=\"row in vm.content.rows track by $index\"><td ng-repeat=\"data in row track by $index\" ng-bind=\"data\"></td></tr></tbody></table></div>"
  );


  $templateCache.put('src/moneypak/moneypak-activation-number-input/moneypak-activation-number-input.template.html',
    "<div class=\"mpak-number-container field\" ng-class=\"{fieldInvalid: $ctrl.form.mpakNumber.$touched && $ctrl.form.mpakNumber.$invalid, inputFocused: inputNumberFocused}\"><div class=\"field-label\"><label for=\"mpak-number\" qa-label=\"mpInputLabel\" ng-bind-html=\"::('moneypakNumberLabel' | CMSLabels: 'moneyPakLabels')\"></label></div><div class=\"field-input mpak-number\"><span class=\"input-container\"><input type=\"text\" qa-label=\"mpInput\" class=\"form-control mpak-number\" id=\"mpak-number\" placeholder=\"{{::('moneypakNumberPlaceholder' | CMSLabels: 'moneyPakLabels')}}\" autocomplete=\"off\" name=\"mpakNumber\" ng-model=\"$ctrl.mpakNumber\" ui-mask=\"999 999 9999 9?9?9?9\" ng-focus=\"$ctrl.startDeposit(); inputNumberFocused= true;\" ui-mask-placeholder ui-mask-placeholder-char=\" \" ng-blur=\"inputNumberFocused = false\" ui-options=\"{ clearOnBlur: false, allowInvalidValue: true }\" ng-change=\"$ctrl.update()\" ng-model-options=\"{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }\" required></span></div><additional-info ng-click=\"$ctrl.openTooltip()\"><span class=\"card-imgs mpak\" qa-label=\"mpHelperImage\"></span></additional-info><div class=\"row non-table amount-errors-ctn clearfix\" ng-if=\"$ctrl.form.mpakNumber.$touched || $ctrl.form.$submitted\"><div ng-messages=\"$ctrl.form.mpakNumber.$error\"><div qa-label=\"error-required\" class=\"js-error-label error-label\" ng-message=\"required\" ng-bind-html=\"::('required' | CMSLabels: 'moneyPakLabels' | trust )\"></div><div qa-label=\"error-invalid\" class=\"js-error-label error-label\" ng-message=\"mask\" ng-bind-html=\"::('invalidCard' | CMSLabels: 'moneyPakLabels')\"></div></div></div></div>"
  );

}]);

angular.module('TVG.ApplePay.Common', ['ngMessages', 'TVG.DMA.Common', 'TVG.Configuration']);

angular.module('TVG.ApplePay.Deposits', [
  'TVG.ApplePay.Common',
  'UserActionEvents'
]);



angular.module('TVG.ApplePay', [
  'TVG.Paypal.Common',
  'TVG.ApplePay.Deposits'
]);

angular.module('TVG.DMA.AddClickListener', []);

angular.module('TVG.DMA.Common', [
  'TVG.DMA.ModalDialog',
  'TVG.DMA.AddClickListener'
]);

angular.module('TVG.DMA.ModalDialog', [
  'ui.bootstrap',
  'TVG.DMA.AddClickListener'
]);

/* eslint angular/no-service-method: 0 */
(function () {
  'use strict';
  ApplePayService.$inject = ['ConfigurationFac', 'Utilities', '$q', '$http', '$filter'];
  function ApplePayService(
    ConfigurationFac,
    Utilities,
    $q,
    $http,
    $filter
  ) {
    var self = this;

    /* endpoint
     * Give the endpoint resources, build the final URI.
     * @param {string} ...resources One or more resources
     * @return {string} URI
     */
    var endpoint = function (base, service, version) {
      version = version || 'v1';
      return function (/* resources */) {
        var separator = '/';
        var resources = [].slice.call(arguments, 0);
        return [base, service, version].concat(resources).join(separator);
      };
    };

    var brainTreeEndpoint = endpoint(ConfigurationFac.getBaseServiceUrl(), 'brt');

    var checkError = function (response) {
      return $q(function (resolve, reject) {
        return reject(self.createApiError([{
          message: _.get(response, 'data.message'),
          code: response.status,
          data: response.data
        }]));
      });
    };

    /**
     * Create an API error instance
     * Try to fetch an error message from the CMS (using the error code)
     * If none is found, use the error.message as a fallback
     *
     * @param  {Array} errors [description]
     * @return {Error}     [description]
     */
    self.createApiError = function (data) {
      var apiError = new Error();
      var error = data[0] || {};
      var applePayError = self.getFromCMS(error.code);

      apiError.message = applePayError || error.message;
      apiError.code = error.code;
      apiError.data = error.data || {};
      return apiError;
    };

    /**
     * request
     * @param  {Object} data
     * @param  {string} data.url
     * @param  {string} data.method
     * @param  {Object} data.data
     *
     * @return {Promise}
     */
    self.request = function (params) {
      var defaults = {
        headers: self.addHeaders(),
        method: 'POST'
      };

      return $http(_.extend({}, defaults, params))
        .catch(function (err) {
          return checkError(err);
        })
        .then(function (response) {
          response.data = _.assign({}, response.data, { statusCode: response.status });
          return response;
        })
        .then(Utilities.prop('data'));
    };

    /**
     * Add the headers needed to perform API calls
     *
     * @return {object}: Header Object
     */
    self.addHeaders = function (options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext())
      };

      if (Utilities.prop('cache', options)) {
        headers = _.extend({}, {
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }, headers);
      }
      return headers;
    };

    /**
     * Get labels from CMS
     * @param  {[string]} name [label Name]
     * @return {[string]}      [label]
     */
    self.getFromCMS = function (name) {
      return $filter('CMSLabels')(name, 'applepayLabels');
    };

    self.getDepositFee = function (amount, accountNumber) {
      var path = 'users/' + accountNumber + '/deposits/fees?amount=' + amount + '&paymentType=APPL';

      var requestOptions = {
        url: brainTreeEndpoint(path),
        method: 'GET'
      };

      return self.request(requestOptions);
    };
  }

  angular
    .module('TVG.ApplePay.Common')
    .service('applepayService', ApplePayService);
}());

angular
  .module('TVG.ApplePay.Deposits')
  .component('applepayDepositButton', {
    controller: 'applepaydepositButtonController',
    bindings: {
      onApplePayDeposit: '&',
      isDisabled: '<'
    },
    templateUrl: 'src/applepay/deposits/deposit-button/deposit-button.template.html'
  });

/* eslint angular/controller-as-vm: 0 */
(function () {
  'use strict';

  function DepositButtonController() {
    var self = this;

    self.onDeposit = function ($event) {
      self.onApplePayDeposit({ $event: $event });
    };
  }

  angular
    .module('TVG.ApplePay.Deposits')
    .controller('applepaydepositButtonController', DepositButtonController);
}());

angular
  .module('TVG.ApplePay.Deposits')
  .component('applepayDeposit', {
    templateUrl: 'src/applepay/deposits/deposit.template.html',
    controller: 'applepayDepositController',
    bindings: {
      minAmount: '<',
      maxAmount: '<',
      amountOptions: '<',
      depositAmount: '<',
      onAmountChange: '&',
      onPaymentComplete: '&'
    }
  });

/* eslint angular/controller-as-vm: "off" */

/**
 * This controllers' use case is mostly to know when to load
 * each screen and which properties it should pass to each component
 */
function ApplePayDepositController(
  $routeParams,
  $document,
  $window,
  $q,
  $timeout,
  NotificationService,
  applepayService,
  ApiDepositsGTMFac,
  ApplePayFac,
  $scope,
  $rootScope
) {
  var self = this;

  self.loading = true;
  self.applePayInstance = null;
  self.deviceData = '';
  self.depositAmount = undefined;
  self.unableToFetchBraintreeClient = false;
  self.fees = { loading: false };
  self.accountNumber = _.get($scope, '$parent.accountDetails.accountDetails.accountNumber', '') ||
    ($rootScope.user && $rootScope.user.accountNumber);
  self.feeRequestFailed = false;

  self.$onInit = function () {
    NotificationService.clearBanner();

    ApplePayFac.createClientInstance(self.accountNumber, false, self.handleBraintreeClientError)
      .then(function (response) {
        self.applePayInstance = response.applePayInstance;

        ApplePayFac.createDataCollector(response.braintreeClientInstance)
          .then(function (deviceData) {
            self.deviceData = deviceData;
            self.loading = false;
          });
      });
  };

  self.handleBraintreeClientError = function () {
    self.unableToFetchBraintreeClient = true;
  };

  /**
   * Method to handle apple pay input amount on change
   * @param {any} event
   * @return null
   */
  self.handleApplePayAmountChange = function ($event) {
    self.fees = {};
    self.depositAmount = $event.amount;
    self.fetchFees($event.amount);
  };

  /**
   * Method to tell if there is any error related with min & max values
   * @return boolean
   */
  self.isMinMaxError = function () {
    return self.minAmount > self.depositAmount || self.maxAmount < self.depositAmount;
  };

  /**
   * Method to fetch the apple pay fees
   * @param {number} amount
   * @return promise
   */
  self.fetchFees = function (amount) {
    if (self.isMinMaxError()) {
      return;
    }

    self.fees.retryFetchingFees = false;
    self.fees.loading = true;

    // stop if no amount is inserted
    // (amount is undefined if the value is not valid)
    if (!amount) {
      return $q.reject('invalid amount');
    }

    self.feeRequestFailed = false;
    NotificationService.clearBanner();

    return applepayService.getDepositFee(
      amount,
      self.accountNumber
    )
      .then(function (data) {
        var feeDiscount = data.feeRefundAmount;
        var feeAmount = parseFloat(data.feeAmount);
        var feeTotalAmount = parseFloat(data.feeTotalAmount);
        self.fees = _.assign({}, self.fees, {
          netAmount: amount,
          fee: feeAmount,
          feeDiscount: feeDiscount,
          transactionTotal: amount + feeTotalAmount
        });
        self.depositAmount = amount;
        return self.fees;
      })
      .then(function (fees) {
        ApiDepositsGTMFac.sendGTMEvent('deposit', {
          gaEventCategory: 'Deposit',
          gaEventAction: 'Deposit Start',
          gaEventLabel: undefined,
          depositType: 'Apple Pay',
          module: 'My Funds',
          depositAmount: amount + fees.fee
        });
      })
      .catch(function () {
        self.feeRequestFailed = true;
        self.fees.retryFetchingFees = true;
      })
      .finally(function () {
        self.fees.loading = false;
      });
  };

  /**
   * Should disable apple pay button
   * @return {boolean}
   */
  self.shouldDisableApplePayButton = function () {
    var amount = self.depositAmount || 0;

    return self.fees.loading ||
      self.feeRequestFailed ||
      amount === 0 ||
      !self.applePayInstance ||
      !self.deviceData ||
      self.isMinMaxError();
  };

  self.successCallbackPayment = function (data) {
    if (data) {
      $scope.$emit('onDepositEventSuccess', data);
      $rootScope.$broadcast('accountBalance_update');
      $rootScope.$emit('accountBalance_changed', data);
    }
    self.onPaymentComplete();
    self.depositAmount = undefined;

    // very ugly hack to force clear amount value
    self.applepayAmount = null;
    self.applepayDeposits.amount.$$writeModelToScope(); //eslint-disable-line
    setTimeout(function () { //eslint-disable-line
      self.applepayAmount = undefined;
      self.applepayDeposits.amount.$$writeModelToScope(); //eslint-disable-line

      $scope.$parent.events.setDepositTypeLimits('APPL');

      $timeout(function () {
        self.fees = { loading: false };
      }, 400);
    }, 0);
  };

  self.getApplePayErrorModalConfigParam = $scope.$parent.events.getApplePayErrorModalConfig;
  /**
   * Method that calls apple pay fac to handle the apple pay deposit
   * @return null
   */
  self.onApplePayDeposit = function () {
    ApplePayFac.onApplePayDeposit(
      self.applePayInstance,
      self.depositAmount,
      self.fees.fee,
      self.fees.feeDiscount,
      self.accountNumber,
      self.deviceData,
      null,
      self.successCallbackPayment,
      self.getApplePayErrorModalConfigParam()
    );
  };
}

angular
  .module('TVG.ApplePay.Deposits')
  .controller('applepayDepositController', ApplePayDepositController);

angular
  .module('TVG.ApplePay.Deposits')
  .component('applepaySelectAmount', {
    controller: 'applepaySelectAmountController',
    bindings: {
      form: '=',
      amount: '<',
      amounts: '<',
      minAmount: '<',
      maxAmount: '<',
      onAmountChange: '&'
    },
    templateUrl: 'src/applepay/deposits/select-amount/select-amount.template.html'
  });

/* eslint angular/controller-as-vm: "off" */
(function () {
  'use strict';

  SelectAmountController.$inject = ['UserActionEventsService', '$timeout'];
  function SelectAmountController(UserActionEventsService, $timeout) {
    var self = this;

    self.change = function (amount) {
      if (self.form.$error) {
        $timeout(function () {
          UserActionEventsService.emit('applePayFill', self.form.$error);
        }, 200);
      }
      self.amount = amount;
      if (self.onAmountChange) {
        self.onAmountChange({ $event: { amount: amount } });
      }
    };
  }

  angular
    .module('TVG.ApplePay.Deposits')
    .controller('applepaySelectAmountController', SelectAmountController);
}());

angular
  .module('TVG.ApplePay.Deposits')
  .component('applepayTotalCost', {
    bindings: {
      data: '<',
      email: '<',
      handleFetchFees: '&'
    },
    templateUrl: 'src/applepay/deposits/total-cost/total-cost.template.html'
  });

(function () {
  'use strict';

  /**
   * This directive adds a "ng-click" to the first, or all, "<a>" found in the "addClickListenerTo" text.
   * This could be useful if someone wants to do something before the default action takes effect or
   * cancel the default action.
   *
   * Before the compilation is performed the text is wrapped in a "<span>" element.
   * This avoids errors when compiling the "addClickListenerTo" text if it's not an HTML element.
   */
  addClickListenerToDirective.$inject = ['$compile', 'addClickListenerToService'];
  function addClickListenerToDirective($compile, addClickListenerToService) {
    var NG_CLICK_TO_APPEND = ' ng-click="clickListener({event: $event})"';
    var SPLIT_STR = '<a';

    return {
      restrict: 'A',
      scope: {
        addClickListenerTo: '<',
        clickListener: '&',
        addToAll: '@?'
      },
      link: function (scope, element) {
        var htmlText;

        if (!scope.addClickListenerTo) {
          return;
        }

        htmlText = addClickListenerToService.appendAttributeTo(
          scope.addClickListenerTo,
          NG_CLICK_TO_APPEND,
          SPLIT_STR,
          scope.addToAll);

        htmlText = addClickListenerToService
          .wrapHtmlTextIn('span', htmlText);

        element.html(htmlText);
        $compile(element.contents())(scope);
      }
    };
  }

  angular
    .module('TVG.DMA.AddClickListener')
    .directive('addClickListenerTo', addClickListenerToDirective);
}());

(function () {
  'use strict';

  function addClickListenerToService() {
    /**
     * @param {String} text The original text.
     * @param {String} attribute The partial text to insert in the middle of the provided text.
     * @param {String} separator A character or string that's going to be used to split the original in half or more.
     * @param {boolean} appendToAll true to append attribute to all parts of the divided text. Otherwise,
     *  the attribute is inserted only in the first occurrence even if the separator is found more than once.
     * @returns {String} The original text with the provided attribute inserted in the middle if separator is found.
     *
     * @private
     */
    function _appendAttributeTo(text, attribute, separator, appendToAll) {
      var i;
      var length;
      var htmlText = text.split(separator);

      if (htmlText.length > 1) {
        length = appendToAll ? htmlText.length : 2;

        for (i = 1; i < length; i++) {
          htmlText[i] = attribute + htmlText[i];
        }
      }

      return htmlText.join(separator);
    }

    /**
     * @param {String} wrapper A HTML element's name
     * @param {String} htmlText The HTML text to wrap
     * @returns {String} The HTML text wrapped with the provided HTML element.
     * @private
     */
    function _wrapHtmlTextIn(wrapper, htmlText) {
      return '<{0}>{1}</{0}>'
        .replace(/\{0\}/gi, wrapper)
        .replace('{1}', htmlText);
    }

    return {
      appendAttributeTo: _appendAttributeTo,
      wrapHtmlTextIn: _wrapHtmlTextIn
    };
  }

  angular
    .module('TVG.DMA.AddClickListener')
    .factory('addClickListenerToService', addClickListenerToService);
}());

(function () {
  'use strict';

  var modalDialogComponent = {
    bindings: {
      body: '<',
      title: '<',
      close: '&',
      klass: '@'
    },
    controller: 'ModalDialogController',
    templateUrl: 'src/common/modal-dialog/modal-dialog.template.html'
  };

  angular
    .module('TVG.DMA.ModalDialog')
    .component('modalDialog', modalDialogComponent);
}());

(function () {
  'use strict';

  ModalDialogController.$inject = ['$document', '$window'];
  function ModalDialogController($document, $window) {
    var vm = this;

    function _getIdOfElementToScrollTo(originalElement) {
      var path;
      var hash;

      path = originalElement && originalElement.pathname;
      hash = originalElement && originalElement.hash;

      if (path !== '/' || hash === '') {
        return null;
      }

      return hash;
    }

    vm.scrollToSection = function (event) {
      var hash;
      var element;

      if (!event || !event.target) {
        return undefined;
      }

      hash = _getIdOfElementToScrollTo(event.target);

      if (!hash) {
        return undefined;
      }

      event.preventDefault();

      // find the element with the id equal to the hash
      element = $document[0].querySelector(hash);
      if (element) {
        if ([
          'touch3',
          'ios2',
          'fdrmobile',
          'fdrios',
          'fdrandroid',
          'androidwrapper',
          'tvgandroid'
        ].indexOf($window.productContext) >= 0) {
          // prevent scroll to on ios iframe
          return true;
        }

        element.scrollIntoView();

        return true;
      }

      return false;
    };
  }

  angular
    .module('TVG.DMA.ModalDialog')
    .controller('ModalDialogController', ModalDialogController);
}());

(function () {
  'use strict';

  modalDialogService.$inject = ['$rootScope', '$uibModal'];
  function modalDialogService($rootScope, $uibModal) {
    var self = this;

    function _open(bindings, dimension, modalClass) {
      var cssClass = dimension || '';

      return $uibModal.open({
        template: '<modal-dialog data-body="modalBody" ' +
          'data-title="modalTitle" data-close="$close()" ' +
          'data-klass="' + cssClass + '"></modal-dialog>',
        scope: bindings,
        windowTemplateUrl: 'src/common/modal-dialog/modal-window.html',
        backdropClass: 'tvgmodal-backdrop',
        windowClass: 'tvgmodal-dma-redesign tvg-ui-modal-dialog ' + (modalClass || '')
      });
    }

    /**
     * Opens a medium-size modal dialog.
     *
     * @param {String} modalTitle The text that is going to appear on the header of the modal
     * @param {String} modalBody The text that is going to appear on the body of the modal. It can be a HTML text.
     * @returns {Object} a modal instance, an object with the following properties: <br>
     * * close(result) (Type: function) - Can be used to close a modal, passing a result.
     * * dismiss(reason) (Type: function) - Can be used to dismiss a modal, passing a reason.
     * * result (Type: promise) - Is resolved when a modal is closed and rejected when a modal is dismissed.
     * * opened (Type: promise) - Is resolved when a modal gets opened after downloading content's template and resolving all variables.
     * * closed (Type: promise) - Is resolved when a modal is closed and the animation completes.
     * * rendered (Type: promise) - Is resolved when a modal is rendered.
     */
    self.open = function (modalTitle, modalBody, modalClass) {
      var bindings = _.extend($rootScope.$new(), {
        modalBody: modalBody,
        modalTitle: modalTitle
      });

      return _open(bindings, '', modalClass);
    };

    /**
     * Opens a large-size modal dialog.
     *
     * @param {String} modalTitle The text that is going to appear on the header of the modal
     * @param {String} modalBody The text that is going to appear on the body of the modal. It can be a HTML text.
     * @returns {Object} a modal instance, an object with the following properties: <br>
     * * close(result) (Type: function) - Can be used to close a modal, passing a result.
     * * dismiss(reason) (Type: function) - Can be used to dismiss a modal, passing a reason.
     * * result (Type: promise) - Is resolved when a modal is closed and rejected when a modal is dismissed.
     * * opened (Type: promise) - Is resolved when a modal gets opened after downloading content's template and resolving all variables.
     * * closed (Type: promise) - Is resolved when a modal is closed and the animation completes.
     * * rendered (Type: promise) - Is resolved when a modal is rendered.
     */
    self.openLarge = function (modalTitle, modalBody, modalClass) {
      var bindings = _.extend($rootScope.$new(), {
        modalBody: modalBody,
        modalTitle: modalTitle
      });

      return _open(bindings, 'large', modalClass);
    };
  }

  angular.module('TVG.DMA.ModalDialog')
    .service('ModalDialogService', modalDialogService);
}());

(function () {
  'use strict';

  Utilities.$inject = ['$q', '$timeout', '$location', 'ConfigurationFac', '$window'];
  function Utilities($q, $timeout, $location, ConfigurationFac, $window) {
    /**
     * curry
     *
     * @param {Function} fn
     * @param {Object} ctx
     * @return {Function}
     */
    var curry = function (fn, ctx) {
      return function curriedFn() {
        var args = [].slice.call(arguments);
        return (args.length >= fn.length) ?
          fn.apply(null, args) :
          function () {
            return curriedFn.apply(ctx, args.concat([].slice.call(arguments)));
          };
      };
    };

    /**
     * attempt
     * Try to call the given function with the given arguments, if the resulting
     * call throws an error, that error is returned, otherwise returns the
     * resulting value.
     * Also, if a second function is given, it will be called if there was an
     * error, with the Error
     * as argument. The return value will then be resulting function return.
     *
     * @param  {Function} fn function to be called
     * @param  {Function} [errfn] if an Error was found, call this function with
     * the error as argument
     * @return {Error|*}
     */
    var attempt = function (fn, errfn) {
      var errorCb = errfn || id;
      var result;

      try {
        result = fn();
      } catch (e) {
        result = errorCb(e);
      }

      return result;
    };

    /**
     * Back Off algorithm with Fibonacci exponential
     * backOff :: (Function<next, stop>, Number) -> Promise<Any, Error>
     *
     * @param {Function<next, stop>} fn function to be called
     * @param {Number} timeout
     * @return {Promise<Any, Error>}
     * @example
     * ```
     *  backOff(function (next, stop) {
     *    // Let's perform this function repeatedly for 60s
     *    doSomething()
     *      .then(function (importantValue) {
     *        // importantValue is not exactly what we
     *        // need so we need to try again
     *        next();
     *
     *        // importantValue is exactly what we are expecting so
     *        // let's stop with the repetions and jump out of the cycle
     *        stop(importantValue);
     *      })
     *      .catch(function (error) {
     *        // there was an error, let's stop this with an error too
     *        stop(error);
     *      })
     *  }, 60000)
     *  .then(function (importantValue) {})
     *  .catch(function (error) {
     *    // deal with errors passed to stop()
     *  })
     * ```
     */
    var backOff = curry(function (fn, timeout) {
      var prevInterval = 0;
      var nextInterval = 1000;
      var checkTimedOut = curry(function (timeoutMax, startTime, currentTime) {
        return (currentTime - startTime > timeoutMax);
      });
      var hasTimedOut = checkTimedOut(timeout, (+new Date()));

      return $q(function (resolve, reject) {
        var stop = function (arg) {
          return (arg instanceof Error) ?
              reject(arg) :
              resolve(arg);
        };

        var next = function () {
          var tmp = nextInterval;
          if (!hasTimedOut((+new Date()))) {
            $timeout(fn.bind(null, next, stop), nextInterval);
            nextInterval = nextInterval + prevInterval;
            prevInterval = tmp;
          } else {
            reject(new Error('BACKOFF_TIMEOUT'));
          }
        };

        fn(next, stop);
      });
    });

    /**
     * compose :: (Function, Function) -> Function -> Any
     *
     * @param  {Function} f
     * @param  {Function} g
     * @return {Function}
     */
    var compose = function (f, g) {
      return function (x) {
        return f(g(x));
      };
    };


/*
@fn function that executes a request and returns the value of the break condition
@timeout expiration time for the poller (requests will be made until that time) - milliseconds
@interval time between requests - milliseconds
 */
    var depositStatusPoller = function (fn, timeout, interval) {
      var endTime = Number(new Date()) + (timeout || 300000);
      var interv = interval || 3000;

      var checkCondition = function (resolve, reject) {
        var result = fn();

        if (result.then) {
          result.then(function (res) {
            if ((res === 'FINISH_DEPOSIT_SUCCESS' || res === 'FINISH_DEPOSIT_ERROR') ||
              $window.pollerRes &&
              ($window.pollerRes === 'FINISH_DEPOSIT_SUCCESS' ||
                $window.pollerRes === 'FINISH_DEPOSIT_ERROR')) {
              resolve(res === 'FINISH_DEPOSIT_SUCCESS' ||
                $window.pollerRes === 'FINISH_DEPOSIT_SUCCESS');
            } else if (Number(new Date()) < endTime) {
              // eslint-disable-next-line
              setTimeout(checkCondition, interv, resolve, reject);
            } else {
              reject(new Error('timed out'));
            }
          });
        } else if (result) {
          resolve(result);
        } else if (Number(new Date()) < endTime) {
          // eslint-disable-next-line
          setTimeout(checkCondition, interv, resolve, reject);
        } else {
          reject(new Error('timed out'));
        }
      };
      return $q(checkCondition);
    };

    /**
     * id
     * Return the first argument given
     * @param  {*} val [description]
     * @return {*}     [description]
     */
    var id = function (val) {
      return val;
    };

    /**
     * isEmpty
     * @param  {Array|Object} list
     * @return {Boolean}
     */
    var isEmpty = function (list) {
      var keys = isObject(list) ? Object.keys(list) : list;
      return keys ? !keys.length : true;
    };

    /**
     * mapKeys
     * iterate and object and apply the given function to the keys of the object
     *
     * @param  {Function} function  A function that will receive the key and the
     * value as arguments
     * @param {object}  obj the object to be iterared
     * @return {object}   Object with new keys
     */
    var mapKeys = curry(function (mapfn, obj) {
      return Object.keys(obj).reduce(function (acc, key) {
        var result = acc;
        result[mapfn(key, obj[key])] = obj[key];
        return result;
      }, {});
    });

    /**
     * memoize
     * Cache function result for the given arguments
     * @param  {Function} func
     * @return {Function}
     * @FIXME Find something more performant than JSON.stringify/parse
     */
    var memoize = function (f) {
      var slice = [].slice;
      var cache = {};
      return function () {
        var args = angular.toJson(slice.call(arguments));
        return (args in cache) ?
          cache[args] :
          (cache[args] = f.apply(this, angular.fromJson(args)));
      };
    };

    /**
     * noop
     * Empty function. This is useful for optional callbacks
     */
    var noop = function () {};

    /**
     * pick
     * Return a new object with the given properties of the original object
     * pick :: ([String]) -> (Object) -> Object
     *
     * @param  {string[]} properties Desired properties
     * @param  {Object} obj
     * @return {Object}
     */
    var pick = curry(function (properties, obj) {
      var props = [].concat(properties);
      return props.reduce(function (acc, key) {
        var result = acc;
        if (obj.hasOwnProperty(key)) {
          result[key] = obj[key];
        }

        return result;
      }, {});
    });

    /**
     * prop
     * Return the given property from the given object
     * prop :: (String) -> (Object) -> Any
     *
     * @param  {string} property
     * @param  {Object} obj
     * @return {*}
     * @example prop('a.very.nested.property', obj);
     */
    var prop = curry(function (property, obj) {
      var path = property.split('.');
      var next = path.shift();
      var pointer = obj;

      if (!isObject(pointer)) {
        return undefined;
      }

      while (angular.isDefined(pointer) && pointer !== null && next) {
        if (pointer.hasOwnProperty(next)) {
          pointer = pointer[next];
          next = path.shift();
        } else {
          return undefined;
        }
      }

      return pointer;
    });

    /**
     * supplant
     * @see http://javascript.crockford.com/remedial.html
     * @param  {string} str
     * @param  {o} object
     * @return {string}
     */
    var supplant = curry(function (str, o) {
      return str.replace(/\{([^{}]*)\}/g, function (a, b) {
        var r = o[b];
        return angular.isString(r) || angular.isNumber(r) ? r : a;
      });
    });

    /*
     * timestamp
     * Returns a timestamp string formatted
     *
     * @return {String}
     * @example timestamp(); // '1458766136720'
     * */
    var timestamp = function () {
      return ('' + +new Date());
    };

    var toTypeString = function (val) {
      return Object.prototype.toString.call(val);
    };

    var isObject = function (val) {
      return Object(val) === val &&
        toTypeString(val) === '[object Object]' ||
        toTypeString(val) === '[object Window]';
    };

    /**
     * uuid ()
     *
     * @return {String} RFC4122 v.4
     */
    var uuid = function () {
      var template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

      return template.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    };

    /**
     * Convert regular base64 strings into URL-safe base64
     *
     * @param  {string} b64 base64 string
     * @return {string}     URL-safe base64 string
     */
    var base64toBase64Url = function (b64) {
      return b64.replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
    };

    /**
     * Convert URL-safe base64 strings into regular base64
     *
     * @param  {string} b64u URL-safe base64 string
     * @return {string}      base64 string
     */
    var base64UrlToBase64 = function (b64u) {
      var str = '' + b64u;

      if (b64u.length % 4 === 2) {
        str = b64u + '==';
      } else if (b64u.length % 4 === 3) {
        str = b64u + '=';
      }

      return str.replace(/-/g, '+').replace(/_/g, '/');
    };

    /**
     * Call fn with the given argument, and return the argument
     * This is useful to inject console.log statements into promises
     *
     * @param  {Function} fn
     * @return {Function}
     */
    var tap = curry(function (fn, val) {
      return (fn(val), val);
    });

    /**
     * toCamelCase
     * @param  {string} str String to convert
     * @return {string}
     */
    var toCamelCase = function (str) {
      var capitalized = str
        .toLowerCase()
        .split(/[^a-zA-Z0-0]/)
        .map(upperFirst)
        .join('');

      return lowerFirst(capitalized);
    };

    var toDateFormat = curry(function (format, inputDate) {
      var date = moment(inputDate);

      return date.isValid(inputDate) ?
          date.format(format) :
          '';
    });

    var lowerFirst = function (str) {
      return str.charAt(0).toLowerCase() + str.slice(1);
    };

    var upperFirst = function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };

    /**
     * parseQueryString :: (String) -> Object
     * @param  {String} qs query string without the initial '?';
     * @return {Object}
     */
    var parseQueryString = function (str) {
      var qs = str;

      if (qs[0] === '?') {
        qs = str.substring(1);
      }

      return qs
        .split('&')
        .reduce(function (acc, pair) {
          var parts = pair.split('=');
          acc[parts[0]] = parts[1];
          return acc;
        }, {});
    };

    var endpoint = function (service) {
      return function (/* resources */) {
        var separator = '/';
        var resources = [].slice.call(arguments, 0);
        var baseUrl = ConfigurationFac.getServiceApiUrl(service) || '';
        var version = '/v1';

        if (service === 'slp') {
          version = '/v2';
          baseUrl = baseUrl.replace('/v1', version);
        }

        if (!baseUrl || baseUrl === 'false') {
          baseUrl = '/' + service + version;
        }

        if (baseUrl.indexOf('false') !== -1) {
          baseUrl = baseUrl.split('false')[0] + '/' + service + version;
        }

        return [baseUrl].concat(resources).join(separator);
      };
    };

    return {
      attempt: attempt,
      backOff: backOff,
      compose: compose,
      curry: curry,
      /**
       * decodeURLSafe
       * Decode URL-safe base64 strings into the original type
       *
       * @param  {string} data URL-safe base64 string
       * @return {*}
       */
      decodeURLSafe: function (data) {
        var b64 = base64UrlToBase64(data);
        var str = atob(b64);

        return attempt(function () {
          return angular.fromJson(str);
        }, function () {
          return str;
        });
      },
      /**
       * encodeURLSafe
       * Safely convert the given data into a URL-safe version of base64.
       *
       * @param  {*} data Any type as long as it's not an object with circular
       * references
       * @return {string}   URL-safe base64
       */
      encodeURLSafe: function (data) {
        var str = angular.isString(data) ? data : angular.toJson(data);
        var b64 = btoa(str);
        return base64toBase64Url(b64);
      },

      id: id,
      isEmpty: isEmpty,
      lowerFirst: lowerFirst,
      mapKeys: mapKeys,
      memoize: memoize,
      noop: noop,
      parseQueryString: parseQueryString,
      pick: pick,
      prop: prop,
      supplant: supplant,
      tap: tap,
      depositStatusPoller: depositStatusPoller,
      endpoint: endpoint,
      timestamp: timestamp,
      toCamelCase: toCamelCase,
      toDateFormat: toDateFormat,
      uuid: uuid,
      upperFirst: upperFirst,
      /**
       * urlBuilder
       * Prepends the full hostname and port to the given partial url
       *
       * @param  {string} property
       * @return {string}
       * @example urlBuilder('/partialURL');
       */
      urlBuilder: function (url) {
        /* ** Some notes: **
         *
         * - $location.host() does not return 'http'/'https'
         * - if the URL contains a querystring it must be removed, otherwise the
         * returned URL won't be valid
         * - $location.hash() doesn't return the '#', so you need to add it by
         * hand
         *
         **/
        var absUrl = $location.absUrl();
        var qsIndex = absUrl.indexOf('?');
        var hash = $location.hash() === '' ?
          $location.hash() :
        '#' + $location.hash();
        var hashIndex = absUrl.indexOf($location.hash());
        var domainNoHash = !!hash ? absUrl.substring(0, hashIndex - 1) : absUrl;
        var domainNoQs = qsIndex > 0 ?
          domainNoHash.substring(0, qsIndex) :
          domainNoHash;

        return domainNoQs.concat(url, hash);
      },

      returnToTab: function (tab, params) {
        var product = ConfigurationFac.getApplicationContextItem('product');
        var location = ConfigurationFac.getApplicationContextItem('location');
        product = (product !== '') ? '&product=' + product : '';
        location = (location !== '') ? '&location=' + location : '';

        return supplant('?activeTab={tab}{product}{location}{params}', {
          tab: tab,
          product: product,
          location: location,
          params: params || ''
        });
      }
    };
  }

  angular.module('TVG.DMA.Common').factory('Utilities', Utilities);
}());

/* global sightline */

(function () {
  'use strict';

  DepositController.$inject = ['$q', '$scope', '$log', '$rootScope', '$timeout', '$location', '$window', '$sce', '$filter', '$uibModal', 'DepositSrv', 'ConfigurationFac', 'ApiDepositsGTMFac', 'ApplePayFac', 'NotificationService', 'SightlineSrv', 'SightlineDepositConfig', 'Utilities', 'FeedbackFac', 'PaypalDepositConfig', 'ApplePayDepositConfig', 'ModalDialogService', 'UserActionEventsService', 'DEPOSIT_TYPES', 'DepositInitialDataFac', 'DMAFeatureTogglesHashContainerSvc', 'depositMinAmountOverrides'];
  function DepositController(
    $q,
    $scope,
    $log,
    $rootScope,
    $timeout,
    $location,
    $window,
    $sce,
    $filter,
    $uibModal,
    DepositSrv,
    ConfigurationFac,
    ApiDepositsGTMFac,
    ApplePayFac,
    NotificationService,
    SightlineSrv,
    SightlineDepositConfig,
    Utilities,
    FeedbackFac,
    PaypalDepositConfig,
    ApplePayDepositConfig,
    ModalDialogService,
    UserActionEventsService,
    DEPOSIT_TYPES,
    DepositInitialDataFac,
    DMAFeatureTogglesHashContainerSvc,
    depositMinAmountOverrides
  ) {
    var invalidFormLabelTimer;
    var bankNameInfoMessages = {
      DEFAULT: '',
      ERROR: 'Please fill the bank name',
      FETCHING: 'Fetching bank name'
    };
    var toggleTimestamp = null;
    var unbind = [];
    var today = new Date();

    var ERRORS = {
      NO_SIGHTLINE_ACCOUNT_FOUND: 'NO_SIGHTLINE_ACCOUNT_FOUND'
    };

    var siteVersion = ApiDepositsGTMFac.getSiteVersion(
      ConfigurationFac.getApplicationContextItem('product').toLowerCase()
    );

    var productVersion = ApiDepositsGTMFac.getProduct(
      ConfigurationFac.getApplicationContextItem('product')
    );
    var isNative = false;

    var applePayInstance = null;
    var deviceData = '';

    var FIRST_DEPOSIT_LABELS = {
      title: 'No deposit methods on File',
      text: 'Speed up your deposits, add a method now.',
      buttonText: 'Add new Deposit Options'
    };

    var SUCCESS_MODAL_LABELS = {
      title: 'Successful Deposit!',
      textTemplate: 'Your $@@@deposit_amount@@@ are now available!',
      buttonText: 'Let\'s bet!'
    };

    var firstDepositCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('navigation', {
        event: 'navigation',
        gaEventCategory: 'Navigation',
        gaEventAction: 'Navigated To',
        gaEventLabel: FIRST_DEPOSIT_LABELS.buttonText,
        module: 'quick deposit',
        sport: undefined,
        microApp: 'non-Microapp',
        tag: undefined,
        destinationUrl: 'https://www.tvg.com/more#funds'
      });
      if ($window && $window.handleNativeMessages) {
        $window.handleNativeMessages('GO_TO_DEPOSITS');
      }
    };


    var successModalOnOpenCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'siteClick',
        gaEventCategory: 'Site click',
        gaEventAction: 'seen',
        gaEventLabel: undefined,
        module: 'deposit success modal',
        tag: undefined,
        microApp: undefined
      });
    };

    var successModalButtonCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('navigation', {
        event: 'navigation',
        gaEventCategory: 'Navigation',
        gaEventAction: 'Navigated To',
        gaEventLabel: SUCCESS_MODAL_LABELS.buttonText,
        module: 'deposit success modal',
        tag: undefined,
        menu: undefined,
        sport: 'Horse Racing',
        destinationUrl: 'https://www.tvg.com/'
      });

      if ($window && $window.handleNativeMessages) {
        $window.handleNativeMessages('CLOSE_DMA');
      }
    };


    var successModalCloseCallback = function () {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'siteClick',
        gaEventCategory: 'Site click',
        gaEventAction: 'close',
        gaEventLabel: undefined,
        module: 'deposit success modal',
        tag: undefined,
        microApp: undefined
      });
    };

    var triggerGaPageLoadEvent = function (accountNumber, state) {
      if (siteVersion === 'ANDROIDWRAPPER') {
        siteVersion = 'android_native';
      }
      ApiDepositsGTMFac.sendGTMEvent('ga_pageload', {
        accountId: accountNumber,
        graphVersion: 'v2',
        page: $window.location.pathname,
        privateBrowser: localStorage.getItem('privateMode') === 'true' ? 'Yes' : 'No',
        productVersion: productVersion,
        residenceState: state,
        screenName: 'Deposit',
        sectionName: 'Deposit',
        siteVersion: siteVersion,
        appVersion: $rootScope.appVersion
      });
    };

        /**
     * Get labels from CMS
     * @param  {[string]} name [label Name]
     * @return {[string]}      [label]
     */
    var getFromCMS = function (name) {
      return $filter('CMSLabels')(name, 'applepayLabels');
    };

    var ApplePayErrorModalDefault = Object.freeze({
      buttonText: '',
      buttonTextSecond: '',
      buttonTextCustomerSupport: getFromCMS('applePayModalErrorButtonCustomerSupport'),
      textMain: getFromCMS('applePayModalErrorTextRedirect'),
      textCustomerSupport: getFromCMS('applePayModalErrorTextCustomerSupport'),
      buttonCallback: Utilities.noop,
      buttonCallbackSecond: Utilities.noop,
      buttonCallbackCustomerSupport: function () {
        window.location = window.location.protocol + '//' + window.location.host + '/redirectengine?type=messageus'; // eslint-disable-line
      }
    });

    $scope.currentYear = parseInt($filter('date')(today, 'yy'), 10);
    $scope.currentMonth = parseInt($filter('date')(today, 'MM'), 10);

    $scope.njxIntegration =
      ConfigurationFac.getApplicationContextItem('product') === 'njx';

    $window.isWrapped =
      ConfigurationFac.getApplicationContextItem('wrapper') === 'true';

    $scope.data = {
      currentMinValue: 0,
      currentMaxValue: 99999,
      numberPattern: /^[0-9]+$/,
      expirationDateValues: DepositSrv.getExpirationDateValues(),
      bankNameDisabled: true, // Disables bank name input by default
      bankNameMessage: bankNameInfoMessages.DEFAULT, // Default bank name label,
      depositSection: 'NEW',
      states: [],
      loading: true,
      makingDeposit: false,
      errorBankName: false,
      fee: {
        calculatingFees: false
      },
      showGreenDotInvalidCardNumberMessage: false,
      showIBCInvalidPinOrPasswordMessage: false,
      availableAmountOptions: [],
      showInvalidFormMessage: false,
      retryFetchingFees: false,
      showAddNewDepositOptions: false,
      defaultPaymentCard: false,
      defaultPaymentValues: [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
      ],
      showAchDepositLimitExceeded: false,
      slnIframeURL: $sce.trustAsResourceUrl(
        ConfigurationFac.getSightline('iframeURL')
      ),
      selectedCard: $rootScope.selectedCard || 0,
      redirectMessage: false,
      shouldDisableApplePayButton: false
    };
    $scope.PaypalDepositConfig = PaypalDepositConfig;
    $scope.ApplePayDepositConfig = ApplePayDepositConfig;
    $scope.sightlineContext = 'deposit';
    $rootScope.sightlineLoaded = false;
    $scope.firstTimeAddFunds = false;

    // because we always get user's data on startup
    $scope.sightlineLoading = true;

    // options to be rendered in quick-deposit-default.html
    $scope.selectDefaultOptions = [
      { name: 'Yes', value: true },
      { name: 'No', value: false }
    ];

    $rootScope.selectedCard = 0;
    $scope.sightlineBalance = 0;

    $scope.events = {
      routingNumberOnChange: _routingNumberOnChange,
      updateTotalCosts: _updateTotalCosts,
      subTypeCardChanged: _subTypeCardChanged,
      selectOnFileChanged: _selectOnFileChanged,
      setDepositTypeLimits: _setDepositTypeLimits,
      toggleNewStoredMethods: _toggleNewStoredMethods,
      selectOption: _selectOption,
      makeDeposit: _makeDeposit,
      onApplePayDeposit: _onApplePayDeposit,
      shouldDisableApplePayButton: _shouldDisableApplePayButton,
      getApplePayErrorModalConfig: _getApplePayErrorModalConfig,
      clearCVN: _clearCVN,
      openTerms: _openTerms,
      goToFullDeposit: _goToFullDeposit,
      existsOnFile: _existSelectedOnFile,
      defaultPaymentChanged: _defaultPaymentChanged,
      resetAllModels: _resetAllModels,
      addQuickDepositFunds: _addQuickDepositFunds,
      addSightlineFunds: _addSightlineFunds,
      getMax: _getMax,
      isSightlinePayment: _isSightlinePayment,
      isSightlineInvalid: _isSightlineInvalid,
      showAddFundsInBetslipWarning: _showAddFundsInBetslipWarning,
      slicedCard: _slicedCard,
      selectOptionByName: _selectOptionByName,
      handleDefaultAmountButtonClick: _handleDefaultAmountButtonClick,
      handleAmountInputChange: _handleAmountInputChange,
      handleAmountInputBlur: _handleAmountInputBlur,
      anyCardsExpired: _anyCardsExpired,
      allCardsDeclined: _allCardsDeclined,
      isSLNDeclinedCard: _isSLNDeclinedCard,
      onlyNumbers: _onlyNumbers,
      FieldFilled: _FieldFilled,
      clickTooltip: _clickTooltip,
      isIos: _isIos,
      isBetslip: _isBetSlip,
      changeCard: _changeCard,
      selectAccount: _selectAccount,
      depositAttemptGtm: _depositAttemptGtm,
      handleBalanceUpdate: function () {
        $rootScope.$broadcast('accountBalance_update');
      },
      handlePaypalAmountChange: function (data) {
        $scope.depositDataModel.amount = data;
      },
      registerAccountSelectionOnGTM: _registerAccountSelectionOnGTM,
      sendOtherAmountErrorToGTM: _sendOtherAmountErrorToGTM,
      completedFieldAndBlursAway: _completedFieldAndBlursAway,
      newAccountFieldError: _newAccountFieldError,
      closeSuccessfulRegistrationModal: _closeSuccessfulRegistrationModal
    };

    $scope.depositDataModel = {
      selectedPayOption: {
        min: 0,
        max: 99999
      },
      toSaveOnFile: true,
      isDefaultPayment: false,
      responsibleGamingDelay: false
    };

    // used to calculate elements display flags in template
    $scope.displays = {
      getSLPLabel: _getSLPLabel,
      isNewOnFileVisible: _isNewOnFileVisible,
      isIBCNewOnFileVisible: _isIBCNewOnFileVisible,
      isDepositFormVisible: _isDepositFormVisible,
      isIBCInvalidVisible: _isIBCInvalidVisible,
      isNotIBCValidVisible: _isNotIBCValidVisible,
      isPendingNotCalculatingVisible: _isPendingNotCalculatingVisible,
      isIBCValidExceededVisible: _isIBCValidExceededVisible,
      isDepositLoaded: _isDepositLoaded,
      isBetcashLimitExceeded: _isBetcashLimitExceeded,
      isAddNewDepositOptionsVisible: _isAddNewDepositOptionsVisible,
      isDMAInjectNoPaymentQuickDepositEnabled: function () {
        return $rootScope.activeFeatures.isDMAInjectNoPaymentQuickDepositEnabled;
      },
      disableQuickDepositButton: _disableQuickDepositButton,
      isPaypalInQuickDepositEnabled: _isPaypalInQuickDepositEnabled,
      isApplePayInQuickDepositEnabled: _isApplePayInQuickDepositEnabled,
      sightlineBalanceExceeded: _sightlineBalanceExceeded,
      hasThreeTitles: _hasThreeTitles,
      toggleTitles: _toggleTitles,
      isIBCValidVisible: _isIBCValidVisible,
      isTVG3: _isTVG3,
      unableToFetchBankAccounts: _unableToFetchBankAccounts,
      unableToFetchCardsOnFile: _unableToFetchCardsOnFile,
      getCardImage: _getCardImage,
      getCardLabel: _getCardLabel,
      isAllRequestCardsFailed: _isAllRequestCardsFailed
    };

    $scope.defaultParams = {
      module: 'My Funds',
      accountId: DepositSrv.user.get('accountNumber'),
      customerStatus: DepositSrv.getCustomerStatus(),
      residenceState: DepositSrv.user.get('homeAddress.StateAbbr')
    };

    DepositSrv.updateCustomerStatus();

    // use "isAddingFunds" to control whether the adding funds iframe should
    // be visible (inherit the value from rootScope to opening on startup)
    $scope.isAddingFunds = false;

    $scope.quickDepositSightlineError = false;

    if ($rootScope.product) {
      isNative = $rootScope.product.indexOf('native') !== -1;
    }

    if (isNative) {
      $scope.$on('accountBalance_update', function () {
        if ($window && $window.handleNativeMessages) {
          $window.handleNativeMessages('UPDATE_BALANCE');
        }
      });
    }

    /**
     * Fills data object with:
     *  - States
     *  - New deposit options (NEW)
     *  - Deposit options on file (STORED)
     *  - Deposit forms object
     *
     * Sets default deposit option to the first in STORED option
     */
    function init() {
      var initData;

      $scope.data.showAddNewDepositOptions =
        ConfigurationFac.getApplicationContextItem('application') !== 'deposit';

      DepositSrv.getInitialData()
        .then(function (data) {
          initData = data;
          $scope.accountDetails = data;
          initData.quickDepositOptions = data.quickDepositOptions;
          initData.depositOptions = data.depositOptions;
          $scope.data.states = data.states;

          // This same GTM event is applied inside TVG4 scope in this case I want to MEP and FDR (UW-1237)
          if (!ApiDepositsGTMFac.isTVG4()) {
            triggerGaPageLoadEvent(
              data.accountDetails.accountNumber,
              data.accountDetails.accountHState
            );
          }

          return data.accountDetails.accountNumber;
        })
        .then(function (accountNumber) {
          if (_isApplePayInQuickDepositEnabled()) {
            var context = _getDepositFormFirstChildSelector(); // eslint-disable-line
            // eslint-disable-next-line
            var handleClientFailure = function () {
              NotificationService.error(
                null,
                $filter('CMSLabels')('quickDepositsBraintreeClientFailMessage', 'applepayLabels'),
                context
              );

              $scope.data.shouldDisableApplePayButton = true;
            };

            ApplePayFac.createClientInstance(accountNumber, true, handleClientFailure, context)
                .then(function (response) {
                  applePayInstance = response.applePayInstance;

                  ApplePayFac.createDataCollector(response.braintreeClientInstance)
                    .then(function (deviceDataResponse) {
                      deviceData = deviceDataResponse;
                    });
                });
          }

          return (
            _isQuickDeposit() &&
            _getUserQuickDepositBankAccounts().then(function (bankAccounts) {
              initData.quickDepositOptions.map(function (opt) {
                if (opt.ftype === 'IBC' || opt.ftype === 'ACH') {
                  opt.onFile = bankAccounts;
                }
                return opt;
              });
            })
          );
        })
        .then(function () {
          return (
            _isQuickDeposit() &&
            _getUserQuickDepositCardsOnFile().then(function (cardsOnFile) {
              initData.quickDepositOptions.map(function (opt) {
                if (opt.ftype === 'CC') {
                  opt.onFile = cardsOnFile;
                }
                return opt;
              });
            })
          );
        })
        .then(function () {
          if ($rootScope.sightlineFlowVersion === '2') {
            return _getUserQuickDepositSLNCards().then(function (cardsOnFile) {
              initData.quickDepositOptions.map(function (opt) {
                if (opt.ftype === 'SLN') {
                  opt.onFile =
                    cardsOnFile && cardsOnFile.length ? cardsOnFile : [];
                }
                return opt;
              });
            });
          }
          return initData.quickDepositOptions.map(function (opt) {
            if (opt.ftype === 'SLN') {
              opt.onFile = [];
            }
            return opt;
          });
        })
        .then(function () {
          var loadEnv =
            ($scope.fromOption && $scope.fromOption.tla) || 'deposit';
          $scope.data.loading = true;
          return DepositSrv.getDepositLandingTab(
            initData.depositOptions,
            loadEnv
          );
        })
        .then(function (params) {
          var depositLandingTab = params.depositLandingTab;
          var hasMadeInitialDeposit = params.hasMadeInitialDeposit;
          var shouldLoadSightline = false;

          $scope.sightlineFlowVersion = $rootScope.sightlineFlowVersion;
          if ($scope.fromOption) {
            shouldLoadSightline =
              $scope.fromOption.tla === 'SLN' ||
              SightlineSrv.isRedirectingToSightlineAddFunds() ||
              $scope.redirectFrom === 'SLN';
          }
          if (
            $scope.sightlineFlowVersion === '1' &&
            (depositLandingTab === 'SLN' || shouldLoadSightline)
          ) {
            // sightline old flow loaders start
            _selectOption(SightlineDepositConfig, false, true);
          }
          // sometimes sightlineLoaded is not reflected on the view...
          $timeout(function () {
            $rootScope.$apply();
          });

          // GTM purposes
          DepositSrv._setHasMadeInitialDeposit(hasMadeInitialDeposit);
          $scope.defaultParams.customerStatus = DepositSrv.getCustomerStatus();
          DepositSrv.updateCustomerStatus();

          $scope.data.loading = false;
          $timeout(function () {
            if (!$scope.activePoller && !$scope.makingDeposit && !$scope.fetchingInfo) {
              angular.element(document.querySelector('#cardsForm_id')).removeClass('loading'); // eslint-disable-line
            }
          }, 5000);
          return _isQuickDeposit()
            ? _initQuickDepositOptions(initData)
            : _initFullDepositOptions(initData, depositLandingTab);
        })
        .then(function (data) {
          $scope.$emit('onDepositLoaded', true, data);
          $scope.$emit('selectedPayOption', {
            depositType: _getCurrentDepositTypeString()
          });

          $scope.data.availableAmountOptions = DepositSrv.getAvailableAmountOptions(
            data
          );
          $scope.data.makingDeposit = false;
          $scope.data.activePoller = false;

          // this condition must match the one in quick-deposit.html
          if (
            _isQuickDeposit() &&
            !$rootScope.isFdrApp &&
            !$scope.data.depositOptions.length &&
            !_isBetSlip() &&
            !_isIos() &&
            !_isAllRequestCardsFailed() &&
            $rootScope.activeFeatures.isDMAInjectNoPaymentQuickDepositEnabled
          ) {
            if($window.ReactInjector && document.getElementById('inject-no-payment-methods')){// eslint-disable-line
              $window.ReactInjector.renderFirstDeposit(document.getElementById('inject-no-payment-methods'), // eslint-disable-line
                {
                  title: FIRST_DEPOSIT_LABELS.title,
                  buttonText: FIRST_DEPOSIT_LABELS.buttonText,
                  text: FIRST_DEPOSIT_LABELS.text,
                  callback: firstDepositCallback
                });
            }
          }

          return null;
        })
        .catch(function (error) {
          $scope.data.loading = false;
          if (error === 'depositRestrictions') {
            $scope.data.errorDepositRestrictions = true;
          } else {
            $scope.data.errorLoadingData = true;
          }

          $scope.data.loading = false;
          $rootScope.sightlineLoaded = true;
          $scope.data.makingDeposit = false;
          $scope.data.activePoller = false;
          $scope.$emit('onDepositLoaded', false);

          if (
            $rootScope.isFdrApp &&
            $rootScope.newUser &&
            $scope.data.errorLoadingData &&
            $location.search().callback
          ) {
            $window.sessionStorage.setItem('newUser', true);
            $window.location.href =
              'https://' + $location.search().callback + '#welcome';
          }
        });
    }

    $scope.$on('hasMadeInitialDeposit_update', function () {
      DepositSrv._setHasMadeInitialDeposit(true);
    });

    $scope.$on('cardType_invalid', function () {
      invalidCardModal($rootScope.activeFeatures.showCardDeclinedModal);
    });

    function _applePayDepositSuccessCallback(data) {
      _resetAllModels();
      _resetFeesInfo();
      $scope.depositDataModel.amount = null;

      if (data) {
        $scope.$emit('onDepositEventSuccess', data);
        $rootScope.$broadcast('accountBalance_update');
        $rootScope.$emit('accountBalance_changed', data);
      }
    }


    function _getPaymentMethod(type) {
      var i = 0;
      var opt = {};
      if ($scope.data.depositOptions && $scope.data.depositOptions.length > 0) {
        for (i = 0; i < $scope.data.depositOptions.length; i++) {
          opt = $scope.data.depositOptions[i];
          if (opt.ftype === type) {
            return opt;
          }
        }
      }
    }

    function _getApplePayErrorModalConfig() {
      var echeck = _getPaymentMethod('IBC');
      var creditDebit = _getPaymentMethod('CC');
      var applePayErrorModalConfig = {};
      var applePayErrorModalConfigParam;

      if (echeck) {
        applePayErrorModalConfig.buttonText = (
          getFromCMS('applePayModalErrorButton1') || echeck.name
        );
        applePayErrorModalConfig.buttonCallback = function _selectBetCash() {
          $scope.events.selectOption(echeck, true, false);
        };
      }

      if (creditDebit) {
        applePayErrorModalConfig.buttonTextSecond = (
          getFromCMS('applePayModalErrorButton2') || creditDebit.name
        );
        applePayErrorModalConfig.buttonCallbackSecond = function _selectCC() {
          $scope.events.selectOption(creditDebit, true, false);
        };
      }

      applePayErrorModalConfigParam = Object.assign(
          {},
          ApplePayErrorModalDefault,
          applePayErrorModalConfig);

      return applePayErrorModalConfigParam;
    }
    /**
     * Method that calls apple pay fac to handle the apple pay deposit
     * @return null
     */
    function _onApplePayDeposit() {
      var context = _getDepositFormFirstChildSelector();
      var accountNumber = $scope.accountDetails.accountDetails.accountNumber;

      var applePayErrorModalConfigParam = _getApplePayErrorModalConfig();
      ApplePayFac.onApplePayDeposit(
        applePayInstance,
        $scope.depositDataModel.amount,
        $scope.data.fee.fee,
        $scope.data.fee.feeDiscount,
        accountNumber,
        deviceData,
        context,
        _applePayDepositSuccessCallback,
        applePayErrorModalConfigParam,
        true
      );
    }

    /**
     * Should disable apple pay button
     * @return {boolean}
     */
    function _shouldDisableApplePayButton() {
      var iosApplePayInstanceFailure = ApplePayFac.iosApplePayInstanceFailure;
      var amount = $scope.data.fee.transactionTotal || 0;

      if ($rootScope.product === 'ios2' && _isQuickDeposit()) {
        return $scope.data.fee.calculatingFees ||
          amount === 0 ||
          iosApplePayInstanceFailure ||
          $scope.data.shouldDisableApplePayButton;
      }

      return $scope.data.fee.calculatingFees ||
          amount === 0 ||
          !applePayInstance ||
          !deviceData ||
          $scope.data.shouldDisableApplePayButton;
    }

    /**
     * Returns if a new account were created during deposit
     * @returns {Boolean}
     */
    function _isDepositWithNewAccount() {
      return !_isQuickDeposit() && $scope.data.depositSection === 'NEW';
    }

    /**
     * Whether is in quick-deposit?
     * @return {Boolean}
     */
    function _isQuickDeposit() {
      var isQuickDeposit = ($scope.data || {}).isQuickDeposit;
      $rootScope.isQuickDeposit = isQuickDeposit;
      return !!isQuickDeposit;
    }

    /**
     * Check if amount is a default value
     */
    function _isDefaultAmount() {
      var defaultAmountList = [50, 100, 300];
      return defaultAmountList.indexOf($scope.depositDataModel.amount) > -1
        ? 'Yes'
        : 'No';
    }

    /**
     * @return {string} the selector for the deposit form's first child.
     * Returns the selector either for quick deposit or normal deposit.
     */
    function _getDepositFormFirstChildSelector() {
      var selector = '';
      if (_isQuickDeposit()) {
        selector =
          'quick-deposit .tvg-deposit .deposit-form section-title.first-title';
      }

      return selector;
    }

    /**
     * Compile DEPOSIT payment options by mixing the available
     * deposit and credit types with the ones that the user owns.
     *
     * @param  {Object} data  Deposit initial data from API
     * @return {Object} data  Deposit initial data from API
     * @private
     */
    function _initQuickDepositOptions(data) {
      var depositOptions;

      $scope.data.forms = DepositSrv.getQuickDepositForms();

      // flatten payment options from different types
      depositOptions = data.quickDepositOptions.reduce(function (
        options,
        mainOption
      ) {
        options = options.concat(mainOption.onFile || []);
        return options;
      },
      []);

      if ($scope.isNewUser) {
        // filter sightline options if the user doesn't have account
        depositOptions = depositOptions.filter(function (option) {
          return option.ftype !== 'SLN';
        });
      }

      // check if any of the payment options was set as default one
      // or fallback to the first card available
      _selectInitialQuickDepositCard(depositOptions);

      return data;
    }

    /**
     * Select the initial payment card to show in quick-deposit-selector.html
     * @param {Array} depositOptions  Initial deposit options
     * @private
     */
    function _selectInitialQuickDepositCard(depositOptions) {
      var defaultPaymentCard = _getDefaultPaymentCard(depositOptions);
      if (defaultPaymentCard) {
        $scope.depositDataModel.isDefaultPayment = !!defaultPaymentCard;
        defaultPaymentCard.isDefaultPayment = true;
      } else if (!!depositOptions.length) {
        defaultPaymentCard = depositOptions.reduce(function (cardSelected, cardOnFile) {
          return !cardSelected ||
                 !_isSLNDeclinedCard(cardOnFile) &&
                 cardOnFile.lastUsedDate > cardSelected.lastUsedDate
                    ? cardOnFile
                    : cardSelected;
        });
        if (!!defaultPaymentCard) {
          defaultPaymentCard.isDefaultPayment = true;
        }
      }

      $scope.data.depositOptions = depositOptions;
      $scope.depositDataModel.selectedOnFile = defaultPaymentCard;
      $scope.data.defaultPaymentCard = defaultPaymentCard;

      if (defaultPaymentCard) {
        _updateSelectedDepositTypeInfo(defaultPaymentCard);
      } else {
        _resetDepositDataModel();
      }

      if (
        ConfigurationFac.getApplicationContextItem('wrapper') === 'true' &&
        !_.get($rootScope.activeFeatures, 'enableDepositOnSinglePage', false) &&
        !depositOptions.length
      ) {
        $scope.data.loading = true;
        $window.parent.postMessage(
          {
            type: 'quick_deposit_redirect_full_deposit'
          },
          '*'
        );
        $location.path('/deposit');
      }

      return null;
    }

    /**
     * Set the select deposit type limits calling the method specific limit endpoint
     * @param {String} depositOptions  Initial deposit options
     * @private
     */
    function _setDepositTypeLimits(depositType, methodCard) {
      var accountId = DepositSrv.user.get('accountNumber');
      var cardType = $scope.depositDataModel.selectedOnFile &&
      $scope.depositDataModel.selectedOnFile.type;
      var useUwtForPaymentOptionsOnDma = angular.isDefined(
        $rootScope.activeFeatures.useUwtForPaymentOptionsOnDma
      ) ? $rootScope.activeFeatures.useUwtForPaymentOptionsOnDma
        : false;
      if ($scope.depositDataModel.selectedOnFile &&
        $scope.depositDataModel.selectedOnFile.signed) {
        cardType += 'S';
      }

      if (methodCard) {
        cardType = methodCard;
      }

      if (depositType) {
        if (useUwtForPaymentOptionsOnDma) {
          DepositSrv.getCardPaymentOptions(accountId, depositType, cardType)
            .then(function (response) {
              var hardMinLimitDepositToggleActive = DMAFeatureTogglesHashContainerSvc
                .getBasedOnKey('dma')('hardMinLimitDepositOverride');
              var overrideMinimumForMethod = depositMinAmountOverrides.filter(function (override) {
                return override.depositType === depositType;
              });

              $scope.data.disabledCard = false;
              if (hardMinLimitDepositToggleActive && overrideMinimumForMethod.length) {
                $scope.depositDataModel.min = Math.max(
                  parseFloat(overrideMinimumForMethod[0].minLimit),
                  response.minSingleDepositLimit ?
                    parseFloat(response.minSingleDepositLimit) : $scope.depositDataModel.min);
              } else {
                $scope.depositDataModel.min = response.minSingleDepositLimit ?
                parseFloat(response.minSingleDepositLimit) : $scope.depositDataModel.min;
              }

              $scope.depositDataModel.max = (!response.remainingDepositLimit &&
                response.remainingDepositLimit !== 0) ?
                $scope.depositDataModel.max : parseFloat(response.remainingDepositLimit);

              if ($scope.depositDataModel.max === 0.00 ||
                $scope.depositDataModel.max < $scope.depositDataModel.min) {
                $scope.depositDataModel.max = 0;
                $scope.depositDataModel.maxOverflow = true;
                $scope.data.disabledCard = true;
                if (depositType === 'APPL') {
                  $scope.data.shouldDisableApplePayButton = true;
                  NotificationService.warning('Disabled Card',
                    getFromCMS('applePayDepositLimitExceeded'),
                    _getDepositFormFirstChildSelector(),
                    null,
                    true
                  );
                } else {
                  NotificationService.warning('Disabled Card',
                    $filter('CMSValue')('creditCardDepositLimitExceeded'),
                    _getDepositFormFirstChildSelector(),
                    null,
                    true
                  );
                }
              }
            })
            .catch(function () {
              //eslint-disable-next-line
              console.warn('unable to fetch deposit limits');
            });
        } else {
          DepositSrv.getPaymentTypeDepositLimit(accountId, depositType, cardType)
            .then(function (response) {
              $scope.data.disabledCard = false;
              $scope.depositDataModel.min = response.minSingleDepositLimit ?
                parseFloat(response.minSingleDepositLimit) : $scope.depositDataModel.min;
              $scope.depositDataModel.max = response.remainingDepositLimit ?
                parseFloat(response.remainingDepositLimit) : $scope.depositDataModel.max;

              if ($scope.depositDataModel.max === 0.00 ||
                $scope.depositDataModel.max < $scope.depositDataModel.min) {
                //  $scope.depositDataModel.min = $scope.depositDataModel.max;
                $scope.depositDataModel.max = 0;
                $scope.depositDataModel.maxOverflow = true;
                $scope.data.disabledCard = true;
                if (depositType === 'APPL') {
                  $scope.data.shouldDisableApplePayButton = true;
                  NotificationService.warning('Disabled Card',
                    getFromCMS('applePayDepositLimitExceeded'),
                    _getDepositFormFirstChildSelector(),
                    null,
                    true
                  );
                } else {
                  NotificationService.warning('Disabled Card',
                    $filter('CMSValue')('creditCardDepositLimitExceeded'),
                    _getDepositFormFirstChildSelector(), null, true);
                }
              }
            })
            .catch(function (obj) {
              if (obj && obj.useInitialDataDefault) {
                return null;
              }

              $scope.depositDataModel.min = 0;
              $scope.depositDataModel.max = 99999;
              //eslint-disable-next-line
              console.warn('unable to fetch deposit limits');
            });
        }
      }
    }

    /**
     * Set user ach accounts on file
     * @private
     */
    function _setUserCardsOnFile() {
      if ($scope.data.selectedPayOption.ftype !== 'CC' && !_isQuickDeposit()) {
        return {};
      }
      //eslint-disable-next-line
      var accountId = DepositSrv.user.get("accountNumber");
      //eslint-disable-next-line
      var cardOnFile = $location.search().cardOnFile;

      $scope.data.fetchingInfo = true;
      DepositSrv.getCardsOnFile(accountId)
        .then(function (data) {
          var optionsOnFile = [];
          var paramPaymentId = $location.search().paymentId;
          var cardIndexFromParamsFound;

          $scope.data.fetchingInfo = false;
          $scope.data.selectedPayOption.onFile = [];
          if (data.CardList && data.CardList.length > 0) {
            angular.forEach(data.CardList, function (card) {
              optionsOnFile.push({
                groupName: 'Cards On File',
                id: card.cardId,
                cardNumber: card.cardNumber,
                cardNumberExt: '****' + card.cardNumber,
                cardTypeId: DepositInitialDataFac.getCardType(card.cardType).id,
                limitTypeId:
                  DepositInitialDataFac.getDepositLimitType(card.cardType).id ||
                  DepositInitialDataFac.getDepositLimitTypeByAbbr(card.cardType)
                    .id,
                expirationDate: card.expDate,
                isExpired:
                  moment(card.expDate, 'MM/YY').add(1, 'month') < moment(),
                signed: card.signed,
                name:
                  '(****' +
                  card.cardNumber +
                  ') ' +
                  card.cardType +
                  ' ' +
                  card.expDate,
                ftype: 'CC',
                network: card.network,
                type: DepositInitialDataFac.getCardType(card.cardType).abbr,
                typeName: card.cardType,
                cardType: card.cardType,
                min: DepositInitialDataFac.getLimitType(
                  card.DepositLimitTypeId,
                  'min'
                ),
                max: DepositInitialDataFac.getLimitType(
                  card.DepositLimitTypeId,
                  'max'
                ),
                depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE,
                lastUsedDate:
                  card.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
              });
            });
            $scope.data.unableToFetchCardsOnFile = false;
            $scope.data.selectedPayOption.onFile = optionsOnFile;

            if (paramPaymentId && $location.search().initialTab) {
              cardIndexFromParamsFound = optionsOnFile.findIndex(function (
                card
              ) {
                return card.id.toString() === paramPaymentId;
              });

              if (cardIndexFromParamsFound >= 0) {
                $scope.data.selectedCard = cardIndexFromParamsFound;
                $scope.depositDataModel.selectedOnFile =
                  optionsOnFile[cardIndexFromParamsFound];
              }
            }

            if ($scope.data.depositSection !== 'STORED') {
              if (cardOnFile) {
                _toggleNewStoredMethods('NEW');
              } else {
                _toggleNewStoredMethods('STORED');
              }
            }
          } else {
            // Open new account section in case the user has no bank account associated
            if ($scope.data.depositSection !== 'NEW') {
              _toggleNewStoredMethods('NEW');
            }
            if ($scope.depositFrm && $scope.depositFrm.cardCvn) {
              $scope.depositFrm.cardCvn.$setPristine();
            }
            _clearCVN();
            _resetAllModels();
            _setDepositTypeLimits(
              $scope.depositDataModel.selectedCardType.ftype,
              $scope.depositDataModel.selectedCardType.type
            );
          }
          $scope.data.fetchingInfo = false;
        })
        .catch(function () {
          $scope.data.unableToFetchCardsOnFile = true;
          $scope.data.fetchingInfo = false;
        })
        .finally(function () {
          $scope.data.fetchingInfo = false;
        });

      return {};
    }

    /**
     * Set user ach accounts on file
     * @private
     */
    function _setUserBankAccounts() {
      var accountId = DepositSrv.user.get('accountNumber');
      var cardOnFile = $location.search().cardOnFile;
      if (
        !_isQuickDeposit() &&
        !(
          $scope.data.selectedPayOption.ftype === 'ACH' ||
          $scope.data.selectedPayOption.ftype === 'IBC'
        )
      ) {
        return {};
      }
      $scope.data.fetchingInfo = true;
      return DepositSrv.getUserBankAccounts(accountId)
        .then(function (data) {
          var paramPaymentId = $location.search().paymentId;
          var eCheckIndexFromParamsFound;
          var optionsOnFile = [];

          $scope.data.fetchingInfo = false;
          if (data.bankAccounts && data.bankAccounts.length > 0) {
            angular.forEach(data.bankAccounts, function (ach) {
              optionsOnFile.push({
                groupName: 'BetCash Accounts On File',
                achId: ach.id,
                bankAccNumber: ach.accountNumber,
                bankAcctType: ach.accountType,
                bankName: ach.name,
                bankRoutingNumber: ach.routingNumber,
                driversLicenseNumber: ach.dlNumber,
                driversLicenseState: ach.dlState,
                name:
                  '(****' +
                  ach.accountNumber.substr(ach.accountNumber.length - 4) +
                  ') ' +
                  ach.name,
                ftype: 'ACH',
                type: 'ACH',
                isPending: false,
                typeName: 'BetCash',
                isAvailable: true,
                cardType: undefined,
                limitTypeId:
                  DepositInitialDataFac.getLimitType('ACH', 'id') ||
                  DepositInitialDataFac.getDepositLimitTypeByAbbr('ACH').id,
                min: DepositInitialDataFac.getLimitType('ACH', 'min'),
                max: DepositInitialDataFac.getLimitType('ACH', 'max'),
                depositTypeId: DEPOSIT_TYPES.ACH_ON_FILE,
                lastUsedDate:
                  ach.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
              });
            });

            $scope.data.unableToFetchBankAccounts = false;
            $scope.data.selectedPayOption.onFile = optionsOnFile;

            if (paramPaymentId && $location.search().initialTab === 'ACH') {
              eCheckIndexFromParamsFound = optionsOnFile.findIndex(function (
                eCheck
              ) {
                return eCheck.achId.toString() === paramPaymentId;
              });

              if (eCheckIndexFromParamsFound >= 0) {
                $scope.data.selectedCard = eCheckIndexFromParamsFound;
                $scope.depositDataModel.selectedOnFile =
                  optionsOnFile[eCheckIndexFromParamsFound];
              }
            }

            if ($scope.data.depositSection !== 'STORED') {
              if (cardOnFile) {
                _toggleNewStoredMethods('NEW');
              } else {
                _toggleNewStoredMethods('STORED');
              }
            }
          } else {
            // Open new account section in case the user has no bank account associated
            if ($scope.data.depositSection !== 'NEW') {
              _toggleNewStoredMethods('NEW');
            }
            if ($scope.depositFrm && $scope.depositFrm.cardCvn) {
              $scope.depositFrm.cardCvn.$setPristine();
            }
            _clearCVN();
            _resetAllModels();
          }
          $scope.data.fetchingInfo = false;
        })
        .catch(function () {
          $scope.data.unableToFetchBankAccounts = true;
          $scope.data.fetchingInfo = false;
        })
        .finally(function () {
          $scope.data.fetchingInfo = false;
        });
    }

    /**
     * Set user ach accounts on file on Quick deposit options
     * @private
     */
    function _getUserQuickDepositBankAccounts() {
      var accountId = DepositSrv.user.get('accountNumber');
      return DepositSrv.getUserBankAccounts(accountId)
        .then(function (data) {
          var optionsOnFile = [];
          if (data.bankAccounts && data.bankAccounts.length > 0) {
            angular.forEach(data.bankAccounts, function (ach) {
              optionsOnFile.push({
                groupName: 'BetCash Accounts On File',
                achId: ach.id,
                bankAccNumber: ach.accountNumber,
                bankAcctType: ach.accountType,
                bankName: ach.name,
                bankRoutingNumber: ach.routingNumber,
                driversLicenseNumber: ach.dlNumber,
                driversLicenseState: ach.dlState,
                name:
                  '(****' +
                  ach.accountNumber.substr(ach.accountNumber.length - 4) +
                  ') ' +
                  ach.name,
                ftype: 'ACH',
                type: 'ACH',
                isPending: false,
                limitTypeId: DepositInitialDataFac.getLimitType('ACH', 'id'),
                min: DepositInitialDataFac.getLimitType('ACH', 'min'),
                max: DepositInitialDataFac.getLimitType('ACH', 'max'),
                depositTypeId: DEPOSIT_TYPES.ACH_ON_FILE,
                lastUsedDate:
                  ach.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
              });
            });

            return optionsOnFile;
          }
        })
        .catch(function () {
          $scope.data.unableToFetchBankAccounts = true;
          return null;
        });
    }

    /**
     * Set user ach accounts on file on Quick deposit options
     * @private
     */
    function _getUserQuickDepositCardsOnFile() {
      var accountId = DepositSrv.user.get('accountNumber');
      var optionsOnFile = [];

      return DepositSrv.getCardsOnFile(accountId)
        .then(function (data) {
          if (data.CardList && data.CardList.length > 0) {
            angular.forEach(data.CardList, function (card) {
              optionsOnFile.push({
                groupName: 'Cards On File',
                id: card.cardId,
                cardNumber: card.cardNumber,
                cardNumberExt: '****' + card.cardNumber,
                cardTypeId: DepositInitialDataFac.getCardType(card.cardType).id,
                limitTypeId: DepositInitialDataFac.getDepositLimitType(
                  card.cardType
                ).id,
                expirationDate: card.expDate,
                isExpired:
                  moment(card.expDate, 'MM/YY').add(1, 'month') < moment(),
                signed: card.signed,
                name:
                  '(****' +
                  card.cardNumber +
                  ') ' +
                  card.cardType +
                  ' ' +
                  card.expDate,
                ftype: 'CC',
                type: DepositInitialDataFac.getCardType(card.cardType).abbr,
                typeName: card.cardType,
                cardType: card.cardType,
                network: card.network,
                min: DepositInitialDataFac.getLimitType(
                  card.DepositLimitTypeId,
                  'min'
                ),
                max: DepositInitialDataFac.getLimitType(
                  card.DepositLimitTypeId,
                  'max'
                ),
                depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE,
                lastUsedDate:
                  card.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
              });
            });
          }
          return optionsOnFile;
        })
        .catch(function () {
          $scope.data.unableToFetchCardsOnFile = true;
          return null;
        });
    }

    function _getUserQuickDepositSLNCards() {
      var accountId = DepositSrv.user.get('accountNumber');
      var optionsOnFile = [];

      return DepositSrv.getPrepaidCardsOnFile(accountId)
        .then(function (userData) {
          if (userData) {
            $scope.depositDataModel.sightlineUser_v2 = userData;
            if (userData.cards && userData.cards.length > 0) {
              angular.forEach(userData.cards, function (card) {
                var expDate =
                  card.expirationMonth.toString() +
                  '/' +
                  card.expirationYear.toString().slice(-2);
                optionsOnFile.push({
                  groupName: 'Cards On File',
                  id: card.id,
                  cardNumber: card.number,
                  cardNumberExt: '****' + card.number,
                  cardTypeId: 1,
                  limitTypeId: 2,
                  expirationDate: expDate,
                  isExpired:
                    moment(expDate, 'MM/YY').add(1, 'month') < moment(),
                  signed: false,
                  name: '(****' + card.number + ') ' + expDate,
                  ftype: 'SLN',
                  type: 'SLN',
                  typeName: card.cardType || 'Credit',
                  network: card.network,
                  cardType: card.cardType || 'Credit',
                  min: false,
                  max: false,
                  depositTypeId: DEPOSIT_TYPES.SIGHTLINE_V2,
                  lastUsedDate:
                    card.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
                });
              });
            }
            return optionsOnFile;
          }
        })
        .catch(function () {
          $scope.data.unableToFetchPrepaidCards = true;
          return null;
        });
    }

    /**
     * Get image for card in selector
     */
    // TODO change default image for credit cards (VISA, MasterCard, Discover)
    function _getCardImage(card) {
      if (card.network === 'VISA') {
        return 'visa-card';
      }

      if (card.network === 'MASTERCARD') {
        return 'master-card';
      }

      if (card.network === 'DISCOVER') {
        return 'discover-card';
      }

      if (card.type === 'ACH') {
        return 'betCash-card';
      }

      if (card === 'PAYPAL') {
        return 'paypal-card';
      }

      if (card.ftype === 'APPL') {
        return '';
      }

      return 'generic-credit-card';
    }

    /**
     * Get label for card in selector based on network property
     */
    function _getCardLabel(card) {
      var slnCardsTypes = ['DISCOVER', 'MASTERCARD', 'VISA'];
      var defaultLabel = 'Credit/Debit Card';
      if (card.network) {
        return slnCardsTypes.includes(card.network.toUpperCase())
          ? card.network
          : defaultLabel;
      }
      return defaultLabel;
    }

    /**
     * Get label for SLP card in selector based on network property
     * @param {Object} card               Card Object
     */
    function _getSLPLabel(card) {
      var declinedLabel;
      var network = _getCardLabel(card);
      var labelSLP = $rootScope.isFdrApp ? network.toLowerCase() : network;
      if (_isSLNDeclinedCard(card)) {
        declinedLabel = $filter('CMSLabels')('dmaCardDeclinedWarning', 'cardErrorRedirect');
        labelSLP += ' - ' + declinedLabel;
      }


      return labelSLP;
    }


    /**
     *
     */

    function _shouldShowOption(option) {
      var toggles = {
        IBC: !$rootScope.activeFeatures.pawsACH,
        CC: !$rootScope.activeFeatures.pawsCC,
        PNM: !$rootScope.activeFeatures.pawsPNM,
        PAY: !$rootScope.activeFeatures.pawsPAY,
        MPAK: !$rootScope.activeFeatures.pawsMPAK,
        BC: !$rootScope.activeFeatures.pawsACH,
        OTHER: !$rootScope.activeFeatures.pawsWalletAvailable
      };

      // eslint-disable-next-line angular/definedundefined
      return toggles[option] !== undefined && !$rootScope.isFdrApp &&
      $rootScope.activeFeatures.pawsWalletAvailable &&
      $rootScope.shouldShowWallet ? toggles[option] : true;
    }

    /**
     * Compile DEPOSIT payment options by mixing the available
     * deposit and credit types with the ones that the user owns.
     *
     * @param  {Object} data  Deposit initial data from API
     * @return {Object} data  Deposit initial data from API
     * @private
     */
    function _initFullDepositOptions(data, receivedLandingDepositTab) {
      var options = data.depositOptions.slice(0);
      var depositOptions = options.filter(function (option) {
        return _shouldShowOption(option.ftype);
      }
     );
      var selectedOptionIdx = null;
      var shouldLoadSightline = false;
      var shouldLoadPaypal = false;
      var depositLandingTab =
        receivedLandingDepositTab === 'IBC' ||
        receivedLandingDepositTab === 'ACH'
          ? 'IBC'
          : receivedLandingDepositTab;

      if ($scope.fromOption) {
        shouldLoadSightline =
          $scope.fromOption.tla === 'SLN' ||
          SightlineSrv.isRedirectingToSightlineAddFunds() ||
          $scope.redirectFrom === 'SLN';
        shouldLoadPaypal =
          $scope.fromOption.tla === 'PAY' || $scope.redirectFrom === 'PAY';
      }

      $scope.data.depositOptions = depositOptions;
      $scope.data.showingFallback = !depositOptions.length;
      $scope.data.forms = DepositSrv.getDepositForms();

      if (shouldLoadSightline) {
        _initSightlineOnStartup();
      } else if (shouldLoadPaypal) {
        _initPaypalOnStartup();
      } else {
        selectedOptionIdx = _getPayOptionIndex(
          depositOptions,
          depositLandingTab
        );
        $scope.data.selectedPayOption =
          selectedOptionIdx > -1
            ? depositOptions[selectedOptionIdx]
            : depositOptions[0];
        $rootScope.selectedPayOption = 0;
      }

      _resetDepositDataModel();

      return data;
    }

    function _getPayOptionIndex(data, option) {
      if (angular.isString(option)) {
        return _.findIndex(data, function (el) {
          return el.ftype === option;
        });
      }

      return option;
    }

    /**
     * Open sightline's tab on startup.
     * If redirected from quick-deposit "add funds" button, open the add funds
     * iframe.
     * @private
     */
    function _initSightlineOnStartup() {
      var isRedirecting = SightlineSrv.isRedirectingToSightlineAddFunds();

      if (isRedirecting) {
        SightlineSrv.isRedirectingToSightlineAddFunds(false);
        $scope.isAddingFunds = true;
      }

      _selectOption(SightlineDepositConfig, false);
    }

    /**
     * Open paypal's tab on startup.
     * If redirected from quick-deposit "add funds" button, open the add funds
     * iframe.
     * @private
     */
    function _initPaypalOnStartup() {
      _selectOption(PaypalDepositConfig, false);
    }

    function _selectOptionByName(optionName) {
      var opt = _.find($scope.data.depositOptions, function (option) {
        return option.name === optionName;
      });
      if (opt) {
        _selectOption(opt, true);
      }
    }

    /**
     * Show loaders while loading sightline user information
     * @private
     */
    function _startSightlineLoaders() {
      $scope.data.sightlineLoading = true;
      $scope.loadSightlineiFrame = false;
      $scope.loadSightlineInfo = false;
    }

    /**
     * Hide loaders after loading sightline user information
     * @private
     */
    function _stopSightlineLoaders() {
      $scope.data.sightlineLoading = false;
      $scope.loadSightlineiFrame = true;
      $scope.loadSightlineInfo = true;
    }

    /**
     * If there was a default payment card set in cookies,
     * check if type_id and id (or achId) match with any available payment
     * options.
     *
     * @private
     * @param {Array} depositOptions  Deposit payment options
     * @return {Object}               Default payment option
     */
    function _getDefaultPaymentCard(depositOptions) {
      var defaultCard = {};
      var selectedCard;
      var defaultCardId;

      Utilities.attempt(function () {
        defaultCard = angular.fromJson(
          $window.localStorage.getItem('defaultPaymentMethod')
        );
      });

      // stop
      if (!defaultCard) {
        return null;
      }

      defaultCardId = _getIdFromPaymentOption(defaultCard);

      selectedCard = _.find(depositOptions || [], function (card) {
        var cardId = _getIdFromPaymentOption(card);
        return cardId === defaultCardId;
      });

      return selectedCard;
    }

    /**
     * Extract the ID from payment option
     * (some payment types use the achId instead of id).
     *
     * @private
     * @param {Object} option            Payment options
     * @param {Number} [option.type_id]  Payment type ID
     * @param {String} [option.type]     Payment type
     * @param {String} [option.ftype]    Payment ftype
     * @param {Number} [option.id]       Payment ID
     * @param {Number} [option.achId]    Betcash payment ID
     * @return {Number}                  Correct payment ID
     */
    function _getIdFromPaymentOption(option) {
      var isBetcash = false;
      var paymentOption = option || {};

      if (
        paymentOption.type_id === 1 ||
        paymentOption.type === 'ACH' ||
        paymentOption.ftype === 'ACH'
      ) {
        isBetcash = true;
      }

      return isBetcash ? option.achId || option.id : option.id;
    }

    /**
     * Clear card verification number
     */
    function _clearCVN() {
      $scope.depositDataModel.cardSecurityNumber = '';
    }

    function _clearIBC() {
      if ($scope.depositDataModel) {
        $scope.depositDataModel.cardNumber = '';
        $scope.depositDataModel.cardSecurityNumber = '';
        $scope.depositDataModel.expirationMonth = '';
        $scope.depositDataModel.expirationYear = '';
        _resetAllModels();
      }
    }

    /**
     * Trigger goto_new_deposit event
     */
    function _goToFullDeposit() {
      if (isNative) {
        if ($window && $window.handleNativeMessages) {
          $window.handleNativeMessages('GO_TO_DEPOSITS');
        }
      }

      if (ConfigurationFac.getApplicationContextItem('product') !== 'njx') {
        $rootScope.$broadcast('goto_new_deposit');

        /* Redirect for For TVG3 */
        Utilities.attempt(function () {
          if (
            $window.document.domain === $window.parent.document.domain &&
            angular.isDefined($window.parent.GoToDeposit)
          ) {
            $window.parent.GoToDeposit(); // eslint-disable-line
          }
        });
        /* Redirect for FDR */
        if ($rootScope.isFdrApp) {
          $window.parent.location.href =
            '/deposit/deposit?location=' +
            ConfigurationFac.getApplicationContextItem('location') +
            '&product=' +
            $rootScope.product +
            '&wrapper=true&callback=' +
            $location.search().callback +
            '/more&fullPage=true&more=true';
        }
      }
    }

    /**
     * Open Invalid Card Modal
     * @params {string} type                  Card type
     * @return {string} cardName              Card name
     */
    function _getCardNameByType(type) {
      return Utilities.attempt(
        function () {
          var selectionTypeCAPI = {
            CC: 'Another Card',
            IBC: 'eCheck',
            PAY: 'Paypal'
          };

          return _.get(selectionTypeCAPI, type, 'Unknown');
        },
        function () {
          return 'Unknown';
        }
      );
    }

    /**
     * Open Invalid Card Modal
     * @param {boolean} openRedirectModal               Open redirect modal
     */
    function invalidCardModal(openRedirectModal) {
      var closeRedirectModal = function (sendGtm) {
        $window.parent.postMessage(
          {
            type: 'sightline_redirect',
            payload: false
          },
          '*'
        );

        // GTM
        if (sendGtm) {
          if (!openRedirectModal) {
            UserActionEventsService.emit(
              'CcpCardDeclinedRedirectSightline',
              {
                isOpen: false,
                module: 'My Funds',
                depositAmount: $scope.depositDataModel.amount
              }
            );
          } else {
            UserActionEventsService.emit(
              'CcpCardDeclinedRedirectBlackListCard',
              {
                isOpen: false
              }
            );
          }
        }
      };

      var modalScope = $scope.$new();
      var defaultSelection = 'CC';
      modalScope.areTermsAccepted = false;

      modalScope.proceed = function (closeFn) {
        _makeDepositInvalidCreditCardError(false);
        closeRedirectModal(false);
        closeFn({ fromProceed: true });
      };

      modalScope.openPrivacyPolicy = function (evt) {
        evt.preventDefault();
        ModalDialogService.openLarge(
          $filter('CMSValue')('sightlinePrivacyTitle'),
          $filter('CMSValue')('sightlinePrivacyTemplate'),
          'sightlinePrivacyPolicyModal'
        );
      };

      modalScope.openTermsConditions = function (evt) {
        evt.preventDefault();
        ModalDialogService.openLarge(
          $filter('CMSValue')('prepaidCardTermsTitle'),
          $filter('CMSValue')('prepaidCardTermsTemplate'),
          'sightlineTermsConditionModal'
        );
      };

      // Define
      modalScope.depositOptions = $scope.data.depositOptions.reduce(
        function (depositOptionsAvailable, depositOption) {
          var availableCards = ['IBC', 'PAY', 'CC'];
          if (availableCards.includes(depositOption.ftype)) {
            depositOptionsAvailable.push(depositOption.ftype);
          }
          return depositOptionsAvailable;
        }, []);

      modalScope.type = defaultSelection;

      modalScope.changeType = function (type) {
        var selection = _getCardNameByType(type || defaultSelection);
        modalScope.type = type || defaultSelection;

        // GTM
        UserActionEventsService.emit(
          'CcpCardDeclinedRedirectBlackListCard',
          {
            selection: selection,
            isFinished: false
          }
        );
      };

      modalScope.redirectTo = function (close, type) {
        var method;
        var selection = _getCardNameByType(type || defaultSelection);

        _clearIBC();

        if (type) {
          method = _getPaymentMethod(type);
          $scope.events.selectOption(method, true, false);
        }

        // GTM
        UserActionEventsService.emit(
          'CcpCardDeclinedRedirectBlackListCard',
          {
            selection: selection,
            isFinished: true
          }
        );

        close();
      };

      modalScope.cardList = Utilities.attempt(
        function () {
          var capiMessages = angular.fromJson(
            $filter('CMSValue')('cardErrorRedirect')
          );
          return _.get(capiMessages, 'cardList', []);
        },
        function () {
          return [];
        }
      );

      if (openRedirectModal) {
        UserActionEventsService.emit(
          'CcpCardDeclinedRedirectBlackListCard',
          {
            isOpen: true
          }
        );
      }

      $uibModal
        .open({
          templateUrl: openRedirectModal ? 'src/templates/ccp_visa_sightline_redirect.html' : 'src/templates/ccp_sightline_redirect.html',
          scope: modalScope,
          windowTemplateUrl: 'src/templates/modal-window.html',
          backdropClass: 'tvgmodal-backdrop',
          windowClass: 'tvg-ui-modal-dialog tvgmodal-dma-redesign'
        })
        .result.then(function (res) {
          if (res && res.fromProceed) {
            closeRedirectModal(false);
          } else {
            closeRedirectModal(!openRedirectModal);
          }
        })
        .catch(function () {
          closeRedirectModal(!openRedirectModal);
        });
    }

    function _getUsedCardType() {
      var bankNumber;
      var firstDigit;
      var secondDigit;

      if ($scope.depositDataModel.routingNumber) {
        bankNumber = $scope.depositDataModel.routingNumber;
        firstDigit = bankNumber % 1000;
        if (firstDigit === 4) {
          return 'Visa';
        } else if (firstDigit === 5) {
          secondDigit = bankNumber % 100;
          if (secondDigit > 0 && secondDigit < 6) {
            return 'Mastercard';
          }
        }
      }
      return undefined;
    }

    function _mapLabelToPaymentMethod(paymentType) {
      switch (paymentType) {
        case DEPOSIT_TYPES.ACH_ON_FILE:
        case DEPOSIT_TYPES.ACH_NEW:
          return 'betCashDepositMessages';

        case DEPOSIT_TYPES.CARD_ON_FILE:
        case DEPOSIT_TYPES.CARD_NEW:
        case DEPOSIT_TYPES.CREDIT_CARD_NEW:
          return 'ccpDepositMessages';

        case DEPOSIT_TYPES.SIGHTLINE:
          return 'sightlineDepositMessages';

        default:
          return 'sightlineDepositMessages';
      }
    }

    function _initiateDepositStatusPoller(
      data,
      context,
      messages,
      successCb,
      errorCb
    ) {
      Utilities.depositStatusPoller(
        function () {
          $scope.data.activePoller = true;
          return DepositSrv.getDepositStatus(data.headers('Location'))
            .then(function (response) {
              return response.status;
            })
            .catch(errorCb);
        },
        10000,
        2000
      )
        .then(successCb)
        .catch(errorCb)
        .finally(function () {
          $scope.data.activePoller = false;
        });
    }

    function _slpSuccessPollerCb(
      messages,
      depositType,
      isSightline,
      data,
      context,
      success
    ) {
      if (success) {
        NotificationService.success(
          'Poller!',
          messages.scenario5,
          context,
          null,
          true
        );
        _makeDepositSuccess(data, isSightline, false);
      } else {
        NotificationService.warning(
          'Poller!',
          messages.scenario3a,
          context,
          null,
          true
        );
        _makeDepositError(data.data, isSightline);
      }
    }

    function _slpErrorPollerCb(context, messages, isSightlineSelected) {
      if (isSightlineSelected) {
        NotificationService.warning(
          'Deposit Poller',
          messages.scenario3c,
          context,
          null,
          true
        );
      }
    }

    function _achSuccessPollerCb(
      messages,
      depositType,
      isAch,
      data,
      context,
      success
    ) {
      if (success) {
        NotificationService.success(
          'Poller!',
          messages.scenario5,
          context,
          null,
          true
        );
        _makeDepositSuccess(data, false, isAch);
      } else {
        NotificationService.warning(
          'Poller!',
          messages.scenario3a,
          context,
          null,
          true
        );
        _makeDepositError(data.data, isAch);
      }
    }

    function _achErrorPollerCb(context, messages, isAchSelected) {
      if (isAchSelected) {
        NotificationService.warning(
          'Deposit Poller',
          messages.scenario3c,
          context,
          null,
          true
        );
      }
    }

    function _newCardSuccessPollerCb(
      messages,
      depositType,
      isNewCard,
      data,
      context,
      success
    ) {
      if (success) {
        NotificationService.success(
          'Poller!',
          messages.scenario5,
          context,
          null,
          true
        );
        // update balance
        if (data.data && data.data.balance) {
          $rootScope.$emit(
            'accountBalance_changed',
            parseFloat(data.data.balance)
          );
        }
        _makeDepositSuccess(data, false, isNewCard);
      } else {
        NotificationService.warning(
          'Poller!',
          messages.scenario3a,
          context,
          null,
          true
        );
        _makeDepositError(data.data, isNewCard);
      }
    }

    function _newCardErrorPollerCb(context, messages, isCc) {
      if (isCc) {
        NotificationService.warning(
          'Deposit Poller',
          messages.scenario3c,
          context,
          null,
          true
        );
      }
    }

    function _cardsOnFileSuccessPollerCb(
      messages,
      depositType,
      isCardOnFile,
      data,
      context,
      success
    ) {
      if (success) {
        NotificationService.success(
          'Poller!',
          messages.scenario5,
          context,
          null,
          true
        );
        // update balance
        if (data.data && data.data.balance) {
          $rootScope.$emit(
            'accountBalance_changed',
            parseFloat(data.data.balance)
          );
        }
        _makeDepositSuccess(data, false, isCardOnFile);
      } else {
        NotificationService.warning(
          'Poller!',
          messages.scenario3a,
          context,
          null,
          true
        );
        _makeDepositError(data.data, isCardOnFile);
      }
    }

    function _achNewAccountSuccessPollerCb(
      messages,
      depositType,
      isAch,
      data,
      context,
      success
    ) {
      if (success) {
        NotificationService.success(
          'Poller!',
          messages.scenario5,
          context,
          null,
          true
        );
        // update balance
        if (data.data && data.data.balance) {
          $rootScope.$emit(
            'accountBalance_changed',
            parseFloat(data.data.balance)
          );
        }
        _makeDepositSuccess(data, false, isAch);
        // change page and update list of cards
        showStoredBetcashAccounts();
      } else {
        NotificationService.warning(
          'Poller!',
          messages.scenario3a,
          context,
          null,
          true
        );
        _makeDepositError(data.data, isAch);
      }
    }

    function _achNewAccountErrorPollerCb(context, messages, isAchSelected) {
      if (isAchSelected) {
        NotificationService.warning(
          'Deposit Poller',
          messages.scenario3c,
          context,
          null,
          true
        );
      }
    }

    function _cardsOnFileErrorPollerCb(context, messages, isCc) {
      if (isCc) {
        NotificationService.warning(
          'Deposit Poller',
          messages.scenario3c,
          context,
          null,
          true
        );
      }
    }

    function showStoredBetcashAccounts() {
      // REMOVE THE TIMEOUT PLS
      $scope.data.fetchingInfo = true;
      $timeout(function () {
        _setUserBankAccounts().then(function () {
          _toggleNewStoredMethods('STORED');
          $scope.data.fetchingInfo = false;
        });
      }, 5000);
    }


    /**
     * Make deposit function. It calls deposit service passing it
     * depositDataModel as argument
     * @private
     */
    function _makeDeposit(form) {
      var accountNumber = $scope.accountDetails.accountDetails.accountNumber; //eslint-disable-line
      var isQuickDeposit = _isQuickDeposit();
      var gtmDepositAmount =
        $scope.depositDataModel.amount ||
        Utilities.prop('depositFrm.amount.$viewValue', $scope);

      UserActionEventsService.emit('depositAttempt', {
        depositType: _getCurrentDepositTypeString(),
        depositAmount: gtmDepositAmount,
        amountOption: _isDefaultAmount(),
        module: isQuickDeposit ? 'Quick Deposit' : 'My Funds'
      });

      if (!form.$valid) {
        if ($scope.notifyErrors) {
          // TODO: send first invalid field name
          $scope.$emit('depositFormValidationError', 'TODO');
        } else {
          FeedbackFac.scrollIntoFirstError();

          $scope.data.showInvalidFormMessage = true;
          $timeout.cancel(invalidFormLabelTimer);
          invalidFormLabelTimer = $timeout(function () {
            $scope.data.showInvalidFormMessage = false;
          }, 3000);
        }

        _saveGTMDepositError('Missing Fields/Invalid Fields');

        angular.forEach(form.$error.required, function (field) {
          if (form[field.$name] && form[field.$name].hasOwnProperty('$dirty')) {
            form[field.$name].$dirty = true;
          }
        });
        return 0;
        /* eslint-disable */
      } else {
        /* eslint-enable */
        if ($scope.data.fee.calculatingFees || $scope.data.makingDeposit) {
          return 0;
        }
        $scope.data.makingDeposit = true;
        $scope.data.showInvalidFormMessage = false;
        $scope.data.showGreenDotInvalidCardNumberMessage = false;
        $scope.data.showIBCInvalidPinOrPasswordMessage = false;

        if (_isSightlinePayment()) {
          $scope.depositDataModel.sightlineUser = angular.extend(
            {},
            $scope.basicSightlineUsr,
            {
              last4SSN: DepositSrv.user.get('last4SSN')
            }
          );
        }

        DepositSrv.makeDeposit($scope.depositDataModel)
          .then(function (data) {
            var depositType = $scope.depositDataModel.depositTypeId;
            var isSightline = depositType === 12;
            var isSightlineV2 = depositType === 13;
            var isAch =
              depositType === DEPOSIT_TYPES.ACH_ON_FILE ||
              depositType === DEPOSIT_TYPES.ACH_NEW;
            var isCardOnFile = depositType === DEPOSIT_TYPES.CARD_ON_FILE;
            var isNewCc =
              depositType === DEPOSIT_TYPES.CARD_NEW ||
              depositType === DEPOSIT_TYPES.CREDIT_CARD_NEW;
            var statusCode = data.status;
            var context = _getDepositFormFirstChildSelector();
            var label = _mapLabelToPaymentMethod(depositType);
            var messagesObj = $filter('CMSValue')(label);
            var messages = {};
            var newCcFlow = isCardOnFile || isNewCc;
            var isSightlineSelected = $scope.data.selectedPayOption
              ? $scope.data.selectedPayOption.ftype === 'SLN'
              : false;
            var isAchSelected = $scope.data.selectedPayOption
              ? $scope.data.selectedPayOption.ftype === 'IBC' ||
                $scope.data.selectedPayOption.ftype === 'ACH'
              : false;
            var isCC = !isQuickDeposit
              ? $scope.data.selectedPayOption.ftype === 'CC'
              : $scope.depositDataModel.selectedOnFile &&
                $scope.depositDataModel.selectedOnFile.ftype === 'CC';
            var isAchNewAccount =
              !isQuickDeposit && $scope.data.depositSection === 'NEW';
            var has207Error = false;
            var depositSuccessMessage;
            var successMessage;
            var depositSuccessFallbackMsg =
              'You successfully deposited <strong>$XXX</strong> into your TVG account through your Pre Paid Card.';
            var depositCode; //eslint-disable-line
            if (isQuickDeposit && !isAchSelected) {
              isAchSelected = $scope.depositDataModel.selectedOnFile
                ? $scope.depositDataModel.selectedOnFile.ftype === 'ACH' ||
                  $scope.depositDataModel.selectedOnFile.ftype === 'IBC'
                : false;
            }
            $scope.data.lastDepositStatus = statusCode;

            if (isAchSelected) {
              depositCode = 'ACH';
            }

            if (isSightlineSelected) {
              depositCode = 'SLN';
            }

            if (isCC) {
              depositCode =
                $scope.depositDataModel.selectedCardType.type;
            }

            try {
              messages = angular.fromJson(messagesObj);
            } catch (err) {
              // Prevent test failure
            }


            if ($rootScope.activeFeatures.isDMAInjectDepositSuccessModalEnabled) {
              if ($window.ReactInjector) {
                $window.ReactInjector.renderDepositSuccess(
                    document.getElementById('injected-modal'),// eslint-disable-line
                  {
                    title: SUCCESS_MODAL_LABELS.title,
                    text: SUCCESS_MODAL_LABELS.textTemplate.replace(
                      '@@@deposit_amount@@@',
                        data &&
                      data.config &&
                      data.config.data &&
                      data.config.data.amount),
                    buttonText: SUCCESS_MODAL_LABELS.buttonText,
                    sharedState: { isOpen: true },
                    buttonCallback: successModalButtonCallback,
                    closeCallback: successModalCloseCallback,
                    onOpenCallback: successModalOnOpenCallback
                  }
                );
              }
            }


            if (data.data && data.status === 200 && isSightlineV2) {
              // sightline v2 fund and deposit success

              depositSuccessMessage =
                $filter('CMSValue')('slpDepositSuccess') ||
                depositSuccessFallbackMsg;
              successMessage =
                'Deposit Successful! ' +
                depositSuccessMessage.replace('XXX', data.config.data.amount);
              NotificationService.success(
                'Deposit Successful!',
                successMessage,
                context,
                $scope.callback,
                true
              );

              // gtm success event
              _saveSuccessfulDepositOnGTM();

              _resetAllModels();
              _resetFeesInfo();

              $scope.$emit('onDepositEventSuccess', data);
              $rootScope.$broadcast('accountBalance_update');

              $scope.depositDataModel.amount = null;
            }

            if (data.data && data.data.tvgBalance && isSightlineV2) {
              $rootScope.$emit(
                'accountBalance_changed',
                parseFloat(data.data.tvgBalance)
              );
            }

            if (data.data && data.data.balance && isAch) {
              $rootScope.$emit('accountBalance_changed', data.data.balance);
            }

            if (
              statusCode &&
              statusCode === 207 &&
              (isSightline || isSightlineV2)
            ) {
              if (_.isArray(data.data)) {
                // eslint-disable-next-line
                var slpWithdrawal = data.data.filter(function(item) {
                  return item.id === 'SIGHTLINE_WITHDRAWAL';
                });
                // eslint-disable-next-line
                var firstStep =
                  slpWithdrawal.length === 1 ? slpWithdrawal[0] : null;
                // eslint-disable-next-line
                var toteDeposit = data.data.filter(function(item) {
                  return item.id === 'TOTE_DEPOSIT';
                });
                // eslint-disable-next-line
                var secondStep =
                  toteDeposit.length === 1 ? toteDeposit[0] : null;
                if (firstStep && firstStep.body) {
                  $scope.sightlineBalance = parseFloat(
                    firstStep.body.sightlineBalance
                  );
                }

                if (secondStep && secondStep.body) {
                  // eslint-disable-next-line
                  var status = secondStep.body.status;
                  // eslint-disable-next-line
                  var errorCode = secondStep.body.exception;
                  has207Error = true;

                  if (!status || !errorCode) {
                    NotificationService.error(
                      'Deposit Poller',
                      _defaultErrorMessage(),
                      context,
                      null,
                      true
                    );
                  } else {
                    switch (status) {
                      case 504:
                      case 502:
                        NotificationService.error(
                          'Deposit Poller',
                          messages.scenario2,
                          context,
                          null,
                          true
                        );
                        break;
                      case 500:
                        if (errorCode === 'SLP_WITHDRAW_FROM_SLP_DECLINED') {
                          NotificationService.error(
                            'Deposit Poller',
                            messages.scenario1,
                            context,
                            null,
                            true
                          );
                        } else if (errorCode === 'SLP_TOTE_DEPOSIT_FAILED') {
                          NotificationService.warning(
                            'Deposit Poller',
                            messages.scenario3a,
                            context,
                            null,
                            true
                          );
                        } else {
                          // generic message
                          NotificationService.error(
                            'Deposit Poller',
                            _defaultErrorMessage(),
                            context,
                            null,
                            true
                          );
                        }
                        break;
                      default:
                        NotificationService.error(
                          'Deposit Poller',
                          messages.scenario3c,
                          context,
                          null,
                          true
                        );
                        break;
                    }
                  }
                }
              }
            }

            if (
              statusCode &&
              statusCode === 202 &&
              (isSightline || isSightlineV2)
            ) {
              NotificationService.warning(
                'Poller!',
                messages.scenario3b,
                context,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                context,
                messages,
                _slpSuccessPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  messages,
                  depositType,
                  isSightline,
                  data,
                  context
                ),
                _slpErrorPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  context,
                  messages,
                  isSightlineSelected || isSightlineV2
                )
              );
            }

            if (statusCode && statusCode === 202 && isAch) {
              NotificationService.warning(
                'Poller!',
                messages.scenario3b,
                context,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                context,
                messages,
                _achSuccessPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  messages,
                  depositType,
                  isAch,
                  data,
                  context
                ),
                // eslint-disable-next-line
                _achErrorPollerCb.bind(this, context, messages, isAchSelected)
              );
            }

            if (
              statusCode &&
              statusCode === 202 &&
              isAchNewAccount &&
              isAchSelected
            ) {
              NotificationService.warning(
                'Poller!',
                messages.scenario3b,
                context,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                context,
                messages,
                _achNewAccountSuccessPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  messages,
                  depositType,
                  isAch,
                  data,
                  context
                ),
                _achNewAccountErrorPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  context,
                  messages,
                  isAchSelected
                )
              );
            }

            if (statusCode && statusCode === 202 && isCardOnFile) {
              NotificationService.warning(
                'Poller!',
                messages.scenario3b,
                context,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                context,
                messages,
                _cardsOnFileSuccessPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  messages,
                  depositType,
                  isCardOnFile,
                  data,
                  context
                ),
                // eslint-disable-next-line
                _cardsOnFileErrorPollerCb.bind(this, context, messages, isCC)
              );
            }

            if (statusCode && statusCode === 202 && isNewCc) {
              NotificationService.warning(
                'Poller!',
                messages.scenario3b,
                context,
                null,
                true
              );
              _initiateDepositStatusPoller(
                data,
                context,
                messages,
                _newCardSuccessPollerCb.bind(
                  // eslint-disable-next-line
                  this,
                  messages,
                  depositType,
                  isNewCc,
                  data,
                  context
                ),
                // eslint-disable-next-line
                _newCardErrorPollerCb.bind(this, context, messages, isCC)
              );
            }

            if (statusCode === 200 && isSightline && isSightlineSelected) {
              if (!_showNewDepositSuccessModal()) {
                NotificationService.success(
                  'Poller!',
                  messages.scenario5,
                  context,
                  null,
                  true
                );
              }
            }

            if (statusCode === 200 && isAch && isAchSelected) {
              if (data.data && data.data.balance) {
                $rootScope.$emit(
                  'accountBalance_changed',
                  parseFloat(data.data.balance)
                );
              }
              if (!_showNewDepositSuccessModal() ||
                data.status !== 200
              ) {
                NotificationService.success(
                  'Poller!',
                  messages.scenario5,
                  context,
                  null,
                  true
                );
              }
            }

            if (statusCode === 200 && isCardOnFile) {
              if (data.data && data.data.balance) {
                $rootScope.$emit(
                  'accountBalance_changed',
                  parseFloat(data.data.balance)
                );
              }
              if (!_showNewDepositSuccessModal() ||
                data.status !== 200
              ) {
                NotificationService.success(
                  'Poller!',
                  messages.scenario5,
                  context,
                  null,
                  true
                );
              }
            }

            if (statusCode === 200 && isAchNewAccount && isAchSelected) {
              // update balance
              if (data.data && data.data.balance) {
                $rootScope.$emit(
                  'accountBalance_changed',
                  parseFloat(data.data.balance)
                );
              }
              if (!_showNewDepositSuccessModal() ||
                data.status !== 200) {
                NotificationService.success(
                  'Poller!',
                  messages.scenario5,
                  context,
                  null,
                  true
                );
              }
              $scope.data.fetchingInfo = true;
              // change page and update list of cards
              showStoredBetcashAccounts();
            }

            if (statusCode === 200 && isNewCc) {
              if (data.data && data.data.balance) {
                $rootScope.$emit(
                  'accountBalance_changed',
                  parseFloat(data.data.balance)
                );
              }
              if (!_showNewDepositSuccessModal() ||
                data.status !== 200) {
                NotificationService.success(
                  'Poller!',
                  messages.scenario5,
                  context,
                  null,
                  true
                );
              }
            }

            if (statusCode !== 202 && !isSightlineV2) {
              if (!has207Error) {
                _makeDepositSuccess(data, isSightline, isAch || newCcFlow);
              } else {
                _makeDepositError(data, isSightline || isAch || newCcFlow);
              }
            }

            if (statusCode === 207 && (isCardOnFile || isNewCc)) {
              if (
                data.data &&
                data.data[1] &&
                data.data[1].body.code === 107505
              ) {
                // deposit will happen via CS
                NotificationService.warning(
                  '',
                  $filter('CMSLabels')('scenario3a', 'ccpDepositMessages'),
                  context,
                  null,
                  true
                );
              }
            }

            if (statusCode === 200 || statusCode === 202 || statusCode === 207) {
              $scope.data.responsibleGamingDelay = true;

              $timeout(function () {
                $scope.data.responsibleGamingDelay = false;
              }, parseInt($filter('CMSValue')('debounceAfterDeposit'), 10) || 0);
            }

            DepositSrv._setHasMadeInitialDeposit(true);
            $scope.defaultParams.customerStatus = DepositSrv.getCustomerStatus();
            DepositSrv.updateCustomerStatus();
          })
          .catch(function (data) {
            var depositType = $scope.depositDataModel.depositTypeId;
            var isSightline = depositType === 12;
            var isAch =
              depositType === DEPOSIT_TYPES.ACH_ON_FILE ||
              depositType === DEPOSIT_TYPES.ACH_NEW;
            var context = _getDepositFormFirstChildSelector();
            var isCardOnFile = depositType === DEPOSIT_TYPES.CARD_ON_FILE;
            var label = _mapLabelToPaymentMethod(depositType);
            var isNewCc =
              depositType === DEPOSIT_TYPES.CARD_NEW ||
              depositType === DEPOSIT_TYPES.CREDIT_CARD_NEW;
            var newCcFlow = isCardOnFile || isNewCc;
            var messagesObj = $filter('CMSValue')(label);
            var messages = {};
            var isSightlineSelected =
              !isQuickDeposit && $scope.data.selectedPayOption
                ? $scope.data.selectedPayOption.ftype === 'SLN'
                : false;
            var isAchSelected = $scope.data.selectedPayOption
              ? $scope.data.selectedPayOption.ftype === 'IBC' ||
                $scope.data.selectedPayOption.ftype === 'ACH'
              : false;
            var isCC = !isQuickDeposit
              ? $scope.data.selectedPayOption.ftype === 'CC'
              : $scope.depositDataModel.selectedOnFile &&
              $scope.depositDataModel.selectedOnFile.ftype === 'CC';
            var depositCode; //eslint-disable-line

            var isSightlineV2 = $scope.depositDataModel.sightlineUser_v2;
            var VISA_INITIAL = '4';
            var errorMessage;
            var notifType = 'error';
            var notifTitle = '';
            var depositMessages;
            var fundSuccessDepositFailMessage;
            var fundSuccessMsg =
              'You funded your Prepaid Card with <strong>$XXX</strong>. You now need to transfer this amount to your TVG Account.';
            var isFundSuccessDepositFail =
              data.name && data.name === 'fundSuccessDepositFail';
            //eslint-disable-next-line
            var defaultSLPErrorMessage =
              'Please review the deposit details and try again.' +
              'If problem persists, please contact customer support at 1-888-PLAY-TVG (752-9884).';
            var exceptionCode = data.exceptionCode || data.errorCode;
            var RGLimitsExceededErrorCode = [107417, 101417];
            var isRGException = RGLimitsExceededErrorCode.includes(exceptionCode);
            var isVisa = isCardOnFile ?
              $scope.depositDataModel &&
              $scope.depositDataModel.selectedOnFile &&
              $scope.depositDataModel.selectedOnFile.network === 'VISA' :
              form.cardNumber &&
              form.cardNumber.$viewValue &&
              form.cardNumber.$viewValue[0] === VISA_INITIAL;

            if (isQuickDeposit && !isAchSelected) {
              isAchSelected = $scope.depositDataModel.selectedOnFile
                ? $scope.depositDataModel.selectedOnFile.ftype === 'ACH' ||
                  $scope.depositDataModel.selectedOnFile.ftype === 'IBC'
                : false;
            }

            if (isAchSelected) {
              depositCode = 'ACH';
            }

            if (isSightlineSelected) {
              depositCode = 'SLN';
            }

            if (isCC) {
              depositCode =
                $scope.depositDataModel.selectedCardType.type;
            }

            try {
              messages = angular.fromJson(messagesObj);
            } catch (err) {
              // Prevent test failure
            }
            if (isSightlineSelected && data && !isSightlineV2) {
              if ((data && data.status === 504) || data.status === 502) {
                NotificationService.error(
                  'Deposit Poller',
                  messages.scenario2,
                  context,
                  null,
                  true
                );
              } else if (data && data.status === 500) {
                if (data.code === 'SLP_WITHDRAW_FROM_SLP_DECLINED') {
                  NotificationService.error(
                    'Deposit Poller',
                    messages.scenario1,
                    context,
                    null,
                    true
                  );
                } else if (data.code === 'SLP_TOTE_DEPOSIT_FAILED') {
                  NotificationService.warning(
                    'Deposit Poller',
                    messages.scenario3a,
                    context,
                    null,
                    true
                  );
                } else {
                  // generic message
                  NotificationService.error(
                    'Deposit Poller',
                    _defaultErrorMessage(),
                    context,
                    null,
                    true
                  );
                }
              } else if (data.code === 'RESP_GAMING_LIMITS_EXCEEDED') {
                _handleRGLimitsExceeded(data);
              } else if (!data.status || !data.code) {
                NotificationService.error(
                  'Deposit Poller',
                  _defaultErrorMessage(),
                  context,
                  null,
                  true
                );
              } else {
                NotificationService.warning(
                  'Deposit Poller',
                  messages.scenario3c,
                  context,
                  null,
                  true
                );
              }
            }

            if (isSightlineV2 && data) {
              if (isFundSuccessDepositFail) {
                notifType = 'warning';
                notifTitle = 'Fund success! ';
                fundSuccessDepositFailMessage =
                  $filter('CMSValue')('slpFundSuccessDepositFail') ||
                  fundSuccessMsg;
                errorMessage = fundSuccessDepositFailMessage.replace(
                  'XXX',
                  +$scope.depositDataModel.sightlineUser_v2.depositFee +
                    $scope.depositDataModel.amount
                );
              }

              if (data.message && data.message.indexOf('scenario') !== -1) {
                notifType =
                  data.message.indexOf('scenario1') !== -1
                    ? 'error'
                    : 'warning';
                depositMessages = $filter('CMSValue')(
                  'sightlineDepositMessages'
                );
                errorMessage = angular.fromJson(depositMessages)[data.message];
              } else if (!isFundSuccessDepositFail) {
                notifType = 'error';
                notifTitle = 'Deposit Failed! ';
                errorMessage =
                  _.attempt(function () {
                    $filter('CMSValue')(data.code || data.errorCode);
                  }) || $filter('CMSValue')('SLP_GENERIC_ERROR');
                if (!errorMessage) {
                  errorMessage = defaultSLPErrorMessage;
                }
              }
              NotificationService[notifType](
                'Deposit Failed!',
                notifTitle + errorMessage,
                context,
                null,
                true
              );
            }

            if (isAchSelected) {
              if (data.code === 'ACH_TOTE_DEPOSIT_FAILED') {
                NotificationService.warning(
                  'Deposit Poller',
                  messages.scenario3a,
                  context,
                  null,
                  true
                );
              } else if (data.code === 'ACH_DEPOSIT_DECLINED') {
                NotificationService.error(
                  'Deposit Poller',
                  messages.scenario1,
                  context,
                  null,
                  true
                );
              } else {
                NotificationService.error(
                  'Deposit Poller!',
                  _defaultErrorMessage(),
                  context,
                  null,
                  true
                );
              }
            }

            if (!isSightlineSelected && !isAchSelected) {
              switch (exceptionCode) {
                case 107701:
                case 107501:
                case 306:
                case 'OLD_CCP_DISCOVER_CARD':
                  if ($rootScope.activeFeatures.showCardDeclinedModal &&
                    (isVisa ||
                      ($rootScope.sightlineFlowVersion === '2'
                        && !isCardOnFile)) &&
                    !_isQuickDeposit()
                  ) {
                    invalidCardModal(true);
                  } else {
                    _oldDepositCardDeclinedFlow();
                  }
                  break;
                default:
                  if (
                    !$filter('CMSLabels')(
                      data.exceptionCode,
                      'depositErrorCodes'
                    ) ||
                    data.exceptionCode === 'generic'
                  ) {
                    NotificationService.error(
                      '',
                      $filter('CMSLabels')('generic', 'depositErrorCodes'),
                      context,
                      null,
                      true
                    );
                  } else {
                    NotificationService.error(
                      '',
                      $filter('CMSLabels')(
                        data.exceptionCode,
                        'depositErrorCodes'
                      ),
                      context,
                      null,
                      true
                    );
                  }
              }
            }

            if (isRGException) {
              _handleRGLimitsExceeded(data);
            }

            _makeDepositError(
              data,
              isSightline ||
                isAch ||
                newCcFlow ||
                data.oldCardDepositFlow ||
                isSightlineV2 ||
                exceptionCode === 'OLD_CCP_DISCOVER_CARD' ||
                exceptionCode === 306
            );
          })
          .finally(function () {
            $scope.data.makingDeposit = false;
            $scope.depositDataModel.lastAmount = null;
            if ($scope.data.lastDepositStatus !== 202) {
              _setDepositTypeLimits(
                isQuickDeposit
                  ? $scope.depositDataModel.selectedOnFile.type
                  : $scope.data.selectedPayOption.ftype
              );
            }
          });
      }

      return undefined;
    }

    /**
     * Notify the user after successful deposit
     * @param  {Object} data Data returned from the server
     */

    function _makeDepositSuccess(data, isSightline, preventNotification) {
      var context = _getDepositFormFirstChildSelector();
      var cmsDescription = $filter('CMSValue')('globalDepositSuccess');
      var customerStatus = DepositSrv.getCustomerStatus();
      var isAchSelected;
      var depositType = ($scope.data.selectedPayOption || {}).ftype;
      var appsflyerEvent;
      if (_isQuickDeposit()) {
        depositType = $scope.depositDataModel.selectedOnFile
          ? $scope.depositDataModel.selectedOnFile.ftype
          : '';
      }
      isAchSelected = depositType === 'ACH' || depositType === 'IBC';
      if (customerStatus === 'First Time') {
        if (data.config.data.amount) {
          appsflyerEvent = {
            type: 'APPSFLYER_EVENT',
            payload: {
              appsflyer: {
                key: 'af_first_deposit',
                values: {
                  account_id: $rootScope.user.accountNumber,
                  af_firstdeposit_amount:
                    $filter('currency')(data.config.data.amount)
                }
              }
            }
          };
        }
        if (appsflyerEvent) {
          // RN native appsflyer event call
          if ($window && $window.handleNativeMessages) {
            $window.handleNativeMessages('FIRST_DEPOSIT', appsflyerEvent.payload);
          }
          // Send AppsFlyer event for iOS app
          if (
            $window.webkit &&
            $window.webkit.messageHandlers &&
            $window.webkit.messageHandlers.APPSFLYER_EVENT
          ) {
            $window.webkit.messageHandlers.APPSFLYER_EVENT.postMessage(appsflyerEvent);
            // Send AppsFlyer event for Android app
          } else if (
            $window.mediatorChannels &&
            $window.mediatorChannels.ios
          ) {
            $window.mediatorChannels.ios.dispatch(appsflyerEvent);
          }
        }
      }
      $scope.$emit('onDepositEventSuccess', data);
      $rootScope.$broadcast('accountBalance_update');

      if (data.hasOwnProperty('sightlineBalance')) {
        $scope.sightlineBalance = angular.isString(data.sightlineBalance)
          ? parseFloat(data.sightlineBalance)
          : data.sightlineBalance;
      } else if (data.data && data.data.hasOwnProperty('sightlineBalance')) {
        $scope.sightlineBalance = angular.isString(data.data.sightlineBalance)
          ? parseFloat(data.data.sightlineBalance)
          : data.data.sightlineBalance;
      }

      if (_isQuickDeposit()) {
        $scope.callback = function () {
          _closeQuickDepositModal();
        };
      }

      if (_showNewDepositSuccessModal() && data.status === 200) {
        DepositSrv.getSuccessDepositModal(isAchSelected);
      } else if (!isSightline && !preventNotification) {
        NotificationService.success(
          'Success!',
          '<strong>Your transaction was successful.</strong><br/>' +
          cmsDescription,
          context,
          $scope.callback,
          true
        );
      }
      _saveSuccessfulDepositOnGTM();
      _resetAllModels();
      _resetFeesInfo();

      $scope.depositDataModel.amount = null;

      return null;
    }

    /**
     * Handle errors during deposits
     * Note that there are two error codes objects handled here
     * (from microservices or api?), one with "error.code" and other
     * "error.errorCode".
     *
     * @param  {Object} error  Error occurred while making deposit
     */
    function _makeDepositError(error, preventNotification) {
      var err = error || {};
      var handlers = {
        50009: _makeDepositInvalidPinOrPasswordError,
        306: _makeDepositInvalidCreditCardError,
        500: _handleMicroServiceError,
        308: _handleBetcashExceeded,
        ResponsibleGamingLimitsExceededException: _handleRGLimitsExceeded,
        RESP_GAMING_LIMITS_EXCEEDED: _handleRGLimitsExceeded,
        SLN_InsufficientFunds: _makeSlnInsufficientFundsError,
        BridgepayException: _makeDepositInvalidCreditCardError,
        default: _makeDepositDefaultError
      };
      var errorKey = err.code || err.errorCode || ''; // make sure we read the error code
      var errorHandler;
      var errorMessageForGtm;
      var isAchOrIbc =
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_ON_FILE ||
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_NEW;

      if (_isSightlinePayment()) {
        errorKey = 'SLN_' + (err.code || '');
      }

      errorHandler = handlers[errorKey] || handlers.default;

      if (_isDepositWithNewAccount() && isAchOrIbc) {
        UserActionEventsService.emit(
          'UnsuccessfullyAddNewAccount',
          err.message
        );
      }

      errorMessageForGtm =
        $rootScope.sightlineFlowVersion === '2' ? err.code : err.message;

      _saveGTMDepositError(errorMessageForGtm);

      if (preventNotification) {
        return null; // already has notification in place
      }

      errorHandler(err);

      return null;
    }

    function _handleBetcashExceeded() {
      var message =
        'No further BetCash deposits are permitted for this period.';
      $scope.data.achDepositLimitExceeded = true;
      NotificationService.warning(
        'Error!',
        message,
        _getDepositFormFirstChildSelector()
      );
    }

    /**
     * Handle errors processed by deposits micro services returning CMS default msg for this error
     *
     * FYI: After Pedro Silva search for this response with code 500 on node and deposit micro
     * services he didn't find any reference to this error code number. Best guess it's that
     * we are no longer using this error.
     *
     * @return {String}
     */
    function _handleMicroServiceError() {
      NotificationService.error(
        'Error!',
        _defaultErrorMessage(),
        _getDepositFormFirstChildSelector()
      );
    }

    /**
     * Handle error of Responsible Gaming when limit Exceeded
     */
    function _handleRGLimitsExceeded(error) {
      var message;
      var limit;
      var context = _getDepositFormFirstChildSelector();
      var floatRegex = new RegExp(/\d*\.\d*/g);
      var CMSMessage = $filter('CMSValue')('RGLimitsExceededError');
      if (error.message && CMSMessage) {
        limit = Number(error.message.match(floatRegex)[0]).toFixed(2);
        message = CMSMessage.replace('[limit]', limit);
      } else {
        message = _defaultErrorMessage();
      }

      NotificationService.error('Error!', message, context, null, true);
      return null;
    }

    /**
     * Handle "InvalidPinOrPassword" error during deposit
     */
    function _makeDepositInvalidPinOrPasswordError() {
      $scope.data.showIBCInvalidPinOrPasswordMessage = true;
      return null;
    }

    function _oldDepositCardDeclinedFlow() {
      var context = _getDepositFormFirstChildSelector();
      var ftype1 = Utilities.prop(
        'depositDataModel.selectedOnFile.type',
        $scope
      );
      var ftype2 = Utilities.prop(
        'depositDataModel.selectedCardType.type',
        $scope
      );
      var errorMsg = '';

      if (ftype1 === 'DEB' || ftype2 === 'DEB') {
        errorMsg = $filter('CMSValue')('depositsErrorDebitCardDeclined');
      } else if (ftype1 === 'CC' || ftype2 === 'CC') {
        errorMsg = $filter('CMSValue')('depositsErrorCreditCardDeclined');
      }

      NotificationService.error('Error!', errorMsg, context, null, true);
    }

    /**
     * Handle "onDepositEventFailure" error during deposit
     */
    function _makeDepositInvalidCreditCardError(isDiscoverCard) {
      if (!_isQuickDeposit() && $rootScope.sightlineFlowVersion === '2') {
        $rootScope.showRedirectMessage = true;
        $rootScope.cardDataToReactSightline = {
          cardNumber: $scope.depositDataModel.cardNumber,
          expirationMonth: $scope.depositDataModel.expirationMonth,
          expirationYear: $scope.depositDataModel.expirationYear, // This will break in the year 3000
          amount: $scope.depositDataModel.amount,
          cvv: $scope.depositDataModel.cardSecurityNumber
        };

        if (typeof isDiscoverCard === 'boolean' && isDiscoverCard) {
          $rootScope.cardDataToReactSightline.isDiscoverCard = true;
          UserActionEventsService.emit('DiscoverCardRedirect', {
            depositAmount: $scope.depositDataModel.amount,
            amountOption: _isDefaultAmount(),
            cardType: $scope.depositDataModel.selectedCardType,
            module: _isQuickDeposit() ? 'Quick Deposit' : 'My Funds'
          });
        }

        _addQuickDepositFunds('SLN', true);
      } else {
        _oldDepositCardDeclinedFlow();
      }

      $scope.data.makingDeposit = false;
      $scope.depositDataModel.lastAmount = null;
    }

    /**
     * Handle sightline "InsufficientFundsError" error during deposit
     * @param  {Object} error  API error
     */
    function _makeSlnInsufficientFundsError(error) {
      var context = _getDepositFormFirstChildSelector();
      var errorMsg = error.message || _defaultErrorMessage();

      NotificationService.error('Error!', errorMsg, context, null, true);

      return null;
    }

    /**
     * Handle unexpected errors during deposit
     */
    function _makeDepositDefaultError() {
      var context = _getDepositFormFirstChildSelector();
      var errorMsg = _defaultErrorMessage();

      NotificationService.error('Error!', errorMsg, context, null, true);

      return null;
    }

    /**
     * Generate the default error message for deposit module
     * @return {String} Default error message
     */
    function _defaultErrorMessage() {
      return (
        "<strong>This method of payment doesn't seem " +
        'to be going through.</strong><br/>' +
        $filter('CMSValue')('depositsErrorDefault')
      );
    }

    /**
     * Check in the current scope if we're dealing with sightline
     * payment option.
     *
     * @return {Boolean}
     */
    function _isSightlinePayment() {
      return !!$scope.data.isSightlineSelected;
    }

    function _isSightlineInvalid() {
      return $scope.sightlineBalance < $scope.depositFrm.amount.$viewValue;
    }

    /**
     * Get the max deposit amount according to card type and
     * current card balance, if possible (e.g: sightline).
     * @return {Number} Max allowed deposit amount
     */
    function _getMax() {
      return !isNaN($scope.depositDataModel.max)
        ? $scope.depositDataModel.max
        : $scope.depositDataModel.max || 99999;
    }

    /**
     * Fetch fees after 1 sec of being called. If called again in less
     * than 1sec, restart timer
     *  - update fees object if success and response data matches user current
     *  amount and selected option
     * @param dataModel
     * @return {Promise} promise resolved with the deposit fee object.
     * @private
     */
    function _updateTotalCosts(dataModel, forceRetry) {
      var isSLNSelected = false;
      var amount = dataModel.amount;
      var depositLimitTypeId = dataModel.limitTypeId;
      if (!depositLimitTypeId) {
        depositLimitTypeId = DepositInitialDataFac.getDepositLimitTypeByAbbr(
          dataModel.selectedOnFile && dataModel.selectedOnFile.ftype
        ).id;
      }

      if (
        $scope.depositDataModel &&
        $scope.depositDataModel.selectedOnFile &&
        $scope.depositDataModel.selectedOnFile.ftype === 'SLN'
      ) {
        isSLNSelected = true;
      }

      // Update current amount
      $scope.depositDataModel.amount = amount;

      if (
        (!isSLNSelected &&
          $scope.depositDataModel.lastAmount === amount &&
          !forceRetry) ||
        amount > $scope.depositDataModel.max ||
        amount < $scope.depositDataModel.min
      ) {
        return $q.when({});
      }

      // stop
      if (!amount || !depositLimitTypeId) {
        _resetFeesInfo(false);
        return $q.when({});
      }

      $scope.depositDataModel.lastAmount = amount;

      $scope.data.retryFetchingFees = false;

      // Clear Fees object and show calculating fees label
      _resetFeesInfo(true);

      if (
        isSLNSelected &&
        _isQuickDeposit() &&
        dataModel.sightlineUser_v2 &&
        $rootScope.sightlineFlowVersion === '2'
      ) {
        $scope.data.fee = {
          netAmount: parseFloat(amount),
          fee: parseFloat(dataModel.sightlineUser_v2.depositFee),
          feeDiscount: 0,
          transactionTotal:
            parseFloat(amount) +
            parseFloat(dataModel.sightlineUser_v2.depositFee),
          calculatingFees: false
        };
      } else {
        return DepositSrv.getDepositFee(depositLimitTypeId, amount).then(
          function (data) {
            if (data && data.useNewFeeFlow) {
              $scope.data.fee = {
                netAmount: parseFloat(data.netAmount),
                fee: parseFloat(data.fee),
                feeDiscount: parseFloat(data.feeDiscount),
                transactionTotal: parseFloat(data.transactionTotal),
                calculatingFees: false
              };
            } else if (
              $scope.depositDataModel.amount &&
              $scope.depositDataModel.amount.toFixed(2) ===
                data.netAmount.toFixed(2)
            ) {
              $scope.data.fee = {
                netAmount: parseFloat(data.netAmount),
                fee: parseFloat(data.fee),
                feeDiscount: parseFloat(data.feeDiscount),
                transactionTotal: parseFloat(data.transactionTotal),
                calculatingFees: false
              };
            } else {
              // Clear Fees object and hide calculating fees label
              _resetFeesInfo(false);
            }
          },
          function () {
            // Clear Fees object and hide calculating fees label
            _resetFeesInfo(false);
            $scope.data.retryFetchingFees = true;
          }
        );
      }
    }

    /**
     * Clear Fees object and show/hide calculating fees label
     * @private
     */
    function _resetFeesInfo(isCalculatingFee) {
      $scope.data.fee = {
        calculatingFees: isCalculatingFee
      };
    }

    /**
     * Handles routing number changed event
     * (only fires when valid routing number)
     * Updates bank name labels for customer feedback
     * @param routingNumber
     * @private
     */
    function _routingNumberOnChange(routingNumber) {
      var currentTimestamp;

      // stop
      if (!routingNumber) {
        return;
      }

      currentTimestamp = toggleTimestamp;
      $scope.data.bankNameMessage = bankNameInfoMessages.FETCHING;
      $scope.data.bankNameDisabled = true;
      $scope.depositDataModel.bankName = null;
      $scope.data.errorBankName = false;

      DepositSrv.getBankName(routingNumber)
        .then(function (data) {
          // Only updates if is still the same routing number and
          // cancel message updates if tab has changed
          if (
            $scope.depositDataModel.routingNumber === data.routingNumber &&
            currentTimestamp === toggleTimestamp
          ) {
            $scope.depositDataModel.bankName = data.bankName;
            $scope.data.bankNameDisabled = false;
          }

          $scope.data.bankNameMessage = null;
        })
        .catch(function () {
          $scope.data.bankNameDisabled = false;

          if (currentTimestamp === toggleTimestamp) {
            $scope.data.bankNameMessage = bankNameInfoMessages.ERROR;
            $scope.data.errorBankName = true;
          } else {
            $scope.data.bankNameMessage = bankNameInfoMessages.DEFAULT;
          }
        });
    }

    /**
     * Save the payment card/method information
     * @param {Object} method  Payment card/method
     */
    function _setPaymentData(method) {
      var firstTime = DepositSrv.getHasMadeInitialDeposit();
      var min =
        method.min || DepositInitialDataFac.getLimitType(method.ftype, 'min');
      var max =
        method.max || DepositInitialDataFac.getLimitType(method.ftype, 'max');
      method = method || {};
      $scope.depositDataModel.selectedCardType = method;
      //eslint-disable-next-line
      $scope.depositDataModel.min = firstTime
        ? 0.1
        : !isNaN(parseFloat(min))
        ? parseFloat(min)
        : 0;
      $scope.depositDataModel.max = !isNaN(parseFloat(max))
        ? parseFloat(max)
        : 99999;
      $scope.depositDataModel.limitTypeId =
        method.limitTypeId ||
        DepositInitialDataFac.getLimitType(method.ftype, 'id');
      $scope.depositDataModel.depositTypeId = method.depositTypeId;

      return null;
    }

    /**
     * Update min and max values based on each payment method specific values
     * Update total costs
     * @param card
     * @private
     */
    function _subTypeCardChanged(card) {
      _resetNotification();
      _setPaymentData(card);
      _setDepositTypeLimits(card.ftype, card.type);

      // Fetch fees for selected card sub type and current amount
      _updateTotalCosts($scope.depositDataModel);
    }

    /**
     * Update the deposit type information saved in model, accordig to
     * the selected card.
     *
     * @param  {Object} depositInfo  Deposit type info
     */
    function _updateSelectedDepositTypeInfo(depositInfo) {
      if (depositInfo) {
        _setPaymentData(depositInfo);
        $scope.depositDataModel.isPending = depositInfo.isPending;
        $scope.depositDataModel.isAvailable = depositInfo.isAvailable;
        $scope.data.isSightlineSelected = depositInfo.ftype === 'SLN';

        $scope.data.showAchDepositLimitExceeded =
          depositInfo.max === 0 &&
          depositInfo.type === 'ACH' &&
          $scope.data.achDepositLimitExceeded;

        _setDepositTypeLimits(depositInfo.type || depositInfo.ftype);

        if (depositInfo.depositTypeId && $scope.depositDataModel.amount) {
          DepositSrv.getDepositFee(
            depositInfo.depositTypeId,
            $scope.depositDataModel.amount
          ).then(
            function (data) {
              if (data && data.useNewFeeFlow) {
                $scope.data.fee = {
                  netAmount: parseFloat(data.netAmount),
                  fee: parseFloat(data.fee),
                  feeDiscount: parseFloat(data.feeDiscount),
                  transactionTotal: parseFloat(data.transactionTotal),
                  calculatingFees: false
                };
              } else if (
                $scope.depositDataModel.amount &&
                $scope.depositDataModel.amount.toFixed(2) ===
                  data.netAmount.toFixed(2)
              ) {
                $scope.data.fee = {
                  netAmount: parseFloat(data.netAmount),
                  fee: parseFloat(data.fee),
                  feeDiscount: parseFloat(data.feeDiscount),
                  transactionTotal: parseFloat(data.transactionTotal),
                  calculatingFees: false
                };
              } else {
                // Clear Fees object and hide calculating fees label
                _resetFeesInfo(false);
              }
            },
            function () {
              // Clear Fees object and hide calculating fees label
              _resetFeesInfo(false);
              $scope.data.retryFetchingFees = true;
            }
          );
        }
      }
    }

    /**
     * Handle changes to the selected payment option
     * @param  {Object} card  Selected card
     * @public
     */
    function _selectOnFileChanged(card) {
      if (card) {
        _resetNotification();
        _updateSelectedDepositTypeInfo(card);
      }

      // Fetch fees for selected card sub type and current amount
      _updateTotalCosts($scope.depositDataModel);
      _updateDefaultPayment($scope.depositDataModel);
    }

    function _toggleNewStoredMethods(method) {
      var selectedPayOption = $scope.data.selectedPayOption;
      var currentAmount = $scope.depositDataModel.amount;
      var onFile = selectedPayOption.onFile || [];
      var subTypes = selectedPayOption.subTypes || [];
      var selCardType;

      _resetNotification();

      if ($scope.data.selectedPayOption.ftype === 'CC') {
        UserActionEventsService.emit('ChangeCreditMethod', method);
      }
      if ($scope.data.selectedPayOption.ftype === 'IBC') {
        if (method === 'NEW') {
          UserActionEventsService.emit('AddNewAccountClick');
        } else {
          UserActionEventsService.emit('AccountsOnFileClick');
        }
      }

      toggleTimestamp = new Date().getTime();
      $scope.data.bankNameMessage = bankNameInfoMessages.DEFAULT;

      $scope.depositDataModel = {
        limitTypeId: selectedPayOption.limitTypeId,
        depositTypeId: selectedPayOption.depositTypeId,
        amount: currentAmount,
        min: parseFloat(selectedPayOption.min),
        max: parseFloat(selectedPayOption.max),
        isAvailable: null,
        isPending: null,
        toSaveOnFile: true
      };

      $scope.data.depositSection = method;

      if (method === 'STORED' && onFile.length) {
        _resetDepositActionModel();
      } else {
        $scope.depositDataModel.selectedOnFile = null;
        $scope.depositDataModel.isAvailable = selectedPayOption.isAvailable;

        if (subTypes.length) {
          selCardType = subTypes[0];
          _setPaymentData(selCardType);
        }
      }
      _setDepositTypeLimits(
        selectedPayOption.ftype,
        selCardType && selCardType.type
      );
      _updateTotalCosts($scope.depositDataModel);
      if (method === 'STORED') {
        _setUserBankAccounts();
        _setUserCardsOnFile();
      }
    }

    function _resetDepositActionModel() {
      $scope.depositDataModel.selectedOnFile = null;
      $scope.depositDataModel.limitTypeId = null;
      $scope.depositDataModel.depositTypeId = null;
      $scope.depositDataModel.min = 0;
      $scope.depositDataModel.max = 99999;
      $scope.depositDataModel.isPending = null;
    }

    function _existSelectedOnFile() {
      return (
        $scope.data.selectedPayOption &&
        _existsOnFile($scope.data.selectedPayOption.onFile)
      );
    }

    function _existsOnFile(onFile) {
      return (onFile || []).some(function (file) {
        return file.isPending === false;
      });
    }

    /**
     * Get sightline user from API
     *
     * 1) get user from TVG deposit
     * 2) check if user has sightline account
     * 3) get full sightline details for the user
     *
     * (previous _handleSightLine() cont.)
     *
     * @param  {Object} depositUser
     * @return {Promise}
     */
    function _getSightlineUser(depositUser) {
      var basicSightlineUsr = SightlineSrv.createSightlineAccount(depositUser);
      $scope.depositDataModel.sightlineNoBalance = false;

      $scope.basicSightlineUsr = basicSightlineUsr;
      if (
        $rootScope.sightlineFlowVersion &&
        $rootScope.sightlineFlowVersion === '1'
      ) {
        return _getSightlineUserWithFallback(basicSightlineUsr)
          .then(function (data) {
            // mark users without sightline and update balance
            $scope.isNewUser = !data.enrolled;
            $scope.sightlineBalance = data.balance || 0;

            $scope.depositDataModel.max = $scope.sightlineBalance;
            if ($scope.sightlineBalance === 0) {
              $scope.depositDataModel.maxOverflow = true;
              $scope.depositDataModel.sightlineNoBalance = true;
            }

            // needed to make deposit...
            DepositSrv.user.set('last4SSN', '0000');

            return data;
          })
          .then(function (data) {
            // @TODO check if we should always get full merchant data
            return $scope.isAddingFunds || !data.exists
              ? _getMerchantData(depositUser)
              : depositUser;
          });
      }
      return null;
    }

    /**
     * To comply with returning 404 when the user does not exist,
     * we need to catch 404 and treat it as a success (like the backend used to do).
     *
     * @param {Object} basicSightlineUsr
     * @return {Promise} User data request
     */
    function _getSightlineUserWithFallback(basicSightlineUsr) {
      return SightlineSrv.isSightlineUser(basicSightlineUsr).catch(function (
        err
      ) {
        var error = err || {};
        var errorCode = error.data ? error.data.code : error.code;

        // handle "NO_SIGHTLINE_ACCOUNT_FOUND" known errors as success
        // (to be compliant with previous api)
        if (errorCode === ERRORS.NO_SIGHTLINE_ACCOUNT_FOUND) {
          return {
            exists: false,
            balance: 0
          };
        }

        return $q.reject(err);
      });
    }

    /**
     * Get sightline user data using the TVG account.
     * Sightline enrollment, deposits and withdrawals are done using
     * sightline API.
     *
     * (previous _getSightlineUser())
     *
     * @param  {Object}  depositUser  TVG user data
     * @return {Promise}              Get sightline from API promise
     */
    function _getMerchantData(depositUser) {
      return SightlineSrv.getToken(depositUser, 'Deposit').then(
        _loadSightlineIframe
      );
    }

    /**
     * Load sightline if any process is forcing the iframe loading
     * (e.g. adding funds).
     *
     * (previous _getSightlineUserData())
     *
     * @param  {Object} data  TVG user data
     */
    function _loadSightlineIframe(data) {
      var forced = $scope.isAddingFunds;

      if (
        forced &&
        $scope.sightlineFlowVersion &&
        $scope.sightlineFlowVersion === '1'
      ) {
        // @TODO please remove when db bug of saving postal codes
        // with extra 4 0000 is fixed
        data.postalCode = data.postalCode.substring(0, 5);
        $scope.sglUser = data;

        $timeout(function () {
          document.getElementById("sightline__user-form").submit(); // eslint-disable-line
          $scope.loadSightlineInfo = true;
          $scope.data.loading = false;
          $scope.loadSightlineiFrame = true;
        }, 300);
      }

      return data;
    }

    /**
     * Select a deposit payment options (tab)
     *
     * @param {Object} opt                              An option present in the depositOptions array.
     * @param {Boolean} [doNotSendGTMClickEvent=false]  True to avoid sending a "Site Click" GTM event.
     * @private
     */
    function _selectOption(opt, doNotSendGTMClickEvent, force) {
      var types;
      // to avoid resetDataModel if the tab doesn't change
      if ($scope.data.selectedPayOption !== opt || force) {
        $scope.data.selectedPayOption = opt;
        _resetDepositDataModel();
        _resetNotification();

        if (!doNotSendGTMClickEvent) {
          _selectOptionGtmEvents(opt.name);
        }

        types = {
          BC: null,
          CC: null,
          ACH: null,
          IBC: null,
          OTHER: null,
          PNM: null,
          APPL: null,
          SLN: _selectOptionSightline,
          PAY: null
        };

        $scope.data.isSightlineSelected = opt.ftype === 'SLN';

        // clear is adding funds flag when moving to other tabs
        if (!$scope.data.isSightlineSelected) {
          $scope.isAddingFunds = false;
        }

        if (types[opt.ftype]) {
          return types[opt.ftype]();
        }
      }
      return undefined;
    }

    /**
     * DO NOT CALL THIS DIRECTLY!
     * (use _selectOption(sightline) instead...)
     *
     * Initialize the sightline as deposit method when opening
     * "TVG Pre Paid Card" in deposits page.
     * (previous _handleSightLine())
     *
     * @return {Promise}
     */
    function _selectOptionSightline() {
      var depositUser = DepositSrv.user;
      if (
        $rootScope.sightlineFlowVersion &&
        $rootScope.sightlineFlowVersion === '1'
      ) {
        _startSightlineLoaders();
        return _getSightlineUser(depositUser)
          .catch(_selectOptionSightlineError)
          .finally(function () {
            $scope.data.loading = false;
            _stopSightlineLoaders();
          });
      }
    }

    /**
     * Handle errors while selecting sightline as the deposit method in
     * deposit page.
     * @param  {Object} error  API error
     */
    function _selectOptionSightlineError(error) {
      var errorMessage = error.message || _defaultErrorMessage();
      var target = _getDepositFormFirstChildSelector();

      return NotificationService.error('Error!', errorMessage, target);
    }

    /**
     * Reset deposit data model and set selected option and current amount;
     * Update total costs
     * @private
     */
    function _resetDepositDataModel() {
      var selectedPayOption = $scope.data.selectedPayOption;
      var currentAmount = $scope.depositDataModel.amount;
      var makeTransfer = !!(
        $scope.fromOption &&
        ($scope.fromOption.tla === 'registration' ||
          $scope.fromOption === 'registration') &&
        ConfigurationFac.getApplicationContextItem('product') === 'njx'
      );
      var selectCardType;

      _resetAllModels();

      if (selectedPayOption) {
        $scope.depositDataModel = {
          limitTypeId: selectedPayOption.limitTypeId,
          depositTypeId: selectedPayOption.depositTypeId,
          amount: currentAmount,
          min: parseFloat(selectedPayOption.min),
          max: parseFloat(selectedPayOption.max),
          isAvailable: selectedPayOption.isAvailable,
          toSaveOnFile: true,
          makeTransfer: makeTransfer
        };
      }

      if (selectedPayOption) {
        if (selectedPayOption.subTypes && selectedPayOption.subTypes.length) {
          selectCardType = selectedPayOption.subTypes[0];
          _setPaymentData(selectCardType);
        }

        // @HACK
        // to render sightline in quick deposit, we simulated a onFile entry...
        if (
          selectedPayOption.ftype !== 'SLN' &&
          selectedPayOption.onFile &&
          selectedPayOption.onFile.length &&
          !$rootScope.dmaShowAddNewCardForm
        ) {
          $scope.data.depositSection = 'STORED';
          _resetDepositActionModel();
        } else {
          $scope.data.depositSection = 'NEW';
          $rootScope.dmaShowAddNewCardForm = false;
        }

        if (
          (selectedPayOption.ftype === 'ACH' ||
            selectedPayOption.ftype === 'IBC') &&
          !$scope.data.achDepositLimitExceeded
        ) {
          _setUserBankAccounts();
        }

        if (selectedPayOption.ftype === 'CC') {
          _setUserCardsOnFile();
        }
      }

      if (
        $scope.fromOption &&
        ($scope.fromOption.tla === 'quick_deposit' ||
          $scope.fromOption === 'quick_deposit')
      ) {
        $scope.data.depositSection = 'NEW';
      }

      // Fetch fees for selected payment method and current amount
      _updateTotalCosts($scope.depositDataModel);

      $scope.$emit('selectedPayOption', {
        depositType: _getCurrentDepositTypeString()
      });

      return undefined;
    }

    /**
     * Clear the notifcation service banner
     * (used when switching tabs in deposit)
     * @private
     */
    function _resetNotification() {
      NotificationService.clearBanner();
    }

    /**
     * Get the selected deposit "name"
     * @return {String} Current deposit type name
     */
    function _getCurrentDepositTypeString() {
      var depositType = ($scope.data.selectedPayOption || {}).ftype;
      var types = {
        IBC: 'BetCash',
        ACH: 'BetCash',
        CC: 'Card',
        MPAK: 'MoneyPak',
        SLN: 'Sightline',
        PNM: 'PayNearMe',
        APPL: 'Apple Pay',
        PAY: 'PayPal',
        OTHER: 'OtherPaymentMethod'
      };

      if (_isQuickDeposit()) {
        depositType = $scope.depositDataModel.selectedOnFile
          ? $scope.depositDataModel.selectedOnFile.ftype
          : '';
      }

      return types[depositType] || 'Unknown';
    }

    /**
     * Handle "TVG default deposit amount" button click by updating the
     * selected amount in model, updating fees from server and notifying GTM.
     *
     * (was _availableAmountOptionClicked())
     *
     * @param  {String} amount  Updated amount from view
     */
    function _handleDefaultAmountButtonClick(amount) {
      // set the value in model
      $scope.depositDataModel.amount = parseInt(amount, 10);

      _updateDepositFeesAndSendGTM({
        isDefaultValue: true,
        silent: false
      });
    }

    /**
     * Handle "deposit amount" input change by updating the
     * selected amount in model and updating fees from server.
     */
    function _handleAmountInputChange() {
      _updateDepositFeesAndSendGTM({
        isDefaultValue: false,
        silent: true // do not send gtm events!
      });
    }

    /**
     * Handle "deposit amount" input blur by updating the
     * selected amount in model, updating fees from server and notifying GTM.
     *
     * (was _otherAmountBlur())
     *
     * @return {Promise}
     */
    function _handleAmountInputBlur() {
      // must be async because the blur triggers before change events
      $timeout(function () {
        _updateDepositFeesAndSendGTM({
          isDefaultValue: false,
          silent: false
        });
      }, 10);
    }

    /**
     * Update the selected amount in model and fees from server.
     * By default, we may notify this change using GTM, but may be silenced
     * using silentGTM as true.
     *
     * @param {Object}  [opts]                 Update options
     * @param {Boolean} [opts.isDefaultValue]  Is the value a default one from TVG?
     * @param {Boolean} [opts.silent]          Prevent sending events through GTM
     * @return {Promise}
     */
    function _updateDepositFeesAndSendGTM(opts) {
      opts = opts || {};

      // stop if no amount is inserted
      // (amount is undefined if the value is not valid)
      if (
        !$scope.depositDataModel ||
        !$scope.depositDataModel.amount ||
        $scope.depositDataModel.amount > $scope.depositDataModel.max
      ) {
        $scope.data.shouldDisableApplePayButton = true;
        return $q.reject('Invalid deposit amount');
      }

      if (
        $scope.depositDataModel &&
        $scope.depositDataModel.selectedOnFile &&
        $scope.depositDataModel.selectedOnFile.ftype === 'SLN'
      ) {
        _updateTotalCosts($scope.depositDataModel);
        if (!opts.silent) {
          _sendGTMAmountChanged();
        }
        return null;
      }

      if ($scope.data.shouldDisableApplePayButton) {
        $scope.data.shouldDisableApplePayButton = false;
      }

      // update fees and notify via GTM
      return _updateTotalCosts($scope.depositDataModel).then(function () {
        if (!opts.silent) {
          _sendGTMAmountChanged();
        }
        return null;
      });
    }

    /**
     * Notify GTM when a "default deposit amount" button was clicked
     * (must only be triggered after fees recalculation)
     */
    function _sendGTMAmountChanged() {
      var eventData = {
        gaEventLabel:
          _isDefaultAmount() === 'Yes' ? 'Default Amount' : 'Other Amount',
        depositAmount: $scope.depositDataModel.amount,
        depositFee: $scope.data.fee.fee,
        depositType: _getCurrentDepositTypeString(),
        cardType: _getUsedCardType()
      };

      return _isQuickDeposit()
        ? UserActionEventsService.emit('QuickDepositStart', eventData)
        : UserActionEventsService.emit('StandardDepositStart', eventData);
    }

    /**
     * Handle "This is your TVG Quick Deposit default?" value change
     * @param  {Boolean} isDefaultPayment
     * @public
     */
    function _defaultPaymentChanged(isDefaultPayment) {
      var selectedPayment = $scope.depositDataModel.selectedOnFile;
      var defaultPaymentCard;
      var eventData = {
        depositType: _getCurrentDepositTypeString(),
        gaEventLabel: isDefaultPayment,
        amountType: _isDefaultAmount()
      };
      UserActionEventsService.emit('selectDefaultAmount', eventData);
      if (isDefaultPayment) {
        defaultPaymentCard = {
          type_id: selectedPayment.depositTypeId,
          id: _getIdFromPaymentOption(selectedPayment)
        };

        DepositSrv.setUserPaymentDefault(defaultPaymentCard).then(function (
          result
        ) {
          if (result) {
            $scope.data.defaultPaymentCard = defaultPaymentCard;
            $scope.depositDataModel.isDefaultPayment = true;
            Utilities.attempt(function () {
              $window.localStorage.setItem(
                'defaultPaymentMethod',
                angular.toJson(defaultPaymentCard)
              );
            });
          } else {
            $scope.depositDataModel.isDefaultPayment = false;
          }
        });
      } else {
        DepositSrv.setUserPaymentDefault(null).then(function (result) {
          if (result) {
            $scope.depositDataModel.isDefaultPayment = false;
            $scope.data.defaultPaymentCard = false;
            Utilities.attempt(function () {
              $window.localStorage.removeItem('defaultPaymentMethod');
            });
          } else {
            $scope.depositDataModel.isDefaultPayment = true;
          }
        });
      }
    }

    /**
     * Check if the current selected payment in dataModel is the default one
     * @param  {Object}  dataModel  View's data model
     * @return {Boolean}            Whether is default
     */
    function _updateDefaultPayment(dataModel) {
      var defaultCard = {};
      var defaultCardId;
      var selectedCardId;
      var isDefaultPayment;

      Utilities.attempt(function () {
        defaultCard = angular.fromJson(
          $window.localStorage.getItem('defaultPaymentMethod')
        );
        defaultCardId = (defaultCard || {}).id;
      });

      if (dataModel.selectedOnFile) {
        selectedCardId = _getIdFromPaymentOption(dataModel.selectedOnFile);
      }
      isDefaultPayment = defaultCardId && selectedCardId === defaultCardId;

      // must cast to boolean!
      dataModel.isDefaultPayment = !!isDefaultPayment;

      return null;
    }

    /**
     * Revert all form fields to a pristine, untouched state.
     */
    function _resetAllModels() {
      if ($scope.depositFrm) {
        angular.forEach($scope.depositFrm, function (value, key) {
          if (!key.match(/\$/)) {
            value.$setUntouched();
            value.$setPristine();
          }
        });
        $scope.depositFrm.$setUntouched();
        $scope.depositFrm.$setPristine();
      }
    }

    /**
     * Open terms modal window
     * @private
     */
    function _openTerms() {
      UserActionEventsService.emit('TermsAndConditionsClick');
      return ModalDialogService.open(
        $filter('CMSValue')('depositBetCashUserAgreementTitle'),
        $filter('CMSValue')('depositBetCashUserAgreementHTML')
      );
    }

    /**
     * Close the quick deposit window
     * @private
     */
    function _closeQuickDepositModal() {
      $scope.$emit('onCloseSuccessWindow');
      return;
    }

    //
    // ADD FUNDS
    //

    /**
     * Load sightline funds iframe
     * @return {Object}
     */
    function _addSightlineFunds() {
      // @TODO should we fetch user information if already loaded?
      _startSightlineLoaders();
      _resetNotification();

      // add funds does not exist with sightline API,
      // so it must always be processed with iframe
      $scope.isAddingFunds = true;
      _addFundsGtmEvent();
      _getSightlineUser(DepositSrv.user)
        .catch(_loadSightlineAddFundsIframeError)
        .finally(function () {
          $scope.data.loading = false;
          _stopSightlineLoaders();
        });

      return;
    }

    /**
     * Show a notification.error when the user tries to add funds from betslip
     * explaining how the user may proceed to add funds manually
     */
    function _showAddFundsInBetslipWarning(ftype) {
      var options = {
        PAY: 'PayPal',
        SLN: 'TVG Pre Paid Card'
      };
      var message = $filter('CMSValue')('addFundsInBetslipWarning');
      var target = _getDepositFormFirstChildSelector();
      return NotificationService.error(
        'Error!',
        Utilities.supplant(message, {
          method: options[ftype]
        }),
        target
      );
    }

    /**
     * Redirect to sightline/paypal deposits from quick deposit window
     * (because of angular router and the routing scheme from touch and
     * desktop being different, we use several methods to redirect users to
     * sightline/paypal ----> @HACK xD)
     *
     * 1) is in deposit? -> emit a global event to swith tabs
     *                      (from quick-deposit to deposit ctrl instance)
     * 2) is not touch?  -> use url redirects
     * 3) otherwise?     -> emit a global event to be handled by wrapper app
     *
     * @private
     */
    function _addQuickDepositFunds(ftype, newSightline) {
      var options = {
        PAY: 'Paypal',
        APPL: 'Apple Pay',
        SLN: 'Sightline'
      };
      UserActionEventsService.emit('navigatedTo', {
        url:
          'http://tvg.com/my-funds/deposit?activeTab=' +
          options[ftype].toLowerCase() +
          '+Deposit',
        name: options[ftype]
      });
      if (ftype) {
        // if is betslip,
        // show a warning explaining how to add funds in sightline
        if (_isBetSlip()) {
          _showAddFundsInBetslipWarning(ftype);
        } else {
          if (ftype === 'SLN' && !newSightline) {
            // set the redirecting flag through the SightlineSrv (like it was a
            // global variable), to be used when opening the deposit
            // screen after redirecting
            SightlineSrv.isRedirectingToSightlineAddFunds(true);
          }

          // when inside deposit routes,
          // emit a global event to be handled by depositCtrl
          // (full deposit instance)
          if (isDepositSubRoute()) {
            _closeQuickDepositModal();
            $rootScope.$emit('redirectFrom' + options[ftype] + 'UsingTabs');

            // in all environments except touch,
            // use url redirects handled by angular router
          } else if (useUrlRedirects()) {
            _closeQuickDepositModal();
            if (ftype === 'PAY') {
              _selectOption(PaypalDepositConfig, false);
            } else {
              _selectOption(SightlineDepositConfig, false);
            }

            // in mobile,
            // emit a global event to be handled by tvg4 wrapper app, that will open
            // the deposit tab from the sidebar and focus on sightline's add funds
          } else {
            // emit a global event to be handled by tvg-touch-angular project
            // this will open the deposit tab from the sidebar and focus on the method
            // add funds option
            // $rootScope.$broadcast('redirectFrom' + options[ftype], 'Deposit'); - this is not correct as it will open a modal
            $rootScope.$emit('redirectFrom' + options[ftype] + 'UsingTabs');
          }

          return;
        }
      }
    }

    /**
     * Is the user inside a deposit subroute?
     * @return {Boolean}
     */
    function isDepositSubRoute() {
      return $location.path().indexOf('my-funds/deposit') > -1;
    }

    /**
     * Can we use url to redirect users throghout the app?
     * This is true for evrything but the touch environment
     * (e.g. DMA standalone and desktop environments)
     *
     * @return {Boolean}
     */
    function useUrlRedirects() {
      return $rootScope.productContext !== 'touch2';
    }

    /**
     * Handle errors while loading sightline information to be used as
     * quick deposit option.
     * @param  {Object} error  API error
     */
    function _loadSightlineAddFundsIframeError(error) {
      var errorMessage = error.message;
      var target = _getDepositFormFirstChildSelector();
      var description;

      if (!errorMessage) {
        description = $filter('CMSValue')('depositsErrorDefault');
        errorMessage =
          '<strong>' +
          "Sightline's method of payment doesn't seem to be going" +
          ' through.</strong><br/>' +
          description;
      }

      return NotificationService.error('Error!', errorMessage, target);
    }

    function _onlyNumbers(evt) {
      var charCode = evt.which || evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    }

    function _FieldFilled(field, module) {
      if (!field.$error) {
        UserActionEventsService.emit('FieldFill', {
          field: field,
          module: module
        });
      } else {
        $timeout(function () {
          UserActionEventsService.emit('FieldFillError', {
            field: field,
            module: module
          });
        }, 200);
      }
    }

    function _selectAccount(card) {
      if (card.ftype === 'APPL') {
        ApiDepositsGTMFac.sendGTMEvent('siteClick', {
          event: 'deposit',
          gaEventCategory: 'Deposit',
          gaEventAction: 'Selected Account',
          gaEventLabel: 'Apple Pay',
          depositType: 'Apple Pay',
          module: 'Quick Deposit',
          depositAmount: $scope.depositDataModel.amount
        });
      }

      UserActionEventsService.emit('selectAccount', {
        type: card.cardType || card.bankName.trim() || card.type,
        ftype: card.ftype
      });
    }

    function _clickTooltip() {
      UserActionEventsService.emit('CreditTooltip');
    }

    function _changeCard(selected) {
      UserActionEventsService.emit('CreditChangeCard', selected);
      _resetNotification();
      _setPaymentData(selected);
      _setDepositTypeLimits(selected.type);
    }

    //
    // GTM
    //

    /**
     * Get the currently selected payment's name/identification to be
     * used in GTM
     * @return {String} Payment name
     */
    //eslint-disable-next-line
    function _getCurrentPaymentName() {
      var paymentName;
      if (_isQuickDeposit()) {
        paymentName = $scope.depositDataModel.selectedOnFile
          ? $scope.depositDataModel.selectedOnFile.typeName
          : '';
      } else {
        paymentName = $scope.depositDataModel.selectedCardType
          ? $scope.depositDataModel.selectedCardType.typeName
          : $scope.depositDataModel.depositTypeId;
      }
      return paymentName;
    }

    function _saveSuccessfulDepositOnGTM() {
      var isAchOrIbc =
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_ON_FILE ||
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_NEW;

      UserActionEventsService.emit('depositSuccess', {
        depositType: _getCurrentDepositTypeString(),
        depositAmount: $scope.depositDataModel.amount,
        amountOption: _isDefaultAmount(),
        module: _isQuickDeposit() ? 'Quick Deposit' : 'My Funds',
        isFeePaid: parseFloat($scope.data.fee.fee) > 0
      });

      if (_isDepositWithNewAccount() && isAchOrIbc) {
        UserActionEventsService.emit('SuccessfullyAddNewAccount');
      }
    }

    function _saveGTMDepositError(errorMessage) {
      var isAchOrIbc =
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_ON_FILE ||
        $scope.depositDataModel.depositTypeId === DEPOSIT_TYPES.ACH_NEW;

      UserActionEventsService.emit('depositError', {
        errorMessage: errorMessage || 'Generic Error',
        depositType: _getCurrentDepositTypeString(),
        depositAmount:
          $scope.depositDataModel.amount ||
          Utilities.prop('depositFrm.amount.$viewValue', $scope),
        amountOption: _isDefaultAmount(),
        module: _isQuickDeposit() ? 'Quick Deposit' : 'My Funds'
      });

      if (_isDepositWithNewAccount() && isAchOrIbc) {
        UserActionEventsService.emit('SuccessfullyAddNewAccount');
      }
    }

    function _addFundsGtmEvent() {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        eventLabel: 'MyFunds-SightlineAddFunds',
        gaEventCategory: 'Site Click',
        gaEventAction: 'My Funds Page Click',
        gaEventLabel: 'MyFunds | Sightline Add Funds',
        productVersion: productVersion,
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        siteVersion: siteVersion,
        accountId: DepositSrv.user.get('accountNumber')
      });
    }

    function _closeSuccessfulRegistrationModal() {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'siteClick',
        gaEventCategory: 'Site click',
        gaEventAction: 'Close',
        gaEventLabel: 'Deposit After Registration',
        module: 'Registration',
        siteVersion: siteVersion,
        productVersion: productVersion
      });
    }

    function _selectOptionGtmEvents(tabName) {
      var ga = $window.ga || Utilities.noop;

      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        eventLabel: 'My Funds-Deposits' + tabName,
        gaEventCategory: 'Site Click',
        gaEventAction: 'My Funds Page Click',
        gaEventLabel: 'My Funds | Deposits | ' + tabName,
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        productVersion: productVersion,
        siteVersion: siteVersion,
        accountId: DepositSrv.user.get('accountNumber'),
        navigationPosition: $rootScope.showLeftBar ? 'Left Nav' : 'Top Nav',
        residenceState: $rootScope.user
          ? $rootScope.user.homeAddress.StateAbbr
          : ''
      });

      ga('send', 'pageview', { title: 'Deposit| ' + tabName });
    }

    function _anyCardsExpired() {
      var disabled = false;
      var selectedCard = $scope.depositDataModel.selectedOnFile || {};
      var stored =
        $scope.data.depositSection === 'STORED' && !_isQuickDeposit();
      var creditCard = selectedCard.ftype === 'CC';
      var sightlineCardSelected = selectedCard.ftype === 'SLN';

      if (
        (_isQuickDeposit() || stored) &&
        (creditCard || sightlineCardSelected)
      ) {
        if (selectedCard.isExpired) {
          disabled = true;
        }
      }
      return disabled;
    }

    /**
     * Check if is declined card
     * @param {Object} card               Card Object
     */
    function _isSLNDeclinedCard(card) {
      var SLPDeclinedCardToggle = $rootScope.activeFeatures &&
        $rootScope.activeFeatures.showCardDeclinedModal;
      return SLPDeclinedCardToggle && card && card.network === 'VISA' && card.ftype === 'SLN';
    }

    /**
     * Check if is all declined cards in scope
     */
    function _allCardsDeclined() {
      var depositOptions = $scope.data.depositOptions ? $scope.data.depositOptions : [];
      var SLPDeclinedCardToggle = $rootScope.activeFeatures &&
        $rootScope.activeFeatures.showCardDeclinedModal;
      var isAllDeclined = SLPDeclinedCardToggle && depositOptions.length > 0 &&
        depositOptions.findIndex(function (card) {
          return (_isApplePayInQuickDepositEnabled() || card.ftype !== 'APPL') &&
           !_isSLNDeclinedCard(card);
        }) === -1;
      $scope.data.disabledCard = $scope.data.disabledCard || isAllDeclined;
      return isAllDeclined;
    }

    /* GTM triggers */

    function _registerAccountSelectionOnGTM(bankName) {
      _updateTotalCosts($scope.depositDataModel, true);
      UserActionEventsService.emit('SelectedAuthorizedAccount', bankName);
    }

    function _depositAttemptGtm() {
      UserActionEventsService.emit('attemptedDepositQuick', {
        amountOption: _isDefaultAmount(),
        cardType: $scope.depositDataModel.selectedOnFile.cardType,
        depositAmount: $scope.depositDataModel.amount,
        netDepositFee: $scope.depositDataModel.fee,
        depositType: $scope.depositDataModel.selectedOnFile.type
      });
    }

    function _sendOtherAmountErrorToGTM(errorText, data) {
      var ftype = _isQuickDeposit()
        ? 'Quick'
        : $scope.data.selectedPayOption.ftype;
      if (data) {
        errorText =
          errorText + ' ' + $filter('currency')($scope.depositDataModel[data]);
      }
      UserActionEventsService.emit(
        'AttemptToCompleteOtherAmount' + ftype,
        errorText
      );
    }

    function _completedFieldAndBlursAway(fieldName, field) {
      $timeout(function () {
        if (field.$valid) {
          UserActionEventsService.emit('CompletedFieldAndBlursAway', fieldName);
        }
      });
    }

    function _newAccountFieldError(fieldName, errorMsg) {
      UserActionEventsService.emit('NewAccountFormFieldError', {
        fieldName: fieldName,
        errorText: errorMsg
      });
    }

    //
    // VISUAL FLAGS
    //

    /**
     * Is "toggle-new-onfile" section visible for non IBC deposits?
     * @return {Boolean}
     */
    function _isNewOnFileVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isAvailable = $scope.depositDataModel.isAvailable !== false;
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';

      return (isAvailable || existsOnFile) && !isIBC;
    }

    /**
     * Is "toggle-new-onfile" section visible for IBC deposits?
     * @return {Boolean}
     */
    function _isIBCNewOnFileVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isAvailable = $scope.depositDataModel.isAvailable !== false;
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';
      var bothACHAndIBCAvailable = selectedPayOption.bothACHAndIBCAvailable;
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;

      return (
        (isAvailable || existsOnFile) &&
        isIBC &&
        bothACHAndIBCAvailable &&
        !achDepositLimitExceeded
      );
    }

    /**
     * Is deposit section visible?
     * - available payment
     * - not stored or not IBC or not exceeded
     *
     * @return {Boolean}
     */
    function _isDepositFormVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isAvailable = $scope.depositDataModel.isAvailable !== false;
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isACH = selectedPayOption.ftype === 'ACH';
      var isCC = selectedPayOption.ftype === 'CC';
      var isStored = $scope.data.depositSection === 'STORED';
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;
      var unableToFetchBankAccounts =
        (isIBC || isACH) && isStored && $scope.data.unableToFetchBankAccounts;
      var unableToFetchCardsOnFile =
        isCC && isStored && $scope.data.unableToFetchCardsOnFile;

      return (
        (isAvailable || existsOnFile || selectedPayOption.isAvailable ||
          ($rootScope.activeFeatures &&
            _.get($rootScope, 'activeFeatures.showApplePayQuickDeposit', false) &&
            $window.ApplePaySession && $window.ApplePaySession.canMakePayments())) &&
        (!isStored || !isIBC || !achDepositLimitExceeded) &&
        !unableToFetchBankAccounts &&
        !unableToFetchCardsOnFile
      );
    }

    /**
     * Is section visible?
     * - is IBC
     * - is not available
     * - is not exceeded
     *
     * @return {Boolean}
     */
    function _isIBCInvalidVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isNew = $scope.data.depositSection === 'NEW';
      var isStored = $scope.data.depositSection === 'STORED';
      var isNotValidNew = isNew && !selectedPayOption.isAvailable;
      var isNotValidStored = isStored && !existsOnFile;
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;

      return (
        isIBC && (isNotValidNew || isNotValidStored) && !achDepositLimitExceeded
      );
    }

    /**
     * Is section visible?
     * - is not IBC
     * - is available
     * - is not exceeded
     *
     * @return {Boolean}
     */
    function _isNotIBCValidVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isNew = $scope.data.depositSection === 'NEW';
      var isStored = $scope.data.depositSection === 'STORED';
      var isValidNew = isNew && selectedPayOption.isAvailable;
      var isValidStored = isStored && existsOnFile;
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;

      return (
        !isIBC || (isValidNew && !achDepositLimitExceeded) || isValidStored
      );
    }

    /**
     * Is section visible?
     * - is not calculating
     * - is pending
     * - is IBC or CC
     * @return {Boolean}
     */
    function _isPendingNotCalculatingVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var calculatingFees = $scope.data.calculatingFees;
      var isPending = $scope.depositDataModel.isPending !== true;
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isCC = selectedPayOption.ftype === 'CC';

      return !calculatingFees && isPending && (isIBC || isCC);
    }

    /**
     * Is section visible?
     * - is IBC
     * - is available
     * - is exceeded
     *
     * @return {Boolean}
     */
    function _isIBCValidExceededVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isAvailable = $scope.depositDataModel.isAvailable !== false;
      var isIBC = selectedPayOption.ftype === 'IBC';
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;

      return isAvailable && isIBC && achDepositLimitExceeded;
    }

    /**
     * Is Deposit Loaded ?
     * @return {Boolean}
     */
    function _isDepositLoaded() {
      return !$scope.data.errorLoadingData && !$scope.data.loading;
    }

    function _isAllRequestCardsFailed() {
      return (
        $scope.data.unableToFetchBankAccounts &&
        $scope.data.unableToFetchCardsOnFile &&
        $scope.data.unableToFetchPrepaidCards
      );
    }

    /**
     * Is "betcash Limit Exceeded"?
     * @return {Boolean}
     */
    function _isBetcashLimitExceeded() {
      var isAvailable = $scope.depositDataModel.isAvailable !== false;
      var isBetcash =
        Utilities.prop('depositDataModel.selectedOnFile.ftype', $scope) ===
        'ACH';
      var limitExceeded = $scope.data.achDepositLimitExceeded;
      return _isDepositLoaded() && isAvailable && isBetcash && limitExceeded;
    }

    /**
     * Is "Add New Deposit Option" visible?
     * @return {Boolean}
     */
    function _isAddNewDepositOptionsVisible() {
      var isDesktop = $rootScope.layout === 'desktop';
      var hasOptions = !!(
        $scope.data.depositOptions && $scope.data.depositOptions.length
      );
      var showAddNewDepositOptions = $scope.data.showAddNewDepositOptions;
      var hideOptions = $rootScope.hideDepositOptions;

      return (
        !isDesktop &&
        _isDepositLoaded() &&
        hasOptions &&
        showAddNewDepositOptions &&
        !hideOptions
      );
    }

    /**
     * Is the feature "paypal in quick-deposit" enabled?
     * @return {Boolean}
     */
    function _isPaypalInQuickDepositEnabled() {
      return (
        $rootScope.activeFeatures &&
        $rootScope.activeFeatures.showPaypalQuickDeposit
      );
    }

    /**
     * Is the feature "paypal in quick-deposit" enabled?
     * @return {Boolean}
     */
    function _isApplePayInQuickDepositEnabled() {
      return (
        _isQuickDeposit() &&
        $rootScope.activeFeatures &&
        $rootScope.activeFeatures.showApplePayQuickDeposit &&
        $window.ApplePaySession &&
        $window.ApplePaySession.supportsVersion(3)
      );
    }

    /**
     * Is the Quick Deposit Button Disabled?
     * @return {Boolean}
     */
    function _disableQuickDepositButton() {
      var makingDeposit = $scope.data.makingDeposit;
      var calculatingFees = $scope.data.fee.calculatingFees;
      var exists = $scope.depositDataModel.depositTypeId;
      var sightlineError =
        Utilities.prop('depositDataModel.selectedOnFile.ftype', $scope) ===
          'SLN' && $scope.quickDepositSightlineError;

      return makingDeposit || calculatingFees || !exists || sightlineError;
    }

    /**
     * Whether we're running the app in the MicroApp environment
     * @return {Boolean}
     */
    function _isDepositMicroApp() {
      return (
        $rootScope.productContext !== 'tvg4' &&
        $rootScope.productContext !== 'touch2'
      );
    }

    function _isBetSlip() {
      return $location.path().indexOf('/betslip') !== -1;
    }

    function _showNewDepositSuccessModal() {
      return $rootScope.activeFeatures &&
        $rootScope.activeFeatures.showDepositSuccessModal &&
        $scope.fromOption && $scope.fromOption.tla !== 'registration';
    }

    function _isIos() {
      return ConfigurationFac.getApplicationContextItem('product') === 'ios';
    }
    /**
     * Is sightline deposit over balance?
     * @return {Boolean}
     */
    function _sightlineBalanceExceeded() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isSLN = selectedPayOption.ftype === 'SLN';
      var overLimit =
        $scope.data.fee.transactionTotal > $scope.sightlineBalance;

      return isSLN && overLimit;
    }

    /**
     * Is section visible?
     * - is IBC
     * - is available
     * - is not exceeded
     *
     * @return {Boolean}
     */
    function _isIBCValidVisible() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var existsOnFile = $scope.events.existsOnFile();
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isNew = $scope.data.depositSection === 'NEW';
      var isStored = $scope.data.depositSection === 'STORED';
      var isValidNew = isNew && selectedPayOption.isAvailable;
      var isValidStored = isStored && existsOnFile;
      var achDepositLimitExceeded = $scope.data.achDepositLimitExceeded;

      return isIBC && (isValidNew || isValidStored) && !achDepositLimitExceeded;
    }

    /**
     * Is section visible?
     * - achNewDepositFlow toggle on
     * - failed request to fetch bank accounts
     *
     * @return {Boolean}
     */
    function _unableToFetchBankAccounts() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var unableToFetchBankAccounts =
        $scope.data.unableToFetchBankAccounts || false;
      var isStored = $scope.data.depositSection === 'STORED';
      var isIBC = selectedPayOption.ftype === 'IBC';
      var isACH = selectedPayOption.ftype === 'ACH';

      return (isIBC || isACH) && isStored && unableToFetchBankAccounts;
    }

    /**
     * Is section visible?
     * - failed request to fetch cards on file
     *
     * @return {Boolean}
     */
    function _unableToFetchCardsOnFile() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var unableToFetchCardsOnFile =
        $scope.data.unableToFetchCardsOnFile || false;
      var isStored = $scope.data.depositSection === 'STORED';
      var isCC = selectedPayOption.ftype === 'CC';

      return isCC && isStored && unableToFetchCardsOnFile;
    }

    /**
     * Is CC or Betcash and New Card
     * to only show three titles
     * @return {Boolean}
     */
    function _hasThreeTitles() {
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isBetCash = selectedPayOption.ftype === 'IBC';
      var isCC = selectedPayOption.ftype === 'CC';
      var isNewCard = $scope.data.depositSection !== 'STORED';
      return isBetCash || (isCC && isNewCard);
    }

    /**
     * Toggle all the CMS keys for the CC
     * and betcash titles
     * @return {Boolean}
     */
    function _toggleTitles() {
      var title;
      var selectedPayOption = $scope.data.selectedPayOption || {};
      var isBetCash = selectedPayOption.ftype === 'IBC';
      var isCC = selectedPayOption.ftype === 'CC';
      var isNewCard = $scope.data.depositSection === 'NEW';
      if (isBetCash) {
        title = isNewCard
          ? 'deposit-betcash-card-add-title'
          : 'deposit-betcash-cards-title';
      } else if (isCC) {
        title = isNewCard
          ? 'deposit-credit-card-add-title'
          : 'deposit-credit-cards-title';
      }
      return title;
    }

    /**
     * If is TVG3 show a paragraph and not paypal deposits
     * @return {Boolean}
     */
    function _isTVG3() {
      return (
        ConfigurationFac.getApplicationContextItem('product') === 'tvg' &&
        ConfigurationFac.getApplicationContextItem('application') === 'deposit'
      );
    }

    //
    // START MODULE
    //

    init();

    /* eslint-disable angular/on-watch */
    unbind.push(
      $rootScope.$on('reloadDeposit', function () {
        $scope.data.selectedPayOption = $rootScope.selectedPayOption;
        $scope.data.selectedCard = $rootScope.selectedCard;
        init();
      })
    );

    unbind.push(
      $rootScope.$on('sightlineUserEnrolled', function () {
        _addSightlineFunds();
        $scope.firstTimeAddFunds = true;
      })
    );

    unbind.push(
      $rootScope.$on('goToSln', function () {
        UserActionEventsService.emit('Deposit', {
          gaEventAction: 'Card Declined Redirect',
          gaEventLabel: 'Card Declined Redirect | Sightline',
          depositAmount: $scope.depositDataModel.amount,
          depositType: $scope.data.fee.fee,
          netDepositFee: _getCurrentDepositTypeString()
        });

        DepositSrv.setGoToSln(true);
        if (_isDepositMicroApp()) {
          $location.path('/deposit');
        }

        // TODO : emit to depositCtrl that we need to change to prePaidCard
      })
    );

    unbind.push(
      $rootScope.$on('redirectFromPaypalUsingTabs', function () {
        if (!_isQuickDeposit()) {
          _selectOption(PaypalDepositConfig, false);
        }
      })
    );

    unbind.push(
      $rootScope.$on('redirectFromSightlineUsingTabs', function () {
        if (!_isQuickDeposit()) {
          $scope.isAddingFunds = true;
          _selectOption(SightlineDepositConfig, false);
        }
      })
    );

    unbind.push(
      $rootScope.$on('redirectSightline-discCard', function () {
        _makeDepositInvalidCreditCardError(true);
      })
    );

    $scope.$on('$destroy', function () {
      if (invalidFormLabelTimer) {
        $timeout.cancel(invalidFormLabelTimer);
      }

      _.forEach(unbind, function (bind) {
        bind();
      });
    });

    function _slicedCard(bankAccNumber) {
      return bankAccNumber
        .toString()
        .slice(bankAccNumber.length - 4, bankAccNumber.length);
    }
    /* eslint-enable */
  }

  angular
    .module('TVG.Deposit')
    .controller('DepositController', DepositController);
}());

(function () {
  'use strict';

  WithdrawCancelDesktopController.$inject = ['$window', '$scope', 'WithdrawFac', 'SightlineSrv', '$rootScope', 'ApiWithdrawGTMFac', 'ConfigurationFac', 'Utilities', '$filter'];
  function WithdrawCancelDesktopController(
    $window,
    $scope,
    WithdrawFac,
    SightlineSrv,
    $rootScope,
    ApiWithdrawGTMFac,
    ConfigurationFac,
    Utilities,
    $filter
  ) {
    $scope.model = {
      withdrawPendingList: [],
      isLoading: true,
      errorFetchingPending: false
    };

    $scope.events = {
      cancelPendingWithdraw: _cancelPendingWithdraw
    };

    getWithdrawPendingList();

    $scope.showPendingWithdrawls = !$rootScope.activeFeatures.pawsWalletAvailable ||
      !$rootScope.shouldShowWallet;

    $scope.$on('WithdrawSuccessful::UpdatePendingRequests', function () {
      getWithdrawPendingList();
    });

    $rootScope.$on('PendingWithdrawCancelClick', function (event, withdrawId) { // eslint-disable-line
      var pendingWithdraw = _getPendingWithdraw(withdrawId);

      _sendGTMEvent('pendingWithdrawCancel', {
        eventAction: 'Cancel Withdraw button Click',
        withdrawAmount: pendingWithdraw.amount,
        withdrawType: _getBetTypeName(pendingWithdraw.paymentType)
      });
    });

    $rootScope.$on('PendingWithdrawUndoCancelClick', function (event, withdrawId) { // eslint-disable-line
      var pendingWithdraw = _getPendingWithdraw(withdrawId);

      _sendGTMEvent('pendingWithdrawCancel', {
        eventAction: 'Cancel Pending Withdraw | Cancel',
        withdrawAmount: pendingWithdraw.amount,
        withdrawType: _getBetTypeName(pendingWithdraw.paymentType)
      });
    });

    //eslint-disable-next-line
    var cancelWithdrawalMockedMessages = {
      success: 'Your withdraw has been cancelled successfully.',
      accepted: 'Almost done, it is taking a little longer to cancel your withdrawal. ',
      toteFailure: 'Almost done, it is taking a little longer to cancel your withdrawal.',
      toteUnknown: 'Almost done, it is taking a little longer to cancel your withdrawal.',
      genericFailure: 'An error occurred while trying to cancel your withdraw.'
    };

    function _getPendingWithdraw(id) {
      var i;

      if (id) {
        for (i = 0; i < $scope.model.withdrawPendingList.length; i++) {
          if (id === $scope.model.withdrawPendingList[i].withdrawalId) {
            return $scope.model.withdrawPendingList[i];
          }
        }
      }

      return {};
    }

    function _shouldShowOption(option) {
      var toggles = {
        ACH: !$rootScope.activeFeatures.pawsACH,
        VIWD: !$rootScope.activeFeatures.pawsCC,
        CHK: !$rootScope.activeFeatures.pawsCHK,
        PAY: !$rootScope.activeFeatures.pawsPAY
      };

      // eslint-disable-next-line angular/definedundefined
      return toggles[option] !== undefined && !$rootScope.isFdrApp &&
      $rootScope.activeFeatures.pawsWalletAvailable &&
      $rootScope.shouldShowWallet ? toggles[option] : true;
    }

    function _getBetTypeName(key) {
      switch (key) {
        case 'ACH':
          return 'TVG BetCash';
        case 'CHK':
          return 'Check Request';
        case 'SPL':
          return 'Sightline';
        case 'VIWD':
          return 'Debit Card';
        case 'MZM':
          return 'Online Banking';
        default:
          return '';
      }
    }

    function _sendGTMCancelWithdraw(withdrawId, success) {
      var pendingWithdraw = _getPendingWithdraw(withdrawId);
      var event = success ?
        'pendingWithdrawCancel' : 'pendingWithdrawCancelError';

      _sendGTMEvent(event, {
        success: success,
        eventName: 'WithdrawCancelled',
        eventScreenName: 'My account | Withdraw',
        eventAction: 'Cancel Pending Withdraw ' +
        (success ? 'Success' : 'Error'),
        gaEventLabel: success ? '' : 'Generic Error',
        errorType: success ? '' : 'Cancel Pending Withdraw Error',
        errorMessage: success ? '' : 'Generic Error',
        logged: true,
        withdrawAmount: pendingWithdraw.Amount,
        withdrawType: _getBetTypeName(pendingWithdraw.PaymentType)
      });
    }

    function _cancelPendingWithdraw(withdrawId) {
      var pendingWithdraw = _getPendingWithdraw(withdrawId);
      var action = _cancelGenericPendingWithdrawal;

      _sendGTMEvent('pendingWithdrawCancel', {
        eventAction: 'Cancel Pending Withdraw | Confirm',
        withdrawAmount: pendingWithdraw.amount,
        withdrawType: _getBetTypeName(pendingWithdraw.paymentType)
      });

      $scope.model.isLoading = true;

      return action(pendingWithdraw)
        .then(function (response) {
          var messagesObj = $filter('CMSValue')('cancelWithdrawalMessages');
          var messages = {};
          try {
            messages = angular.fromJson(messagesObj);
          } catch (error) {
              // Prevent test failure
          }

          if (response && response.data && response.data.status
            && response.data.status === 202) {
            $scope.$emit('onWithdrawalCancelSuccess', {});
            $scope.$broadcast('PendingWithdrawals::CancelWarning',
              { withdrawalId: withdrawId,
                message: messages && messages.accepted ? messages.accepted :
                cancelWithdrawalMockedMessages.accepted });
            $rootScope.$broadcast('accountBalance_update');
            _sendGTMCancelWithdraw(withdrawId, true);
          } else {
            if (response.succeeded) {
              $scope.$emit('onWithdrawalCancelSuccess', {});
              $scope.$broadcast('PendingWithdrawals::CancelSuccess',
                { withdrawalId: withdrawId,
                  message: messages && messages.success ? messages.success :
                cancelWithdrawalMockedMessages.success });
              $rootScope.$broadcast('accountBalance_update');
              _sendGTMCancelWithdraw(withdrawId, true);
            } else {
              $scope.$emit('onWithdrawalCancelError', {});
              $scope.$broadcast('PendingWithdrawals::CancelError',
                { withdrawalId: withdrawId,
                  message: messages && messages.genericFailure ? messages.genericFailure
                : cancelWithdrawalMockedMessages.genericFailure });
              _sendGTMCancelWithdraw(withdrawId, false);
            }
          }
        })
        .catch(function (err) {
          var messagesObj = $filter('CMSValue')('cancelWithdrawalMessages');
          var messages = {};
          try {
            messages = angular.fromJson(messagesObj);
          } catch (error) {
              // Prevent test failure
          }

          $scope.$emit('onWithdrawalCancelError', {});

          if (err && err.data && err.data.exception) {
            switch (err.data.exception) {
              case 'TOTE_DEPOSIT_FAILURE':
                $scope.$broadcast('PendingWithdrawals::CancelWarning',
                  { withdrawalId: withdrawId,
                    message: messages && messages.toteFailure ? messages.toteFailure :
                     cancelWithdrawalMockedMessages.toteFailure });
                break;
              case 'TOTE_DEPOSIT_UNKNOWN':
                $scope.$broadcast('PendingWithdrawals::CancelWarning',
                  { withdrawalId: withdrawId,
                    message: messages && messages.toteUnknow ? messages.toteUnknow :
                    cancelWithdrawalMockedMessages.toteUnknown });
                break;
              default:
                $scope.$broadcast('PendingWithdrawals::CancelError',
                  { withdrawalId: withdrawId,
                    message: messages && messages.genericFailure ? messages.genericFailure :
                    cancelWithdrawalMockedMessages.genericFailure });
                break;
            }
          } else {
            $scope.$broadcast('PendingWithdrawals::CancelError',
              { withdrawalId: withdrawId,
                message: messages && messages.genericFailure ? messages.genericFailure :
                cancelWithdrawalMockedMessages.genericFailure });
          }
          _sendGTMCancelWithdraw(withdrawId, false);
        })
        .finally(function () {
          $scope.model.isLoading = false;
        });
    }

    function _cancelGenericPendingWithdrawal(pendingWithdrawal) {
      return WithdrawFac.withdrawCancel(pendingWithdrawal.withdrawalId)
        .then(function (response) {
           // update balance
          if (response.data && response.data.balance) {
            $rootScope.$emit('accountBalance_changed', parseFloat(response.data.balance));
          }
          return { data: response, succeeded: response &&
            ((response[0] && response[0].CancellationSucceeded) ||
            response.data && response.data.hasOwnProperty('balance')) };
        });
    }

    //eslint-disable-next-line
    function _cancelSightlinePendingWithdraw(pendingWithdrawal) {
      return SightlineSrv.cancelWithdrawal(pendingWithdrawal.withdrawalId)
        .then(function () { return true; })
        .catch(function () { return false; });
    }

    function getWithdrawPendingList() {
      $scope.model.isLoading = true;
      return WithdrawFac.withdrawPendingList()
        .then(function (response) {
          var lastWithdrawalResult = $rootScope.lastWithdrawalResult;
          var updateLastWithdrawal;
          if (lastWithdrawalResult && lastWithdrawalResult.UUID) {
            updateLastWithdrawal = response.filter(function (item) {
              return item.transactionUUID === lastWithdrawalResult.UUID;
            }).length === 0;
            if (updateLastWithdrawal) {
              lastWithdrawalResult.processing = true;
              response.push(lastWithdrawalResult);
            }
          }

          $scope.model.withdrawPendingList = response.filter(function (withdraw) {
            return _shouldShowOption(withdraw.paymentType);
          });
          $rootScope.hasPendingWithdrawals = response.length > 0;
          $scope.model.withdrawPendingList.forEach(function (item) {
            item.DateInitiated = Utilities.toDateFormat('MM/DD/YYYY', item.transactionDate);
            item.amount = parseFloat(item.amount);
          });

          $scope.model.errorFetchingPending = false;
          $rootScope.lastWithdrawalResult = null;
        })
        .catch(function () {
          /* eslint-disable */
          $rootScope.hasPendingWithdrawals = false;
          /* eslint-enable */
          $scope.model.errorFetchingPending = true;
        })
        .finally(function () {
          $scope.model.isLoading = false;
        });
    }

    function _buildGTMEvent(params) {
      var p = {};
      var applicationContext = ConfigurationFac.getApplicationContextItem('application');

      if ($rootScope.user) {
        p.accountId = $rootScope.user.accountNumber;
        p.residenceState = $rootScope.user.homeAddress.StateAbbr;
      }

      p.gaEventCategory = 'Pending Withdraw';
      p.page = params.page || $window.location.pathname;
      p.gaEventAction = params.eventAction;
      p.gaEventLabel = params.withdrawType;
      p.loginStatus = !!p.accountId ? 'Logged In' : 'Logged Out';
      p.registrationStatus = 'Registered';
      p.screenName = ApiWithdrawGTMFac.isTVG4() ? 'My Account' : 'Withdraw';
      p.sectionName = ApiWithdrawGTMFac.isTVG4() ?
        'My Account | My Funds | Withdraw' :
        params.eventScreenName;
      p.siteVersion = ConfigurationFac.getSiteVersion(applicationContext);
      p.withdrawAmount = ApiWithdrawGTMFac.gtmCurrencyFormat(params.withdrawAmount);
      p.withdrawType = params.withdrawType;

      if (params.errorMessage) {
        p.errorMessage = params.errorMessage;
        p.errorType = params.errorType;
        p.gaEventAction = params.errorType;
        p.gaEventLabel = params.errorMessage;
      }

      if (p.siteVersion === 'TVG3') {
        p.screenName = 'Withdrawal';
        p.sectionName = undefined;
      }

      return p;
    }

    function _sendGTMEvent(event, params) {
      var obj = _buildGTMEvent(params);

      ApiWithdrawGTMFac.sendGTMEvent(event, obj);
    }
  }

  angular.module('TVG.Withdraw')
         .controller('WithdrawCancelDesktopController', WithdrawCancelDesktopController);
}());

(function () {
  'use strict';

  ManagePaymentMethodsController.$inject = ['$uibModal', '$q', '$scope', '$rootScope', '$timeout', '$location', '$window', '$sce', '$filter', 'DepositSrv', 'ConfigurationFac', 'CookieFac', 'ApiDepositsGTMFac', 'NotificationService', 'ManagePaymentMethodsSrv', 'DepositInitialDataFac', 'DEPOSIT_TYPES'];
  function ManagePaymentMethodsController(
    $uibModal,
    $q,
    $scope,
    $rootScope,
    $timeout,
    $location,
    $window,
    $sce,
    $filter,
    DepositSrv,
    ConfigurationFac,
    CookieFac,
    ApiDepositsGTMFac,
    NotificationService,
    ManagePaymentMethodsSrv,
    DepositInitialDataFac,
    DEPOSIT_TYPES
  ) {
    var editCardRedesignModule = (function () {
      function _performEditCard(card) {
        var accountId =
          ($rootScope.user && $rootScope.user.accountNumber) ||
          DepositSrv.accountId;
        $scope.data.loading = true;
        ManagePaymentMethodsSrv.updateCard(
          {
            bankName: card.bankName || '',
            cardID: card.id,
            ExpirationMonthYear: _buildExpirationMonthYear(
              card.expirationMonth,
              card.expirationYear
            ),
            selectedCardType: {
              cardTypeId: card.cardTypeId
            }
          },
          accountId
        )
          .then(
            function () {
              $rootScope.activePaymentMngTab =
                $scope.data.selectedPayOption &&
                $scope.data.selectedPayOption.ftype;
              NotificationService.success(
                'Success!',
                $filter('CMSValue')('managePaymentsUpdateCardsSuccess'),
                _getDepositFormFirstChildSelector()
              );

              $scope.events.resetDataModel();
              $scope.events.getPayMethodsInitialData('CC');
            },
            function () {
              // $scope.$emit('onDepositEventFailure');
              var message = $filter('CMSValue')(
                'managePaymentsUpdateCardsFailure'
              );

              NotificationService.error(
                'Error!',
                message,
                _getDepositFormFirstChildSelector()
              );

              $scope.data.loading = false;
            }
          )
          .catch(function () {
            var message = $filter('CMSValue')(
              'managePaymentsUpdateCardsFailure'
            );

            NotificationService.error(
              'Error!',
              message,
              _getDepositFormFirstChildSelector()
            );

            $scope.data.loading = false;
          });
      }

      function _getMonthAndYearFromExpirationDate(expirationDate) {
        if (!/^\d{1,2}\/\d{1,2}$/.test(expirationDate)) {
          return 0;
        }
        return {
          month: parseInt(expirationDate.split('/')[0], 10),
          year: parseInt(expirationDate.split('/')[1], 10)
        };
      }

      function _createEditCardInput(card) {
        var expirationMonthYear = _getMonthAndYearFromExpirationDate(
          card.expirationDate
        );
        card.expirationMonth = expirationMonthYear.month;
        card.expirationYear = expirationMonthYear.year;
        return card;
      }

      function _showEditCardConfirmModal(card) {
        var editCardModal;
        var modalScope = $scope.$new();
        modalScope.selectedCard = _createEditCardInput(card);

        editCardModal = $uibModal.open({
          templateUrl: 'src/templates/notification_edit_card.html',
          scope: modalScope,
          windowTemplateUrl: 'src/templates/modal-window.html',
          backdropClass: 'tvgmodal-backdrop',
          windowClass: 'account tvgmodal-dma-redesign'
        });

        editCardModal.result
          .then(function (editedCard) {
            if (editedCard) {
              _performEditCard(editedCard);
            }
          })
          .catch(function () {})
          .finally(function () {
            if (modalScope) {
              modalScope.$destroy();
            }
          });
      }

      return {
        openModal: _showEditCardConfirmModal
      };
    }());

    var removeCardRedesignModule = (function () {
      function _showRemoveCardConfirmModal(card) {
        var removeCardModal;
        var modalScope = $scope.$new();
        modalScope.selectedCard = card;
        modalScope.slicedCard = function (opt) {
          return _slicedCard(opt);
        };

        removeCardModal = $uibModal.open({
          templateUrl: 'src/templates/notification_delete_card.html',
          scope: modalScope,
          windowTemplateUrl: 'src/templates/modal-window.html',
          backdropClass: 'tvgmodal-backdrop',
          windowClass: 'account tvgmodal-dma-redesign'
        });

        removeCardModal.result
          .then(function (cardToRemove) {
            if (cardToRemove) {
              _removeCard(cardToRemove.id);
            }
          })
          .catch(function () {})
          .finally(function () {
            if (modalScope) {
              modalScope.$destroy();
            }
          });
      }

      return {
        openModal: _showRemoveCardConfirmModal
      };
    }());

    var today = new Date();

    var bankNameInfoMessages = {
      DEFAULT: '',
      ERROR: 'Please fill the bank name',
      FETCHING: 'Fetching bank name'
    };

    $scope.withPlaceholders = true;
    $scope.currentYear = parseInt($filter('date')(today, 'yy'), 10);
    $scope.currentMonth = parseInt($filter('date')(today, 'MM'), 10);

    $scope.data = {
      // Disables bank name input by default
      bankNameDisabled: true,
      // Default bank name label,
      bankNameMessage: bankNameInfoMessages.DEFAULT,
      errorBankName: false,
      numberPattern: /^[0-9]+$/,
      expirationDateValues: DepositSrv.getExpirationDateValues(),
      loading: true,
      savingCard: false,
      errorFormRestrictions: false,
      errorPaymentRestrictions: false,
      newCardForm: false,
      editCardForm: false,
      limitEditor: false,
      showLimits: true,
      showLimityTypes: {
        Credit: true,
        Debit: true,
        CreditSigned: true,
        DebitSigned: true,
        ACH: true,
        APPL: true
      },
      showLimitIntervals: { Daily: true, Monthly: true },
      limitError: false,
      limitErrorMessage: '',
      forms: ManagePaymentMethodsSrv.getPaymentForms(),
      paymentMethodsOptions: [
        {
          depositTypeId: 2,
          ftype: 'IBC',
          name: 'eCheck',
          paymentLimits: [
            {
              typeName: 'eCheck',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 4,
                  Min: 0.1,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 4,
                  Min: 0.1,
                  Effective: 0
                }
              }
            }
          ]
        },
        {
          depositTypeId: 4,
          ftype: 'CC',
          name: 'Credit/Debit Card',
          paymentLimits: [
            {
              typeName: 'Credit',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 2,
                  Min: 3,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 2,
                  Min: 3,
                  Effective: 0
                }
              }
            },
            {
              typeName: 'Debit',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 3,
                  Min: 3,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 3,
                  Min: 3,
                  Effective: 0
                }
              }
            },
            {
              typeName: 'CreditSigned',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 5,
                  Min: 3,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 5,
                  Min: 3,
                  Effective: 0
                }
              }
            },
            {
              typeName: 'DebitSigned',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 6,
                  Min: 3,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 6,
                  Min: 3,
                  Effective: 0
                }
              }
            }
          ]
        }
      ]
    };

    $scope.events = {
      resetDataModel: _resetDataModel,
      addNewCard: _addNewCard,
      editCard: _editCard,
      showEditCardConfirmModal: editCardRedesignModule.openModal,
      showRemoveCardConfirmModal: removeCardRedesignModule.openModal,
      redirectToAddNewCard: _redirectToAddNewCard,
      removeCard: _removeCard,
      editCardAction: _editCardAction,
      removeCardAction: _removeCardAction,
      editLimit: _editLimit,
      cancelLimitEdition: _cancelLimitEdition,
      validateLimitAmount: _validateLimitAmount,
      saveLimit: _saveLimit,
      subTypeCardChanged: _subTypeCardChanged,
      getPayMethodsInitialData: _getPayMethodsInitialData,
      goToDeposit: _goToDeposit,
      selectOption: _selectOption,
      slicedCard: _slicedCard,
      unableToFetchLimits: _unableToFetchLimits
    };

    function init() {
      var applePayManagement = false;

      // eslint-disable-next-line
      if (window.__TVG_GLOBALS__ && window.__TVG_GLOBALS__.FEATURE_TOGGLES) {
        // eslint-disable-next-line
        var toggles = JSON.parse(decodeURIComponent(window.__TVG_GLOBALS__.FEATURE_TOGGLES) || { featureToggles: [] }).featureToggles;
        // eslint-disable-next-line
        for (var i = 0; i < toggles.length; i++) {
          if (toggles[i].name === 'applePayPaymentManagement') {
            applePayManagement = toggles[i].enabled;
            break;
          }
        }
      }

      if (
        $scope.data.paymentMethodsOptions[0].ftype !== 'APPL' &&
        applePayManagement
      ) {
        $scope.data.paymentMethodsOptions.unshift({
          depositTypeId: 11,
          ftype: 'APPL',
          name: 'Apple Pay',
          paymentLimits: [
            {
              typeName: 'Apple Pay',
              limitInterval: {
                Daily: {
                  DepositLimitIntervalId: 2,
                  DepositLimitTypeId: 7,
                  Min: 3,
                  Effective: 0
                },
                Monthly: {
                  DepositLimitIntervalId: 4,
                  DepositLimitTypeId: 7,
                  Min: 3,
                  Effective: 0
                }
              }
            }
          ]
        });
      }
    }

    function _unableToFetchLimits() {
      return (
        $scope.data.unableToFetchLimits
      );
    }

    function _resetDepositDataModel() {
      $scope.depositDataModel = {
        cardNumber: '',
        bankName: '',
        selectedCardType: null
      };
    }

    function _resetDepositLimitModel() {
      $scope.depositLimitModel = {
        depositLimit: {},
        daily: false,
        depositLimitTypeName: '',
        amount: null,
        min: 0,
        max: 99999
      };
    }

    _resetDepositDataModel();
    _resetDepositLimitModel();

    function _resetDataModel() {
      $scope.data.loading = false;
      $scope.data.savingCard = false;
      $scope.data.errorFormRestrictions = false;
      $scope.data.errorPaymentRestrictions = false;
      $scope.data.newCardForm = false;
      $scope.data.editCardForm = false;
      $scope.data.limitEditor = false;
      $scope.data.limitError = false;

      _resetDepositDataModel();
      _resetDepositLimitModel();
    }

    function _buildExpirationMonthYear(expMonth, expYear) {
      var month =
        expMonth.toString().length === 1 ? '0' + expMonth : expMonth.toString();

      return month + '/' + expYear;
    }

    function _addNewCard(form) {
      var message;

      if (form.$valid) {
        $scope.data.loading = true;
        $scope.data.addingCard = true;

        $scope.depositDataModel.ExpirationMonthYear = _buildExpirationMonthYear(
          $scope.depositDataModel.expirationMonth,
          $scope.depositDataModel.expirationYear
        );

        ManagePaymentMethodsSrv.addCard($scope.depositDataModel).then(
          function () {
            NotificationService.success(
              'Success!',
              'Your card was successfully added.',
              _getDepositFormFirstChildSelector()
            );

            $scope.events.resetDataModel();
            $scope.events.getPayMethodsInitialData('CC');
          },
          function () {
            message =
              'We have not been able to add the card. Please try ' +
              'again if the problem persists.</br>' +
              $filter('CMSValue')('depositInitialDataErrorActionText');

            NotificationService.error(
              'Error!',
              message,
              _getDepositFormFirstChildSelector()
            );

            $scope.data.loading = false;
            $scope.data.savingCard = false;
          }
        );
      }
    }

    function _editCardAction(card) {
      $scope.data.editCardForm = true;
      $scope.depositDataModel.cardID = card.id;
      $scope.depositDataModel.cardNumber = card.cardNumberExt;
      $scope.depositDataModel.cardSecurityNumber = '';
      $scope.depositDataModel.ExpirationMonthYear = card.expirationDate;
      $scope.depositDataModel.expirationMonth = parseInt(
        card.expirationDate.split('/')[0],
        10
      );
      $scope.depositDataModel.expirationYear = parseInt(
        card.expirationDate.split('/')[1],
        10
      );
      $scope.depositDataModel.selectedCardType = {
        cardTypeId: card.cardTypeId,
        depositTypeId: card.depositTypeId,
        ftype: card.ftype,
        name: card.typeName,
        type: card.type
      };

      if ([
        'touch3',
        'ios2',
        'fdrmobile',
        'fdrios',
        'fdrandroid',
        'androidwrapper',
        'tvgandroid'
      ].indexOf($window.productContext) >= 0) {
        // prevent scroll to on ios iframe
        return;
      }

      $window.scrollTo(0, 0);
    }

    function _editCard(form) {
      var message;
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;

      if (form.$valid) {
        $scope.data.loading = true;
        $scope.data.editingCard = true;

        $scope.depositDataModel.ExpirationMonthYear = _buildExpirationMonthYear(
          $scope.depositDataModel.expirationMonth,
          $scope.depositDataModel.expirationYear
        );

        ManagePaymentMethodsSrv.updateCard($scope.depositDataModel, accountId)
          .then(
            function () {
              NotificationService.success(
                'Success!',
                $filter('CMSValue')('managePaymentsUpdateCardsSuccess'),
                _getDepositFormFirstChildSelector()
              );

              $scope.events.resetDataModel();
              $scope.events.getPayMethodsInitialData('CC');
            },
            function () {
              // $scope.$emit('onDepositEventFailure');
              message = $filter('CMSValue')('managePaymentsUpdateCardsFailure');

              NotificationService.error(
                'Error!',
                message,
                _getDepositFormFirstChildSelector()
              );

              $scope.data.loading = false;
              $scope.data.savingCard = false;
            }
          )
          .catch(function () {
            message = $filter('CMSValue')('managePaymentsUpdateCardsFailure');

            NotificationService.error(
              'Error!',
              message,
              _getDepositFormFirstChildSelector()
            );

            $scope.data.loading = false;
            $scope.data.savingCard = false;
          });
      }
    }

    function _removeCardAction(card) {
      var cardID = card.id;
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;

      NotificationService.confirm(
        'Remove Card',
        'Are you sure you want to remove this card?',
        _getDepositFormFirstChildSelector(),
        function () {
          $scope.events.removeCard(cardID, accountId);
        }
      );
    }

    function _removeCard(cardID) {
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;
      $scope.data.loading = true;
      $scope.data.savingCard = true;

      ManagePaymentMethodsSrv.removeCard(cardID, accountId)
        .then(
          function () {
            NotificationService.success(
              'Success!',
              $filter('CMSValue')('managePaymentsDeleteCardsSuccess'),
              _getDepositFormFirstChildSelector()
            );
            $scope.events.resetDataModel();
            $scope.events.getPayMethodsInitialData('CC');
          },
          function () {
            var message = $filter('CMSValue')(
              'managePaymentsDeleteCardsFailure'
            );

            NotificationService.error(
              'Error!',
              message,
              _getDepositFormFirstChildSelector()
            );

            $scope.data.loading = false;
            $scope.data.savingCard = false;
          }
        )
        .catch(function () {
          var message = $filter('CMSValue')('managePaymentsDeleteCardsFailure');

          NotificationService.error(
            'Error!',
            message,
            _getDepositFormFirstChildSelector()
          );

          $scope.data.loading = false;
          $scope.data.savingCard = false;
        });
    }

    function _editLimit(daily, depositLimit) {
      var limit;

      $scope.depositLimitModel.depositLimit = depositLimit;
      $scope.depositLimitModel.daily = daily;

      if (depositLimit) {
        $scope.depositLimitModel.depositLimitTypeName = depositLimit.typeName;

        limit = daily
          ? depositLimit.limitInterval.Daily
          : depositLimit.limitInterval.Monthly;
        $scope.depositLimitModel.amount = limit.Effective;
      }

      $scope.data.limitEditor = true;
      $scope.data.limitError = false;
    }

    function _cancelLimitEdition() {
      _resetDepositLimitModel();
      $scope.data.limitError = false;
      $scope.data.limitEditor = false;
    }

    function _validateLimitAmount() {
      var limit;
      var mapCardType = {
        Credit: 'CC',
        Debit: 'DEB',
        CreditSigned: 'CCS',
        DebitSigned: 'DEBS',
        ApplePay: 'APPL'
      };
      $scope.data.limitError = false;

      if (!$scope.depositLimitModel.amount) {
        $scope.data.limitError = true;
        $scope.data.limitErrorMessage = 'Limit amount is required';
        return;
      }

      if (isNaN($scope.depositLimitModel.amount)) {
        $scope.data.limitError = true;
        $scope.data.limitErrorMessage = 'Please, only enter numbers';
        return;
      }

      limit = $scope.depositLimitModel.daily
        ? $scope.depositLimitModel.depositLimit.limitInterval.Monthly
        : $scope.depositLimitModel.depositLimit.limitInterval.Daily;

      if (
        $scope.depositLimitModel.daily &&
        $scope.depositLimitModel.amount > limit.Effective
      ) {
        $scope.data.limitError = true;
        $scope.data.limitErrorMessage =
          'Daily limit can not be greater than monthly';
        return;
      }

      if (
        !$scope.depositLimitModel.daily &&
        $scope.depositLimitModel.amount < limit.Effective
      ) {
        $scope.data.limitError = true;
        $scope.data.limitErrorMessage =
          'Monthly limit can not be smaller than daily';
        return;
      }

      limit = $scope.depositLimitModel.daily
        ? $scope.depositLimitModel.depositLimit.limitInterval.Daily
        : $scope.depositLimitModel.depositLimit.limitInterval.Monthly;

      if ($scope.depositLimitModel.amount < limit.Min) {
        $scope.data.limitError = true;
        $scope.data.limitErrorMessage =
          'The limit has to be greater than ' + limit.Min;
      }

      //eslint-disable-next-line
      var isBetcash =
        $scope.data.selectedPayOption &&
        $scope.data.selectedPayOption.ftype &&
        ($scope.data.selectedPayOption.ftype === 'IBC' ||
          $scope.data.selectedPayOption.ftype === 'ACH');
      //eslint-disable-next-line
      var isApplePay =
        $scope.data.selectedPayOption &&
        $scope.data.selectedPayOption.ftype &&
        $scope.data.selectedPayOption.ftype === 'APPL';
      //eslint-disable-next-line
      var isCC =
        $scope.data.selectedPayOption &&
        $scope.data.selectedPayOption.ftype &&
        ($scope.data.selectedPayOption.ftype === 'CC' ||
          $scope.data.selectedPayOption.ftype === 'DEB');

      if ($scope.data.tvgLimits && isBetcash) {
        if ($scope.depositLimitModel.daily) {
          if (
            parseFloat($scope.depositLimitModel.amount) >
            parseFloat($scope.data.tvgLimits.dailyLimit)
          ) {
            $scope.data.limitError = true;
            $scope.data.limitErrorMessage =
              'Deposit limit chosen exceeds the maximum allowed';
          }
        } else if (
          parseFloat($scope.depositLimitModel.amount) >
          parseFloat($scope.data.tvgLimits.monthlyLimit)
        ) {
          $scope.data.limitError = true;
          $scope.data.limitErrorMessage =
            'Deposit limit chosen exceeds the maximum allowed';
        }
      }

      if ($scope.data.tvgLimits && (isCC || isApplePay)) {
        //eslint-disable-next-line
        var limitType =
          mapCardType[$scope.depositLimitModel.depositLimitTypeName];
        //eslint-disable-next-line
        var tvgLimit =
          limitType && $scope.data.tvgLimits[limitType]
            ? $scope.data.tvgLimits[limitType]
            : null;
        if (tvgLimit) {
          if ($scope.depositLimitModel.daily) {
            if (
              parseFloat($scope.depositLimitModel.amount) >
              parseFloat(tvgLimit.dailyLimit.depositLimit)
            ) {
              $scope.data.limitError = true;
              $scope.data.limitErrorMessage =
                'Deposit limit chosen exceeds the maximum allowed';
            }
          } else if (
            parseFloat($scope.depositLimitModel.amount) >
            parseFloat(tvgLimit.monthlyLimit.depositLimit)
          ) {
            $scope.data.limitError = true;
            $scope.data.limitErrorMessage =
              'Deposit limit chosen exceeds the maximum allowed';
          }
        }
      }
    }

    function _saveLimit() {
      var limit;
      var days;
      var futureDate;
      var isAchOrIbc;
      var isCC;
      var isApplePay;
      var limitAmounts;
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;

      if (!$scope.data.limitError) {
        $scope.data.loading = true;
        $scope.data.limitEditor = false;
        // $scope.data.savingCard = true;

        // Params: depositLimitTypeId, depositLimitIntervalId, maxLimit
        limit = $scope.depositLimitModel.daily
          ? $scope.depositLimitModel.depositLimit.limitInterval.Daily
          : $scope.depositLimitModel.depositLimit.limitInterval.Monthly;
        days =
          limit.Effective >= parseInt($scope.depositLimitModel.amount, 10)
            ? 0
            : 7;
        futureDate = moment()
          .add(days, 'd')
          .format('MM/DD/YYYY');
        // replace limit with object containing all limits if achNewDepositFlow
        isAchOrIbc =
          limit.DepositLimitTypeId === 1 || limit.DepositLimitTypeId === 4;
        isCC =
          limit.DepositLimitTypeId === 2 ||
          limit.DepositLimitTypeId === 3 ||
          limit.DepositLimitTypeId === 5 ||
          limit.DepositLimitTypeId === 6; // CCS, CC, DEB, DEBS
        isApplePay = limit.DepositLimitTypeId === 7;
        limitAmounts =
          isAchOrIbc ||
          (isCC || isApplePay)
            ? {
              daily: $scope.depositLimitModel.daily
                  ? $scope.depositLimitModel.amount
                  : null,
              weekly: null,
              monthly: $scope.depositLimitModel.daily
                  ? null
                  : $scope.depositLimitModel.amount
            }
            : $scope.depositLimitModel.amount;
        ManagePaymentMethodsSrv.updateLimit(
          limit.DepositLimitTypeId,
          limit.DepositLimitIntervalId,
          limitAmounts,
          accountId
        )
          .then(
            function () {
              var msg;
              $rootScope.activePaymentMngTab =
                $scope.data.selectedPayOption &&
                $scope.data.selectedPayOption.ftype;

              _setDepositTypeLimits();
              $scope.data.loading = false;
              $scope.data.errorPaymentRestrictions = false;
              msg =
                  'Your card limit was successfully updated.<br/> ' +
                  'The limit will be changed to ' +
                  $filter('currency')($scope.depositLimitModel.amount) +
                  ' at ' +
                  futureDate;
              NotificationService.success(
                  'Success!',
                  msg,
                  _getDepositFormFirstChildSelector()
                );
              $scope.data.message = msg;
            },
            function (data) {
              var error = data && data.response;
              var message =
                'We have not been able to update the card ' +
                'limit. Please try again if the problem persists.</br>' +
                $filter('CMSValue')('depositInitialDataErrorActionText');

              if ($scope.data.selectedPayOption.ftype === 'APPL') {
                message = $filter('CMSLabels')('applePayError', 'dmaManagementLabels') + '</br>' +
                  $filter('CMSValue')('depositInitialDataErrorActionText');
              }

              if (error && error.errorCode === 318) {
                message =
                  $filter('CMSLabels')('outOfRange', 'dmaManagementLabels') +
                  ' ' +
                  $filter('CMSValue')('depositInitialDataErrorActionText');
              }

              NotificationService.error(
                'Error!',
                message,
                _getDepositFormFirstChildSelector()
              );

              $scope.events.resetDataModel();
              $scope.data.loading = false;
            }
          )
          .then(_setDepositTypeLimits)
          .catch(function (error) {
            var message =
              'We have not been able to update the card ' +
              'limit. Please try again if the problem persists.</br>' +
              $filter('CMSValue')('depositInitialDataErrorActionText');

            if ($scope.data.selectedPayOption.ftype === 'APPL') {
              message = $filter('CMSLabels')('applePayError', 'dmaManagementLabels') + '</br>' +
                $filter('CMSValue')('depositInitialDataErrorActionText');
            }

            if (error && error.errorCode === 318) {
              message =
                $filter('CMSLabels')('outOfRange', 'dmaManagementLabels') +
                ' ' +
                $filter('CMSValue')('depositInitialDataErrorActionText');
            }

            NotificationService.error(
              'Error!',
              message,
              _getDepositFormFirstChildSelector()
            );

            $scope.events.resetDataModel();
            $scope.data.loading = false;
          });
      }
    }
    function _selectOption(opt) {
      $scope.data.selectedPayOption = opt;
      _setUserCardsOnFile();
      _setUserBankAccounts();
      NotificationService.clearBanner();
      $scope.data.limitEditor = false;

      _setDepositTypeLimits();
    }

    function _subTypeCardChanged(card) {
      $scope.depositDataModel.selectedCardType = card;
    }

    function _getBankAndCardsData(method) {
      var selectedOption;

      selectedOption = $scope.data.paymentMethodsOptions.indexOf(method);
      $scope.data.paymentMethodsOptions.map(function (item, index) {
        if (item.ftype === method) {
          selectedOption = index;
        }
        return item;
      });
      $scope.data.selectedPayOption =
        selectedOption === -1
          ? $scope.data.paymentMethodsOptions[0]
          : $scope.data.paymentMethodsOptions[selectedOption];

      _setUserBankAccounts();
      _setDepositTypeLimits();
      _setUserCardsOnFile();

      $scope.data.message = '';
      $scope.data.loading = false;
      $scope.data.errorPaymentRestrictions = false;
    }

    function _getPayMethodsInitialData(method) {
      if (
        !($rootScope.user && $rootScope.user.accountNumber) &&
        !DepositSrv.accountId
      ) {
        DepositSrv.getAccountNumber()
          .then(function () {
            $rootScope.loadedInitData = true;
            _getBankAndCardsData(method);
          })
          .catch(function (data) {
            var msg =
              'We encountered a problem. Please try again if the ' +
              'problem persists.</br>' +
              $filter('CMSValue')('depositInitialDataErrorActionText');
            if (data && data.response) {
              if (data.response.errorCode === 619) {
                msg =
                  'We encountered a problem. ' +
                  "It's required sign in the application";
              }
            }

            $scope.data.message = msg;
            $scope.data.loading = false;
            $scope.data.errorPaymentRestrictions = true;
          });
      } else {
        _getBankAndCardsData(method);
      }
    }

    function _slicedCard(bankAccNumber) {
      return bankAccNumber
        .toString()
        .slice(bankAccNumber.length - 4, bankAccNumber.length);
    }

    function _goToDeposit(card, index) {
      $rootScope.selectedPayOption =
        card.ftype === 'ACH' || card.ftype === 'IBC'
          ? $rootScope.betCashIndex
          : card.ftype;

      $rootScope.managePaymentMethodsRedirect = true;
      $rootScope.managePaymentMethodsTab = card.ftype;
      $rootScope.selectedCard = index;
      $rootScope.$broadcast('open', 'Deposit');
    }

    function _redirectToAddNewCard(option) {
      $rootScope.activeOption = undefined;
      $rootScope.dmaShowAddNewCardForm = true;
      $rootScope.managePaymentMethodsRedirect = true;
      $rootScope.managePaymentMethodsTab = option;
      $rootScope.selectedPayOption = option.toString();
      $rootScope.selectedCard = 0;
      $rootScope.$broadcast('open', 'Deposit');
    }

    /**
     * @return {string} the selector for the deposit form's first child.
     */
    function _getDepositFormFirstChildSelector() {
      return 'manage-payment-methods .tvg-deposit .before-notification';
    }

    /**
     * Set the select deposit type limits calling the method specific limit endpoint
     * @param {String} depositOptions  Initial deposit options
     * @private
     */
    function _setDepositTypeLimits() {
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;
      var depositType =
        $scope.data.selectedPayOption && $scope.data.selectedPayOption.ftype;
      var storedLimits;
      var useUwtForDepositLimitsOnDma = angular.isDefined(
        $rootScope.activeFeatures.useUwtForDepositLimitsOnDma
      ) ? $rootScope.activeFeatures.useUwtForDepositLimitsOnDma
        : false;

      if (!accountId || !depositType) {
        $scope.data.unableToFetchLimits = true;
        return {};
      }

      if (depositType === 'IBC' || depositType === 'CC' || depositType === 'APPL') {
        if (useUwtForDepositLimitsOnDma) {
          DepositSrv.getDepositLimits(accountId, depositType)
            .then(function (response) {
              processPaymentLimitsServiceResponse(response, depositType, storedLimits);
            })
            .catch(function () {
              $scope.data.unableToFetchLimits = true;
            });
        } else {
          return DepositSrv.getPaymentTypeDepositLimit(accountId, depositType)
            .then(function (response) {
              processPaymentLimitsServiceResponse(response, depositType, storedLimits);
            })
            .catch(function () {
              $scope.data.unableToFetchLimits = true;
            });
        }
      }

      return $q.defer().promise;
    }

    function processPaymentLimitsServiceResponse(response, depositType, storedLimits) {
      $scope.data.tvgLimits = {};
      if (depositType === 'IBC') {
        if (response && response.userLimits) {
          storedLimits = $scope.data.selectedPayOption.paymentLimits[0];
          if (storedLimits) {
            // set user daily limit
            storedLimits.limitInterval.Daily.Effective =
              response.userLimits && response.userLimits.dailyLimit
                ? parseFloat(response.userLimits.dailyLimit.depositLimit)
                : storedLimits.limitInterval.Daily.Effective;
            // set user weekly limit
            storedLimits.limitInterval.Weekly = {
              Effective:
                response.userLimits && response.userLimits.weeklyLimit
                  ? parseFloat(response.userLimits.weeklyLimit.depositLimit)
                  : '4000.00'
            };
            // set user monthly limit
            storedLimits.limitInterval.Monthly.Effective =
              response.userLimits && response.userLimits.monthlyLimit
                ? parseFloat(response.userLimits.monthlyLimit.depositLimit)
                : storedLimits.limitInterval.Monthly.Effective;

            storedLimits.limitInterval.Daily.ShowFuture = false;
            storedLimits.limitInterval.Monthly.ShowFuture = false;

            if (
              response.userLimits.dailyLimit.futureDate &&
              response.userLimits.dailyLimit.futureDepositLimit
            ) {
              storedLimits.limitInterval.Daily.Future =
                response.userLimits.dailyLimit.futureDepositLimit;
              storedLimits.limitInterval.Daily.FutureDateStr = moment(
                response.userLimits.dailyLimit.futureDate
              ).format('MM/DD/YYYY');
              storedLimits.limitInterval.Daily.ShowFuture = true;
            }

            if (
              response.userLimits.monthlyLimit.futureDate &&
              response.userLimits.monthlyLimit.futureDepositLimit
            ) {
              storedLimits.limitInterval.Monthly.Future =
                response.userLimits.monthlyLimit.futureDepositLimit;
              storedLimits.limitInterval.Monthly.FutureDateStr = moment(
                response.userLimits.monthlyLimit.futureDate
              ).format('MM/DD/YYYY');
              storedLimits.limitInterval.Monthly.ShowFuture = true;
            }

            $scope.data.unableToFetchLimits = false;
          }
        }

        if (response && response.tvgLimits) {
          $scope.data.tvgLimits = {
            dailyLimit: parseFloat(response.tvgLimits.dailyLimit.depositLimit),
            weeklyLimit: parseFloat(
              response.tvgLimits.weeklyLimit.depositLimit
            ),
            monthlyLimit: parseFloat(
              response.tvgLimits.monthlyLimit.depositLimit
            )
          };
        }
      }

      if (depositType === 'CC') {
        //eslint-disable-next-line
        var mapCardType = {
          CC: 'Credit',
          DEB: 'Debit',
          CCS: 'CreditSigned',
          DEBS: 'DebitSigned'
        };
        //eslint-disable-next-line
        var tvgLimits = {};
        //eslint-disable-next-line
        var newPaymentLimits = [];
        //eslint-disable-next-line
        var currentLimits = Object.assign(
          [],
          $scope.data.selectedPayOption.paymentLimits
        );

        response.cardLimits.map(function (type) {
          if (!type.limitsResponse.userLimits) {
            $scope.data.unableToFetchLimits = true;
            return {};
          }

          $scope.data.unableToFetchLimits = false;

          currentLimits.map(function (storedType) {
            if (mapCardType[type.cardType] === storedType.typeName) {
              //eslint-disable-next-line
              var userDailyLimit = type.limitsResponse.userLimits.dailyLimit;
              //eslint-disable-next-line
              var userMonthlyLimit =
                type.limitsResponse.userLimits.monthlyLimit;
              //eslint-disable-next-line
              var newStoredType = storedType;

              // set daily limits
              newStoredType.limitInterval.Daily.Effective = parseInt(
                userDailyLimit.depositLimit,
                10
              );
              newStoredType.limitInterval.Daily.ShowFuture = false;
              newStoredType.limitInterval.Monthly.ShowFuture = false;

              newStoredType.limitInterval.Daily.Future = userDailyLimit.futureDepositLimit
                ? parseInt(userDailyLimit.futureDepositLimit, 10)
                : newStoredType.limitInterval.Daily.Future;
              newStoredType.limitInterval.Daily.FutureDate = userDailyLimit.futureDate
                ? userDailyLimit.futureDate
                : newStoredType.limitInterval.Daily.FutureDate;

              if (
                userDailyLimit.futureDate &&
                userDailyLimit.futureDepositLimit
              ) {
                newStoredType.limitInterval.Daily.FutureDateStr = moment(
                  userDailyLimit.futureDate
                ).format('MM/DD/YYYY');
                newStoredType.limitInterval.Daily.ShowFuture = true;
              }

              if (
                userMonthlyLimit.futureDate &&
                userMonthlyLimit.futureDepositLimit
              ) {
                newStoredType.limitInterval.Monthly.FutureDateStr = moment(
                  userMonthlyLimit.futureDate
                ).format('MM/DD/YYYY');
                newStoredType.limitInterval.Monthly.ShowFuture = true;
              }

              // set monthly limits
              newStoredType.limitInterval.Monthly.Effective = parseInt(
                userMonthlyLimit.depositLimit,
                10
              );
              newStoredType.limitInterval.Monthly.Future = userMonthlyLimit.futureDepositLimit
                ? parseInt(userMonthlyLimit.futureDepositLimit, 10)
                : newStoredType.limitInterval.Monthly.Future;
              newStoredType.limitInterval.Monthly.FutureDate = userMonthlyLimit.futureDate
                ? userMonthlyLimit.futureDate
                : newStoredType.limitInterval.Monthly.FutureDate;
              newPaymentLimits.push(newStoredType);
            }

            return storedType;
          });

          // set tvg limits
          $scope.data.tvgLimits[type.cardType] = type.limitsResponse.tvgLimits;

          return type;
        });

        $scope.data.selectedPayOption.paymentLimits = newPaymentLimits;
      }


      if (depositType === 'APPL') {
        if (response && response.limitsUser) {
          storedLimits = $scope.data.selectedPayOption.paymentLimits[0];
          if (storedLimits) {
            // set user daily limit
            storedLimits.limitInterval.Daily.Effective =
              response.limitsEffective && response.limitsEffective.limits.dailyLimit
                ? parseFloat(response.limitsEffective.limits.dailyLimit)
                : storedLimits.limitInterval.Daily.Effective;
            // set user weekly limit
            storedLimits.limitInterval.Weekly = {
              Effective:
                response.limitsEffective && response.limitsEffective.limits.weeklyLimit
                  ? parseFloat(response.limitsEffective.limits.weeklyLimit)
                  : '100000.00'
            };
            // set user monthly limit
            storedLimits.limitInterval.Monthly.Effective =
              response.limitsEffective && response.limitsEffective.limits.monthlyLimit
                ? parseFloat(response.limitsEffective.limits.monthlyLimit)
                : storedLimits.limitInterval.Monthly.Effective;

            storedLimits.limitInterval.Daily.ShowFuture = false;
            storedLimits.limitInterval.Monthly.ShowFuture = false;

            if (
              response.limitsFuture.futureDailyDate &&
              response.limitsFuture.limits.dailyLimit
            ) {
              storedLimits.limitInterval.Daily.Future =
                response.limitsFuture.limits.dailyLimit;
              storedLimits.limitInterval.Daily.FutureDateStr = moment(
                response.limitsFuture.futureDailyDate
              ).format('MM/DD/YYYY');
              storedLimits.limitInterval.Daily.ShowFuture = true;
            }

            if (
              response.limitsFuture.futureMonthlyDate &&
              response.limitsFuture.limits.monthlyLimit
            ) {
              storedLimits.limitInterval.Monthly.Future =
                response.limitsFuture.limits.monthlyLimit;
              storedLimits.limitInterval.Monthly.FutureDateStr = moment(
                response.limitsFuture.futureMonthlyDate
              ).format('MM/DD/YYYY');
              storedLimits.limitInterval.Monthly.ShowFuture = true;
            }

            $scope.data.unableToFetchLimits = false;
          }
        }

        if (response && response.limitsTvg) {
          $scope.data.tvgLimits = {
            dailyLimit: parseFloat(response.limitsTvg.limits.dailyLimit),
            weeklyLimit: parseFloat(
              response.limitsTvg.limits.weeklyLimit
            ),
            monthlyLimit: parseFloat(
              response.limitsTvg.limits.monthlyLimit
            )
          };
        }
      }
    }

    /**
     * Set user ach accounts on file
     * @private
     */
    function _setUserCardsOnFile() {
      if ($scope.data.selectedPayOption.ftype !== 'CC') {
        return {};
      }
        //eslint-disable-next-line
        var accountId =
          ($rootScope.user && $rootScope.user.accountNumber) ||
          DepositSrv.accountId;
      if (!accountId) {
        $scope.data.unableToFetchCardsOnFile = true;
        return {};
      }
      $scope.data.fetchingInfo = true;
      DepositSrv.getCardsOnFile(accountId)
          .then(function (data) {
            var optionsOnFile = [];
            if (data.CardList && data.CardList.length > 0) {
              angular.forEach(data.CardList, function (card) {
                optionsOnFile.push({
                  groupName: 'Cards On File',
                  id: card.cardId,
                  cardNumber: card.cardNumber,
                  cardNumberExt: '************' + card.cardNumber,
                  cardTypeId: DepositInitialDataFac.getCardType(card.cardType)
                    .id,
                  limitTypeId: DepositInitialDataFac.getDepositLimitType(
                    card.cardType
                  ).id,
                  expirationDate: card.expDate,
                  isExpired:
                    moment(card.expDate, 'MM/YY').add(1, 'month') < moment(),
                  signed: card.signed,
                  name:
                    '(************' +
                    card.cardNumber +
                    ') ' +
                    card.cardType +
                    ' ' +
                    card.expDate,
                  ftype: 'CC',
                  type: DepositInitialDataFac.getCardType(card.cardType).abbr,
                  typeName: card.cardType,
                  cardType: card.cardType,
                  min: DepositInitialDataFac.getLimitType(
                    card.DepositLimitTypeId,
                    'min'
                  ),
                  max: DepositInitialDataFac.getLimitType(
                    card.DepositLimitTypeId,
                    'max'
                  ),
                  depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE
                });
              });
            }

            $scope.data.unableToFetchCardsOnFile = false;
            $scope.data.selectedPayOption.onFile = optionsOnFile;
          })
          .catch(function () {
            $scope.data.unableToFetchCardsOnFile = true;
          })
          .finally(function () {
            $scope.data.fetchingInfo = false;
          });

      return {};
    }

    /**
     * Set user ach accounts on file
     * @private
     */
    function _setUserBankAccounts() {
      var accountId =
        ($rootScope.user && $rootScope.user.accountNumber) ||
        DepositSrv.accountId;
      if (!accountId) {
        $scope.data.unableToFetchBankAccounts = true;
        return {};
      }

      if ($scope.data.selectedPayOption.ftype !== 'IBC' &&
        $scope.data.selectedPayOption.ftype !== 'ACH') {
        return {};
      }
      $scope.data.loading = true;
      return DepositSrv.getUserBankAccounts(accountId)
        .then(function (data) {
          var optionsOnFile = [];
          if (data.bankAccounts && data.bankAccounts.length > 0) {
            angular.forEach(data.bankAccounts, function (ach) {
              optionsOnFile.push({
                groupName: 'BetCash Accounts On File',
                achId: ach.id,
                bankAccNumber: ach.accountNumber,
                bankAcctType: ach.accountType,
                bankName: ach.name,
                bankRoutingNumber: ach.routingNumber,
                driversLicenseNumber: ach.dlNumber,
                driversLicenseState: ach.dlState,
                name:
                  '(*****' +
                  ach.accountNumber.substr(ach.accountNumber.length - 4) +
                  ') ' +
                  ach.name,
                ftype: 'ACH',
                type: 'ACH',
                isPending: false,
                typeName: 'BetCash',
                isAvailable: true,
                cardType: undefined,
                limitTypeId: false,
                min: false,
                max: false
              });
            });
          }

          $scope.data.unableToFetchBankAccounts = false;
          $scope.data.selectedPayOption.onFile = optionsOnFile;
        })
        .catch(function () {
          $scope.data.unableToFetchBankAccounts = true;
        })
        .finally(function () {
          $scope.data.loading = false;
        });
    }

    /**
     * Fills data object with:
     *  - States
     *  - New deposit options (NEW)
     *  - Deposit options on file (STORED)
     *  - Deposit forms object
     *
     * Sets default deposit option to the first in STORED option
     */

    if (!$rootScope.loadedInitData) {
      $scope.data.loading = true;
      $scope.events.getPayMethodsInitialData(
      $rootScope.activePaymentMngTab ? $rootScope.activePaymentMngTab : null
    );
      $scope.njxIntegration =
      ConfigurationFac.getApplicationContextItem('product') === 'njx';
    }

    init();
  }

  angular
    .module('TVG.ManagePaymentMethods')
    .controller(
      'ManagePaymentMethodsController',
      ManagePaymentMethodsController
    );
}());

(function () {
  'use strict';

  PayNearMeController.$inject = ['$scope', 'PayNearMeFac', '$sce', '$filter', 'NotificationService', 'ApiDepositsGTMFac', 'ConfigurationFac', 'DepositSrv', '$uibModal', '$templateCache', 'ModalDialogService'];
  function PayNearMeController($scope, PayNearMeFac, $sce, $filter,
                               NotificationService, ApiDepositsGTMFac,
                               ConfigurationFac, DepositSrv,
                               $uibModal, $templateCache, ModalDialogService) {
    $scope.data = {
      userPnmId: null,
      loading: true,
      showPnmIframe: false,
      orderTrackingUrl: '',
      payNearMeLogoUrl: $filter('CMSValue')('pnmLogo'),
      familyDollarLogoUrl: $filter('CMSValue')('pnmFamilyDollarLogo'),
      sevenElevenLogoUrl: $filter('CMSValue')('pnmSevenElevenLogo'),
      currentUserAccount: DepositSrv.user.get('accountNumber'),
      genericErrorMessage: $filter('CMSValue')('pnmGenericErrorMessage')
    };

    $scope.events = {
      getPayNearMeId: _getPayNearMeId,
      createPayNearMeId: _createPayNearMeId,
      toggleFaq: _toggleFaq,
      toggleLocations: _toggleLocations
    };

    function _getPayNearMeId() {
      $scope.data.loading = true;
      if (!$scope.data.currentUserAccount) {
        $scope.data.loading = false;
        _displayErrorDialog($scope.data.genericErrorMessage);
      } else {
        PayNearMeFac.getPayNearMeId($scope.data.currentUserAccount)
          .then(function (response) {
            $scope.data.userPnmId = response.data.payNearMeId;
            $scope.data.orderTrackingUrl =
              $sce.trustAsResourceUrl(response.data.orderTrackingUrl);
            $scope.data.showPnmIframe = true;
          })
          .catch(function (error) {
            if (error.status !== 404) {
              _displayErrorDialog($scope.data.genericErrorMessage);
            }
          })
          .finally(function () {
            $scope.data.loading = false;
          });
      }
    }

    function _createPayNearMeId() {
      _createGtmEvent();
      if (!$scope.data.currentUserAccount) {
        $scope.data.loading = false;
        _displayErrorDialog($scope.data.genericErrorMessage);
      } else {
        $scope.data.loading = true;

        PayNearMeFac.createPayNearMeId($scope.data.currentUserAccount)
          .then(function (response) {
            $scope.data.userPnmId = response.data.payNearMeId;
            $scope.data.orderTrackingUrl =
              $sce.trustAsResourceUrl(response.data.orderTrackingUrl);
            $scope.data.showPnmIframe = true;
          }).catch(function () {
            _displayErrorDialog($scope.data.genericErrorMessage);
          })
          .finally(function () {
            $scope.data.loading = false;
          });
      }
    }

    function _toggleFaq() {
      return ModalDialogService.openLarge(
        $filter('CMSValue')('pnmFaqTitle'),
        $filter('CMSValue')('pnmFaqTemplate')
      );
    }

    function _toggleLocations() {
      /* eslint-disable */
      $scope.locationsModal = $uibModal.open({
        template: $templateCache.get('src/templates/deposit/types/payNearMe/locations-modal.html'),
        windowTemplateUrl: 'js/common/modules/Utilities/templates/modal-window.html',
        backdropClass: 'tvgmodal-backdrop',
        windowClass: 'paynearme-locations',
        scope: $scope
      });
      /* eslint-enable */
    }

    function _displayErrorDialog(errorMessage) {
      NotificationService.error('Error', errorMessage,
        '.payNearMe__container .before-notification');
    }

    (function init() {
      _getPayNearMeId();
    }());

    /**
     * Modal $scope values
     */
    $scope.locationsTemplate = '<iframe src="' +
      $filter('CMSValue')('pnmLocationsPageUrl') + '"> </iframe>';

    $scope.closeLocationsModal = function () {
      $scope.locationsModal.close();
    };

    /**
     * GTM EVENTS
     */
    function _createGtmEvent() {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        eventLabel: 'Create PayNearMe PayCode',
        gaEventCategory: 'Site Click',
        gaEventAction: 'Deposit Click',
        gaEventLabel: 'Deposit-Click PayNearMe create pay code button ',
        productVersion:
          ApiDepositsGTMFac.getProduct(ConfigurationFac.getApplicationContextItem('product')),
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        siteVersion:
          ApiDepositsGTMFac.getSiteVersion(ConfigurationFac.getApplicationContextItem('product')),
        accountId: DepositSrv.user.get('accountNumber')
      });
    }
  }

  angular // eslint-disable-line
    .module('TVG.Deposit')
    .controller('PayNearMeCtrl', PayNearMeController);
}());

(function () {
  'use strict';

  SightlineController.$inject = ['$q', '$scope', '$rootScope', '$filter', 'DepositSrv', 'NotificationService', 'SightlineSrv', 'ApiDepositsGTMFac', 'ConfigurationFac', 'ModalDialogService'];
  function SightlineController($q,
            $scope,
            $rootScope,
            $filter,
            DepositSrv,
            NotificationService,
            SightlineSrv,
            ApiDepositsGTMFac,
            ConfigurationFac,
            ModalDialogService) {
    /**
     * Holds account info, available options, selected options and
     * interface flags
     */
    $scope.data = {
      areTermsAccepted: false,
      isEnrollingCard: false
    };

    /**
     * PUBLIC methods
     */
    $scope.events = {
      toggleSightlineTerms: _toggleSightlineTerms,
      openModals: _openModals,
      enrolCard: _enrolCard
    };

    /**
     * Set/unset sightline terms flag
     * @param  {Boolean} val  Whether the terms are accepted
     * @return {Boolean}      Value set to the terms
     */
    function _toggleSightlineTerms(val) {
      $scope.data.areTermsAccepted = val;
      return $scope.data.areTermsAccepted;
    }

    /**
     * Send GTM event when user clicks enrollment button
     */
    function _sendEnrollClickGTM() {
      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        eventLabel: 'MyFunds-SightlineEnrollmentClick',
        gaEventCategory: 'Deposit',
        gaEventAction: 'Site Click',
        gaEventLabel: 'MyFunds | Sightline Enrollment Click',
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        siteVersion: ConfigurationFac
          .getSiteVersion(DepositSrv.getApplicationContextItem('application')),
        accountId: DepositSrv.user.get('accountNumber')
      });
    }

    /**
     * Send GTM event when user enrollment is successful
     */
    function _enrollSuccessGTM() {
      ApiDepositsGTMFac.sendGTMEvent('SightlineEnrollment', {
        eventLabel: 'SightlineEnrollmentSuccess',
        gaEventCategory: 'Deposit',
        gaEventAction: 'Sightline Enrollment Success',
        gaEventLabel: 'MyFunds | Sightline Enrollment Success"',
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        siteVersion: ConfigurationFac
          .getSiteVersion(DepositSrv.getApplicationContextItem('application')),
        accountId: DepositSrv.user.get('accountNumber')
      });
    }

    /**
     * Send GTM event when user enrollment fails
     */
    function _enrollErrorGTM(errorMsg) {
      ApiDepositsGTMFac.sendGTMEvent('SightlineEnrollment', {
        eventLabel: 'SightlineEnrollmentError',
        errorType: 'Sightline Enrollment Error',
        errorMessage: errorMsg,
        gaEventAction: 'Sightline Enrollment Failed',
        gaEventCategory: 'Deposit',
        gaEventLabel: 'MyFunds | Sightline Enrollment Error',
        screenName: ApiDepositsGTMFac.tvg4ScreenName(),
        sectionName: ApiDepositsGTMFac.tvg4SectionName(),
        siteVersion: ConfigurationFac
          .getSiteVersion(DepositSrv.getApplicationContextItem('application')),
        accountId: DepositSrv.user.get('accountNumber')
      });
    }
    /**
     * Enroll user's sightline card in TVG
     * @return {Promise}
     */
    function _enrolCard() {
      var noTerms = 'You must accept terms before enrolling card.';
      var pending = 'Enrolling card request is pending.';
      var context = _getDepositFirstChildSelector();

      if (!$scope.data.areTermsAccepted) {
        NotificationService
          .error('Error!', noTerms, context);
        return $q.reject({
          code: 'missing_required_terms',
          message: noTerms
        });
      }

      if ($scope.data.isEnrollingCard) {
        NotificationService
          .error('Error!', noTerms, context);
        return $q.reject({
          code: 'pending_requests',
          message: pending
        });
      }

      _sendEnrollClickGTM();
      $scope.data.isEnrollingCard = true;
      return SightlineSrv.enrollSightlineUser($scope.data.areTermsAccepted)
        .then(function () {
          _enrollSuccessGTM();
          $rootScope.$emit('sightlineUserEnrolled');
        })
        .catch(function (error) {
          var cmsError = $filter('CMSValue')('sightlineEnrollmentFailed');
          var errorMsg = (error || {}).message || cmsError;
          NotificationService
            .error('Error!', cmsError, context);
          _enrollErrorGTM(errorMsg);
        })
        .finally(function () {
          $scope.data.isEnrollingCard = false;
        });
    }

    /**
     * Open Sightline Modals
     *
     * @param  {String} titleCMSKey  CMS key for the modal header text
     * @param  {String} bodyCMSKey   CMS key for the modal body text
     * @return {Object}
     */
    function _openModals(titleCMSKey, bodyCMSKey) {
      return ModalDialogService.openLarge(
        $filter('CMSValue')(titleCMSKey),
        $filter('CMSValue')(bodyCMSKey)
      );
    }

    /**
     * Get the current sightline context 'deposit' or 'withdraw'
     *
     * $scope.sightlineContext is inherited from the parent controller
     * (DepositCtrl.js or WithdrawCtrl.js)
     *
     * @return {String}
     */
    function _getDepositFirstChildSelector() {
      var parentContextSelector = $scope.sightlineContext || 'deposit';
      var innerElementSelector = ' .tvg-deposit';
      if (parentContextSelector === 'deposit') {
        innerElementSelector += ' .deposit-form deposit-type-selector';
      } else if (parentContextSelector === 'withdraw') {
        innerElementSelector += ' withdraw-type-selector';
      }
      return parentContextSelector + innerElementSelector;
    }
  }

  angular
      .module('TVG.Deposit')
      .controller('SightlineController', SightlineController);
}());

(function () {
  'use strict';

  TransferController.$inject = ['$q', '$scope', '$rootScope', '$timeout', '$location', '$window', '$sce', '$filter', 'TransferSrv', 'NotificationService'];
  function TransferController(
    $q,
    $scope,
    $rootScope,
    $timeout,
    $location,
    $window,
    $sce,
    $filter,
    TransferSrv,
    NotificationService) {
    function _selectSource() {
      if ($scope.transferDataModel.destination
        && $scope.transferDataModel.source.id ===
        $scope.transferDataModel.destination.id) {
        $scope.transferDataModel.destination = undefined;
      }
    }

    function _selectDestination() {
      if ($scope.transferDataModel.source
        && $scope.transferDataModel.destination.id ===
        $scope.transferDataModel.source.id) {
        $scope.transferDataModel.source = undefined;
      }
    }

    function _makeTransfer(form) {
      if (form.$valid) {
        $scope.data.loading = true;

        TransferSrv.makeTransfer({
          source: $scope.transferDataModel.source.name,
          destination: $scope.transferDataModel.destination.name,
          amount: $scope.transferDataModel.amount
        }).then(function (data) {
          var status = data && data.status || 200;
          $scope.$emit('onDepositEventSuccess');
          $rootScope.$broadcast('accountBalance_update');

          if ($scope.transferDataModel.destination.name === 'Tote' &&
            status === 202) {
            NotificationService.warning('Transfer successful!',
            $filter('CMSLabels')(202, 'exwTransferToToteMessages'),
            _getDepositFormFirstChildSelector());
          } else {
            NotificationService.success('Transfer successful!',
              'Success! Your funds have been transferred',
            _getDepositFormFirstChildSelector());
          }

          $scope.transferDataModel.amount = undefined;
          form.$setUntouched();
          form.$setPristine();
          $scope.transferDataModel.source = undefined;
          $scope.transferDataModel.destination = undefined;
          $scope.data.loading = false;
        }, function (data) {
          $scope.$emit('onDepositEventFailure');
          _transferErrorHandler(data);
          $scope.data.loading = false;
        });
      }
    }

    function _transferErrorHandler(response) {
      if (response && response.code) {
        if ($scope.transferDataModel.destination.name === 'Tote') { // To TVG
          handleTransferToTote(response.code);
        } else {
          handleTransferToExchange(response.code);
        }
      }
    }

    function handleTransferToTote(code) {
      var genericMessage = 'We have not been able to complete your transfer at this time.'
      + ' Please call customer service.';
      switch (code) {
        case 139500:
          NotificationService.warning('Unable to complete transfer!',
            $filter('CMSLabels')(code, 'exwTransferToToteMessages') ||
            $filter('CMSLabels')('generic', 'exwTransferToToteMessages') ||
            genericMessage,
            _getDepositFormFirstChildSelector());
          break;
        default:
          NotificationService.error('Unable to complete transfer!',
            $filter('CMSLabels')(code, 'exwTransferToToteMessages') ||
            $filter('CMSLabels')('generic', 'exwTransferToToteMessages') ||
            genericMessage,
            _getDepositFormFirstChildSelector());
          break;
      }
    }

    function handleTransferToExchange(code) {
      NotificationService.error('Unable to complete transfer!',
            $filter('CMSLabels')(code, 'exwTransferToExchangeMessages') ||
            $filter('CMSLabels')('generic', 'exwTransferToExchangeMessages') ||
            'We have not been able to complete your transfer at this time.'
            + ' Please call customer service.',
            _getDepositFormFirstChildSelector());
    }

    $scope.data = {
      availableAmountOptions: [25, 100, 500],
      optionsAccounts: TransferSrv.getOptionsAccounts(),
      loading: true,
      makingTransfer: false,
      errorLoadingData: undefined,
      errorDepositRestrictions: false,
      message: ''
    };

    $scope.events = {
      makeTransfer: _makeTransfer,
      selectSource: _selectSource,
      selectDestination: _selectDestination
    };

    $scope.transferDataModel = {
      isAvailable: true,
      isPending: false,
      amount: undefined,
      source: undefined,
      destination: undefined,
      min: 0,
      max: 999999999
    };

    TransferSrv.getTransferInitialData().then(function () {
      var msg = '';
      $scope.data.errorDepositRestrictions = false;
      $scope.data.loading = false;

      if (TransferSrv.failedSession()) {
        msg = $filter('CMSValue')('transferFailedSession');
        $scope.data.errorDepositRestrictions = true;
        $scope.data.message = msg;
      } else if (TransferSrv.failedContext()) {
        $scope.data.errorDepositRestrictions = true;
        msg = $filter('CMSValue')('transferInitialError');
        $scope.data.message = msg;
      } else if (TransferSrv.failedExchange()) {
        msg = $filter('CMSValue')('transferFailedExchange');
        $scope.data.message = msg;
      }
    });

    /**
     * @return {string} the selector for the deposit form's first child.
     */
    function _getDepositFormFirstChildSelector() {
      return 'transfer .tvg-deposit .deposit-form transfer-amount-input';
    }
  }

  angular.module('TVG.Transfer').controller('TransferController', TransferController);
}());

(function () {
  'use strict';

  WithdrawCancelController.$inject = ['$scope', '$rootScope', '$filter', 'WithdrawFac', 'NotificationService', 'ConfigurationFac', '$location', 'ApiWithdrawGTMFac', 'SightlineSrv', 'Utilities'];
  function WithdrawCancelController($scope, $rootScope, $filter, WithdrawFac, NotificationService,
            ConfigurationFac, $location, ApiWithdrawGTMFac, SightlineSrv, Utilities) {
    $scope.data = {
      withdrawPendingList: [],
      isLoading: false,
      rootData: $rootScope
    };

    getWithdrawPendingList();

    function _getPendingWithdraw(id) {
      var i;

      if (id) {
        for (i = 0; i < $scope.data.withdrawPendingList.length; i++) {
          if (id === $scope.data.withdrawPendingList[i].withdrawalId) {
            return $scope.data.withdrawPendingList[i];
          }
        }
      }

      return {};
    }

    function _cancelGenericPendingWithdrawal(pendingWithdrawal) {
      return WithdrawFac.withdrawCancel(pendingWithdrawal.withdrawalId)
        .then(function (response) {
          // update balance
          if (response.data && response.data.balance) {
            $rootScope.$emit('accountBalance_changed', parseFloat(response.data.balance));
          }
          return [
            (response && ((response[0] && response[0].CancellationSucceeded) ||
            response.data && response.data.hasOwnProperty('balance'))),
            response
          ];
        });
    }

    //eslint-disable-next-line
    function _cancelSightlinePendingWithdraw(pendingWithdrawal) {
      return SightlineSrv.cancelWithdrawal(pendingWithdrawal.withdrawalId)
        .then(function () { return [true]; })
        .catch(function () { return [false]; });
    }

    $scope.cancelPendingWithdraw = function (withdrawId) {
      var pendingWithdraw = _getPendingWithdraw(withdrawId);
      var action = _cancelGenericPendingWithdrawal;

      $scope.data.isLoading = true;
      return action(pendingWithdraw)
        .then(function (data) {
          var myList;
          var myObj;
          var p;
          var _withdrawType;
          var succeeded = data[0];
          var response = data[1];

          if (succeeded) {
            getWithdrawPendingList();
            $scope.$emit('onWithdrawalCancelSuccess', {});
            NotificationService
              .success('Confirmation', 'Your withdrawal has been ' +
                'cancelled and the funds are back in your account',
              _getWithdrawCancelDepositContainerSelector());
          } else {
            NotificationService
              .error('Error', 'Your withdrawal has not been cancelled',
              _getWithdrawCancelDepositContainerSelector());

            $scope.$emit('onWithdrawalCancelError', {});
          }

          if ($scope.data.rootData) {
            myList = $scope.data.withdrawPendingList;
            myObj = function () { // eslint-disable-line
              for (var prop in myList) { // eslint-disable-line
                if (myList[prop].hasOwnProperty('withdrawalId') &&
                  myList[prop].WithdrawalId === withdrawId) {
                  return myList[prop];
                }
              }
            };

            _withdrawType = 'Check';

            if (myObj()) {
              if (myObj().PaymentType === 'CHK') {
                _withdrawType = 'Check';
              } else if (myObj().PaymentType === 'ACH') {
                _withdrawType = 'Bet Cash';
              } else {
                _withdrawType = 'Direct Deposit';
              }
            }

            if ($scope.data.rootData.userSession) {
              p = {
                eventName: 'withdrawCancelled',
                eventScreenName: 'My account|Withdrawal',
                screenName: 'Home',
                accountId: $scope.data.rootData.user.accountNumber,
                accountState: $scope.data.rootData.user.homeAddress ?
                  $scope.data.rootData.user.homeAddress.StateAbbr : '',
                customerStatus: '',
                eventAction: 'Withdrawal Cancellation',
                logged: $scope.data.rootData.userSession,
                withdrawAmount: myObj() ? myObj().Amount : 0,
                withdrawType: _withdrawType
              };
            } else if ($scope.data.rootData && response &&
              response.length && response[0].userData) {
              p = {
                eventName: 'withdrawCancelled',
                eventScreenName: undefined,
                screenName: 'Withdrawal',
                accountId: response[0].userData.customerId,
                accountState: response[0].userData.homeAddress &&
                angular.fromJson(response[0].userData.homeAddress)
                  .StateAbbr ?
                  angular.fromJson(response[0].userData.homeAddress)
                    .StateAbbr : '',
                customerStatus: '',
                eventAction: 'Withdrawal Cancellation',
                logged: 'Logged In',
                withdrawAmount: myObj() ? myObj().Amount : 0,
                withdrawType: _withdrawType,
                siteVersion: 'TVG3'
              };
            }

            if (p) {
              sendGTMCancellationEvent(p);
            }
          }
        })
        .catch(function () {
          NotificationService.error('Error',
            'Your withdrawal has not been cancelled',
            _getWithdrawCancelDepositContainerSelector());
          $scope.$emit('onWithdrawalCancelError', {});
        });
    };

    function getWithdrawPendingList() {
      $scope.data.isLoading = true;
      return WithdrawFac.withdrawPendingList()
        .then(function (response) {
          if (response) {
            $scope.data.withdrawPendingList = response;
            response.forEach(function (item) {
              item.DateInitiated = Utilities.toDateFormat('MM/DD/YYYY', item.transactionDate);
            });
          }
        })
        .catch(function () {
          $scope.data.errorFetchingPending = true;
        })
        .finally(function () {
          $scope.data.isLoading = false;
        });
    }

    function sendGTMCancellationEvent(params) {
      var p = {};
      p.event = params.eventName;
      p.accountId = params.accountId;
      p.residenceState = params.accountState;
      p.customerStatus = '';
      p.gaEventCategory = 'Withdraw';
      p.gaEventAction = params.eventAction;
      p.gaEventLabel = params.withdrawType;
      p.loginStatus = 'Logged In';
      p.registrationStatus = 'Registered';
      p.screenName = params.screenName;
      p.sectionName = params.eventScreenName;
      p.siteVersion = params.siteVersion ? params.siteVersion : 'mobile_web';
      p.withdrawAmount = ApiWithdrawGTMFac
        .gtmCurrencyFormat(params.withdrawAmount);
      p.withdrawType = params.withdrawType;

      ApiWithdrawGTMFac.sendGTMEvent(null, p);
    }

    /**
     * @return {string} the selector for the withdraw cancel deposit container.
     */
    function _getWithdrawCancelDepositContainerSelector() {
      return 'withdraw-cancel .tvg-deposit .before-notification';
    }
  }

  angular.module('TVG.Withdraw').controller('WithdrawCancelController', WithdrawCancelController);
}());

(function () {
  'use strict';

  WithdrawController.$inject = ['$rootScope', '$scope', '$filter', '$sce', '$window', '$q', 'WithdrawFac', 'ConfigurationFac', '$location', 'ApiWithdrawGTMFac', 'NotificationService', 'SightlineSrv', 'UserFactory', 'Utilities', 'FeedbackFac', 'paypalService', 'DepositSrv', 'DepositInitialDataFac', 'DEPOSIT_TYPES'];
  function WithdrawController(
    $rootScope,
    $scope,
    $filter,
    $sce,
    $window,
    $q,
    WithdrawFac,
    ConfigurationFac,
    $location,
    ApiWithdrawGTMFac,
    NotificationService,
    SightlineSrv,
    UserFactory,
    Utilities,
    FeedbackFac,
    paypalService,
    DepositSrv,
    DepositInitialDataFac,
    DEPOSIT_TYPES
  ) {
    var productVersion = ApiWithdrawGTMFac.getProduct(
      ConfigurationFac.getApplicationContextItem('product')
    );
    var device = ConfigurationFac.getApplicationContextItem('device');
    var firstWithdraw;
    var sightlineIframeUrl = ConfigurationFac.getSightline('iframeURL');
    var unbind = [];
    var paymentMethodsNoAddress = ['SLN', 'PAY'];
    var paymentsThreeColumns = ['SLN'];

    var standardWithdrawTypes = {
      ach: 'ACH',
      betcash: 'ACH',
      check: 'CHK',
      sln: 'SLP',
      slp: 'SLP',
      pay: 'PAY',
      debit_card: 'DEB',
      debit: 'DEB'
    };

    var initialTab = $location.search().initialTab;

    var isNative = false;
    if ($rootScope.product) {
      isNative = $rootScope.product.indexOf('native') !== -1;
    }

    /**
     * Holds account info, available options, selected options and
     * interface flags
     */
    $scope.data = {
      withdrawOptions: [],
      cardsOnFile: [],
      fetchedCardsOnFile: false,
      availableCheckOptions: [],
      availableBetCashAccounts: [],
      accountId: 0,
      balance: 0,
      availableBalance: 0,
      forms: WithdrawFac.getForms(),
      selectedWithdrawOption: {},
      selectedAddressSection: {},
      selectedBetCashAccount: {},
      selectedCardOnFile: {},
      isLoading: true, // Show loading indicator
      errorFetchingData: false,
      minWithdraw: 2,
      numberPattern: /^\d*([.]?\d+)$/,
      user: UserFactory.build(), // default empty,
      slnIframeURL: $sce.trustAsResourceUrl(sightlineIframeUrl),
      providerEmail: undefined,
      pageSetFromParams: false
    };

    $scope.sightlineContext = 'withdraw';

    $scope.njxIntegration = ConfigurationFac.getApplicationContextItem('product') === 'njx';
    $scope.isDesktop = device === 'desktop' && ($rootScope.product === 'ios2' || isNative
      || $rootScope.product === 'androidwrapper' || $rootScope.product === 'tvgandroid') ? false
      : device === 'desktop';

    $scope.showPendingWithdrawals = ($rootScope.layout === 'desktop' &&
      $rootScope.activeFeatures.showPendingWithdrawals) ||
      $scope.njxIntegration;

    /**
     * PUBLIC methods
     */
    $scope.events = {
      toggleHomeMailMethods: _toggleHomeMailMethods,
      toggleWithdrawOptions: _toggleWithdrawOptions,
      setCurrentBetCash: _setCurrentBetCash,
      setCurrentCardOnFile: _setCurrentCardOnFile,
      withdraw: _withdraw,
      // canWithdraw: _canWithdraw,
      changeAmount: _changeAmount,
      initDropdown: _initDropdown,
      started: _started
    };

    $scope.displays = {
      isSightlineApiEnrollmentVisible: _isSightlineApiEnrollmentVisible
    };

    /**
     * Withdraw data model
     */
    $scope.withdrawDataModel = {
      amount: '',
      locationId: -1,
      started: false
    };

    firstWithdraw = null;

    function getWithdrawType(type) {
      if (type) {
        return standardWithdrawTypes[type.toLowerCase()];
      }
      return '';
    }

    function _started() {
      var type;
      if (!$scope.withdrawDataModel.started) {
        type = getWithdrawType($scope.data.selectedWithdrawOption.id);
        _sendGTMEvent('withdrawal', {
          eventName: 'widthdrawal',
          eventAction: 'Withdrawal Started',
          logged: true,
          depositType: type,
          module: 'Withdrawal'
        });
        $scope.withdrawDataModel.started = true;
      }
    }

    function _changeAmount(dirty, valid) {
      if (firstWithdraw && dirty && valid) {
        _sendGTMEvent('withdrawStart', {
          eventName: 'withdrawStart',
          eventScreenName: 'My account|Withdrawal',
          gaEventLabel: '',
          eventAction: 'Withdraw Start',
          logged: true,
          withdrawAmount: $scope.withdrawDataModel.amount,
          withdrawType: $scope.data.selectedWithdrawOption &&
            $scope.data.selectedWithdrawOption.name ?
              $scope.data.selectedWithdrawOption.name :
              ''
        });

        firstWithdraw = false;
      }
    }

    /**
     * If is TVG3 show a paragraph and not paypal deposits
     * @return {Boolean}
     */
    function _isTVG3() {
      return ConfigurationFac.getApplicationContextItem('product') === 'tvg' &&
        ConfigurationFac.getApplicationContextItem('application') === 'deposit';
    }

    $scope.payPalTVG3 = function () {
      return _isTVG3() && $scope.data.selectedWithdrawOption.id === 'PAY';
    };

    $scope.payPalNJX = function () {
      return ConfigurationFac.getApplicationContextItem('product') === 'njx' &&
        $scope.data.selectedWithdrawOption.id === 'PAY';
    };

    $scope.showAddressForPayment = function () {
      return paymentMethodsNoAddress.indexOf($scope.data.selectedWithdrawOption.id) > -1;
    };

    $scope.showThreeColumns = function () {
      return paymentsThreeColumns.indexOf($scope.data.selectedWithdrawOption.id) > -1 ||
        ($scope.data.selectedWithdrawOption.id === 'PAY' && !$scope.data.providerEmail);
    };

    $scope.useDebitCardLimit = function (option) {
      return $scope.data.selectedWithdrawOption === option &&
        (option.max < $scope.data.availableBalance ||
          !$scope.data.availableBalance);
    };

    $scope.getMaxWithdrawValue = function () {
      var option;
      if ($rootScope.activeFeatures.limitWithdrawDebitCard) {
        option = _.find($scope.data.withdrawOptions, function (withdrawOption) {
          return withdrawOption.id === 'DEBIT_CARD';
        });
        if ($scope.useDebitCardLimit(option)) {
          return option.max;
        }
      }
      return $scope.data.availableBalance;
    };


    $scope.getInvalidWithdrawalMessage = function (input, min) {
      var message = 'Invalid amount.';
      var minAmount = $filter('CMSLabels')('amountLowerError', 'withdrawLabels');
      var option;
      if (input.$error.max) {
        message = $filter('CMSLabels')('amountGreaterError', 'withdrawLabels');
        if ($rootScope.activeFeatures.limitWithdrawDebitCard) {
          option = _.find($scope.data.withdrawOptions, function (withdrawOption) {
            return withdrawOption.id === 'DEBIT_CARD';
          });
          if ($scope.useDebitCardLimit(option)) {
            message = $filter('CMSLabels')('amountGreaterDebitCardLimit', 'withdrawLabels');
          }
        }
      }

      if (input.$error.min) {
        message = Utilities.supplant(minAmount, {
          minAmount: $filter('currency')(min)
        });
      }

      return message;
    };

    $scope.$on('accountBalance_update', function () {
      _updateBalance();
      if (isNative) {
        if ($window && $window.handleNativeMessages) {
          $window.handleNativeMessages('UPDATE_BALANCE');
        }
      }
    });

    //eslint-disable-next-line
    function _isAchRestricted(achAccounts) {
      return achAccounts.length === 0;
    }

    function _isCheckRestricted() {
      // TODO: implement logic to validate if check is restricted
      return false;
    }

    function _selectOption(opt) {
      var types = {
        SLN: handleSightline,
        DEBIT_CARD: handleDebitCard
      };
      var type = getWithdrawType(opt.id);

      $scope.data.selectedWithdrawOption = opt;

      _sendGTMEvent('withdrawal', {
        eventName: 'withdrawal',
        eventAction: 'Withdrawal Type Selected',
        eventCategory: 'Withdrawal',
        gaEventLabel: type,
        module: 'Withdrawal'
      });

      if (opt.id === 'BETCASH') {
        _setUserBankAccounts();
      }
      return types[opt.id] && types[opt.id]();
    }

    function _shouldShowOption(option) {
      var toggles = {
        BETCASH: !$rootScope.activeFeatures.pawsACH,
        DEBIT_CARD: !$rootScope.activeFeatures.pawsCC,
        CHECK: !$rootScope.activeFeatures.pawsCHK,
        PAY: !$rootScope.activeFeatures.pawsPAY
      };

      // eslint-disable-next-line angular/definedundefined
      return toggles[option] !== undefined && !$rootScope.isFdrApp &&
      $rootScope.activeFeatures.pawsWalletAvailable &&
      $rootScope.shouldShowWallet ? toggles[option] : true;
    }


    /**
     * Update models with withdraw initial data
     */
    function _getInitialData() {
      var cms = $filter('CMSValue');
      var currency = $filter('currency');

      return WithdrawFac.getWithdrawalProfile()
        .then(function (withdrawResponse) {
          var accountNumber = withdrawResponse.accountNumber ||
            WithdrawFac.getPlainAccountId();

          SightlineSrv.setInfo(accountNumber);

          return paypalService
            .getAccountInfo(accountNumber)
            .then(function (paypalResponse) {
              return [withdrawResponse, paypalResponse];
            }).catch(function () {
              return [withdrawResponse, {}];
            });
        })
        .then(function (response) {
          return handleSightline()
            .then(function () {
              return response;
            }).catch(function () {
              return response;
            });
        })
        .then(function (response) {
          var data = response[0];
          var paypalData = response[1];
          var cmsOptions;
          var cmsConfig = Utilities.attempt(function () {
            return angular.fromJson(cms('depositWidthrawAvailableOptions'));
          }, function () {
            return [];
          });

          if (
            $rootScope.activeFeatures.hideSightlineIfNotEnrolled &&
            !$scope.data.hasSightlineAccount
          ) {
            cmsConfig = cmsConfig.filter(function (value) { return value !== 'SLN'; });
          }

          cmsOptions = WithdrawFac.getWithdrawOptions(cmsConfig);

          $scope.data.unableToFetchProfile = false;

          if (data.failure) {
            $scope.data.unableToFetchProfile = true;
            $scope.data.availableBalance = data.response.availableBalance;
            $scope.data.balance = currency(data.response.toteBalance, '$');
          }

          // Paypal tab should only appear if user has made a paypal account
          cmsOptions = cmsOptions.filter(function (method) {
            return (method && method.id && method.id !== 'PAY' || paypalData && paypalData.payerId);
          });

          if (_isCheckRestricted()) {
            cmsOptions = cmsOptions.filter(function (method) {
              return method.id !== 'CHECK';
            });
          }

          //eslint-disable-next-line
          var locationTypes = [];

          if (data && data.homeAddress && data.mailingAddress) {
            locationTypes = [{
              id: 0,
              name: 'Residential Address',
              code: 'RESIDENTIAL',
              address:
          [data.homeAddress.streetNumber, data.homeAddress.address1, data.homeAddress.address2,
            data.homeAddress.city, data.homeAddress.state, data.homeAddress.zipCode]
            .join(' ').replace(/\s{2,}/g, ' ') // remove double whitespace, incase address2 is empty
            },
            {
              id: 1,
              name: 'Mailing Address',
              code: 'MAILING',
              address: [data.mailingAddress.streetNumber, data.mailingAddress.address1,
                data.mailingAddress.address2,
                data.mailingAddress.city, data.mailingAddress.state, data.mailingAddress.zipCode]
            .join(' ').replace(/\s{2,}/g, ' ') // remove double whitespace, incase address2 is empty
            }];
          }

          $scope.data.availableCheckOptions = _.filter(locationTypes, function (location) {
            return location.address !== '' && location.address.trim() !== '';
          });
          $scope.data.withdrawOptions = $scope.data.withdrawOptions.concat(cmsOptions)
          .filter(function (option) {
            return _shouldShowOption(option.id);
          });

          $scope.data.showingFallback = !$scope.data.withdrawOptions.length;
          if ($scope.data.withdrawOptions.length > 0) {
            $scope.data.withdrawOptions.forEach(function (item) {
              item.qalabel = item.name.replace(/ /g, '') + 'Tab';
            });
          }

          // Update account info
          if (data && !data.failure) {
            $scope.data.availableBalance = data.availableBalance;
            $scope.data.balance = currency(data.toteBalance, '$');
            $scope.data.user = UserFactory.build(data);
          }
          $scope.data.accountId = data.accountNumber ||
            WithdrawFac.getPlainAccountId();
          // Update available options and sets a default one
          if (initialTab) {
            _setInitalConfigFromParam();
            _initDropdown('CHECK');
          } else {
            $scope.data.selectedWithdrawOption = $scope.data.withdrawOptions[0];
            $scope.data.selectedAddressSection = {};
            $scope.withdrawDataModel.locationId = -1;
          }
          $scope.data.minWithdraw = parseFloat(cms('minWithdrawAmount')) || 2;
          $scope.data.providerEmail = _.get(paypalData, 'email');

          _sendGTMEvent('ga_pageload', {
            accountId: $scope.data.accountId,
            page: $window.location.pathname,
            privateBrowser: localStorage.getItem('privateMode') === 'true' ? 'Yes' : 'No',
            productVersion: productVersion,
            screenName: 'Withdrawal',
            sectionName: 'Withdrawal',
            appVersion: $rootScope.appVersion,
            eventName: 'ga_pageload',
            eventScreenName: 'My account|Withdrawal',
            customerStatus: '',
            eventAction: 'Withdrawal Page Load',
            logged: $scope.data.user.has('accountNumber'),
            module: 'Withdrawal'
          });
        })
        .then(_setUserBankAccounts)
        .then(_setUserCardsOnFile)
        .then(function () {
          var slnOption = $scope.data.withdrawOptions.filter(function (option) {
            return (option.id === 'SLN');
          });

          if (slnOption.length && $scope.fromOption === 'SLN') {
            _toggleWithdrawOptions(slnOption[0]);
          }
        })
        .catch(function () {
          _sendGTMEvent(null, {
            eventName: 'withdrawalError',
            eventScreenName: 'My account|Withdrawal',
            customerStatus: '',
            eventAction: 'Withdrawal Error',
            logged: $scope.data.user.has('accountNumber'),
            withdrawAmount: '',
            withdrawType: '',
            errorType: 'Withdrawal Error',
            errorMessage: 'Failed to load necessary withdrawal data from server.',
            module: 'Withdrawal'
          });

          $scope.data.errorFetchingData = true; // Show error
        })
        .finally(function () {
          if ($scope.data.selectedWithdrawOption.id !== 'DEBIT_CARD') {
            $scope.data.isLoading = false; // Hide loading indicator
          }
        });
    }

    function handleSightline() {
      if ($scope.data.unableToFetchProfile) {
        return {};
      }
      $scope.data.sightlineAccount = SightlineSrv.createSightlineAccount($scope.data.user);

      $scope.sightlineLoading = true;
      return SightlineSrv
        .isSightlineUser($scope.data.sightlineAccount)
        .then(function (user) {
          $scope.data.hasSightlineAccount = user.enrolled || user.exists;
          $scope.data.sightlineAccount.last4SSN = user.last4SSN || '0000';

          return (!user.enrolled);
        })
        .finally(function () {
          $scope.sightlineLoading = false;
        });
    }

    function handleDebitCard() {
      if (!$scope.data.fetchedCardsOnFile) {
        $scope.data.isLoading = true;
      }
    }

    /**
     * Toggles between Residential and Mail CHECK types
     * @param method
     * @private
     */
    function _toggleHomeMailMethods(method) {
      $scope.withdrawDataModel.locationId = method && method.id;
      $scope.data.selectedAddressSection = method;
    }

    function _resetNotification() {
      NotificationService.clearBanner();
    }

    /**
     * Toggles between CHECK and BetCash options
     * @param option - current option
     * @private
     */
    function _toggleWithdrawOptions(option) {
      var amount = $scope.withdrawDataModel.amount;
      var i;
      _resetNotification();

      $scope.data.selectedWithdrawOption = option;
      $scope.withdrawDataModel = {
        amount: amount
      };

      if ($scope.data.withdrawOptions &&
        $scope.data.withdrawOptions.length) {
        for (i = 0; i < $scope.data.withdrawOptions.length; i++) {
          if (option.id === $scope.data.withdrawOptions[i].id) {
            $scope.withdrawDataModel.locationId = $scope.data.selectedAddressSection.id;
          }
        }
      }

      _selectOption(option);
    }

    /**
     * Updates selected betCash account and update withdraw data model
     * @param betCashAccount - selected betCash option
     * @private
     */
    function _setCurrentBetCash(betCashAccount) {
      $scope.data.selectedBetCashAccount = betCashAccount;
      $scope.withdrawDataModel.betCashId = betCashAccount && betCashAccount.achId;

      // Useful for emitting messages
      $scope.withdrawDataModel.bankName = betCashAccount && betCashAccount.bankName;
    }

    /**
     * Select credit for withdraw
     * @param card
     * @private
     */
    function _setCurrentCardOnFile(card) {
      if (card && card.id) {
        $scope.data.selectedCardOnFile = card;
        $scope.withdrawDataModel.ccid = card.id;
      }
    }

    /**
     * Withdraw type chooser
     *
     * @param {Object}  form
     * @param {Boolean} form.$valid  Is form valid?
     * @private
     */
    function _withdraw(form) {
      var option = $scope.data.selectedWithdrawOption.id;
      var options = {
        BETCASH: _withdrawBetCashNewFlow,
        DEBIT_CARD: _withdrawDebitCard,
        CHECK: _withdrawCheck,
        SLN: _withdrawSightlineNewFlow,
        PAY: _withdrawPaypal
      };
      var depositType = getWithdrawType($scope.data.selectedWithdrawOption.id);
      var withdrawMethod = options[option];
      var label;
      var formAmount;
      var newAmount;
      if (form && form.amount && form.amount.$viewValue) {
        formAmount = form.amount.$viewValue;
      }
      if (form && form.newAmount && form.newAmount.$viewValue) {
        newAmount = form.newAmount.$viewValue;
      }

      _sendGTMEvent('withdrawal', {
        eventName: 'withdrawal',
        eventAction: 'Withdrawal Attempt',
        depositType: depositType,
        module: 'Withdrawal'
      });

      if ($scope.data.selectedWithdrawOption.id === 'DEBIT_CARD'
        && $scope.data.cardsOnFile.length === 0) {
        _sendGTMEvent(null, {
          eventName: 'withdrawal',
          customerStatus: '',
          eventAction: 'Withdrawal Error',
          logged: true,
          gaEventLabel: 'No Eligible visa debit on file',
          depositAmount: formAmount || newAmount,
          depositType: depositType,
          module: 'Withdrawal'
        });
      }
      if (!form.$valid) {
        label = _.get(document.querySelector('.js-error-label'), 'innerText', ''); //eslint-disable-line
        _sendGTMEvent(null, {
          eventName: 'withdrawal',
          customerStatus: '',
          eventAction: 'Withdrawal Error',
          logged: true,
          gaEventLabel: label,
          depositAmount: formAmount || newAmount,
          depositType: depositType,
          module: 'Withdrawal'
        });

        FeedbackFac.scrollIntoFirstError();
      } else {
        firstWithdraw = true;
        $scope.data.isLoading = true;

        return withdrawMethod()
          .then(function (withdrawalResult) {
            _updatePendingWithdrawals(withdrawalResult);
          })
          .then(function () {
            _clearAmount(form);
          })
          .then(function () {
            if (option === 'BETCASH') { _setUserBankAccounts(); }
          })
          .finally(function () {
            $scope.data.isLoading = false;
          });
      }

      return null;
    }

    function _clearAmount(form) {
      $scope.data.selectedBetCashAccount = undefined;
      $scope.withdrawDataModel.amount = null;
      if (form.$dirty) {
        form.$setUntouched();
        form.$setPristine();
      }
    }

    /**
     * Init the dropdown and set the first value in it
     * to the defaukt value so that an empty option is not created
     * @param {String}  Name of withdraw option
     * @public
     */

    function _initDropdown(option) {
      var i = 0;
      var checkOptionArray;
      var checkOption;
      var paramPaymentId;
      var cardFromParamsFound;
      var paramPaymentAddress;
      var paramAchId;
      var betCashAccountFromParam;

      switch (option) {
        case 'BETCASH':
          paramAchId = $location.search().paymentId;
          if ($scope.data.pageSetFromParams && paramAchId) {
            betCashAccountFromParam = $scope.data.availableBetCashAccounts.find(
              function (account) {
                return account.achId.toString() === paramAchId;
              }
            );
            if (betCashAccountFromParam) {
              _setCurrentBetCash(betCashAccountFromParam);
            }
          }

          if (!betCashAccountFromParam) {
            _setCurrentBetCash($scope.data.availableBetCashAccounts[0]);
          }
          break;
        case 'CHECK':
          paramPaymentAddress = _.get(
            $location.search(),
            'paymentId',
            ''
          ).toUpperCase();
          checkOptionArray = _.get($scope, 'data.availableCheckOptions', []);
          checkOption = checkOptionArray[0];

          for (i; i < checkOptionArray.length; i++) {
            if (checkOptionArray[i].code === 'MAILING') {
              checkOption = checkOptionArray[i];
              if (!$scope.data.pageSetFromParams) {
                break;
              }
            }
            if (
              $scope.data.pageSetFromParams &&
              paramPaymentAddress &&
              checkOptionArray[i].code === paramPaymentAddress
            ) {
              checkOption = checkOptionArray[i];
              break;
            }
          }
          _toggleHomeMailMethods(checkOption);
          break;
        case 'DEBIT_CARD':
          paramPaymentId = $location.search().paymentId;

          if ($scope.data.pageSetFromParams && paramPaymentId) {
            cardFromParamsFound = $scope.data.cardsOnFile.find(function (card) {
              return card.id.toString() === paramPaymentId;
            });
            if (cardFromParamsFound) {
              _setCurrentCardOnFile(cardFromParamsFound);
            }
          }

          if (!cardFromParamsFound) {
            _setCurrentCardOnFile($scope.data.cardsOnFile[0]);
          }
          break;
        default:
          break;
      }
    }

    /**
     * Withdraws using Check type
     * @private
     */
    function _withdrawCheck() {
      var msg = $filter('CMSLabels')('withdraw-check-success', 'dmaDepositLabels');
      var locationId = $scope.withdrawDataModel.locationId;
      var message = $filter('CMSLabels')('no-address', 'dmaDepositLabels');

      if (_.isNumber(locationId) && locationId !== -1) {
        return WithdrawFac.withdrawCheck(
          $scope.withdrawDataModel.amount,
          $scope.data.accountId,
          _.get($scope, 'data.selectedAddressSection.code', '')
        )
        .then(function (response) {
          var data = response.data;
          var serviceErrorMessage = _.get(response, 'data.message', '');
          if (response.status === 200) {
            if (response.data && response.data.balance) {
              $rootScope.$emit('accountBalance_changed', parseFloat(response.data.balance));
            }

            notifyWithdrawSuccess({
              type: 'check',
              message: Utilities.supplant(msg, {
                amount: $filter('currency')($scope.withdrawDataModel.amount)
              })
            });

            return {
              DateInitiated: moment(data.checkWithdrawalDetails.transactionDate).format('MM/DD/YYYY'),
              amount: parseFloat(data.checkWithdrawalDetails.amount),
              paymentType: 'CHK',
              transactionDate: data.checkWithdrawalDetails.transactionDate,
              transactionUUID: data.checkWithdrawalDetails.UUID,
              withdrawalId: data.checkWithdrawalDetails.UUID
            };
          }
          notifyWithdrawFailure({ type: 'check', serviceErrorMessage: serviceErrorMessage });
          return {};
        })
        .catch(function (response) {
          var serviceErrorMessage = _.get(response, 'data.message', '');
          return notifyWithdrawFailure({
            type: 'check',
            logged: response && (
              response.errorMessage &&
              response.errorMessage === 'ApiMissingUserSessionToken' ||
              response.errorMessage === 'ApiUserSessionTimedOut' ||
              response.errorMessage === 'ApiUserSessionNotFound'
            ),
            serviceErrorMessage: serviceErrorMessage
          });
        });
      }

      return NotificationService.error('Error!', message,
          _getWithdrawDepositContainerFirstChildSelector());
    }

    /**
     * Withdraws using Sightline New Flow
     * @private
     */
    function _withdrawSightlineNewFlow() {
      var option = $scope.data.selectedWithdrawOption.id;
      var msg = $filter('CMSLabels')('withdraw-sightline-success', 'dmaDepositLabels');
      option = option === 'SLN' ? 'SLP' : option;
      return SightlineSrv
          .transferToSightline($scope.withdrawDataModel.amount)
          .then(function (data) {
            if (data.data && data.data.balance) {
              $rootScope.$emit('accountBalance_changed', parseFloat(data.data.balance));
            }
            notifyWithdrawSuccess({
              type: option,
              message: Utilities.supplant(msg, {
                for: $filter('currency')($scope.withdrawDataModel.amount)
              })
            });
            return data.data ? data.data.slpWithdrawalDetails : {};
          })
        .catch(function (response) {
          var serviceErrorMessage = _.get(response, 'data.message', '');
          return notifyWithdrawFailure({
            type: option,
            serviceErrorMessage: serviceErrorMessage
          });
        });
    }

    /**
     * Withdraws using debit card flow
     */
    function _withdrawDebitCard() {
      var msg = $filter('CMSLabels')('withdraw-debit-success', 'dmaDepositLabels');
      if ($scope.withdrawDataModel.ccid) {
        return WithdrawFac.withdrawDebitCard(
          $scope.withdrawDataModel.amount, $scope.data.accountId, $scope.withdrawDataModel.ccid)
          .then(function (data) {
            if (data.data && data.data.balance) {
              $rootScope.$emit('accountBalance_changed', parseFloat(data.data.balance));
            }
            notifyWithdrawSuccess({
              type: 'debit',
              message: Utilities.supplant(msg, {
                for: $filter('currency')($scope.withdrawDataModel.amount),
                to: $scope.withdrawDataModel.ccid
              })
            });
            return data.data ? data.data : {};
          }).catch(function (response) {
            var serviceErrorMessage = _.get(response, 'data.message', '');
            return notifyWithdrawFailure({
              type: 'debit',
              serviceErrorMessage: serviceErrorMessage
            }, response);
          });
      }

      return NotificationService.error('Error!',
        'No debit cards available to withdrawal',
        _getWithdrawDepositContainerFirstChildSelector());
    }

    /**
     * Withdraws using BetCash new flow
     * @private
     */
    function _withdrawBetCashNewFlow() {
      var msg = $filter('CMSLabels')('withdraw-betcash-success', 'dmaDepositLabels');
      if ($scope.withdrawDataModel.betCashId) {
        return WithdrawFac.withdrawBetcashNewDepositFlow(
          $scope.withdrawDataModel.amount, $scope.data.accountId,
            $scope.withdrawDataModel.betCashId)
        .then(function (data) {
          if (data.data && data.data.balance) {
            $rootScope.$emit('accountBalance_changed', parseFloat(data.data.balance));
          }
          notifyWithdrawSuccess({
            type: 'ach',
            message: Utilities.supplant(msg, {
              for: $filter('currency')($scope.withdrawDataModel.amount),
              to: $scope.withdrawDataModel.bankName
            })
          });
          return data.data ? data.data.achWithdrawalResult : {};
        }).catch(function (response) {
          var serviceErrorMessage = _.get(response, 'data.message', '');
          return notifyWithdrawFailure({
            type: 'ach',
            logged: response && (response.errorMessage &&
            response.errorMessage === 'ApiMissingUserSessionToken' ||
            response.errorMessage === 'ApiUserSessionTimedOut' ||
            response.errorMessage === 'ApiUserSessionNotFound'),
            serviceErrorMessage: serviceErrorMessage
          });
        });
      }

      return NotificationService.error('Error!',
        'No BetCash Account selected',
          _getWithdrawDepositContainerFirstChildSelector());
    }

    function _withdrawPaypal() {
      var msg = $filter('CMSLabels')('withdraw-paypal-success', 'dmaDepositLabels');

      return WithdrawFac.withdrawPaypal(
        $scope.withdrawDataModel.amount,
        $scope.data.accountId
      )
        .then(function (response) {
          notifyWithdrawSuccess({
            type: 'PAY',
            message: Utilities.supplant(msg, {
              for: $filter('currency')($scope.withdrawDataModel.amount)
            })
          });

          return response;
        })
        .then(function (withdraw) {
          $rootScope.$emit('accountBalance_changed', parseFloat(withdraw.balance));

          return {
            DateInitiated: moment(withdraw.payWithdrawalDetails.transactionDate).format('MM/DD/YYYY'),
            amount: parseFloat(withdraw.payWithdrawalDetails.amount),
            paymentType: 'PAY',
            transactionDate: withdraw.payWithdrawalDetails.transactionDate,
            transactionUUID: withdraw.payWithdrawalDetails.UUID,
            withdrawalId: withdraw.payWithdrawalDetails.UUID
          };
        })
        .catch(function (response) {
          var serviceErrorMessage = _.get(response, 'data.message', '');
          return notifyWithdrawFailure({
            type: 'PAY',
            serviceErrorMessage: serviceErrorMessage
          });
        });
    }

    function notifyWithdrawSuccess(options) {
      var type = getWithdrawType(options.type);
      $scope.$emit('onDepositEventSuccess');
      $rootScope.$broadcast('accountBalance_update');
      NotificationService.success('Success!', options.message,
        _getWithdrawDepositContainerFirstChildSelector());

      _sendGTMEvent(null, {
        eventName: 'withdrawal',
        eventScreenName: 'My account|Withdrawal',
        customerStatus: '',
        eventAction: 'Withdrawal Success',
        logged: true,
        depositAmount: $scope.withdrawDataModel.amount,
        depositType: type,
        module: 'Withdrawal'
      });
    }

    function notifyWithdrawFailure(options, response) {
      var message;
      var errorObj;
      var errorMessage;
      var responseCode = _.get(response, 'data.code', null);
      var serviceErrorMessage = _.get(options, 'serviceErrorMessage', '');
      var type = getWithdrawType(options.type);

      if (responseCode) {
        message = _.attempt(function () {
          return $filter('CMSLabels')(responseCode, 'depositErrorCodes');
        });
      }

      errorObj = {
        type: options.type,
        title: 'This method of withdrawal doesn\'t seem to be going through.',
        text: message && !_.isError(message) ? message : [
          'Please',
          '<a target="_blank" href=\'/redirectengine?type=messageus\'>contact our customer services</a>',
          'and we\'ll work as fast as we can to help you.'
        ].join(' ')
      };
      errorMessage = '<strong>{title}</strong><br/>{text}';
      $scope.$emit('onDepositEventFailure');

      NotificationService.error(
        'Error!',
        Utilities.supplant(errorMessage, errorObj),
        _getWithdrawDepositContainerFirstChildSelector()
      );

      _sendGTMEvent(null, {
        eventName: 'withdrawal',
        eventAction: 'Withdrawal Fail',
        depositAmount: $scope.withdrawDataModel.amount,
        logged: options.logged || true,
        depositType: type,
        gaEventLabel: serviceErrorMessage,
        module: 'Withdrawal'
      });
    }

    function _buildGTMEvent(params) {
      var user = $scope.data.user;
      var withdrawAmount = params.withdrawAmount;
      var p = {};
      var cookie;
      var accountId;
      var residenceState;
      var gaEventLabel = _.get(params, 'gaEventLabel', params.withdrawType);

      if (_hasParentWindow()) {
        cookie = Utilities.prop('parent.TVG.Cookie.getValueByKey', window) || Utilities.noop;
      } else {
        cookie = Utilities.noop;
      }
      accountId = user.get('accountNumber') || cookie('user_id');
      residenceState = user.get('homeAddress.StateAbbr') || cookie('state');

      if (accountId) {
        p.accountId = accountId;
      }

      if (residenceState) {
        p.residenceState = residenceState;
      }

      p.event = params.eventName;
      p.page = params.page || $window.location.pathname;
      p.customerStatus = '';
      p.gaEventCategory = 'Withdrawal';
      p.gaEventAction = params.eventAction;
      p.gaEventLabel = gaEventLabel;
      p.loginStatus = !!accountId ? 'Logged In' : 'Logged Out';
      p.registrationStatus = 'Registered';
      p.screenName = '';
      p.module = params.module;
      p.depositType = params.depositType;
      p.depositAmount = params.depositAmount;

      if (ApiWithdrawGTMFac.isTVG4()) {
        p.screenName = 'My Account';
      } else {
        if ($location.path().split('/').length > 1) {
          p.screenName = $location.path().split('/')[1];
        } else {
          p.screenName = '';
        }
      }

      p.sectionName = ApiWithdrawGTMFac.isTVG4() ?
          'My Account | My Funds | Withdraw' :
          params.eventScreenName;
      p.siteVersion =
        ApiWithdrawGTMFac.getSiteVersion(ConfigurationFac.getApplicationContextItem('product'));
      p.withdrawAmount = ApiWithdrawGTMFac.gtmCurrencyFormat(withdrawAmount);
      p.withdrawType = params.withdrawType;

      if (params.errorMessage) {
        p.errorMessage = params.errorMessage;
        p.errorType = params.errorType;
        p.gaEventAction = params.errorType;
        p.gaEventLabel = params.errorMessage;
      }

      if (p.siteVersion === 'TVG3' || p.siteVersion === 'FDR-01') {
        p.screenName = 'Withdrawal';
        p.sectionName = undefined;
      }

      return p;
    }

    function _sendGTMEvent(event, params) {
      var obj = _buildGTMEvent(params);
      ApiWithdrawGTMFac.sendGTMEvent(event, obj);
    }

    function _updateBalance() {
      var currency = $filter('currency');
      return WithdrawFac.getAccountBalance()
        .then(function (data) {
          $scope.data.availableBalance = data.availableBalance;
          $scope.data.balance = currency(data.toteBalance, '$');
        });
    }

    function _updatePendingWithdrawals(withdrawalResult) {
      // This is only used on the desktop version
      if ($scope.showPendingWithdrawals) {
        $rootScope.hasPendingWithdrawals = true; // eslint-disable-line
        $rootScope.lastWithdrawalResult = withdrawalResult;
        $rootScope.$broadcast('WithdrawSuccessful::UpdatePendingRequests');
      }
    }

    /**
     * Is sightline enrollment with API visible?
     * (previous data.showSightlineApiEnrollment flag)
     * @return {Boolean}
     */
    function _isSightlineApiEnrollmentVisible() {
      var isSightline = $scope.data.selectedWithdrawOption.id === 'SLN';
      var hasSightlineAccount = $scope.data.hasSightlineAccount;
      var notLoading = !$scope.sightlineLoading;

      return isSightline && !hasSightlineAccount && notLoading;
    }

    /**
     * @return {string} the selector for the withdraw deposit container's first child.
     */
    function _getWithdrawDepositContainerFirstChildSelector() {
      return 'withdraw .tvg-deposit withdraw-type-selector';
    }

    function _hasParentWindow() {
      return Utilities.attempt(
        function () {
          return $window.document.referrer
              && $window.document.domain === $window.parent.document.domain
              && $window.self !== $window.top
              && $window.parent.location.href !== $window.location.href;
        },
        function () {
          return false;
        }
      );
    }

    function _setInitalConfigFromParam() {
      var filteredFromInitialTab;
      var filteredFromAvailableOptions;

      switch (initialTab) {
        case 'CCP':
        case 'DEB':
          filteredFromInitialTab = 'DEBIT_CARD';
          break;
        case 'ACH':
          filteredFromInitialTab = 'BETCASH';
          break;
        case 'CHK':
          filteredFromInitialTab = 'CHECK';
          break;
        case 'PPAL':
        case 'PAY':
          filteredFromInitialTab = 'PAY';
          break;
        case 'SLN':
        case 'SLP':
          filteredFromInitialTab = 'SLN';
          break;
        default:
          filteredFromInitialTab = null;
          break;
      }

      if (filteredFromInitialTab) {
        filteredFromAvailableOptions = $scope.data.withdrawOptions;
        filteredFromAvailableOptions = filteredFromAvailableOptions.filter(function (item) {
          if (item.id) {
            return item.id === filteredFromInitialTab;
          }
          return false;
        });

        if (filteredFromAvailableOptions && filteredFromAvailableOptions.length > 0) {
          $scope.data.selectedWithdrawOption = filteredFromAvailableOptions[0];
          $scope.data.pageSetFromParams = true;
        } else {
          $scope.data.selectedWithdrawOption = $scope.data.withdrawOptions[0];
        }
      } else {
        $scope.data.selectedWithdrawOption = $scope.data.withdrawOptions[0];
      }
    }

    /**
     * Get user cards on file
     */
    function _setUserCardsOnFile() {
      var accountId = $scope.data.accountId;
      var optionsOnFile = [];

      if (
        !_.find($scope.data.withdrawOptions, function (value) {
          return value.id === 'DEBIT_CARD';
        })
      ) {
        return;
      }

      WithdrawFac.getCardsOnFile(accountId)
        .then(function (data) {
          if (data.CardList && data.CardList.length > 0) {
            angular.forEach(data.CardList, function (card) {
              optionsOnFile.push({
                groupName: 'Cards On File',
                id: card.cardId,
                cardNumber: card.cardNumber,
                cardNumberExt: '****' + card.cardNumber,
                cardTypeId: DepositInitialDataFac.getCardType(card.cardType).id,
                limitTypeId: DepositInitialDataFac.getDepositLimitType(card.cardType).id,
                expirationDate: card.expDate,
                isExpired: moment(card.expDate, 'MM/YY')
                  .add(1, 'month') < moment(),
                signed: card.signed,
                name: card.network + ' (****' + card.cardNumber + ') ' + card.expDate,
                ftype: 'CC',
                type: DepositInitialDataFac.getCardType(card.cardType).abbr,
                typeName: card.cardType,
                cardType: card.cardType,
                network: card.network,
                min: DepositInitialDataFac.getLimitType(card.DepositLimitTypeId, 'min'),
                max: DepositInitialDataFac.getLimitType(card.DepositLimitTypeId, 'max'),
                depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE,
                lastUsedDate: card.lastUsedDate || '1900-01-01T00:00:00.000-07:00'
              });
            });
          }

          if ($scope.data.cardsOnFile.length !== 0 && optionsOnFile.length) {
            _setUserCardsOnFile(optionsOnFile[0]);
          }

          $scope.data.unableToFetchCardsOnFile = false;
          $scope.data.cardsOnFile = optionsOnFile;
          _initDropdown('DEBIT_CARD');
          $scope.data.isLoading = false;
          $scope.data.fetchedCardsOnFile = true;
        })
        .catch(function () {
          $scope.data.unableToFetchCardsOnFile = true;
          $scope.data.isLoading = false;
          $scope.data.fetchedCardsOnFile = true;
        });
    }

    /**
     * Set user ach accounts on file
     * @private
     */
    function _setUserBankAccounts() {
      var accountId = $scope.data.accountId;

      DepositSrv.getUserBankAccounts(accountId)
      .then(function (data) {
        var optionsOnFile = [];
        if (data.bankAccounts && data.bankAccounts.length > 0) {
          angular.forEach(data.bankAccounts, function (ach) {
            optionsOnFile.push({
              achId: ach.id,
              bankName: ach.name,
              name: '(*****' + ach.accountNumber
              .substr(ach.accountNumber.length - 4) + ') ' + ach.name
            });
          });
        }

        $scope.data.unableToFetchBankAccounts = false;
        $scope.data.availableBetCashAccounts = optionsOnFile;

        if (data.bankAccounts && data.bankAccounts.length > 0) {
          _initDropdown('BETCASH');
        } else {
         //eslint-disable-next-line
         var newWithdrawOptions = $scope.data.withdrawOptions.filter(function (item) {
           return item.id !== 'BETCASH';
         });

          $scope.data.withdrawOptions = newWithdrawOptions;

          if (initialTab) {
            _setInitalConfigFromParam();
          } else {
            $scope.data.selectedWithdrawOption = $scope.data.withdrawOptions[0];
          }
        }
      })
      .catch(function () {
        $scope.data.unableToFetchBankAccounts = true;
      });
    }

    /* eslint-disable */
    unbind.push($rootScope.$on('sightlineUserEnrolled', function () {
      $scope.data.hasSightlineAccount = true;
      return NotificationService
        .success('Success!',
        'Congratulations! Your pre paid account has been approved!',
        'withdraw');
    }));

    $scope.$on('$destroy', function () {
      _.forEach(unbind, function (bind) {
        bind();
      });
    });

    (function init() {
      _getInitialData();
      firstWithdraw = true;
    }());
  }

  angular
    .module('TVG.Withdraw')
    .controller('WithdrawCtrl', WithdrawController);
}());

(function () {
  'use strict';

  BannerController.$inject = ['$sce'];
  bannerDirective.$inject = ['$rootScope', '$compile'];
  function BannerController($sce) {
    var DEFAULT_TYPE = 'success';
    this.type = angular.isString(this.type) && this.type || DEFAULT_TYPE;
    this.title = angular.isString(this.title) && $sce.trustAsHtml(this.title) || '';
  }

  function bannerDirective($rootScope, $compile) {
    var scopeObj = {
      callback: '&?',
      message: '=',
      title: '=?',
      type: '=?'
    };

    function _linkFn(scope, element) {
      var vm = scope.vm;
      var message = '<div>' + vm.message + '</div>';

      vm.close = function (invokeCallback) {
        element.remove();
        if (invokeCallback && angular.isFunction(vm.callback)) {
          return vm.callback();
        }

        return angular.noop();
      };

      vm.isConfirmBanner = function () {
        return vm.type === 'confirm';
      };

      scope.broadcastEvent = function (eventName) {
        $rootScope.$emit(eventName);
      };

      element.find('alert-content').append($compile(message)(scope));
    }

    return {
      bindToController: true,
      controller: BannerController,
      controllerAs: 'vm',
      link: _linkFn,
      restrict: 'E',
      scope: scopeObj,
      templateUrl: 'src/templates/banner.html'
    };
  }

  angular
    .module('TVG.Deposit')
    .directive('banner', bannerDirective);
}());

(function () {
  'use strict';

  clickOutside.$inject = ['$window', '$parse'];
  function clickOutside($window, $parse) {
    function link(scope, el, attr) {
      var fn = $parse(attr.clickOutside);

      var handler = function (e) {
        if (el[0] === e.target || el[0].contains(e.target) || !attr.clickOutside) {
          return;
        }

        scope.$apply(fn);
      };

      $window.addEventListener('click', handler, true);

      scope.$on('$destroy', function () {
        $window.removeEventListener('click', handler);
      });
    }

    return {
      link: link,
      restrict: 'A'
    };
  }

  angular.module('TVG.Deposit')
    .directive('clickOutside', clickOutside);
}());

(function () {
  'use strict';
  angular.module('TVG.Deposit')
    .directive('deposit', function () {
      return {
        restrict: 'E',
        scope: {
          withPlaceholders: '=',
          withAccountDetails: '=',
          notifyErrors: '=',
          fromOption: '=?',
          callback: '='
        },
        templateUrl: 'src/templates/deposit/deposit.html',
        link: function ($scope, $element, $attrs) {
          $scope.fromOption = $scope.fromOption || $attrs.fromOption; // eslint-disable-line
          $scope.redirectFrom = $attrs.redirectFrom; // this is an edge case: when the user comes from registration page
        }
      };
    })
    .directive('tvgCollapse', function () {
      return {
        restrict: 'E',
        transclude: true,
        scope: {
          title: '@',
          scrollDown: '@'
        },
        controller: ['$scope', '$window', '$timeout', '$rootScope', function ($scope, $window, $timeout, $rootScope) {
          var applyScroll = true;
          $scope.scrollDown = function () {
            if (applyScroll && $rootScope.isFdrApp) {
              $timeout(function () {
                $window.scrollTo(0, $window.innerHeight + 300);
              }, 50);
            }
            applyScroll = !applyScroll;
          };
        }],
        templateUrl: 'src/templates/tvg-collapse.html'
      };
    })
    .directive('customerOptions', function () {
      return {
        restrict: 'E',
        scope: {
          standalone: '@'
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
          var optionConfig = [];

          try {
            optionConfig = angular
              .fromJson($filter('CMSValue')('depositConfigOtherMenu', null));
          } catch (e) {
            // TODO: handle exception e
          }

          $scope.data = { optionsConfig: optionConfig }; // eslint-disable-line
        }],
        templateUrl: 'src/templates/customer-options.html'
      };
    })
    .directive('customerInfo', function () {
      return {
        restrict: 'E',
        scope: {
          htmlContentKey: '@'
        },
        templateUrl: 'src/templates/customer-info.html',
        controller: ['$scope', '$location', '$filter', '$sce', function ($scope, $location, $filter, $sce) {
          var path = $location.path();
          var cmsContent = '';

          $scope.data = {}; // eslint-disable-line

          if (!$scope.htmlContentKey) {
            cmsContent = $filter('CMSValue')(path.substring(
              path.lastIndexOf('/') + 1));
          } else {
            cmsContent = $filter('CMSValue')($scope.htmlContentKey);
          }

          $scope.data = { // eslint-disable-line
            htmlContent: $sce.trustAsHtml(cmsContent)
          };
        }]
      };
    })
    .directive('footerLinks', function () {
      return {
        restrict: 'E',
        scope: {},
        templateUrl: 'src/templates/footer-links.html'
      };
    })
    .directive('successDeposit', function () {
      return {
        restrict: 'E',
        scope: {
          depositData: '='
        },
        templateUrl: 'src/templates/deposit/deposit-success.html'
      };
    })
    .directive('errorDeposit', function () {
      return {
        restrict: 'E',
        scope: {},
        templateUrl: 'src/templates/deposit/deposit-error.html'
      };
    })
    .directive('depositAmountInput', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/deposit-amount-input.html'
      };
    })
    .directive('depositTypeSelector', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/deposit-type-selector.html'
      };
    })

    .directive('quickDepositSelector', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/quick-deposit-selector.html'
      };
    })

    .directive('quickDepositDefault', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/quick-deposit-default.html'
      };
    })

    .directive('depositTotalCost', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/deposit-total-cost.html'
      };
    })
    .directive('achDescriptionText', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/ach-description-text.html'
      };
    })
    .directive('cardDescriptionText', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/card-description-text.html'
      };
    })
    .directive('applepayDescriptionText', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/fields/applepay-description-text.html'
      };
    })
    .directive('sightlineEnrollment', function () {
      return {
        require: 'ngModel',
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/deposit/types/sightline/enrollment.html'
      };
    })
    .directive('dwInfoMessage', function () {
      return {
        restrict: 'E',
        scope: {
          title: '@',
          message: '@'
        },
        templateUrl: 'src/templates/dw-info-message.html'
      };
    })
    .directive('dwInfoDialog', function () {
      return {
        restrict: 'E',
        transclude: true,
        scope: {
          actionUrl: '=',
          action: '=',
          actionText: '@',
          livePerson: '@'
        },
        templateUrl: 'src/templates/dw-info-dialog.html'
      };
    })
    .directive('dwInfoDialogFdr', function () {
      return {
        restrict: 'E',
        transclude: true,
        scope: {
          actionUrl: '=',
          action: '=',
          actionText: '@',
          headingText: '@',
          buttonText: '@',
          buttonAction: '=',
          livePerson: '@'
        },
        templateUrl: 'src/templates/dw-info-dialog-fdr.html'
      };
    })
    .directive('welcomeDialogFdr', ['$rootScope', '$location', function ($rootScope, $location) {
      return {
        restrict: 'E',
        templateUrl: 'src/templates/welcome-dialog-fdr.html',
        link: function ($scope) {
          $scope.dismiss = function () {
            $scope.events.closeSuccessfulRegistrationModal();
            $rootScope.newUser = false;
            $location.search('newUser', null);
          };
        }
      };
    }])
    .directive('toggleComponent', function () {
      return {
        restrict: 'E',
        scope: {
          savein: '=',
          title: '@',
          subtitle: '@'
        },
        templateUrl: 'src/templates/toggle-component.html'
      };
    })
    .directive('additionalInfo', function () {
      return {
        restrict: 'E',
        scope: true,
        transclude: true,
        controller: ['$scope', 'UserActionEventsService', function ($scope, UserActionEventsService) {
          var defaultAmountList;
          var amountType;
          $scope.data = { infoState: false };
          $scope.events = {
            toggleInfo: function () {
              $scope.data.infoState = !$scope.data.infoState;
              if (!$scope.$ctrl) {
                defaultAmountList = [50, 100, 300];
                amountType = defaultAmountList.
                    indexOf(_.get($scope, 'depositDataModel.amount')) > -1 ? 'Yes' : 'No';
                if ($scope.data.selectedPayOption && $scope.data.selectedPayOption.ftype === 'CC') {
                  UserActionEventsService.emit('CVVInfoClick', amountType);
                } else {
                  UserActionEventsService.emit('TooltipClick');
                }
              }
            },

            closeInfo: function () {
              $scope.data.infoState = false;
            }
          };
        }],
        templateUrl: 'src/templates/additional-info.html'
      };
    })
    .directive('tvgDmaModal', function () {
      return {
        restrict: 'E',
        scope: {
          close: '&',
          title: '@',
          body: '@'
        },
        templateUrl: 'src/templates/deposit/utils/modal-content-directive.html'
      };
    })

    .directive('restrictChars', [function () {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          angular.element(elem).on('keypress', function (e) { // eslint-disable-line
            var CHAR_AFTER_DP = 2;  // number of decimal places
            var validList = '0123456789.';  // allowed characters in field
            var key;
            var keyChar;
            var dp;
            var obj = angular.element(document.querySelector('input[name="amount"]')); // eslint-disable-line
            key = window.event ? window.event.keyCode : e ? e.which : null; // eslint-disable-line

            // control keys
            // null, backspace, tab, carriage return, escape
            if (key === 0 || key === 8 || key === 9 || key === 13 ||
              key === 27) {
              return true;
            }

            // get character
            keyChar = String.fromCharCode(key);

            // check valid characters
            if (validList.indexOf(keyChar) !== -1) {
              // check for existing decimal point
              dp = 0;

              if ((dp = obj.val().indexOf('.')) > -1) { // eslint-disable-line
                if (keyChar === '.') {
                  e.preventDefault();  // only one allowed
                } else {
                  // check for room for more numbers after decimal point
                  if ((obj.val().length - dp > CHAR_AFTER_DP) ||
                    obj.val().length >= 9) {
                    e.preventDefault();
                  }
                }
              } else if (obj.val().length >= 9 ||
                (obj.val().length >= 8 && keyChar === '.') ||
                (obj.val().length === 0 && keyChar === '.')) {
                // over the field input limit
                e.preventDefault();
              } else {
                return true;
              }
            } else if (validList.indexOf(keyChar) === -1) {
              // not a valid character
              e.preventDefault();
            } else {
              return true;
            }
          });
        }
      };
    }])
    .directive('tvgLimitTo', ['$document', '$window', function ($document, $window) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          var limit = parseInt(attrs.tvgLimitTo, 10);

          elem.on('keydown', function (e) {
            var text = '';

            if (angular.isFunction($window.getSelection)) {
              text = $window.getSelection().toString();
            } else if (angular.isDefined($document[0].selection) &&
              $document[0].selection.type === 'Text') {
              text = $document[0].selection.createRange().text;
            }

            if (text !== this.value
                && this.value.length === limit
                && e.keyCode !== 8
                && e.keyCode !== 9
                && e.keyCode !== 46
                && e.keyCode !== 37
                && e.keyCode !== 39
            ) {
              return false;
            }

            return true;
          });
        }
      };
    }])
    .directive('sectionTitle', function () {
      return {
        restrict: 'E',
        scope: {
          title: '@',
          index: '@',
          qalabel: '@'
        },
        templateUrl: 'src/templates/section-title.html'
      };
    });
}());

(function () {
  'use strict';

  pendingWithdrawElement.$inject = ['$rootScope', '$timeout', 'ConfigurationFac'];
  function pendingWithdrawElement($rootScope, $timeout, ConfigurationFac) {
    return {
      restrict: 'E',
      scope: {
        item: '=',
        loading: '=',
        cancelPendingWithdraw: '&'
      },
      templateUrl: 'src/templates/withdraw/desktop/pendingWithdrawals/' +
      'pending-withdraw-element.html',
      link: function (scope, element) {
        var timer;
        var $li;

        scope.showConfirmation = false;
        scope.showMessage = false;
        scope.showCancelButton = true;

        scope.njxIntegration = ConfigurationFac.getApplicationContextItem('product') === 'njx';

        timer = null;
        $li = element.find('li');

        scope.undoCancel = function () {
          scope.showConfirmation = false;
          $li.removeClass('lighter-warning');
          $rootScope.$emit('PendingWithdrawUndoCancelClick', scope.item.WithdrawalId);
        };

        scope.onCancel = function () {
          scope.showConfirmation = true;
          $li.removeClass('lighter-error lighter-success');
          $li.addClass('lighter-warning');
          $rootScope.$emit('PendingWithdrawCancelClick', scope.item.withdrawalId);
        };

        scope.getBetTypeName = function (key) {
          switch (key) {
            case 'ACH':
              return 'eCheck';
            case 'CHK':
              return 'Check Request';
            case 'SLP':
              return 'TVG Pre Paid Card';
            case 'PAY':
              return 'PayPal';
            case 'VIWD':
              return 'Debit Card';
            case 'MZM':
              return 'Online Banking';
            default:
              return '';
          }
        };

        function _hideOnTimeout() {
          timer = $timeout(function () {
            scope.onRemoveMessage();
          }, 10000);
        }

        scope.$on('PendingWithdrawals::CancelSuccess', function (event, params) {
          if (scope.item.withdrawalId === params.withdrawalId) {
            scope.isSuccess = true;
            scope.successMessage = params.message;
            _onMessageDisplay();
            $li.addClass('lighter-success');
            _hideOnTimeout();
          }
        });

        scope.$on('PendingWithdrawals::CancelError', function (event, params) {
          if (scope.item.withdrawalId === params.withdrawalId) {
            scope.isError = true;
            scope.errorMessage = params.message;
            _onMessageDisplay();
            _hideOnTimeout();
            $li.addClass('lighter-error');
          }
        });

        scope.$on('PendingWithdrawals::CancelCriticalError', function (event, params) {
          if (scope.item.withdrawalId === params) {
            scope.isCriticalError = true;
            _onMessageDisplay();
            _hideOnTimeout();
            $li.addClass('lighter-error');
          }
        });

        scope.$on('PendingWithdrawals::CancelWarning', function (event, params) {
          if (scope.item.withdrawalId === params.withdrawalId) {
            scope.isWarning = true;
            scope.warningMessage = params.message;
            _onMessageDisplay();
            _hideOnTimeout();
            $li.addClass('lighter-warning');
          }
        });

        scope.onRemoveMessage = function () {
          $timeout.cancel(timer);
          scope.$emit('WithdrawSuccessful::UpdatePendingRequests');
          scope.showMessage = false;
          scope.isError = false;
          scope.showCancelButton = !scope.isSuccess;
          scope.isSuccess = false;
          scope.isCriticalError = false;
          scope.isWarning = false;
          scope.showConfirmation = false;
          $li.removeClass('lighter-error lighter-success lighter-warning');
        };

        function _onMessageDisplay() {
          scope.showConfirmation = false;
          scope.showCancelButton = false;
          scope.showMessage = true;
        }
      }
    };
  }

  angular.module('TVG.Withdraw')
      .directive('pendingWithdrawElement', pendingWithdrawElement);
}());

(function () {
  'use strict';

  angular.module('TVG.ManagePaymentMethods')
    .directive('managePaymentMethods', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/managePaymentMethods/' +
        'manage-payment-methods.html'
      };
    })
    .directive('newPaymentMethod', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/managePaymentMethods/fields/' +
        'new-payment-method.html'
      };
    })
    .directive('paymentMethodOnFileList', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/managePaymentMethods/fields/' +
        'payment-method-on-file-list.html'
      };
    })
    .directive('depositLimits', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/managePaymentMethods/fields/' +
        'deposit-limits.html'
      };
    })
    .directive('paymentMethodsTypeSelector', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/managePaymentMethods/fields/' +
        'payment-methods-type-selector.html'
      };
    })
    .directive('paymentMethodOnFileOption', function () {
      return {
        restrict: 'E',
        scope: {
          card: '=',
          onEditCardAction: '&',
          onGoToDeposit: '&',
          onRemoveCardAction: '&',
          $index: '='
        },
        templateUrl: 'src/templates/managePaymentMethods/fields/' +
        'payment-method-on-file-option.html'
      };
    })
    .directive('ngEnter', function () {
      return function (scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter, { event: event });
            });

            event.preventDefault();
          }
        });
      };
    })
    .component('paymentMethodCard', {
      templateUrl: 'src/templates/managePaymentMethods/fields/payment-method-card.html',
      controller: 'ManagePaymentMethodsController',
      bindings: {
        card: '=',
        removeCard: '&',
        sliceCard: '&'
      }
    })
    .component('paymentTitles', {
      templateUrl: 'src/templates/managePaymentMethods/fields/titles.html',
      controller: 'ManagePaymentMethodsController',
      bindings: {
        type: '=',
        length: '=',
        redirectAdd: '&'
      }
    });
}());

(function () {
  'use strict';

  function moneyFormater() {
    var oldValue = '';

    function link(scope, element, attrs, ngModel) {
      element.bind('keyup', function (event) {
        var patt;
        var str = event.currentTarget.value;
        if (event.currentTarget.validity.badInput) {
          event.currentTarget.value = oldValue; // eslint-disable-line
          ngModel.$viewValue = oldValue; // eslint-disable-line
          ngModel.$render();
        } else {
          patt = new RegExp('(^$|^(\\d{1,' + attrs.numLength +
            '}(\\.)?$|^\\d{1,' + attrs.numLength +
            '}\\.\\d{1,2}$|^\\.(\\d{1,2})?$))');
          if (patt.test(str)) {
            oldValue = str;
          } else {
            event.currentTarget.value = oldValue; // eslint-disable-line
            ngModel.$viewValue = oldValue; // eslint-disable-line
            ngModel.$render();
          }
        }
      });
    }

    return {
      link: link,
      restrict: 'A',
      require: '?ngModel'
    };
  }

  angular.module('TVG.Deposit')
    .directive('moneyFormater', moneyFormater);
}());

(function () {
  'use strict';

  function quickDeposit() {
    return {
      restrict: 'E',
      scope: {
        quick: '@',
        withPlaceholders: '=',
        withAccountDetails: '=',
        notifyErrors: '='
      },
      templateUrl: 'src/templates/deposit/quick-deposit.html'
    };
  }

  angular.module('TVG.Deposit')
    .directive('quickDeposit', quickDeposit);
}());

(function () {
  'use strict';

  /* eslint-disable */

  /**
    * series
    * Given an array of functions, it will call every function,
    * once at a time, sequentially.
    * Every function will have a trigger function as its last argument,
    * that should be called when the function is done.
    * If arguments are given to this trigger function, those will be passed
    * to the next function.
    *
    * @example
    *     series([
    *         function doSomething(next) {
    *             //when it's done
    *             next(argument1, arguments2)
    *         },
    *         function doSomethingElse(arg1, arg2, next) {
    *             // do something with the arguments,
    *             // and when it's done:
    *             next();
    *         },
    *         function doAnotherThing(next) {
    *             // because we didn't give arguments to this function
    *             // only the 'next' is available
    *             // when done.
    *             next();
    *         }
    *     ]);
    *
    *
    * @param   {Array} fns Array of functions
    */
  var cachedComponent;

  var series = function (fns) {
      (function next() {
          var args = Array.prototype.slice.call(arguments);
          fns.length && fns.shift().apply(this, args.concat(next));
      }());
  };

  var parseJSON = function(json) {
    var data = {};
    var error = null;

    try { data = JSON.parse(json) }
    catch (e) {
      error = e;
    }

    return error ? error : data;
  }

  function getURL(path) {
    return path;
  }

  function request(url, callback) {
    var oReq = new XMLHttpRequest();

    oReq.addEventListener('error', callback);
    oReq.addEventListener('load', function () {
      var data = parseJSON(this.responseText);
      return (data instanceof Error)
        ? callback(data)
        : callback(null, data);
    });
    oReq.open('GET', url);
    oReq.setRequestHeader('Accept', 'application/json')
    oReq.setRequestHeader('Content-Type', 'application/json')

    oReq.send();
  }

  var createLink = function (url) {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', getURL(url));
    document.head.appendChild(link)
    return link;
  };

  var createScript = function (url, cb) {
    var script = document.createElement('script');
    script.setAttribute('src', getURL(url));
    script.onload = function() { cb() };
    script.onerror = function (e) { cb(e) };
    document.body.appendChild(script);
    return script;
  };

  var createHTML = function (str) {
    var fragment = document.createDocumentFragment();
    if (str) { fragment.innerHTML = str; }
    cachedComponent = fragment;
    return fragment;
  };

  var append = function (manifest, cb) {
    manifest.css.map(createLink)

    // Prepare an array of functions
    var tasks = manifest.js.map(function (url) {
      return function(next) {
        if (next instanceof Error) { return cb(next); }
        return createScript(url, next)
      };
    })

    tasks = tasks.concat(function (next) {
      if (next instanceof Error) { return cb(next); }

      cb(null);
      next();
    });

    series(tasks);
  };

  function loadComponent(url, callback) {
    if(cachedComponent) {
      return callback(null, cachedComponent);
    } else {
      request(getURL(url), function (err, data) {
        if (err) { return callback(err); }
        append(data, function () {
          return callback(null, createHTML(data.html));
        });
      });
    }
  }

    /* eslint-enable */
  angular
        .module('TVG.Deposit')
        .directive('reactSightline', ['$rootScope', '$timeout', '$window',
          function ($rootScope, $timeout, $window) {
            return {
              restrict: 'E',
              scope: false,
              link: function ($scope, $element) {
                $element.attr('id', 'funds'); // we'll keep this as some css classes on funds are dependent on this
                $element.addClass('loading');
              // eslint-disable-next-line no-console,angular/log
                loadComponent('/fnd/component', function (err, node) {
                // Stop! Hammer time!
                // We're not sure how to remove the loading states
                  $timeout(function () {
                    $element.removeClass('loading');
                    $scope.data.loading = false;
                    $scope.data.sightlineLoading = false;
                    $scope.data.makingDeposit = false;
                    $scope.sightlineLoading = false;
                  });

                  if (err) {
                    $element.addClass('error');
                    throw err;
                  }

                  $element.html(node);
                  sightline.mount(
                  $element.get(0),
                    {
                      isAuthenticated: !!$scope.$parent.accountDetails,
                      accountDetails: $scope.$parent.accountDetails,
                      showRedirectMessage: $rootScope.showRedirectMessage,
                      depositInfo: $rootScope.cardDataToReactSightline,
                      onDepositComplete: function (payload) {
                        $rootScope.$broadcast('emitEgFund', payload);
                      },
                      onFundComplete: function () {
                        $rootScope.$broadcast('hasMadeInitialDeposit_update');
                        if (
                        $rootScope.product &&
                        $rootScope.product.indexOf('native') !== -1
                      ) {
                          if ($window && $window.handleNativeMessages) {
                            $window.handleNativeMessages('UPDATE_BALANCE');
                          }
                        }
                      },
                      onPaymentComplete: function () {
                        $rootScope.$broadcast('accountBalance_update');
                      },
                      onInvalidCardType: function () {
                        $rootScope.$broadcast('cardType_invalid');
                      }
                    }
                );

                  $scope.$on('$destroy', function () {
                    sightline.destroy($element.get(0));
                    $rootScope.showRedirectMessage = false;
                    $rootScope.cardDataToReactSightline = {};
                    $scope.depositInitialData = {};
                  });
                });
              }
            };
          }]);

  return angular;
}());

(function () {
  'use strict';

  angular.module('TVG.Transfer')
    .directive('transfer', function () {
      return {
        restrict: 'E',
        templateUrl: 'src/templates/transfer/transfer.html'
      };
    })
    .directive('transferAmountInput', function () {
      return {
        restrict: 'E',
        templateUrl: 'src/templates/transfer/fields/transfer-amount-input.html'
      };
    })
    .directive('transferSourceDestination', function () {
      return {
        restrict: 'E',
        templateUrl: 'src/templates/transfer/fields/' +
        'transfer-source-destination.html'
      };
    });
}());

(function () {
  'use strict';

  angular.module('TVG.Withdraw')

    .directive('withdraw', function () {
      return {
        restrict: 'E',
        scope: {
          fromOption: '@?'
        },
        templateUrl: 'src/templates/withdraw/withdraw.html',
        link: function ($scope, $element, $attrs) {
          $scope.fromOption = $attrs.fromOption; // eslint-disable-line
        },
        controller: 'WithdrawCtrl',
        controllerAs: 'withdrawCtrl'
      };
    }).directive('withdrawTypeSelector', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/withdraw/fields/withdraw-type-selector.html'
      };
    })
    .directive('withdrawSuccess', function () {
      return {
        restrict: 'E',
        scope: {
          withdraw: '='
        },
        templateUrl: 'src/templates/withdraw/withdraw-success.html'
      };
    })
    .directive('withdrawError', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/withdraw/withdraw-error.html'
      };
    })
    .directive('withdrawCancel', function () {
      return {
        restrict: 'E',
        scope: true,
        templateUrl: 'src/templates/withdraw/withdraw-cancel.html'
      };
    })
    .directive('withdrawPendingRequests', function () {
      return {
        restrict: 'EA',
        scope: true,
        templateUrl: 'src/templates/withdraw/desktop/pendingWithdrawals/withdraw-pending-requests.html',
        controller: 'WithdrawCancelDesktopController',
        controllerAs: 'WithdrawCancelDesktopController'
      };
    });
}());

(function () {
  'use strict';

  var capitalize = function (Utilities) {
    return Utilities.upperFirst;
  };
  capitalize.$inject = ['Utilities'];

  angular.module('TVG.DMA.Common').filter('capitalize', capitalize);
}());

(function () {
  'use strict';

  DMAFeatureTogglesFilter.$inject = ['DMAFeatureTogglesHashContainerSvc'];
  function DMAFeatureTogglesFilter(DMAFeatureTogglesHashContainerSvc) {
    var _featureTooglesHash = DMAFeatureTogglesHashContainerSvc.getBasedOnKey('dma');

    return function (key) {
      return _featureTooglesHash(key);
    };
  }

  angular.module('TVG.DMAToggles')
    .filter('DMAFeatureTogglesFilter', DMAFeatureTogglesFilter);
}());

(function () {
  'use strict';

  var noFractionCurrency = function ($filter, $locale) {
    var currencyFilter = $filter('currency');
    var formats = $locale.NUMBER_FORMATS;
    return function (amount, currencySymbol) {
      var value = currencyFilter(amount, currencySymbol);
      var sep = value.indexOf(formats.DECIMAL_SEP);
      if (amount >= 0) {
        if (amount % 1 === 0) {
          return value.substring(0, sep);
        }
        return value;
      }
      return value.substring(0, sep) + ')';
    };
  };
  noFractionCurrency.$inject = ['$filter', '$locale'];

  angular.module('TVG.DMA.Common')
         .filter('noFractionCurrency', noFractionCurrency);
}());

(function () {
  'use strict';
  var trust = function ($sce) {
    return $sce.trustAsHtml;
  };
  trust.$inject = ['$sce'];

  angular.module('TVG.DMA.Common').filter('trust', trust);
}());

(function () {
  'use strict';

  ApiDepositsGTMFac.$inject = ['$rootScope', '$location', '$document', '$window', 'ConfigurationFac', 'DMAScreenNames', 'DMASectionNames', 'Utilities'];
  function ApiDepositsGTMFac($rootScope,
            $location,
            $document,
            $window,
            ConfigurationFac,
            DMAScreenNames,
            DMASectionNames,
            Utilities) {
    function _gtmCurrencyFormat(val) {
      var tempBetAmount = val;
      try {
        tempBetAmount = tempBetAmount.toFixed(2);
      } catch (e) {
        // Purposely ignore the exception
      }
      return tempBetAmount;
    }

    /**
     *
     * @param {type} input
     * @returns {unresolved}
     */
    function _formatGALAbelUpperCase(input) {
      var result;

      if (input) {
        result = input.replace(/([A-Z]+)/g, ',$1').replace(/^,/, '');

        return result.replace(/,/g, ' ').replace(/\b\w/g, function (m) {
          return m.toUpperCase();
        });
      }
      return '';
    }


    /**
     *
     * @param {type} evName event name
     * @returns {object} defaulParams
     */
    function _baseParams(evName) {
      var eventParams = {};
      eventParams.accountId = undefined;
      eventParams.betAmount = undefined;
      eventParams.betName = undefined;
      eventParams.betType = undefined;
      eventParams.cableProvider = undefined;
      eventParams.cardType = undefined;
      eventParams.customerStatus = undefined;
      eventParams.dedicatedTVGChannel = undefined;
      eventParams.depositAmount = undefined;
      eventParams.depositMethod = undefined;
      eventParams.depositType = undefined;
      eventParams.errorMessage = undefined;
      eventParams.errorType = undefined;
      eventParams.gaEventAction = undefined;
      eventParams.gaEventCategory = undefined;
      eventParams.gaEventLabel = undefined;
      eventParams.gaEventValue = undefined;
      eventParams.loginStatus = undefined;
      eventParams.netDepositFee = undefined;
      eventParams.paymentMethod = undefined;
      eventParams.promoCode = undefined;
      eventParams.productVersion = undefined;
      eventParams.raceName = undefined;
      eventParams.raceNumber = undefined;
      eventParams.raceStatus = undefined;
      eventParams.registrationStatus = undefined;
      eventParams.residenceState = undefined;
      eventParams.referrer = undefined;
      eventParams.runnerSelectionList = undefined;
      eventParams.screenName = undefined;
      eventParams.siteVersion = undefined;
      eventParams.sectionName = undefined;
      eventParams.videoName = undefined;
      eventParams.videoType = undefined;
      eventParams.withdrawAmount = undefined;
      eventParams.withdrawType = undefined;
      eventParams.trackName = undefined;
      eventParams.eventLabel = undefined;
      eventParams.url = undefined;
      eventParams.wagerAmount = undefined;
      eventParams.wagerName = undefined;
      eventParams.wagerType = undefined;
      eventParams.withdrawalAmount = undefined;
      eventParams.withdrawalType = undefined;
      eventParams.event = evName;
      eventParams.sport = undefined;
      eventParams.gaEventCategory = 'Deposit';
      eventParams.loginStatus = 'Logged In';
      eventParams.registrationStatus = 'Registered';
      eventParams.screenName = 'Deposit';
      eventParams.sectionName = 'Deposit';
      eventParams.siteVersion = _isTVG4() ? 'desktop' : 'mobile_web';
      eventParams.productVersion = _getProduct(
        ConfigurationFac.getApplicationContextItem('product')
      );
      return eventParams;
    }

    function _sendGTMEvent(_eventName, aditionalParams) {
      var finalParams = _baseParams(_eventName);

      if (angular.isObject(aditionalParams)) {
        finalParams = angular.extend(finalParams, aditionalParams);
      }

      if ($window.dataLayer) {
        $window.dataLayer.push(finalParams);
      }
      return finalParams;
    }

    function _isTVG4() {
      return $rootScope.layout === 'desktop';
    }

    function _eventScreenName() {
      if (_isTVG4() && $location.hash().length > 1) {
        return _formatGALAbelUpperCase($location.path().substring(1)) + '|' +
          _getScreenName($location.hash());
      }
      return _formatGALAbelUpperCase($location.path().split('/').length > 1 ?
        $location.path().split('/')[1] : '');
    }

    function _getSiteVersion(product) {
      var siteVersionKeys = {
        touch3: 'mobile_web',
        ios2: 'ios_native',
        fdrmobile: 'mobile_web',
        fdrios: 'ios_native',
        fdrandroid: 'android_native',
        androidwrapper: 'android_native',
        tvgandroid: 'android_native',
        iosnative: 'ios_native'
      };
      return siteVersionKeys[product] ? siteVersionKeys[product] : product.toUpperCase();
    }

    function _getProduct(product) {
      var productKeys = {
        touch3: 'MEP',
        ios2: 'iOS',
        fdrmobile: 'MEP',
        fdrios: 'MEP',
        fdrandroid: 'android_apk',
        androidwrapper: 'android_gps',
        tvgandroid: 'android_apk',
        iosnative: 'ios_native'
      };
      return productKeys[product] ? productKeys[product] : product.toUpperCase();
    }


    // Get Screenname for all GTM events
    function _tvg4ScreenName() {
      var url = $location.path().split('/');
      var urlToken = url[1];
      var sectionName = DMAScreenNames[urlToken];

      if (angular.isUndefined(sectionName)) {
        return '';
      }

      return sectionName;
    }


    function _getScreenName(name) {
      var screenName;

      switch (name) {
        case 'wallet':
          screenName = 'My Wallet';
          break;
        case 'deposit':
          screenName = 'Deposit';
          break;
        case 'withdraw':
          screenName = 'Withdraw';
          break;
        case 'reports':
          screenName = 'My Bets';
          break;
        case 'account':
          screenName = 'My Account';
          break;
        case 'handicapping-store':
          screenName = 'Handicapping Store';
          break;
        case 'free-pp':
          screenName = 'Free Past Performances';
          break;
        case 'talentpicks':
          screenName = 'TVG Picks';
          break;
        case 'my-tracks':
          screenName = 'My Tracks';
          break;
        case 'my-stable':
          screenName = 'My Stable';
          break;
        default:
          screenName = name;
      }

      return screenName;
    }

    function _tvg4SectionNameByURLSharp(name, params) {
      var parts = _URLParse(name);
      var section = parts.pathname.replace('/', '');
      var hash = parts.hash.replace('#', '');
      var splitHash = hash.split('+');
      var translation = [section, 'translation'].join('.');
      var firstSection = Utilities.isEmpty(splitHash[0]) ? '' :
        [section, splitHash[0]].join('.');
      var sectionName = Utilities.prop(translation, DMASectionNames);
      var fullSectionName;
      var secondSection;

      if (splitHash.length > 1) {
        secondSection = [section, splitHash[1]].join('.');
        fullSectionName = [
          sectionName,
          (Utilities.prop(firstSection, DMASectionNames) || ''),
          (Utilities.prop(secondSection, DMASectionNames) || '')
        ].join(' | ');
      } else {
        fullSectionName = Utilities.isEmpty(firstSection) ?
          sectionName :
          [sectionName, (Utilities.prop(firstSection, DMASectionNames) || '')]
            .join(' | ');
      }

      return Utilities.isEmpty(params) ?
        fullSectionName : fullSectionName.concat(' | ')
        .concat(params.sectionName);
    }

    function _URLParse(url) {
      var parser = $window.document.createElement('a');
      parser.href = url;

      return {
        pathname: parser.pathname,
        hash: parser.hash
      };
    }

    function _tvg4SectionNameByURLToken(key, name, params) {
      var sectionName;

      if (angular.isString(name) && !Utilities.isEmpty(name)) {
        sectionName = DMASectionNames[key].translation + ' | ' +
          DMASectionNames[key][name];
      } else {
        sectionName = DMASectionNames[key].translation;
      }

      if (!Utilities.isEmpty(params) && !Utilities.isEmpty(params.sectionName)) {
        sectionName += ' | ' + params.sectionName;
      }

      return sectionName;
    }

    function _getURLForRetroCompatibleGTM() {
      var url = $location.url();

      if (url.indexOf('my-funds/deposit') > -1) {
        return '/my-profile#funds+deposit';
      } else if (url.indexOf('my-funds/bank') > -1) {
        return '/my-profile#funds+bank';
      } else if (url.indexOf('my-funds/withdraw') > -1) {
        return '/my-profile#funds+withdraw';
      }

      return url;
    }

    function _tvg4SectionName(params) {
      var url = _getURLForRetroCompatibleGTM().split('/');
      var urlToken = url[1];
      var defaultParam;

      if (urlToken && (urlToken.indexOf('#') > -1 ||
        urlToken.indexOf('%20') > -1)) {
        return _tvg4SectionNameByURLSharp(urlToken, params);
      }

      switch (urlToken) {
        case 'info':
          return _tvg4SectionNameByURLToken('siteinfo', url[2], params);
        case 'races':
          defaultParam = {
            sectionName: 'By Time'
          };
          return _tvg4SectionNameByURLToken('horseracing', urlToken,
            angular.isUndefined(params) || Utilities.isEmpty(params) ?
              defaultParam : params);
        case 'results':
          defaultParam = {
            sectionName: 'By Time'
          };
          return _tvg4SectionNameByURLToken('horseracing', urlToken,
            angular.isUndefined(params) || Utilities.isEmpty(params) ?
              defaultParam : params);
        case 'home':
          return _tvg4SectionNameByURLToken('home', null, params);
        case 'my-profile':
          return _tvg4SectionNameByURLToken('my-profile', 'profile', params);
        case 'my-favorite-tracks':
          return _tvg4SectionNameByURLToken('my-profile', 'my-favorite-tracks', params);
        case 'my-stable':
          return _tvg4SectionNameByURLToken('my-profile', 'my-stable', params);
        case 'my-tracks':
          return _tvg4SectionNameByURLToken('my-profile', 'my-tracks', params);
        case 'my-funds':
          return _tvg4SectionNameByURLToken('my-profile', 'funds', params);
        case 'my-bets':
          return _tvg4SectionNameByURLToken('my-profile', 'my-bets', params);
        case 'my-account-summary':
          return _tvg4SectionNameByURLToken('my-profile', 'my-account-summary', params);
        case 'registration':
          return _tvg4SectionNameByURLToken('registration', null, params);
        default:
          return '';
      }
    }

    return {
      sendGTMEvent: _sendGTMEvent,
      gtmCurrencyFormat: _gtmCurrencyFormat,
      formatGALAbelUpperCase: _formatGALAbelUpperCase,
      isTVG4: _isTVG4,
      eventScreenName: _eventScreenName,
      getScreenName: _getScreenName,
      tvg4ScreenName: _tvg4ScreenName,
      tvg4SectionName: _tvg4SectionName,
      getSiteVersion: _getSiteVersion,
      getProduct: _getProduct
    };
  }

  angular.module('TVG.Deposit').factory('ApiDepositsGTMFac', ApiDepositsGTMFac);
}());

(function () {
  'use strict';
  ApiWithdrawGTMFac.$inject = ['$rootScope', '$window', 'ConfigurationFac'];
  function ApiWithdrawGTMFac($rootScope, $window, ConfigurationFac) {
    function _gtmCurrencyFormat(val) {
      var tempBetAmount = val;
      try {
        tempBetAmount = tempBetAmount.toFixed(2);
      } catch (e) {
        // Purposely ignore the exception
      }
      return tempBetAmount;
    }

    /**
     *
     * @param {type} input
     * @returns {unresolved}
     */
    function _formatGALAbelUpperCase(input) {
      var result;

      if (input) {
        result = input.replace(/([A-Z]+)/g, ',$1').replace(/^,/, '');

        return result.replace(/,/g, ' ').replace(/\b\w/g, function (m) {
          return m.toUpperCase();
        });
      }

      return '';
    }


    /**
     *
     * @param {type} evName event name
     * @returns {object} defaulParams
     */
    function _baseParams(evName) {
      var eventParams = {};
      eventParams.accountId = undefined;
      eventParams.betAmount = undefined;
      eventParams.betName = undefined;
      eventParams.betType = undefined;
      eventParams.cableProvider = undefined;
      eventParams.cardType = undefined;
      eventParams.customerStatus = undefined;
      eventParams.dedicatedTVGChannel = undefined;
      eventParams.depositAmount = undefined;
      eventParams.depositMethod = undefined;
      eventParams.depositType = undefined;
      eventParams.errorMessage = undefined;
      eventParams.errorType = undefined;
      eventParams.gaEventAction = undefined;
      eventParams.gaEventCategory = undefined;
      eventParams.gaEventLabel = undefined;
      eventParams.loginStatus = undefined;
      eventParams.netDepositFee = undefined;
      eventParams.paymentMethod = undefined;
      eventParams.promoCode = undefined;
      eventParams.productVersion = undefined;
      eventParams.raceName = undefined;
      eventParams.raceNumber = undefined;
      eventParams.raceStatus = undefined;
      eventParams.registrationStatus = undefined;
      eventParams.residenceState = undefined;
      eventParams.referrer = undefined;
      eventParams.runnerSelectionList = undefined;
      eventParams.screenName = undefined;
      eventParams.siteVersion = undefined;
      eventParams.sectionName = undefined;
      eventParams.videoName = undefined;
      eventParams.videoType = undefined;
      eventParams.withdrawAmount = undefined;
      eventParams.withdrawType = undefined;
      eventParams.trackName = undefined;
      eventParams.url = undefined;
      eventParams.wagerAmount = undefined;
      eventParams.wagerName = undefined;
      eventParams.wagerType = undefined;
      eventParams.withdrawalAmount = undefined;
      eventParams.withdrawalType = undefined;
      eventParams.page = '';
      eventParams.accountId = '';
      eventParams.residenceState = '';
      eventParams.event = evName;
      eventParams.gaEventCategory = 'Withdraw';
      eventParams.loginStatus = 'Logged In';
      eventParams.registrationStatus = 'Registered';
      eventParams.screenName = 'Withdraw';
      eventParams.sectionName = 'Withdraw';
      eventParams.siteVersion = isTVG4() ? 'desktop' : 'mobile_web';
      eventParams.productVersion =
        _getProduct(ConfigurationFac.getApplicationContextItem('product'));
      return eventParams;
    }

    function _sendGTMEvent(_eventName, aditionalParams) {
      var finalParams = _baseParams(_eventName);

      if (angular.isObject(aditionalParams)) {
        finalParams = angular.extend(finalParams, aditionalParams);
      }

      if ($window.dataLayer) {
        $window.dataLayer.push(finalParams);
      }
    }

    function _getSiteVersion(product) {
      var siteVersionKeys = {
        touch3: 'mobile_web',
        ios2: 'ios_native',
        fdrmobile: 'mobile_web',
        fdrios: 'ios_native',
        fdrandroid: 'android_native',
        androidwrapper: 'android_native',
        tvgandroid: 'android_native',
        iosnative: 'ios_native'
      };
      return siteVersionKeys[product] ? siteVersionKeys[product] : product.toUpperCase();
    }

    function _getProduct(product) {
      var productKeys = {
        touch3: 'MEP',
        ios2: 'iOS',
        fdrmobile: 'MEP',
        fdrios: 'MEP',
        fdrandroid: 'android_apk',
        androidwrapper: 'android_gps',
        tvgandroid: 'android_apk',
        iosnative: 'ios_native'
      };
      return productKeys[product] ? productKeys[product] : product.toUpperCase();
    }

    function isTVG4() {
      return $rootScope.layout === 'desktop';
    }

    return {
      sendGTMEvent: _sendGTMEvent,
      gtmCurrencyFormat: _gtmCurrencyFormat,
      formatGALAbelUpperCase: _formatGALAbelUpperCase,
      isTVG4: isTVG4,
      getSiteVersion: _getSiteVersion,
      getProduct: _getProduct
    };
  }

  angular.module('TVG.Withdraw').factory('ApiWithdrawGTMFac', ApiWithdrawGTMFac);
}());

(function () {
  'use strict';

  applePayFac.$inject = ['$compile', '$rootScope', 'NotificationService', 'ApiDepositsGTMFac', 'Utilities', 'ConfigurationFac', 'APPLE_PAY_VERSION', '$q', '$http', '$filter', '$document', '$window'];
  function applePayFac(
    $compile,
    $rootScope,
    NotificationService,
    ApiDepositsGTMFac,
    Utilities,
    ConfigurationFac,
    APPLE_PAY_VERSION,
    $q,
    $http,
    $filter,
    $document,
    $window
  ) {
    var brainTreeEndpoint = Utilities.endpoint('brt');
    var applepay = {};

    /* This variables are meant for Apple Pay quick deposits swift implementation,
     so we can have a reference of this values instead of duplicating functions */
    var iOSdepositAmount = '';
    var iOSaccountNumber = '';
    var iOScontext = '';
    var iOSsuccessCallback = null;

    /**
     * Get labels from CMS
     * @param  {string} name
     * @return {[string]}      [label]
     */
    var getFromCMS = function (name) {
      return $filter('CMSLabels')(name, 'applepayLabels');
    };

    /**
     * Create an API error instance
     * Try to fetch an error message from the CMS (using the error code)
     * If none is found, use the error.message as a fallback
     *
     * @param  {Array} errors [description]
     * @return {Error}     [description]
     */
    var createApiError = function (data) {
      var apiError = new Error();
      var error = data[0] || {};
      var applePayError = getFromCMS(error.code);

      apiError.message = applePayError || error.message;
      apiError.code = error.code;
      apiError.data = error.data || {};
      return apiError;
    };

    var checkError = function (response) {
      return $q(function (resolve, reject) {
        return reject(createApiError([{
          message: _.get(response, 'data.message'),
          code: response.status,
          data: response.data
        }]));
      });
    };

    /**
     * Add the headers needed to perform API calls
     *
     * @return {object}: Header Object
     */
    var addHeaders = function (options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext())
      };

      if (Utilities.prop('cache', options)) {
        headers = _.extend({}, {
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }, headers);
      }
      return headers;
    };

    /**
     * request
     * @param  {Object} data
     * @param  {string} data.url
     * @param  {string} data.method
     * @param  {Object} data.data
     *
     * @return {Promise}
     */
    var request = function (params) {
      var defaults = {
        headers: addHeaders(),
        method: 'POST'
      };

      return $http(_.extend({}, defaults, params))
        .catch(function (err) {
          return checkError(err);
        })
        .then(function (response) {
          response.data = _.assign({}, response.data, { statusCode: response.status });
          return response;
        })
        .then(Utilities.prop('data'));
    };

    var getToken = function (accountNumber) {
      var path = 'users/' + accountNumber + '/client-token';

      return request({
        url: brainTreeEndpoint(path),
        method: 'GET'
      })
        .then(Utilities.prop('token'));
    };

    var applePayDepositAttempt = function (depositAmount, isInQuickDeposits) {
      ApiDepositsGTMFac.sendGTMEvent('deposit', {
        gaEventCategory: 'Deposit',
        gaEventAction: 'Apple Pay Attempt',
        gaEventLabel: undefined,
        depositType: 'Apple Pay',
        module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
        depositAmount: depositAmount
      });
    };

    var applePayDepositFailAPI = function (depositAmount, isInQuickDeposits, error) {
      ApiDepositsGTMFac.sendGTMEvent('deposit', {
        event: 'deposit',
        gaEventCategory: 'Deposit',
        gaEventAction: 'Apple Pay Error',
        gaEventLabel: error,
        depositType: 'Apple Pay',
        module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
        depositAmount: depositAmount
      });
    };

    var applePayDepositPanelOpen = function (depositAmount, isInQuickDeposits) {
      ApiDepositsGTMFac.sendGTMEvent('deposit', {
        gaEventCategory: 'Deposit',
        gaEventAction: 'Open',
        gaEventLabel: 'Apple Pay',
        depositType: 'Apple Pay',
        module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
        depositAmount: depositAmount
      });
    };

    /**
     * Send nonce from braintree payment
     * @param  {String} accountNumber
     * @param  {String} nonce
     * @param  {String} amount
     * @param  {String} deviceData
     * @return {String} BrainTree token
     */
    var sendNonce = function (accountNumber, nonce, amount, deviceData) {
      var path = 'users/' + accountNumber + '/deposits';

      return request({
        url: brainTreeEndpoint(path),
        method: 'POST',
        data: {
          nonce: nonce,
          amount: amount,
          deviceData: deviceData
        }
      })
        .then(Utilities.prop('balance'));
    };

    /**
     * Method to handle the sightline workaround modal
     * @param {object} applePayErrorModalConfigParam
     * @return null
     */
    var setErrorModal = function (applePayErrorModalConfigParam) {
      $window.ReactInjector.renderApplePayRedirect(
        document.getElementById('injected-modal'), //eslint-disable-line
        {
          sharedState: { isOpen: true },
          title: 'Deposit Declined',
          buttonText: applePayErrorModalConfigParam.buttonText,
          buttonTextSecond: applePayErrorModalConfigParam.buttonTextSecond,
          buttonTextCustomerSupport: applePayErrorModalConfigParam.buttonTextCustomerSupport,
          buttonCallback: applePayErrorModalConfigParam.buttonCallback,
          buttonCallbackSecond: applePayErrorModalConfigParam.buttonCallbackSecond,
          buttonCallbackCustomerSupport: applePayErrorModalConfigParam.buttonCallbackCustomerSupport, // eslint-disable-line
          textMain: applePayErrorModalConfigParam.textMain,
          textCustomerSupport: applePayErrorModalConfigParam.textCustomerSupport

        }
      );
    };

    /**
     * Method to submit the nonce generated from the Braintree to our BE
     * @param {string} nonce
     * @param {string} accountNumber
     * @param {string} depositAmount
     * @param {string} deviceData
     * @param {any} session
     * @param {string} context
     * @param {function} successCallback
     * @param {object} applePayErrorModalConfigParam
     * @param {boolean} isInQuickDeposits
     * @return null
     */
    var sendNonceToBE = function (
      nonce,
      session,
      accountNumber,
      depositAmount,
      deviceData,
      context,
      successCallback,
      applePayErrorModalConfigParam,
      isInQuickDeposits
    ) {
      sendNonce(
        accountNumber,
        nonce,
        depositAmount,
        deviceData
      )
        .then(function (data) {
          // call `completePayment` to dismiss the Apple Pay sheet.
          session.completePayment($window.ApplePaySession.STATUS_SUCCESS);

          // has to be called before the NotificationService or it will hide it
          if (angular.isFunction(successCallback)) {
            successCallback(data);
          }

          NotificationService.success(
            null,
            getFromCMS('transactionSuccessful'),
            context
          );

          ApiDepositsGTMFac.sendGTMEvent('deposit', {
            event: 'deposit',
            gaEventCategory: 'Deposit',
            gaEventAction: 'Deposit Success',
            gaEventLabel: undefined,
            depositType: 'Apple Pay',
            module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
            depositAmount: data
          });
        })
        .catch(function (error) {
          var data = error.data || {};

          switch (data.code) {
            case 159407:
            case 159500:
            case 159501:
            case 159502:
              // Braintree error
              if (!isInQuickDeposits) {
                setErrorModal(applePayErrorModalConfigParam);
              }
            default: // eslint-disable-line
              NotificationService.error(
                null,
                getFromCMS(data.code) || getFromCMS('generalError'),
                context
              );
          }

          ApiDepositsGTMFac.sendGTMEvent('deposit', {
            event: 'deposit',
            gaEventCategory: 'Deposit',
            gaEventAction: 'Deposit Error',
            gaEventLabel: data.exception,
            depositType: 'Apple Pay',
            module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
            depositAmount: depositAmount
          });

          session.abort();
        });
    };

    /**
     * Method to submit the nonce generated from the Braintree to our BE from our iOS implementation
     * @param {string} nonce
     * @param {string} deviceData
     * @return null
     */
    var iOSQuickDepositSendNonceToBE = function (
      nonce,
      deviceData
    ) {
      sendNonce(
        iOSaccountNumber,
        nonce,
        iOSdepositAmount,
        deviceData
      )
        .then(function (data) {
          // TODO: handle post message origins with configuration
          if ($window.parent) {
            $window.parent.postMessage({
              isSuccessful: true
            }, '*');
          }

          if (angular.isFunction(iOSsuccessCallback)) {
            iOSsuccessCallback(data);
          }

          NotificationService.success(
            null,
            getFromCMS('transactionSuccessful'),
            iOScontext
          );


          ApiDepositsGTMFac.sendGTMEvent('deposit', {
            event: 'deposit',
            gaEventCategory: 'Deposit',
            gaEventAction: 'Deposit Success',
            gaEventLabel: undefined,
            depositType: 'Apple Pay',
            module: 'Quick Deposit',
            depositAmount: data
          });
        })
        .catch(function (error) {
          var data = error.data || {};
          // TODO: handle post message origins with configuration
          if ($window.parent) {
            $window.parent.postMessage({
              isSuccessful: false
            }, '*');
          }

          NotificationService.error(
            null,
            getFromCMS(data.code) || getFromCMS('generalError'),
            iOScontext
          );

          ApiDepositsGTMFac.sendGTMEvent('deposit', {
            event: 'deposit',
            gaEventCategory: 'Deposit',
            gaEventAction: 'Deposit Error',
            gaEventLabel: data.exception,
            depositType: 'Apple Pay',
            module: 'Quick Deposit',
            depositAmount: iOSdepositAmount
          });
        });
    };

    /**
     * Method to send when we submit the nonce to BE, this is just for security reasons https://developers.braintreepayments.com/guides/advanced-fraud-management-tools/device-data-collection/javascript/v3
     * @param {any} client
     * @return Promise
     */
    applepay.createDataCollector = function (client) {
      var deferred = $q.defer();

      $window.braintree.dataCollector.create({
        client: client,
        applepay: true
      })
        .then(function (dataCollectorInstance) {
          deferred.resolve(dataCollectorInstance.deviceData);
        })
        .catch(function (error) {
          deferred.resolve(error);
        });

      return deferred.promise;
    };

    function handlePostMessageQuickDeposits(event) {
      var data = event.data;
      var payload = data.payload;

      if (payload.message === 'braintreeClientFailed') {
        applepay.handleNativeApplePayFailure(iOScontext);
      }

      if (payload.message === 'paymentRequestInvalid') {
        applepay.handleNativePaymentRequestInvalid(iOScontext);
      }

      if (payload.message === 'applePayPanelOpen') {
        applePayDepositPanelOpen(iOSdepositAmount, true);
      }

      if (payload.message === 'applePayAttempt') {
        applePayDepositAttempt(iOSdepositAmount, true);
      }

      if (payload.message === 'applePayAPIFail') {
        applePayDepositFailAPI(iOSdepositAmount, true, 'payment failed');
      }

      // Swift is submitting a payment so lets send to the BE
      if (payload.nonce && payload.deviceData) {
        iOSQuickDepositSendNonceToBE(
          payload.nonce,
          payload.deviceData
        );
      }
    }

    /**
     * Method to disable Apple Pay button if braintree client fails inside iOS and trigger error message for quick deposits
     * @param {string} context
     * @return {null}
     */
    applepay.handleNativeApplePayFailure = function (context) {
      // Variable to control apple pay native iOS instance
      applepay.iosApplePayInstanceFailure = true;

      NotificationService.error(
        null,
        getFromCMS('quickDepositsBraintreeClientFailMessage'),
        context
      );
    };

    /**
     * Method to throw error message of something went wrong when payment request is mounted incorrectly
     * @param {string} context
     * @return {null}
     */
    applepay.handleNativePaymentRequestInvalid = function (context) {
      NotificationService.error(
        null,
        getFromCMS('defaultError'),
        context
      );
    };

    /**
     * Creates a client instance of BrainTree
     * @param {string} accountNumber
     * @param {boolean} isInQuickDeposits
     * @param {function} handleBraintreeClientError
     * @param {string} context
     * @return Promise
     */
    applepay.createClientInstance = function (
      accountNumber,
      isInQuickDeposits,
      handleBraintreeClientError,
      context
    ) {
      var deferred = $q.defer();
      var braintreeClientInstance = null;

      getToken(accountNumber)
        .then(function (token) {
          if ($rootScope.product === 'ios2' && isInQuickDeposits) {
            iOScontext = context;

            $window.addEventListener('message', handlePostMessageQuickDeposits, false);

            // TODO: handle post message origins with configuration
            if ($window.parent) {
              $window.parent.postMessage({
                initBrainTreeIOS: token
              }, '*');
            }
          } else {
            $window.braintree.client.create({
              authorization: token
            })
              .then(function (clientInstance) {
                braintreeClientInstance = clientInstance;

                return $window.braintree.applePay.create({
                  client: clientInstance
                });
              })
              .then(function (applePayInstance) {
                return deferred.resolve({
                  applePayInstance: applePayInstance,
                  braintreeClientInstance: braintreeClientInstance
                });
              })
              .catch(function (err) {
                deferred.resolve(err);

                if (angular.isFunction(handleBraintreeClientError)) {
                  handleBraintreeClientError();
                } else {
                  NotificationService.error(
                    null,
                    getFromCMS('defaultError'),
                    context
                  );
                }
              });
          }
        })
        .catch(function (err) {
          if (angular.isFunction(handleBraintreeClientError)) {
            handleBraintreeClientError();
          } else {
            NotificationService.error(
              null,
              getFromCMS('quickDepositsBraintreeClientFailMessage'),
              context
            );
          }

          deferred.resolve(err);
        });

      return deferred.promise;
    };

    /**
     * Method that handles the onClick of apple pay button
     * @param {any} applePayInstance
     * @param {string} depositAmount
     * @param {string} fee
     * @param {string} feeDiscount
     * @param {string} accountNumber
     * @param {string} deviceData
     * @param {string} context
     * @param {function} successCallback
     * @param {object} applePayErrorModalConfigParam
     * @param {boolean} isInQuickDeposits
     * @return null
     */
    applepay.onApplePayDeposit = function (
      applePayInstance,
      depositAmount,
      fee,
      feeDiscount,
      accountNumber,
      deviceData,
      context,
      successCallback,
      applePayErrorModalConfigParam,
      isInQuickDeposits
    ) {
      var paymentRequest;
      var session;

      ApiDepositsGTMFac.sendGTMEvent('siteClick', {
        event: 'deposit',
        gaEventCategory: 'Deposit',
        gaEventAction: 'Deposit Attempt',
        gaEventLabel: 'Deposit Attempt',
        depositType: 'Apple Pay',
        module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
        depositAmount: depositAmount
      });

      // We handle iOS quick deposits natively
      if ($rootScope.product === 'ios2' && isInQuickDeposits) {
        // TODO: handle post message origins with configuration
        if ($window.parent) {
          $window.parent.postMessage({
            amount: depositAmount,
            label: 'TVG'
          }, '*');

          // Lets save our vars to the scope so we can access when trying to submit the nonce

          iOSaccountNumber = accountNumber;
          iOSdepositAmount = depositAmount;
          iOScontext = context;
          iOSsuccessCallback = successCallback;
        }
      } else {
        paymentRequest = applePayInstance.createPaymentRequest({
          total: {
            label: 'TVG',
            amount: depositAmount + fee - feeDiscount
          }
        });
        session = new $window.ApplePaySession(APPLE_PAY_VERSION, paymentRequest);

        NotificationService.clearBanner();

        // Validate merchant
        session.onvalidatemerchant = function (event) {
          applePayDepositPanelOpen(depositAmount, isInQuickDeposits);

          applePayInstance.performValidation({
            validationURL: event.validationURL,
            displayName: 'TVG'
          })
            .then(function (merchantSession) {
              session.completeMerchantValidation(merchantSession);
            })
            .catch(function () {
              NotificationService.error(
                null,
                getFromCMS('defaultError'),
                context
              );
              session.abort();
            });
        };

        session.onpaymentauthorized = function (event) {
          applePayDepositAttempt(depositAmount, isInQuickDeposits);

          applePayInstance.tokenize({
            token: event.payment.token
          })
            .then(function (payload) {
              // Send nonce to BE
              sendNonceToBE(
                payload.nonce,
                session,
                accountNumber,
                depositAmount,
                deviceData,
                context,
                successCallback,
                applePayErrorModalConfigParam,
                isInQuickDeposits
              );
            })
            .catch(function (error) {
              applePayDepositFailAPI(depositAmount, isInQuickDeposits, error);

              NotificationService.error(
                null,
                getFromCMS('generalError'),
                context
              );
              session.completePayment($window.ApplePaySession.STATUS_FAILURE);
            });
        };

        session.begin();
      }

      ApiDepositsGTMFac.sendGTMEvent('deposit', {
        gaEventCategory: 'Deposit',
        gaEventAction: 'Open',
        gaEventLabel: undefined,
        depositType: 'Apple Pay',
        module: isInQuickDeposits ? 'Quick Deposit' : 'My Funds',
        depositAmount: depositAmount
      });
    };

    return applepay;
  }

  angular
    .module('TVG.Deposit')
    .factory('ApplePayFac', applePayFac);
}());

'use strict';

angular.module('TVG.Deposit')
  .constant('SightlineDepositConfig', {
    ftype: 'SLN',
    name: 'TVG Pre Paid Card',
    id: 99999999999, // @TODO check if this is ok (needed in quick-deposit)
    limitTypeId: 12,
    min: 10,
    max: 25000,
    depositTypeId: 12
  })
  .constant('PaypalDepositConfig', {
    ftype: 'PAY',
    name: 'PayPal',
    id: 0,
    min: 5,
    max: 100000,
    limitTypeId: 13,
    depositTypeId: 13
  })
  .constant('ApplePayDepositConfig', {
    ftype: 'APPL',
    name: 'ApplePay',
    id: 0,
    min: 3,
    max: 25000,
    limitTypeId: 11,
    depositTypeId: 11
  })
  .constant('DMAScreenNames', {
    'my-profile': 'My Account',
    'my-tracks': 'My Account',
    'my-favorite-tracks': 'My Account',
    'my-funds': 'My Account',
    'my-bets': 'My Account',
    'my-account-summary': 'My Account',
    'my-stable': 'My Account',
    races: 'Races',
    race: 'Program',
    handicapping: 'Handicapping',
    info: 'Site Info',
    home: 'Home',
    results: 'Races',
    betslip: 'Bet Ticket',
    promotions: 'Promotions',
    'password-recovery': 'Credentials Recovery',
    'forgot-credentials': 'Credentials Recovery',
    'reset-credentials': 'Credentials Recovery',
    registration: 'Registration'
  })
  .constant('DMASectionNames', {
    'my-profile': {
      translation: 'My Account',
      'my-tracks': 'My Tracks',
      'my-favorite-tracks': 'My Favorite Tracks',
      funds: 'My Funds',
      'my-bets': 'My Bets',
      'my-account-summary': 'My Account Summary',
      profile: 'My Profile',
      deposit: 'Deposit',
      bank: 'Payment Management',
      withdraw: 'Withdraw',
      'my-stable': 'My Stable'
    },
    handicapping: {
      translation: 'Handicapping',
      'handicapping-store': 'Handicapping Store',
      'free-pp': 'Free Past Performances',
      talentpicks: 'Talent Picks',
      racereplays: 'Race Replays'
    },
    promotions: {
      translation: 'Promotions',
      'wager-rewards': 'Wager Rewards'
    },
    horseracing: {
      translation: 'Races',
      races: 'Full Schedule',
      results: 'Results'
    },
    home: {
      translation: 'Home | Home Page'
    },
    programpage: {
      translation: 'Program Page'
    },
    siteinfo: {
      translation: 'Site Info',
      privacypolicy: 'Privacy Policy',
      wagerresponsibly: 'Wager Responsibly',
      termsandconditions: 'Terms and Conditions'
    },
    betslip: {
      translation: 'Bet Ticket',
      default: 'Bet Ticket Page'
    },
    'password-recovery': {
      translation: 'Info'
    },
    'reset-credentials': {
      translation: 'Credentials Setup'
    },
    'forgot-credentials': {
      translation: 'Credentials Recovery | Start'
    },
    registration: {
      translation: 'Registration'
    }
  })
  .constant('depositMinAmountOverrides', [
    { depositType: 'ACH', minLimit: 5.00 },
    { depositType: 'CC', minLimit: 5.00 },
    { depositType: 'CCS', minLimit: 5.00 },
    { depositType: 'DEB', minLimit: 5.00 },
    { depositType: 'DEBS', minLimit: 5.00 },
    { depositType: 'CHK', minLimit: 5.00 },
    { depositType: 'IBC', minLimit: 5.00 },
    { depositType: 'PAY', minLimit: 5.00 },
    { depositType: 'SLP', minLimit: 10.00 }
    // { depositType: 'MPAK', minLimit: 0.00 },
    // { depositType: 'OTR', minLimit: 0.00 },
    // { depositType: 'PNM', minLimit: 0.00 },
    // { depositType: 'VIWD', minLimit: 0.00 }
  ])
  .constant('DEPOSIT_TYPES', {
    ACH_ON_FILE: 1,
    ACH_NEW: 2, // or 'INSTANT_BETCASH'?
    CARD_ON_FILE: 3,
    CARD_NEW: 4,
    GREENDOT_MONEY_PAK: 5,
    CREDIT_CARD_NEW: 6,
    OTHER: 9,
    APPLE_PAY: 11,
    SIGHTLINE: 12, // should match SightlineDepositConfig.depositTypeId
    SIGHTLINE_V2: 13, // should match SightlineDepositConfig.depositTypeId
    PAYPAL: 13
  })
  .constant('APPLE_PAY_VERSION', 3)
  .constant('DepositPath', {
    tvg4: '/my-funds/deposit',
    touch2: '/deposit',
    touch3: '/deposit',
    ios: '/deposit/deposit',
    ios2: '/deposit',
    njx: '/deposit/deposit',
    fdrmobile: '/deposit',
    fdrios: '/deposit',
    fdrandroid: '/deposit',
    androidwrapper: '/deposit',
    tvgandroid: '/deposit'
  });

(function () {
  'use strict';

  DepositSrv.$inject = ['$http', '$q', '$filter', '$window', '$rootScope', 'Utilities', 'ConfigurationFac', 'DepositInitialDataFac', 'ApiDepositsGTMFac', 'SightlineSrv', 'UserFactory', 'DEPOSIT_TYPES', 'RequestContextHeaders', 'APPLE_PAY_VERSION', '$uibModal', '$location'];
  function DepositSrv(
    $http,
    $q,
    $filter,
    $window,
    $rootScope,
    Utilities,
    ConfigurationFac,
    DepositInitialDataFac,
    ApiDepositsGTMFac,
    SightlineSrv,
    UserFactory,
    DEPOSIT_TYPES,
    RequestContextHeaders,
    APPLE_PAY_VERSION,
    $uibModal,
    $location
  ) {
    var goToSln = false;
    var _depositInitialData = null;
    var tmpAmount = 0;
    var _transactionFee = 0;
    var _FeeDiscount = 0;
    var deposits = {
      user: UserFactory.build({}),
      accountId: null,
      gtmDepositErrorEvent: function () {
        return _gtmDepositErrorEvent();
      },
      getApplicationContextItem: function (item) {
        return ConfigurationFac.getApplicationContextItem(item);
      },
      getDepositDataConfig: function () {
        return _depositInitialData;
      },

      getInitialData: function () {
        deposits.accountId = '';
        return deposits.getAccountNumber().then(function (accountId) {
          deposits.accountId = accountId;
          return deposits.getProfile(accountId).then(function (data) {
            data.accountNumber = deposits.accountId;
            deposits.user = UserFactory.build(data);
            $rootScope.userSession = true;
            $rootScope.user = deposits.user;

            SightlineSrv
              .getSightlineFlowVersion(accountId).then(function (version) {
                $rootScope.sightlineFlowVersion = version;
                $rootScope.sightlineLoaded = true;
                return deposits.user;
              }).catch(function () {
                $rootScope.sightlineVersion = undefined;
              });
          });
        })
        .then(function () {
          return deposits.getStates();
        })
        .then(function (states) {
          return deposits.getDepositOptions(states);
        });
      },

      getProfile: function (accountId) {
        var url = '/uam/v1/users/' + accountId + '/profile';
        url = ConfigurationFac.getBaseServiceUrl() + url;
        return $http({
          method: 'GET',
          url: url,
          headers: _addHeaders()
        }).then(function (res) {
          return res.data;
        });
      },

      getUserPaymentDefault: function () {
        var url = '/uam/v1/users/' + deposits.user.get('accountNumber') + '/preferences/defaultPaymentMethod';
        url = ConfigurationFac.getBaseServiceUrl() + url;
        return $http({
          method: 'GET',
          url: url,
          headers: _addHeaders()
        }).then(function (res) {
          return Utilities.prop('preferences[0].value', res.data);
        }).catch(function () {
          return null;
        });
      },

      setUserPaymentDefault: function (paymentMethod) {
        var url = '/uam/v1/users/' + deposits.user.get('accountNumber') + '/preferences';
        url = ConfigurationFac.getBaseServiceUrl() + url;
        return $http({
          method: 'PUT',
          url: url,
          headers: _addHeaders(),
          data: {
            preferences: [
              {
                description: 'defaultPaymentMethod',
                metadata: angular.toJson(paymentMethod) || ''
              }
            ]
          }
        }).then(function () {
          return true;
        }).catch(function () {
          return false;
        });
      },

      getStates: function () {
        var url = '/uam/v1/states';
        url = ConfigurationFac.getBaseServiceUrl() + url;
        return $http({
          method: 'GET',
          url: url,
          headers: _addHeaders()
        }).then(function (res) {
          return res.data && res.data.states || [];
        });
      },

      buildAccountDetails: function () {
        var accDetails = {};
        if (deposits.user) {
          accDetails.accountHState = deposits.user.homeAddress.state;
          accDetails.accountNumber = deposits.user.accountNumber;
          accDetails.accountUsername = deposits.user.username;
        }
        return accDetails;
      },

      getDepositOptions: function (states) {
        var deferred = $q.defer();
        var accountId = deposits.user.get('accountNumber');
        var url = walletEndpoint('users') + '/' + accountId + '/deposit-options/';
        var urlMerchantId = brainTreeEndpoint('merchant');
        var headers = _addHeaders({ cache: true });
        var successCallback = function (depositOptionsData, canMakePaymentsWithActiveCard) {
          var cmsConfig = Utilities.attempt(
            function () {
              return angular.fromJson(
                $filter('CMSValue')('depositConfigAvailableOptions'));
            },
            function () {
              return ['IBC', 'CC', 'ACH', 'SLN'];
            }
          );

          var initialData = Object.assign(
            {
              accountDetails: deposits.buildAccountDetails(),
              states: DepositInitialDataFac.parseStates(states || [])
            },
            DepositInitialDataFac.buildPaymentOptions(
              depositOptionsData,
              cmsConfig,
              canMakePaymentsWithActiveCard
            )
          );

          _depositInitialData = initialData;

          deferred.resolve(initialData);
        };

        /* eslint-disable */
        $http.get(url, { headers: headers }).success(function (depositOptionsData) {
          if (
            $window.ApplePaySession &&
            $window.ApplePaySession.supportsVersion(APPLE_PAY_VERSION)
          ) {
            $http.get(urlMerchantId, { headers: headers }).success(function (data) {
              return $window.ApplePaySession.canMakePaymentsWithActiveCard(
                'merchant.' + data.merchantId
              )
                .then(function (canMakePaymentsWithActiveCard) {
                  console.log('Can make payments with active card', canMakePaymentsWithActiveCard); //eslint-disable-line
                  successCallback(depositOptionsData, canMakePaymentsWithActiveCard);
                });
            }).error(function () {
              successCallback(depositOptionsData);
            });
          } else {
            successCallback(depositOptionsData);
          }
        }).error(function (data) {
          deferred.reject(data);
        });

        return deferred.promise;
      },


      /**
       * Get deposit initial data:
       * - available payment options
       * - available payment options from CMS
       * - card types hash
       * - payment types hash
       * (...)
       *
       * @return {Promise}
       */
      getDepositInitialData: function () {
        var deferred = $q.defer();
        var url = _baseUrl() + 'depositInitialData?showAccountDetails=true';
        var headers = _addHeaders({ cache: true });

        // @TODO: may be factored to remove promise and use $http only?
        /* eslint-disable */
        $http.get(url, { headers: headers }).success(function (data) {
        /* eslint-enable */
          var cmsConfig;
          var restrictedDepositTypes;
          var message;

          if (data.status === 'success') {
            deposits.user = UserFactory.build(data.response.accountDetails);
            _depositInitialData = data.response;

            cmsConfig = Utilities.attempt(
              function () {
                return angular.fromJson(
                  $filter('CMSValue')('depositConfigAvailableOptions'));
              },
              function () {
                return ['IBC', 'CC', 'ACH'];
              }
            );

            restrictedDepositTypes = DepositInitialDataFac
              .getDepositRestrictedTypes(data.response, cmsConfig);

            cmsConfig = cmsConfig.filter(function (value) {
              return restrictedDepositTypes.indexOf(value) === -1;
            });

            if (cmsConfig.length === 0) {
              return deferred.reject('depositRestrictions');
            }

            if (cmsConfig.indexOf('ACH') === -1) {
              /* eslint-disable */
              data.response.achOnFile = [];
              /* eslint-enable */
            }

            deferred.resolve(DepositInitialDataFac.buildInitialData(
              data.response,
              _getTypeEnumMapValues(),
              cmsConfig)
            );

            deposits.updateCustomerStatus();
          } else {
            message = Utilities.prop('response.errorMessage', data) ||
              'UnknownError';

            _gtmDepositErrorEvent(
              ApiDepositsGTMFac.formatGALAbelUpperCase(message), data);

            deferred.reject(data);
          }
        }).error(function (data) {
          var message = Utilities.prop('response.errorMessage', data) ||
            'UnknownError';

          _gtmDepositErrorEvent(
            ApiDepositsGTMFac.formatGALAbelUpperCase(message), data);

          deferred.reject(data);
        });

        return deferred.promise;
      },
        /**
       * Get deposit status after transferToTVG with the new deposit flow
       */
      getDepositStatus: function (url) {
        var accountId = deposits.user.get('accountNumber');
        var uuid = url.split('deposits/').length > 0 ? (url.split('deposits/')[1].split('/status')[0]) : null;
        var locationUrl = url;
        if (!locationUrl.contains('http') && uuid) {
          locationUrl = walletEndpoint('users') + '/' + accountId + '/deposits/' + uuid + '/status';
        }
        return request({
          url: locationUrl,
          method: 'GET'
        });
      },
        /**
       * Get user account number incase it's not previously loaded
       */
      getAccountNumber: function () {
        return request({
          url: usaEndpoint('session') + '/context',
          method: 'GET'
        }).then(function (data) {
          if (data.accountNumber) {
            deposits.accountId = data.accountNumber;
            $rootScope.userSession = true;
            if (!$rootScope.user) {
              $rootScope.user = {accountNumber:  data.accountNumber};
            } else {
              $rootScope.user.accountNumber = data.accountNumber
            }
          }
          return data.accountNumber;
        }).catch(function (err) {
          return err;
        });
      },
      getDepositFee: function (depositType, amount) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var config = { headers: headers };
        var accountId = deposits.user.get('accountNumber');
        var url;
        var newFeeEndpoint = false;

        switch (depositType) {
          case 1: // IBC
            url = achEndpoint('users') + '/' + accountId + '/deposits/fee';
            config.params = { depositAmount: amount };
            newFeeEndpoint = true;
            break;
          case 4: // ACH
            url = achEndpoint('users') + '/' + accountId + '/deposits/fee';
            config.params = { depositAmount: amount };
            newFeeEndpoint = true;
            break;
          case 12: // SLN
            url = sightlineEndpoint('user') + '/' + accountId + '/deposit/fee';
            config.params = { depositAmount: amount };
            newFeeEndpoint = true;
            break;
          case 2: // CC
              url = ccpEndpoint('users') + '/' + accountId + '/deposits/fee';
              config.params = { depositAmount: amount };
              newFeeEndpoint = true;
              break;
          case 3: // DEB
              url = ccpEndpoint('users') + '/' + accountId + '/deposits/fee';
              config.params = { depositAmount: amount };
              newFeeEndpoint = true;
              break;
          case 11: // APPL
            url = brainTreeEndpoint('users') + '/' + accountId + '/deposits/fees';
            config.params = {
              paymentType: 'APPL',
              amount: amount
            };
            newFeeEndpoint = true;
            break;
          default:
            return deferred.promise;
        }

        $http.get(url, config)
          .success(function (data) {
            if (newFeeEndpoint) {
              _transactionFee = data.feeAmount || 0;
              _FeeDiscount = data.feeRefundAmount || 0;
              data.useNewFeeFlow = true;
              data.RequestedAmount = amount;
              deferred.resolve(_depositTransactionFeeBuilder(
                data, depositType));
            } else {
              if (data.status === 'success') {
                _transactionFee = Utilities.prop('response.Fee', data) || 0;
                _FeeDiscount = Utilities.prop('response.FeeDiscount', data) || 0;
                deferred.resolve(_depositTransactionFeeBuilder(
                  data.response, depositType));
              } else {
                deferred.reject(data);
              }
            }
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },

      makeCreditDebitDepositNewFlow: function (
                                        amount,
                                        bankName,
                                        cardNumber,
                                        cardTypeId,
                                        nameOnCard,
                                        cardVerificationNumber,
                                        month,
                                        year,
                                        cardTypeDesc,
                                        sightlineFlowVersion) {
        var accountId = deposits.user.get('accountNumber');
        var url = ccpEndpoint('users') + '/' + accountId + '/deposit';
        var prefixPattern = /^(6|60|601|6011|65|64|64[4-9]|622[126-925])$/;
        var exactPattern = /^(6011|65|6221|6229|64[4-9]|622[126-925])\d*$/;

        var cardType = cardTypeDesc;
        var isDiscoverCard = false;
        tmpAmount = amount;

        if (exactPattern.test(cardNumber) || prefixPattern.test(cardNumber)) {
          isDiscoverCard = true;
        }

        if (isDiscoverCard && sightlineFlowVersion === '1') {
          $rootScope.$emit('redirectSightline-discCard');
        } else {
          return request({
            url: url,
            method: 'POST',
            data: {
              cardNumber: cardNumber,
              cardType: cardType,
              cardVerificationNumber: cardVerificationNumber,
              nameOnCard: nameOnCard,
              bankName: bankName,
              amount: amount,
              expirationMonth: month,
              expirationYear: year.toString(),
              headers: _addHeaders()
            }
          }, true);
        }
        return $q.defer().promise;
      },

      makeCreditDebitDeposit: function (addCardOnFile,
                                        amount,
                                        bankName,
                                        cardNumber,
                                        cardTypeId,
                                        nameOnCard,
                                        cardVerificationNumber,
                                        expirationDate,
                                        makeTransfer) {
        var deferred = $q.defer();
        var depositToMake;
        var prefixPattern = /^(6|60|601|6011|65|64|64[4-9]|622[126-925])$/;
        var exactPattern = /^(6011|65|6221|6229|64[4-9]|622[126-925])\d*$/;

        var cardType = null;

        tmpAmount = amount;

        depositToMake = _newCreditDebitCard(
          bankName,
          cardNumber,
          cardTypeId,
          nameOnCard,
          cardVerificationNumber,
          expirationDate,
          '',
          ''
        );
        depositToMake.depositAndTransfer = makeTransfer || false;

        if (exactPattern.test(cardNumber) || prefixPattern.test(cardNumber)) {
          cardType = 'DISCOVER';
        }

        if (cardType && cardType === 'DISCOVER') {
          deferred.reject({
            oldCardDepositFlow: true,
            exceptionCode: 'OLD_CCP_DISCOVER_CARD'
          });

          return deferred.promise;
        } else {
          $http({
            method: 'POST',
            url: _baseUrl() + 'CreditOrDebitCard?addCardOnFile=' +
            (addCardOnFile === true ? 'true' : 'false') + '&amount=' + amount,
            data: depositToMake,
            headers: _addHeaders()
          }).success(function (data) {
            data.response.depositType = 'CreditOrDebitCard';

            if (data.status === 'success') {
              deferred.resolve(_depositSuccessBuilder(data.response));
            } else {
              _gtmDepositErrorEvent('Credit', data);
              deferred.reject(data.response);
            }
          }).error(function (response) {
            deferred.reject(response);
          });
        }
        return deferred.promise;
      },

      // Bet cash (other account)
      getBankName: function (routingNumber) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url = achEndpoint('bank') + '/' + routingNumber;

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            var resp;

            resp = {
              routingNumber: routingNumber,
              bankName: data.name
            };
            deferred.resolve(resp);
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },
      makeInstantBetCashDeposit: function (
          pinOrPassword,
          bankName,
          checkingAccountNumber,
          bankRoutingNumber,
          driversLicenseNumber,
          driversLicenseStateAbbr,
          depositAmount,
          addCardOnFile,
          makeTransfer
        ) {
        var deferred = $q.defer();
        tmpAmount = depositAmount;

        $http({
          method: 'POST',
          url: _baseUrl() + 'InstantBetCash',
          data: {
            pinOrPassword: pinOrPassword,
            bankName: bankName,
            checkingAccountNumber: checkingAccountNumber,
            bankRoutingNumber: bankRoutingNumber,
            driversLicenseNumber: driversLicenseNumber,
            driversLicenseStateAbbr: driversLicenseStateAbbr,
            depositAmount: depositAmount,
            addCardOnFile: addCardOnFile,
            depositAndTransfer: makeTransfer || false
          },
          headers: _addHeaders()
        }).success(function (data) {
          var depositSuccess;

          /* eslint-disable */
          data.response.depositType = 'InstantBetCash';
          /* eslint-enable */

          if (data.status === 'success') {
            depositSuccess = {
              DepositResult: data.response
            };

            deferred.resolve(_depositSuccessBuilder(depositSuccess));
          } else {
            _gtmDepositErrorEvent('InstantBetCash', data);
            deferred.reject(data.response);
          }
        }).error(function (data) {
          deferred.reject(data);
        });

        return deferred.promise;
      },
      makeInstantBetCashDepositNewFlow: function (
          routingNumber,
          bankAccountNumber,
          licenseNumber,
          licenseState,
          depositAmount
        ) {
        var accountId = deposits.user.get('accountNumber');
        var url = achEndpoint('users') + '/' + accountId + '/deposits';
        var postData = {
          bankRoutingNumber: routingNumber,
          bankAccountNumber: bankAccountNumber,
          dlNumber: licenseNumber,
          dlState: licenseState,
          amount: depositAmount
        };
        tmpAmount = depositAmount;

        return request({
          url: url,
          method: 'POST',
          data: postData
        }, true);
      },
      makeCardOnFileDepositNewFlow: function (cvn, amount, cardId) {
        var accountId = deposits.user.get('accountNumber');
        var url = ccpEndpoint('users') + '/' + accountId + '/bankCard/' + cardId + '/deposit';
        tmpAmount = amount;
        return request({
          url: url,
          method: 'POST',
          data: {
            cardVerificationNumber: cvn,
            amount: amount,
            headers: _addHeaders()
          }
        }, true);
      },
      makeCardOnFileDeposit: function (cvn, amount, cardId) {
        var deferred = $q.defer();
        tmpAmount = amount;

        $http({
          method: 'POST',
          url: _baseUrl() + 'CardOnFile',
          data: {
            cvn: cvn,
            cardId: cardId,
            amount: amount
          },
          headers: _addHeaders()
        }).success(function (data) {
          data.response.depositType = 'CardOnFile';

          if (data.status === 'success') {
            deferred.resolve(_depositSuccessBuilder(data.response));
          } else {
            _gtmDepositErrorEvent('Credit', data);
            deferred.reject(data.response);
          }
        }).error(function (data) {
          deferred.reject(data);
        });

        return deferred.promise;
      },

      makeACHOnFileDepositNewFlow: function (
        amount,
        achOnFileID) {
        var postData = {
          amount: amount,
          headers: _addHeaders()
        };
        var accountId = deposits.user.get('accountNumber');
        var url = achEndpoint('users') + '/' + accountId + '/bankAccount/' + achOnFileID + '/deposits';
        tmpAmount = amount;

        return request({
          url: url,
          method: 'POST',
          data: postData
        }, true);
      },

      makeACHOnFileDeposit: function (
          driversLicenseNumber,
          amount,
          achOnFileID,
          driversLicenseStateAbbr
        ) {
        var deferred = $q.defer();
        var postData = {
          driversLicenseNumber: driversLicenseNumber,
          achOnFileID: achOnFileID,
          driversLicenseStateAbbr: driversLicenseStateAbbr,
          amount: amount
        };
        tmpAmount = amount;

        $http({
          method: 'POST',
          url: _baseUrl() + 'AchOnFile',
          data: postData,
          headers: _addHeaders()
        }).success(function (data) {
          var depositSuccess;
          data.response.depositType = 'AchOnFile'; // eslint-disable-line

          if (data.status === 'success') {
            depositSuccess = {
              DepositResult: data.response
            };
            deferred.resolve(_depositSuccessBuilder(depositSuccess));
          } else {
            _gtmDepositErrorEvent('BetCash', data);
            deferred.reject(data.response);
          }
        }).error(function (data) {
          deferred.reject(data);
        });

        return deferred.promise;
      },
      makeSightlineDeposit: function (sightlineUser, amount) {
        return SightlineSrv.transferToTVG(sightlineUser, amount);
      },

      /**
       * Get the templates' filenames that must be rendered for each
       * type of quick deposit.
       *
       * Names must match the files present in templates/deposit/fields/.
       * (see more in quick-deposit.html)
       *
       * @return {Object} Description labels for quick deposit view
       */
      getQuickDepositForms: function () {
        return {
          CC: [
            'card-description-text',
            'card-verification-number'
          ],
          SLN: [
            'card-verification-number'
          ],
          ACH: [
            'ach-description-text'
          ],
          APPL: [
            'applepay-description-text'
          ]
        };
      },

      /**
       * Get the templates' filenames that must be rendered for each
       * type of deposit.
       *
       * Names must match the files present in templates/deposit/fields/.
       * (see more in deposit.html)
       *
       * @return {Object} Description labels for deposit view
       */
      getDepositForms: function () {
        return {
          NEW: {
            CC: [
              'card-type-selector',
              'card-number-input',
              'card-exp-date-and-cvn'
            ],
            IBC: [
              'bank-routing-number',
              'bank-account-number',
              'bank-name',
              'driver-license-number',
              'driver-license-state'
            ]
          },
          STORED: {
            CC: [
              'card-onfile-selector',
              'card-verification-number'
            ]
          }
        };
      },

      getExpirationDateValues: _getExpirationDateValues,

      /**
       * Make deposit according to the deposit type ID
       * @param  {Object} depositData  Deposit information
       * @return {Promise}
       */
      makeDeposit: function (depositData) {
        var selected;
        var month;
        var promise;

        switch (depositData.depositTypeId) {
          case DEPOSIT_TYPES.ACH_ON_FILE:
            selected = depositData.selectedOnFile || {};
            promise = deposits.makeACHOnFileDepositNewFlow(
                          depositData.amount,
                          selected.achId
                        );
            break;

          case DEPOSIT_TYPES.ACH_NEW:
            selected = depositData.selectedOnFile || {};
            promise = deposits.makeInstantBetCashDepositNewFlow(
                          depositData.routingNumber,
                          depositData.accountNumber,
                          depositData.licenseNumber,
                          depositData.stateSelectedOption.abbreviation,
                          depositData.amount
                        );
            break;
          case DEPOSIT_TYPES.CARD_ON_FILE:
            promise = deposits.makeCardOnFileDepositNewFlow(
              depositData.cardSecurityNumber,
              depositData.amount,
              depositData.selectedOnFile.id
            );
            break;
          case DEPOSIT_TYPES.CARD_NEW:
            month = depositData.expirationMonth.toString();

            if (month.length === 1) {
              month = '0' + month;
            }

            promise = deposits.makeCreditDebitDepositNewFlow(
              depositData.amount,
              '',
              depositData.cardNumber.toString(),
              depositData.selectedCardType.cardTypeId,
              '',
              depositData.cardSecurityNumber,
              month,
              depositData.expirationYear,
              depositData.selectedCardType.type,
              $rootScope.sightlineFlowVersion
          );
            break;

          case DEPOSIT_TYPES.GREENDOT_MONEY_PAK:
            promise = deposits.makeGreenDotMoneyPakDeposit(
              depositData.amount, depositData.pakNumber
            );
            break;

          case DEPOSIT_TYPES.SIGHTLINE:
            promise = deposits.makeSightlineDeposit(
              depositData.sightlineUser,
              depositData.amount
            );
            break;

          case DEPOSIT_TYPES.SIGHTLINE_V2:
            promise = SightlineSrv.fundAndTransferToTVG(depositData);
            break;

          default:
            promise = $q.reject('Invalid deposit type selected');
            break;
        }

        return promise;
      },

      getAvailableAmountOptions: function (initialData) {
        var depositConfigAmountOptions = Utilities.attempt(
          function () {
            return angular.fromJson(
              $filter('CMSValue')('depositConfigAmountOptions'));
          },
          function () {
            return {
              firstTimeAmountList: [20, 50, 100],
              defaultAmountList: [20, 50, 100]
            };
          }
        );

        return initialData.madeFirstDeposit ?
          depositConfigAmountOptions.defaultAmountList :
          depositConfigAmountOptions.firstTimeAmountList;
      },
      setGoToSln: function (value) {
        goToSln = value;
      },
      getGoToSln: function () {
        var message = goToSln;
        goToSln = false;
        return message;
      },

      /**
       * Get the customer status from the the payment options
       * @return {String} Customer status
       */
      getCustomerStatus: function () {
        var hasInitialDeposit = this.getHasMadeInitialDeposit();
        return hasInitialDeposit ?
          'Returning' : 'First Time';
      },

      /**
       * Update CustomerStatus saved in rootScope
       */
      updateCustomerStatus: function () {
        $rootScope.hasInitialDeposit = deposits.getCustomerStatus();
      },

      /**
       * Get the "madeInitialDeposit" flag value
       * @return {Boolean}  Has the user made the initial deposit?
       */
      getHasMadeInitialDeposit: function () {
        if (!_depositInitialData || !_depositInitialData.availableOptions) {
          return false;
        }
        return !!_depositInitialData.availableOptions.HasMadeInitialDeposit;
      },

      /**
       * THIS FLAG WILL BE UPDATED WHEN A /depositInitialData is received
       *
       * Set the "madeInitialDeposit" flag value
       *
       * @param {Boolean} val  Value to set
       */
      _setHasMadeInitialDeposit: function (val) {
        // stop
        if (!_depositInitialData) { return this; }

        _depositInitialData.availableOptions = _depositInitialData.availableOptions || {};
        _depositInitialData.availableOptions.HasMadeInitialDeposit = !!val;

        return _depositInitialData.availableOptions.HasMadeInitialDeposit;
      },

      getDepositLandingTab: function (depositOptions, loadEnv) {
        var depositLandingTab = '';
        var initialTab = $location.search().initialTab;

        if(initialTab) {
          return {depositLandingTab: initialTab};
        }

        try {
          var message =  loadEnv === 'registration' ?
            $filter('CMSValue')('RMADefaultDepositLandingTab') :
            $filter('CMSValue')('DMADefaultDepositLandingTab');
          var capiDefaults = JSON.parse(message);

          var canUserMakeApplePayPayments = $window.ApplePaySession && ApplePaySession.supportsVersion(3) && $window.ApplePaySession.canMakePayments();

          // check if first default is Apple Pay and if it is check if safari is available
          if (capiDefaults.firstDefault === 'APPL' && canUserMakeApplePayPayments) {
            depositLandingTab = capiDefaults.firstDefault;
          } else if (capiDefaults.firstDefault === 'APPL' && !canUserMakeApplePayPayments) {
            depositLandingTab = capiDefaults.secondDefault;
          } else if (capiDefaults.firstDefault !== 'APPL') {
            depositLandingTab = capiDefaults.firstDefault;
          }
        } catch (e) {
          // Common default case when json is wrong in CAPI message
          depositLandingTab = 'CC';
        }

        var accountId = deposits.accountId;
        var deferred = $q.defer();
        var url = walletEndpoint('users') + '/' + accountId + '/deposits';
        var headers = { 'Content-Type': 'application/json' };
        var lastPaymentMethod;
        var hasMadeInitialDeposit = false;

        if ($rootScope.managePaymentMethodsRedirect) {
          depositLandingTab = $rootScope.managePaymentMethodsTab;
          return {depositLandingTab: depositLandingTab};
        }

        if (loadEnv === 'registration') {
          return {depositLandingTab: depositLandingTab};
        }

        /* eslint-disable */
        $http.get(url + '?pageSize=1', { headers: headers }).success(function (data) {
          /* eslint-enable */
          if (data.deposits.length > 0 && data.deposits[0].type !== '') {
            hasMadeInitialDeposit = true;
            lastPaymentMethod = data.deposits[0].type === 'SLP' ? 'SLN' : data.deposits[0].type;
            // check if last payment method used is on available deposit options
            if (search(lastPaymentMethod, 'ftype', depositOptions)) {
              depositLandingTab = lastPaymentMethod;
            } else if (lastPaymentMethod === 'ACH' && search('IBC', 'ftype', depositOptions)) {
              depositLandingTab = 'IBC';
            } else if (lastPaymentMethod === 'IBC' && search('ACH', 'ftype', depositOptions)) {
              depositLandingTab = 'ACH';
            }
          }

          deferred.resolve({depositLandingTab: depositLandingTab, hasMadeInitialDeposit: hasMadeInitialDeposit});
        }).error(function () {
          deferred.resolve({depositLandingTab: depositLandingTab, hasMadeInitialDeposit: false});
        });

        return deferred.promise;
      },

      getDepositLimits: function (accountId, paymentType, cardType) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url;

        if (paymentType === 'IBC' || paymentType === 'ACH') {
          url = walletEndpoint("users") + "/" + accountId + "/limits/ACH";
          $http
            .get(url, { headers: headers })
            .success(function (data) {
              var formattedResponse = formatPaymentLimit(data);
              deferred.resolve(formattedResponse);
            })
            .error(function (data) {
              deferred.reject(data);
            });

        } else if (paymentType === 'APPL') {
          url = walletEndpoint("users") + "/" + accountId + "/limits/APPL";
          $http
            .get(url, { headers: headers })
            .success(function (data) {
              deferred.resolve(data);
            })
            .error(function (data) {
              deferred.reject(data);
            });

        } else if (paymentType === 'CC' || paymentType === 'DEB') {
          var cardTypes = ["CC", "CCS", "DEB", "DEBS"];
          var cardLimits = [];
          url = walletEndpoint("users") + "/" + accountId + "/limits";

          $http
              .get(url, {headers: headers})
              .success(function (data) {
                data.accountDepositLimits.forEach(function(item) {
                  if (item.paymentType !== "ACH") {
                    cardLimits.push({
                      cardType: item.paymentType,
                      limitsResponse: formatPaymentLimit(item)
                    });
                  }
                });
                if (cardType) {
                  var singlePaymentTypeResult = cardLimits.filter(
                    function(item) {
                      return item.cardType === cardType;
                    }
                  );
                  return deferred.resolve({
                    minSingleDepositLimit: singlePaymentTypeResult[0].limitsResponse.minSingleDepositLimit,
                    remainingDepositLimit: singlePaymentTypeResult[0].limitsResponse.remainingDepositLimit
                  });
                }
                return deferred.resolve({cardLimits: cardLimits});
              }).error(function (data) {
                deferred.reject(data);
              });
        } else {
          deferred.reject({ useInitialDataDefault: true });
          return deferred.promise;
        }

        return deferred.promise;
      },

      getCardPaymentOptions: function (accountId, paymentType, cardType) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url;
        var paymentMethod = cardType ? cardType : paymentType;
        if (paymentMethod === "IBC") {
          paymentMethod = "ACH";
        }

        url = walletEndpoint("users") + "/" + accountId + "/payment-options";

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            var min;
            var max;

            data.forEach(function (item) {
              if (item.paymentType === paymentMethod) {
                min = item.minLimit;
                max = item.maxLimit;
              }
            });

            return deferred.resolve({
              minSingleDepositLimit: min,
              remainingDepositLimit: max
            });

          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },

      getPaymentTypeDepositLimit: function (accountId, paymentType, cardType) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url;

        switch (paymentType) {
          case 'IBC':
            url = achEndpoint('users') + '/' + accountId + '/deposits/limits';
            break;
          case 'ACH':
            url = achEndpoint('users') + '/' + accountId + '/deposits/limits';
            break;
          case 'CC':
              url = ccpEndpoint('users') + '/' + accountId + '/deposits/limits';
              break;
          case 'DEB':
              url = ccpEndpoint('users') + '/' + accountId + '/deposits/limits';
              break;
          case 'APPL':
            url = walletEndpoint('users') + '/' + accountId + '/limits/APPL';
              break;
          default:
            deferred.reject({ useInitialDataDefault: true });
            return deferred.promise;
        }

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            var limitMatch = null;
            if (
              data.cardLimits &&
              cardType &&
              (paymentType === "CC" || paymentType === "DEB")
            ) {
              limitMatch = data.cardLimits.filter(function(item) {
                return item.cardType === cardType;
              });
              if (limitMatch && limitMatch[0]) {
                //eslint-disable-next-line
                var min = limitMatch[0].limitsResponse.minSingleDepositLimit;
                //eslint-disable-next-line
                var max = limitMatch[0].limitsResponse.remainingDepositLimit;


                return deferred.resolve({
                  minSingleDepositLimit: min,
                  remainingDepositLimit: max
                });
              }
            }
            deferred.resolve(data);
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },

      getUserBankAccounts: function (accountId) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url = achEndpoint('users') + '/' + accountId + '/bankAccounts';

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },

      getCardsOnFile: function (accountId) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url = ccpEndpoint('users') + '/' + accountId + '/bankCards';

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },

      getPrepaidCardsOnFile: function (accountId) {
        var deferred = $q.defer();
        var headers = _addHeaders({ cache: true });
        var url = sightlineEndpoint('user') + '/' + accountId + '/account-info';

        $http.get(url,
          { headers: headers })
          .success(function (data) {
            deferred.resolve(data);
          }).error(function (data) {
          deferred.reject(data);
        });

        return deferred.promise;
      },

      getSuccessDepositModal: function(isACH) {
          var modalScope = $rootScope.$new();
          modalScope.isACH = isACH;
          modalScope.betNow = function (closeFn) {
            closeFn({ fromBetNow: true });
          };

          $uibModal
            .open({
              templateUrl:
                'src/templates/deposit/deposit-success-modal.html',
              scope: modalScope,
              windowTemplateUrl: 'src/templates/modal-window.html',
              backdropClass: 'tvgmodal-backdrop',
              windowClass: 'tvg-ui-modal-dialog tvgmodal-dma-redesign'
            })
            .result.then(function (res) {
              if (res && res.fromBetNow) {
                if ($window && $window.handleNativeMessages) {
                  $window.handleNativeMessages('CLOSE_DMA');
                } else if ($rootScope.isQuickDeposit) {
                    $rootScope.$broadcast('onCloseSuccessWindow');
                    if ($window.parent) {
                      $window.parent.postMessage(
                        {
                          type: 'close_deposit'
                        },
                        '*'
                      );
                    }
                } else if ($location.search().callback) {
                  Utilities.attempt(
                    function () {
                      var callbackDecoded = decodeURIComponent($location.search().callback);
                      var callbackSearchParams = new URLSearchParams(callbackDecoded)
                      var pgmDepositRedirect = $rootScope && $rootScope.activeFeatures && $rootScope.activeFeatures.pgmDepositRedirect;
                      if(pgmDepositRedirect && callbackSearchParams.getAll("wt").length > 0 && callbackSearchParams.getAll("bet").length > 0) {
                        // user came from program page, sending him back with bets
                        $window.location.href = '//' + callbackDecoded;
                      }
                      else{
                        $window.location.href = '//' + decodeURIComponent($location.search().callback.split("/")[0]);
                      }
                    }
                  );
                } else {
                  $window.location = "/"
                }
              }
            })
            .catch(function(error){
              console.log("modal error:", error);
            });
          }
    };

    var walletEndpoint = Utilities.endpoint('uwt');
    var achEndpoint = Utilities.endpoint('ach');
    var ccpEndpoint = Utilities.endpoint('ccp');
    var brainTreeEndpoint = Utilities.endpoint('brt');
    var sightlineEndpoint = Utilities.endpoint('slp');
    var usaEndpoint = Utilities.endpoint('usa');

    /**
     * Function to format a payment type object
     * @param  {Object}   item containing the information for a single payment type
     * @return {Object}   formated item
     */
    function formatPaymentLimit(item) {
      var formatedItem = {
        minSingleDepositLimit: item.minLimit,
        remainingDepositLimit: item.limitsEffective.limits.dailyLimit,
        userLimits: {
          dailyLimit: {
            depositLimit: item.limitsEffective.limits.dailyLimit,
            futureDepositLimit: item.limitsFuture.limits.dailyLimit,
            futureDate: item.limitsFuture.futureDailyDate
          },
          weeklyLimit: {
            depositLimit: item.limitsEffective.limits.weeklyLimit,
            futureDepositLimit: item.limitsFuture.limits.weeklyLimit,
            futureDate: item.limitsFuture.futureWeeklyDate
          },
          monthlyLimit: {
            depositLimit: item.limitsEffective.limits.monthlyLimit,
            futureDepositLimit: item.limitsFuture.limits.monthlyLimit,
            futureDate: item.limitsFuture.futureMonthlyDate
          }
        },
        tvgLimits: {
          dailyLimit: {
            depositLimit: item.limitsTvg.limits.dailyLimit
          },
          weeklyLimit: {
            depositLimit: item.limitsTvg.limits.weeklyLimit
          },
          monthlyLimit: {
            depositLimit: item.limitsTvg.limits.monthlyLimit
          },
          holdDays: item.limitsTvg.holdDays
        }
      };
      return formatedItem;
    }

    /**
     * checkTransaction
     * Check if the transaction failed, although the request did not return
     * any error status code.
     *
     * @param  {$httpResponse} response the response object from the $http call
     * @return {Promise}
     * @FIXME angular doesn't respect the Promise A+ standard
     */
    function checkTransaction(response) {
      return $q(function (resolve, reject) {
        if (Utilities.prop('data.errors', response)) {
          return reject(createApiError(response));
        }

        return resolve(response);
      });
    }

    /**
     * request
     * @param  {Object} data
     * @param  {string} data.url
     * @param  {string} data.method
     * @param  {string} data.headers
     * @param  {Object} data.data
     *
     * @return {Promise}
     */
    function request(data, fullResponse) {
      if (data) {
        data.headers = prepareHeaders(data.headers);
      }

      return $http(data)
        .then(checkTransaction)
        .then(function (response) { return fullResponse ? response : response.data; })
        .catch(function (err) {
          return $q.reject(createApiErrorFromHttpError(err));
        });
    }

    /**
     * Add default headers if needed
     * @param  {Object} headers  Headers to send
     * @return {Object}          Headers with defaults
     */
    function prepareHeaders(headers) {
      var defaultHeaders = {};
      var xTvgContext = RequestContextHeaders[$window.clientApp + '_' + $window.locationContext];

      defaultHeaders['Content-Type'] = 'application/json';
      defaultHeaders['x-tvg-context'] = xTvgContext;

      return _.defaults(headers || {}, defaultHeaders);
    }

      /**
     * Create an API error instance
     * @param  {Object} response  HTTP Response with nested errors
     * @return {Object}           Extracted errors
     */
    function createApiError(response) {
      var apiError = new ApiError();
      var responseError = response.data.errors[0];

      apiError.uri = response.config.url;
      apiError.message = responseError.message;
      apiError.code = responseError.code;

      return apiError;
    }

     /**
     * Create an API error instance from new HTTP code errors
     * @param  {Object} response  HTTP Response with nested errors
     * @return {Object}           Extracted errors
     */
    function createApiErrorFromHttpError(response) {
      var apiError = new ApiError();
      var responseError = response.data || {};

      apiError.uri = (response.config || {}).url;
      apiError.message = responseError.message;
      apiError.code = responseError.exception || responseError.code;
      apiError.exceptionCode = responseError.code;
      apiError.status = responseError.status;

      return apiError;
    }

        /**
     * @class ApiError
     * @extends Error
     */
    function ApiError() {
      this.uri = '';
      this.name = '';
      this.message = '';
      this.code = '';
      this.status = '';
      Error.apply(this, [].slice.call(arguments, 0));
    }

    ApiError.prototype = Object.create(Error.prototype);
    ApiError.prototype.constructor = ApiError;

    function search(nameKey, prop, myArray) {
      var i;
      for (i = 0; i < myArray.length; i++) {
        if (myArray[i][prop] === nameKey) {
          return myArray[i];
        }
      }
      return false;
    }

    function _getLoginStatus(errorMessage) {
      return [
        'ApiMissingUserSessionToken',
        'ApiUserSessionTimedOut',
        'ApiUserSessionNotFound'
      ].indexOf(errorMessage) !== -1 ? 'Logged Out' : 'Logged In';
    }

    function _gtmDepositErrorEvent(_depositType, _data) {
      var _errorMessage = Utilities.prop('response.errorMessage', _data) || null;
      var _isQuickDeposit = $rootScope.isQuickDeposit;
      var eventName = 'depositStandardError';
      var eventGAEventAction = 'Deposit Error';
      var eventGAEventLabel = _errorMessage;
      var _netDepositFee = ApiDepositsGTMFac.gtmCurrencyFormat(_transactionFee);
      var iframePos = 0;
      var iframePosQuick = 0;
      /* eslint-disable */
      var modalHeaders = document.getElementsByClassName('modal-header');
      /* eslint-enable */
      var p = {};
      if (ConfigurationFac.getApplicationContextItem('product') !== 'njx') {
        Utilities.attempt(
          function () {
            /* eslint-disable */
            if($window.document.domain === $window.parent.document.domain) {
              iframePos = $window.parent.document.getElementsByTagName('iframe').length;
              iframePosQuick = $window.parent.document.getElementsByTagName('iframe')[iframePos - 1]
                  .src.indexOf('quick') > -1;
            }
            /* eslint-enable */
          }
        );
      }

      if (_depositType && (deposits.user.has('homeAddress.StateAbbr') ||
        deposits.user.has('accountNumber'))) {
        if (!_isQuickDeposit && modalHeaders.length && modalHeaders[0] &&
          modalHeaders.innerHTML) {
          _isQuickDeposit = modalHeaders[0].innerHTML.indexOf('Quick') !== -1;
        }

        if (_isQuickDeposit || (iframePos > 0 && iframePosQuick)) {
          eventName = 'depositQuickError';
        }

        if (tmpAmount === 0 || (_transactionFee > 0 &&
          _FeeDiscount === _transactionFee)) {
          _netDepositFee = '0.00';
        }

        p.event = eventName;
        p.accountId = deposits.user.get('accountNumber');
        p.residenceState = deposits.user.get('homeAddress.StateAbbr');
        p.gaEventCategory = 'Deposit';
        p.gaEventAction = eventGAEventAction;
        p.gaEventLabel = eventGAEventLabel;
        p.customerStatus = deposits.getCustomerStatus();
        p.depositAmount = ApiDepositsGTMFac.gtmCurrencyFormat(tmpAmount);
        p.netDepositFee = _netDepositFee;
        p.depositType = _depositType;
        p.errorType = eventGAEventAction;
        p.errorMessage = _errorMessage;
        p.loginStatus = _getLoginStatus(_errorMessage);
        p.promoCode = '';
        p.registrationStatus = 'Registered';
        p.screenName = ApiDepositsGTMFac.tvg4ScreenName();
        p.sectionName = ApiDepositsGTMFac.tvg4SectionName();
        p.siteVersion = ConfigurationFac.getSiteVersion(
          ConfigurationFac.getApplicationContextItem('application'));

        if (p.siteVersion === 'TVG3') {
          p.screenName = 'Deposit';
          p.sectionName = undefined;
        }

        ApiDepositsGTMFac.sendGTMEvent(null, p);
      }
    }

    function _getExpirationDateValues() {
      var currentYear = parseInt($filter('date')(new Date(), 'yy', 'UTC'), 10);
      return {
        min: currentYear.toString(),
        max: (currentYear + 50).toString()
      };
    }

    function _baseUrl() {
      var protocol;

      if ($rootScope.useAbsoluteRequests ||
        ConfigurationFac.absoluteRequests()) {
        protocol = ConfigurationFac
          .getBaseUrlForApplicationContext('protocol') ?
          ConfigurationFac.getBaseUrlForApplicationContext('protocol') : '//';
        return protocol + ConfigurationFac
            .getBaseUrlForApplicationContext('deposit') + '/deposit/api/v1.0/';
      }

      return '/deposit/api/v1.0/';
    }

    function _getTypeEnumMapValues() {
      return {
        ALL: {
          key: 'ALL',
          value: { type: 'ALL', name: 'all', value: 0 } },
        IBC: {
          key: 'IBC',
          value: { type: 'IBC', name: 'ibc', value: 1 } },
        CC: {
          key: 'CREDIT',
          value: { type: 'CC', name: 'credit', value: 2 } },
        DEB: {
          key: 'DEBIT',
          value: { type: 'DEB', name: 'debit', value: 3 } },
        ACH: {
          key: 'ACH',
          value: { type: 'ACH', name: 'ach', value: 4 } },
        CCS: {
          key: 'CREDIT_SIGNED',
          value: { type: 'CCS', name: 'credit_signed', value: 5 }
        },
        DEBS: {
          key: 'DEBIT_SIGNED',
          value: { type: 'DEBS', name: 'debit_signed', value: 6 }
        },
        MPAKS: {
          key: 'GIFT_CARD_SIGNED',
          value: { type: 'MPAKS', name: 'gift_card_signed', value: 7 }
        },
        MPAK: {
          key: 'MONEY_PACK',
          value: { type: 'MPAK', name: 'money_pak', value: 8 }
        },
        SLN: {
          key: 'SLN', value: {
            type: 'SLN', name: 'sightline', value: 12
          }
        }
      };
    }

    function _newCreditDebitCard(bankName,
        cardNumber,
        cardTypeId,
        nameOnCard,
        cardVerificationNumber,
        expirationDate,
        cardID,
        depositLimitTypeId
      ) {
      return {
        cardID: cardID,
        bankName: bankName,
        cardNumber: cardNumber,
        cardTypeId: cardTypeId,
        depositLimitTypeId: depositLimitTypeId,
        nameOnCard: nameOnCard,
        cardVerificationNumber: cardVerificationNumber,
        expirationDate: expirationDate
      };
    }

    function _depositSuccessBuilder(responseData) {
      return {
        serialNumber: responseData.SerialNumber,
        collectedFee: responseData.DepositResult.Fee,
        discountFee: responseData.DepositResult.FeeDiscount,
        netAmount: responseData.DepositResult.NetAmount,
        requestedAmount: responseData.DepositResult.RequestedAmount,
        transactionalTotal: responseData.DepositResult.TransactionTotal,
        depositType: responseData.depositType || responseData.DepositResult.depositType
      };
    }

    /**
     * _addHeaders
     *
     * @param {object} options
     * @param {boolean} options.cache   Add headers to avoid IE caching of GET
     * requests
     * @returns {object}
     */
    function _addHeaders(options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext()),
        'x-tvg-context': RequestContextHeaders[$window.clientApp + '_' + $window.locationContext]
      };

      if (Utilities.prop('cache', options)) {
        headers = angular.extend({}, {
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }, headers);
      }
      return headers;
    }

    function _depositTransactionFeeBuilder(transactionFee, depositType) {
      return {
        fee: transactionFee.useNewFeeFlow ?
          parseFloat(transactionFee.feeAmount) : transactionFee.Fee,
        feeDiscount: transactionFee.useNewFeeFlow ?
          parseFloat(transactionFee.feeRefundAmount) : transactionFee.FeeDiscount,
        netAmount: transactionFee.useNewFeeFlow ?
          parseFloat(transactionFee.RequestedAmount) : transactionFee.NetAmount,
        requestedAmount: transactionFee.RequestedAmount,
        transactionTotal: transactionFee.useNewFeeFlow ?
          parseFloat(transactionFee.RequestedAmount) + parseFloat(transactionFee.feeAmount) -
          parseFloat(transactionFee.feeRefundAmount) : transactionFee.TransactionTotal,
        depositTypeId: depositType,
        useNewFeeFlow: !!transactionFee.useNewFeeFlow ? transactionFee.useNewFeeFlow : false
      };
    }

    return deposits;
  }

  angular.module('TVG.Deposit')
    .factory('DepositSrv', DepositSrv)
    .constant('RequestContextHeaders', {
      tvg4_nj: 'tvg4-4njbets',
      tvg4_pa: 'tvg4-pabets',
      tvg4_all: 'tvg4-tvg',
      tvg4_ia: 'tvg4-iowa',
      touch2_nj: 'touch2-4njbets',
      touch2_pa: 'touch2-pabets',
      touch2_all: 'touch2-tvg',
      touch2_ia: 'touch2-iowa',
      touch3_nj: 'touch3-4njbets',
      touch3_pa: 'touch3-pabets',
      touch3_all: 'touch3-tvg',
      touch3_tvg: 'touch3-tvg',
      touch3_ia: 'touch3-iowa',
      ios2_nj: 'ios2-4njbets',
      ios2_pa: 'ios2-pabets',
      ios2_all: 'ios2-tvg',
      ios2_tvg: 'ios2-tvg',
      ios2_ia: 'ios2-iowa',
      ios_nj: 'ios-4njbets',
      ios_pa: 'ios-pabets',
      ios_all: 'ios-tvg',
      ios_tvg: 'ios-tvg',
      ios_ia: 'ios-iowa',
      njx_nj: 'exchange-exchange',
      fdrmobile_all: 'fdrmobile-fdr',
      fdrmobile_fdr: 'fdrmobile-fdr',
      fdrios_all: 'fdrios-fdr',
      fdrios_fdr: 'fdrios-fdr',
      fdrandroid_all: 'fdrandroid-fdr',
      fdrandroid_fdr: 'fdrandroid-fdr',
      iosnative_all: 'iosnative-tvg',
      iosnative_tvg: 'iosnative-tvg',
      iosnative_nj: 'iosnative-4njbets',
      iosnative_pa: 'iosnative-pabets',
      iosnative_ia: 'iosnative-iowa',
      androidnative_all: 'androidnative-tvg',
      androidnative_tvg: 'androidnative-tvg',
      androidnative_nj: 'androidnative-4njbets',
      androidnative_pa: 'androidnative-pabets',
      androidnative_ia: 'androidnative-iowa',
      androidwrapper_tvg: "androidwrapper-tvg",
      androidwrapper_all: "androidwrapper-tvg",
      androidwrapper_nj:"androidwrapper-4njbets",
      androidwrapper_fdr:"androidwrapper-fdr",
      tvgandroid_tvg: "tvgandroid-tvg",
      tvgandroid_all: "tvgandroid-tvg",
      tvgandroid_nj: "tvgandroid-4njbets",
      tvgandroid_fdr:"tvgandroid-fdr"
    });
}());

(function () {
  'use strict';

  DepositInitialDataFac.$inject = ['SightlineDepositConfig', 'PaypalDepositConfig', 'ApplePayDepositConfig', '$filter', '$window', '$timeout', '$rootScope', 'DEPOSIT_TYPES'];
  function DepositInitialDataFac(
      SightlineDepositConfig,
      PaypalDepositConfig,
      ApplePayDepositConfig,
      $filter,
      $window,
      $timeout,
      $rootScope,
      DEPOSIT_TYPES
    ) {
    var LIMIT_TYPES = {};

    var DEPOSIT_OPTIONS = {
      CC: 'Credit',
      CCS: 'CreditSigned',
      DEB: 'Debit',
      DEBS: 'DebitSigned'
    };

    var CARD_TYPES = {
      CC: {
        id: 1,
        name: 'Credit',
        abbr: 'CC'
      },
      DEB: {
        id: 2,
        name: 'Debit',
        abbr: 'DEB'
      }
    };

    var LIMIT_TYPES_MOCK = [
      {
        id: 1,
        name: 'Betcash',
        abbr: 'IBC'
      },
      {
        id: 1,
        name: 'Betcash',
        abbr: 'ACH'
      },
      {
        id: 2,
        name: 'Credit',
        abbr: 'CC'
      },
      {
        id: 3,
        name: 'Debit',
        abbr: 'DEB'
      },
      {
        id: 5,
        name: 'CreditSigned',
        abbr: 'CCS'
      },
      {
        id: 8,
        name: 'MoneyPak',
        abbr: 'MPAK'
      },
      {
        id: 10,
        name: 'PayNearMe',
        abbr: 'PNM'
      },
      {
        id: 11,
        name: 'ApplePay',
        abbr: 'APPL'
      }
    ];

    function _getCardType(name) {
      var match = Object.values(CARD_TYPES).filter(function (item) {
        return item.name === name;
      });
      return match.length > 0 ? match[0] : {};
    }

    function _getDepositLimitType(name) {
      var match = LIMIT_TYPES_MOCK.filter(function (item) {
        return item.name === name;
      });
      return match.length > 0 ? match[0] : {};
    }

    function _getDepositLimitTypeByAbbr(abbr) {
      var match = LIMIT_TYPES_MOCK.filter(function (item) {
        return item.abbr === abbr;
      });
      return match.length > 0 ? match[0] : {};
    }

    function _parseStates(statesList) {
      return statesList.map(function (state) {
        return {
          abbreviation: state.Abbreviation || state.abbreviation,
          name: state.Name || state.name
        };
      });
    }

    function _parseCardTypes(response) {
      var cardAbbr;
      var card;

      return response.reduce(function (acc, cardType) {
        cardAbbr = cardType.Abbreviation.toLowerCase().trim() === 'db' ?
          'DEB' : 'CC';
        card = {
          id: cardType.Id,
          name: cardType.Name,
          abbr: cardAbbr
        };

        acc[cardAbbr] = card; // eslint-disable-line
        acc[cardType.Id] = card; // eslint-disable-line
        return acc;
      }, {});
    }

    function _parseLimitMinMax(optionMinMaxList, typeToEnumMap) {
      var cardType;
      var limitType;

      return optionMinMaxList.reduce(function (acc, optionMinMax) {
        cardType = typeToEnumMap[optionMinMax.Type.trim()];
        limitType = {};

        if (cardType && cardType.value) {
          limitType = {
            name: cardType.value.name,
            type: cardType.value.type,
            feeType: cardType.value.name,
            min: optionMinMax.Min || 0,
            max: optionMinMax.Max || 0,
            id: cardType.value.value
          };

          acc[optionMinMax.Type.trim()] = limitType; // eslint-disable-line
          acc[cardType.value.value] = limitType; // eslint-disable-line
        }

        return acc;
      }, {});
    }


    /**
     * Get deposit max or min limits by paymentType
     *
     * @param  {String} type     Limit type ID
     * @param  {String} prop     Max or min key
     * @return {Number/Boolean}  Max/min limit for the selected limit type
     */
    function _getLimitType(type, prop) {
      var fallback;

      // stop
      if ((!angular.isObject(LIMIT_TYPES) ||
          !angular.isObject(LIMIT_TYPES[type]))) {
        return false;
      }

      if (prop === 'min') {
        fallback = 0.1;
      } else if (prop === 'max') {
        fallback = 999999;
      }

      return LIMIT_TYPES[type][prop] || fallback;
    }

    function _parseAccountDetails(accountDetails) {
      // stop
      if (!accountDetails) { return null; }

      return {
        accountNumber: accountDetails.AccountNumber,
        accountHState: accountDetails.HomeAddress.StateAbbr,
        accountUsername: accountDetails.Username
      };
    }

    function _buildCreditDebitCardsOption(
        cardTypes,
        //eslint-disable-next-line
        cardOnFile
      ) {
      var option = {
        name: $rootScope.isFdrApp ? 'Credit / Debit Card' : 'Credit/Debit Card',
        ftype: 'CC',
        depositTypeId: DEPOSIT_TYPES.CARD_NEW,
        subTypes: []
      };

      option.onFile = [];

      if (cardTypes.CC) {
        option.subTypes.push({
          name: 'Credit',
          ftype: 'CC',
          type: 'CC',
          limitTypeId: _getLimitType('CC', 'id') ||
            _getDepositLimitTypeByAbbr('CC').id,
          min: _getLimitType('CC', 'min'),
          max: _getLimitType('CC', 'max'),
          cardTypeId: cardTypes.CC.id,
          depositTypeId: DEPOSIT_TYPES.CARD_NEW
        });
      }

      if (cardTypes.DEB) {
        option.subTypes.push({
          name: 'Debit',
          ftype: 'CC',
          type: 'DEB',
          limitTypeId: _getLimitType('DEB', 'id')
            || _getDepositLimitTypeByAbbr('DEB').id,
          min: _getLimitType('DEB', 'min'),
          max: _getLimitType('DEB', 'max'),
          cardTypeId: cardTypes.DEB.id,
          depositTypeId: DEPOSIT_TYPES.CARD_NEW
        });
      }

      return option;
    }

    function _buildDepositOptionsOnFile(
        cardsOnFile,
        achOnFile,
        cardTypes
      ) {
      var optionsOnFile = [];

      angular.forEach(cardsOnFile, function (card) {
        if (cardTypes[card.CardTypeID]) {
          optionsOnFile.push({
            groupName: 'Cards On File',
            id: card.CardID,
            cardNumber: card.CardNumber,
            cardNumberExt: '****' + card.CardNumber,
            cardTypeId: card.CardTypeID,
            limitTypeId: card.DepositLimitTypeId,
            expirationDate: card.ExpirationDate,
            isExpired: moment(card.ExpirationDate, 'MM/YY')
              .add(1, 'month') < moment(),
            signed: card.Signed,
            name: '(****' + card.CardNumber + ') ' +
            cardTypes[card.CardTypeID].name + ' ' + card.ExpirationDate,
            ftype: 'CC',
            type: cardTypes[card.CardTypeID].abbr,
            min: _getLimitType(card.DepositLimitTypeId, 'min'),
            max: _getLimitType(card.DepositLimitTypeId, 'max'),
            depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE
          });
        }
      });

      angular.forEach(achOnFile, function (ach) {
        optionsOnFile.push({
          groupName: 'BetCash Accounts On File',
          achId: ach.AppAchId,
          bankAccNumber: ach.BankAcctNumber,
          bankAcctType: ach.BankAcctType,
          bankName: ach.BankName,
          bankRoutingNumber: ach.BankRoutingNumber,
          driversLicenseNumber: ach.DriversLicenseNumber,
          driversLicenseState: ach.DriversLicenseState,
          isPending: ach.IsPending,
          name: '(****' + ach.BankAcctNumber
            .substr(ach.BankAcctNumber.length - 4) + ') ' + ach.BankName,
          ftype: 'ACH',
          type: 'ACH',
          limitTypeId: _getLimitType('ACH', 'id'),
          min: _getLimitType('ACH', 'min'),
          max: _getLimitType('ACH', 'max'),
          depositTypeId: DEPOSIT_TYPES.ACH_ON_FILE
        });
      });

      return optionsOnFile;
    }

    /**
     * Check if a type of deposit has any available option
     *
     * @param  {Array}  options      Array of deposit options
     * @param  {String} depositType  Deposit type key
     * @return {Boolean}             Deposit type is available?
     */
    function _isDepositOptionAvailable(options, depositType) {
      return (options || []).some(function (option) {
        var key = (option.Abbreviation || '').trim();
        var isAvailable = false;

        if (key === depositType) {
          isAvailable = option.IsAvailable;
        }

        return isAvailable;
      });
    }

    /**
     * Parse user's credit cards information to be rendered
     *
     * @param  {Array}  cardsOnFile   User's credit cards
     * @param  {Object} cardTypes     Credit card types hash
     * @return {Array}                Parsed user's credit cards
     */
    //eslint-disable-next-line
    function _parseCardsOnFile(cardsOnFile, cardTypes) {
      return cardsOnFile.map(function (card) {
        if (cardTypes[card.CardTypeID]) {
          return {
            groupName: 'Cards On File',
            id: card.CardID,
            cardNumber: card.CardNumber,
            cardNumberExt: '****' + card.CardNumber,
            cardTypeId: card.CardTypeID,
            limitTypeId: card.DepositLimitTypeId,
            expirationDate: card.ExpirationDate,
            isExpired: moment(card.ExpirationDate, 'MM/YY')
              .add(1, 'month') < moment(),
            signed: card.Signed,
            name: '(****' + card.CardNumber + ') ' +
            cardTypes[card.CardTypeID].name + ' ' + card.ExpirationDate,
            ftype: 'CC',
            type: cardTypes[card.CardTypeID].abbr,
            typeName: cardTypes[card.CardTypeID].name,
            cardType: cardTypes[card.CardTypeID].name,
            min: _getLimitType(card.DepositLimitTypeId, 'min'),
            max: _getLimitType(card.DepositLimitTypeId, 'max'),
            depositTypeId: DEPOSIT_TYPES.CARD_ON_FILE
          };
        }
        return undefined;
      }).filter(Boolean);
    }

    /**
     * Parse user's betcash accounts information to be rendered
     *
     * @param  {Array}  achOnFile         User's credit cards
     * @param  {Object} availableOptions  Available deposit options
     * @return {Array}                    Parsed user's credit cards
     */
    function _parseAchOnFile(achOnFile, availableOptions) {
      return achOnFile.map(function (ach) {
        return {
          groupName: 'BetCash Accounts On File',
          achId: ach.AppAchId,
          bankAccNumber: ach.BankAcctNumber,
          bankAcctType: ach.BankAcctType,
          bankName: ach.BankName,
          bankRoutingNumber: ach.BankRoutingNumber,
          driversLicenseNumber: ach.DriversLicenseNumber,
          driversLicenseState: ach.DriversLicenseState,
          isPending: ach.IsPending,
          name: '(****' + ach.BankAcctNumber
            .substr(ach.BankAcctNumber.length - 4) + ') ' + ach.BankName,
          ftype: 'ACH',
          type: 'ACH',
          limitTypeId: _getLimitType('ACH', 'id'),
          min: _getLimitType('ACH', 'min'),
          max: _getLimitType('ACH', 'max'),
          depositTypeId: DEPOSIT_TYPES.ACH_ON_FILE,
          typeName: 'BetCash',
          cardType: ach.cardType,
          isAvailable: _isDepositOptionAvailable(
            availableOptions.DepositOptions, 'ACH')
        };
      });
    }

    /**
     * Prepare user's sightline information to be rendered
     * @param {Object} sightlineData  Sightline data
     * @return {Array}                Sightline deposit options
     */
    function _parseSightlineOnFile(sightlineData) {
      var onFile = {
        groupName: 'TVG Pre Paid Card',
        name: 'Pre Paid Card',
        id: sightlineData.id,
        ftype: sightlineData.ftype,
        type: sightlineData.type,
        limitTypeId: sightlineData.limitTypeId,
        min: sightlineData.min,
        max: sightlineData.max,
        cardType: sightlineData.cardType,
        typeName: 'TVG Pre Paid Card',
        depositTypeId: DEPOSIT_TYPES.SIGHTLINE // was sightlineData.depositTypeId
      };

      return [onFile];
    }

    function _parsePayPalOnFile(paypalData) {
      var onFile = {
        groupName: 'PayPal',
        name: 'PayPal',
        typeName: 'PayPal',
        id: paypalData.id,
        ftype: paypalData.ftype,
        type: paypalData.type,
        limitTypeId: paypalData.limitTypeId,
        cardType: paypalData.cardType,
        min: paypalData.min,
        max: paypalData.max,
        depositTypeId: DEPOSIT_TYPES.PAYPAL // was sightlineData.depositTypeId
      };

      return [onFile];
    }

    function _parseApplePayOnFile(applePayData) {
      var onFile = {
        groupName: 'ApplePay',
        name: 'ApplePay',
        bankName: 'ApplePay',
        typeName: 'ApplePay',
        id: applePayData.id,
        ftype: applePayData.ftype,
        type: applePayData.type,
        limitTypeId: applePayData.limitTypeId,
        cardType: applePayData.cardType,
        min: applePayData.min,
        max: applePayData.max,
        depositTypeId: DEPOSIT_TYPES.APPLE_PAY // was sightlineData.depositTypeId
      };

      return [onFile];
    }

    function _BetCashPositionIfAvailable(depOptions) {
      var ACHPosition = depOptions.indexOf('ACH');
      var IBCPosition = depOptions.indexOf('IBC');

      if (ACHPosition === -1 && IBCPosition === -1) {
        return false;
      }

      if (_isACHAndIBCAvailable(depOptions)) {
        return Math.min(ACHPosition, IBCPosition);
      }

      return ACHPosition !== -1 ? ACHPosition : IBCPosition;
    }

    function _isACHAndIBCAvailable(depOptions) {
      return depOptions.indexOf('ACH') !== -1 &&
        depOptions.indexOf('IBC') !== -1;
    }

    /**
     * Build deposit/quick deposit payment options
     * @param  {Object} availableOptions                 All deposit options
     * @param  {Object} cardTypes                        Credit cards hash
     * @param  {Array}  cardsOnFile                      Credit cards in account
     * @param  {Array}  achOnFile                        Betcash cards in account
     * @param  {Array}  availableCMSDepositOptions       Available deposit keys
     *                                                   from CMS
     * @param  {boolean} canMakePaymentsWithActiveCard   Apple Pay user validation
     * @return {Object}                                  Filtered deposit and
     *                                                   quick deposit options
     */
    function _buildDepositOptions(
        availableOptions,
        cardTypes,
        cardsOnFile,
        achOnFile,
        availableCMSDepositOptions,
        canMakePaymentsWithActiveCard
      ) {
      var depositOptions = [];
      var quickDepositOptions = [];
      var depositObj;
      var betCashIndex = _BetCashPositionIfAvailable(availableCMSDepositOptions);

      if (betCashIndex !== false) {
        availableCMSDepositOptions.splice(betCashIndex, 0, 'BC');
        $rootScope.betCashIndex = betCashIndex;
      }

      angular.forEach(availableCMSDepositOptions, function (option) {
        switch (option) {
          case 'APPL':
            if (
              canMakePaymentsWithActiveCard ||
              ($rootScope.product === 'ios2' && $rootScope.isQuickDeposit)
            ) {
              if ($rootScope.activeFeatures.showApplePayMoreDeposit) {
                depositOptions.unshift({
                  depositTypeId: DEPOSIT_TYPES.APPLE_PAY,
                  limitTypeId: _getLimitType('APPL', 'id') ||
                      _getDepositLimitTypeByAbbr('APPL').id,
                  ftype: 'APPL',
                  name: 'Apple Pay'
                });
              }

              if ($rootScope.activeFeatures.showApplePayQuickDeposit) {
                depositObj = _.extend({}, ApplePayDepositConfig);
                depositObj.onFile = _parseApplePayOnFile(depositObj);

                quickDepositOptions.push(depositObj);
              }
            }
            break;

          case 'BC':
            depositObj = {
              name: 'eCheck',
              ftype: 'IBC',
              limitTypeId: _getLimitType('IBC', 'id') ||
                _getDepositLimitTypeByAbbr('IBC').id,
              min: _getLimitType('IBC', 'min'),
              max: _getLimitType('IBC', 'max'),
              isAvailable: true,
              depositTypeId: DEPOSIT_TYPES.ACH_NEW,
              onFile: _parseAchOnFile(achOnFile, availableOptions),
              bothACHAndIBCAvailable: _isACHAndIBCAvailable(
                availableCMSDepositOptions)
            };
            depositOptions.push(depositObj);
            quickDepositOptions.push(depositObj);
            break;

          case 'CC':
            depositObj = _buildCreditDebitCardsOption(cardTypes);
            depositOptions.push(depositObj);
            quickDepositOptions.push(depositObj);
            break;

          case 'MPAK':
            depositObj = {
              name: $rootScope.isFdrApp ? 'Cash with MoneyPak' : 'MoneyPak',
              ftype: 'MPAK',
              limitTypeId: _getLimitType('MPAK', 'id') ||
               _getDepositLimitTypeByAbbr('MPAK').id,
              min: _getLimitType('MPAK', 'min'),
              max: _getLimitType('MPAK', 'max'),
              depositTypeId: DEPOSIT_TYPES.GREENDOT_MONEY_PAK
            };
            depositOptions.push(depositObj);
            break;

          case 'SLN':
            // Sighline
            depositObj = _.extend({}, SightlineDepositConfig);
            depositObj.onFile = _parseSightlineOnFile(depositObj);

            depositOptions.push(depositObj);
            if ($rootScope.isFdrApp) {
              depositObj.name = 'FanDuel Pre Paid';
            }
            quickDepositOptions.push(depositObj);

            break;

          case 'PAY':
            depositObj = _.extend({}, PaypalDepositConfig);
            depositObj.onFile = _parsePayPalOnFile(depositObj);

            depositOptions.push(depositObj);

            break;

          case 'PNM':
            // PayNearMe. I'd prefer that the deposit options came from the
            // backend response -> Account/DepositOptions (.net api)
            depositOptions.push({
              depositTypeId: 10,
              ftype: 'PNM',
              limitTypeId: _getDepositLimitTypeByAbbr('PNM').id,
              name: $filter('CMSValue')('pnmTabName') || 'Pay Near Me'
            });
            break;

          case 'OTHER':
            // Other
            depositObj = {
              name: $rootScope.isFdrApp ? 'Other Methods' : 'Other Payment Methods',
              ftype: 'OTHER',
              limitTypeId: _getLimitType('OTHER', 'id') ||
                 _getDepositLimitTypeByAbbr('OTHER').id,
              min: 0,
              max: _getLimitType('OTHER', 'max'),
              depositTypeId: DEPOSIT_TYPES.OTHER
            };
            depositOptions.push(depositObj);
            break;

          default:
            break;
        }
      });

      return {
        depositOptions: depositOptions,
        quickDepositOptions: quickDepositOptions
      };
    }

    function _buildPaymentOptions(data, availableCMSDepositOptions, canMakePaymentsWithActiveCard) {
      var cardTypes = _buildCardTypes(data.paymentOptions);
      var availableDepositOptions = availableCMSDepositOptions.filter(function (item) {
        var existsCC = false;
        switch (item) {
          case 'SLN':
            item = 'SLP';
            break;
          case 'OTHER':
            item = 'OTR';
            break;
          case 'CC':
            existsCC = data.paymentOptions.indexOf('CC') !== -1 ||
              data.paymentOptions.indexOf('CCS') !== -1 ||
              data.paymentOptions.indexOf('DEB') !== -1 ||
              data.paymentOptions.indexOf('DEBS') !== -1;
            break;
          default:
            break;
        }
        return data.paymentOptions.indexOf(item) !== -1 || existsCC;
      });
      var depOptObj = _buildDepositOptions(
        data.paymentOptions,
        cardTypes,
        [],
        [],
        availableDepositOptions,
        canMakePaymentsWithActiveCard
      );
      var depositOptions = depOptObj.depositOptions;
      var quickDepositOptions = depOptObj.quickDepositOptions;
      return {
        cardTypes: cardTypes,
        depositOptions: depositOptions,
        quickDepositOptions: quickDepositOptions };
    }

    function _buildCardTypes(response) {
      var cardAbbr;
      var card;

      return response.reduce(function (acc, cardType, index) {
        cardAbbr = cardType;
        if (cardAbbr === 'CC' || cardAbbr === 'CCS' ||
          cardAbbr === 'DEB' || cardAbbr === 'DEBS') {
          card = {
            id: CARD_TYPES[cardType] ? CARD_TYPES[cardType].id : index,
            name: DEPOSIT_OPTIONS[cardType],
            abbr: cardType
          };

        acc[cardAbbr] = card; // eslint-disable-line
        acc[index] = card; // eslint-disable-line
        }
        return acc;
      }, {});
    }

    /**
     * Build initial data
     *
     * @param  {Object} initialData                [description]
     * @param  {Object} typeEnumMap                [description]
     * @param  {Array}  availableCMSDepositOptions [description]
     * @return {Object}                            [description]
     */
    function _buildInitialData(
        initialData,
        typeEnumMap,
        availableCMSDepositOptions
      ) {
      var cardTypes;
      var depOptObj;
      //eslint-disable-next-line
      var depositOptions;
      //eslint-disable-next-line
      var quickDepositOptions;
      var depositOptionsOnFile;
      var states;
      var accountDetails;
      var achDepositLimitExceeded;
      var ret;

      LIMIT_TYPES = _parseLimitMinMax(initialData.limitMinMax, typeEnumMap);

      cardTypes = _parseCardTypes(initialData.cardTypes);
      depOptObj = _buildDepositOptions(
        initialData.availableOptions,
        cardTypes,
        initialData.cardOnFile,
        initialData.achOnFile,
        availableCMSDepositOptions
      );

      depositOptions = depOptObj.depositOptions;
      quickDepositOptions = depOptObj.quickDepositOptions;
      depositOptionsOnFile = _buildDepositOptionsOnFile(
        initialData.cardOnFile,
        initialData.achOnFile,
        cardTypes
      );

      states = _parseStates(initialData.depositStates);
      accountDetails = _parseAccountDetails(initialData.accountDetails);
      achDepositLimitExceeded = initialData.achDepositLimitExceeded;

      ret = {
        depositOptions: [],
        quickDepositOptions: [],
        depositOptionsOnFile: depositOptionsOnFile,
        states: states,
        achDepositLimitExceeded: achDepositLimitExceeded,
        madeFirstDeposit: initialData.availableOptions.HasMadeInitialDeposit,
        defaultDepositOptions: initialData.availableOptions.DepositOptions,
        defaultLimitMinMax: initialData.limitMinMax
      };

      if (accountDetails) {
        ret.accountDetails = accountDetails;
      }

      return ret;
    }

    /**
     * Build payment initial data
     *
     * @param  {Object} initialData                [description]
     * @param  {Array}  availableCMSDepositOptions [description]
     * @return {Object}                            [description]
     */
    function _buildPaymentInitialData(
        initialData,
        availableCMSDepositOptions
      ) {
      var cardTypes = _parseCardTypes(initialData.cardTypes);
      var depOptObj = _buildDepositOptions(
        initialData.availableOptions,
        cardTypes,
        initialData.cardOnFile,
        initialData.achOnFile,
        availableCMSDepositOptions
      );

      return {
        depositOptions: depOptObj.depositOptions
      };
    }

    /**
     * Get the list of restricted deposit types according
     *
     * @param  {Object} initialData  Deposit's initial data
     * @return {Array}               Restricted deposit types
     */
    function _getDepositRestrictedTypes(initialData) {
      var restrictedTypes = [];
      var depositOpts = initialData.availableOptions.DepositOptions;

      if (_areCreditAndDebitCardRestricted(initialData.cardTypes)) {
        restrictedTypes.push('CC');
      }

      if (_isIBCRestricted(depositOpts)) {
        restrictedTypes.push('IBC');
      }

      if (_isACHRestricted(depositOpts)) {
        restrictedTypes.push('ACH');
      }

      return restrictedTypes;
    }

    function _areCreditAndDebitCardRestricted(cardTypes) {
      return (Object.keys(cardTypes).length === 0);
    }

    function _isIBCRestricted(depositOptions) {
      return !depositOptions.some(function (option) {
        return option.Abbreviation.indexOf('IBC') > -1;
      });
    }

    function _isACHRestricted(depositOptions) {
      return !depositOptions.some(function (option) {
        return option.Abbreviation.indexOf('ACH') > -1;
      });
    }

    return {
      buildPaymentInitialData: _buildPaymentInitialData,
      buildPaymentOptions: _buildPaymentOptions,
      buildCardTypes: _buildCardTypes,
      buildInitialData: _buildInitialData,
      getDepositRestrictedTypes: _getDepositRestrictedTypes,
      getLimitType: _getLimitType,
      getDepositLimitTypeByAbbr: _getDepositLimitTypeByAbbr,
      getCardType: _getCardType,
      getDepositLimitType: _getDepositLimitType,
      parseStates: _parseStates
    };
  }

  angular.module('TVG.Deposit')
    .factory('DepositInitialDataFac', DepositInitialDataFac);
}());

(function () {
  'use strict';

  DmaTvg4FeatureTogglesSvc.$inject = ['$rootScope'];
  function DMAFeatureTogglesHashContainerSvc() {
    var _toggleHashContainer = {};
    var _default = 'dma';

    function _register(key, value) {
      _toggleHashContainer[key] = value;
    }

    function _registerAsDefault(value) {
      _register(_default, value);
    }

    function _getBasedOnKey(key) {
      return	_toggleHashContainer[key] || _toggleHashContainer[_default];
    }

    return {
      register: _register,
      registerAsDefault: _registerAsDefault,
      getBasedOnKey: _getBasedOnKey
    };
  }

  function DmaTvg4FeatureTogglesSvc($rootScope) {
    return function (key) {
      return $rootScope.activeFeatures && $rootScope.activeFeatures[key];
    };
  }

  angular.module('TVG.DMAToggles')
    .factory('DMAFeatureTogglesHashContainerSvc', DMAFeatureTogglesHashContainerSvc)
    .factory('DmaTvg4FeatureTogglesSvc', DmaTvg4FeatureTogglesSvc);
}());

(function () {
  'use strict';
  FeedbackFac.$inject = ['$window'];
  function FeedbackFac($window) {
    return {
      /**
       * Is the element inside the viewport?
       * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
       *
       * @param {Object} el               Element to check position
       * @param {Object} [offsets]        Custom offsets
       * @param {Object} [offsets.top]    Top offset that must be respected
       * @param {Object} [offsets.right]  Right offset that must be respected
       * @param {Object} [offsets.bottom] Bottom offset that must be respected
       * @param {Object} [offsets.left]   Left offset that must be respected
       * @return {Boolean}                Is in viewport?
       * @private
       */
      _isInViewport: function (el, offsets) {
        var top = 0;
        var right = 0;
        var bottom = 0;
        var left = 0;
        var rect;

        // stop
        if (!el) { return true; }

        rect = el.getBoundingClientRect();
        offsets = offsets || {};

        top = offsets.top || 0;
        left = offsets.left || 0;
        right = ($window.innerWidth || document.documentElement.clientWidth || 0) - (offsets.right || 0);  // eslint-disable-line
        bottom = ($window.innerHeight || document.documentElement.clientHeight || 0) - (offsets.bottom || 0);  // eslint-disable-line

        return (
            rect.top >= top &&
            rect.left >= left &&
            rect.bottom <= bottom &&
            rect.right <= right
        );
      },

      /**
       * Calculate the fixed header height (if any)
       * @param {Object} el  Header element to check height
       * @return {Number}    Header's height
       * @private
       */
      _getHeaderHeight: function (headerSelector) {
        var header = document.querySelector(headerSelector || '.sticky-header'); // eslint-disable-line
        var height = 0;

        if (header) {
          height = header.getBoundingClientRect().height || 0;
        }

        return height;
      },

      //
      // PUBLIC
      //

      /**
       * Scroll into first error tooltip, if not already inside viewport
       *
       * @param {Object} [options]                 Scroll options
       * @param {String} [options.headerSelector]  Header selector
       * @param {String} [options.labelSelector]   Error label selector
       * @public
       */
      scrollIntoFirstError: function (options) {
        var opts = options || {};
        var label = document.querySelector(opts.labelSelector || '.js-error-label');  // eslint-disable-line
        var headerHeight = this._getHeaderHeight(opts.headerSelector);
        var offsetTop = 40 + headerHeight;
        var labelTop = 0;
        var left = 0;
        var top = 0;
        var inViewport = true;

        if ([
          'touch3',
          'ios2',
          'fdrmobile',
          'fdrios',
          'fdrandroid',
          'androidwrapper',
          'tvgandroid'
        ].indexOf($window.productContext) >= 0) {
          // prevent scroll to on ios iframe
          return;
        }

        // stop if there's no element
        if (!label) { return; }

        inViewport = this._isInViewport(label, { top: offsetTop });

        // do not scroll when already visible
        if (inViewport) { return; }


        label = angular.element(label);
        labelTop = label.offset().top || 0;

        top = labelTop - offsetTop;
        top = (top < 0) ? 0 : top;
        left = $window.scrollX || 0;

        $window.scrollTo(left, top);

        return;
      }
    };
  }

  angular.module('TVG.Deposit')
    .factory('FeedbackFac', FeedbackFac);
}());

(function () {
  'use strict';
  ManagePaymentMethodsSrv.$inject = ['$http', '$q', '$location', '$filter', '$window', '$timeout', '$rootScope', 'ConfigurationFac', 'DepositInitialDataFac', 'Utilities'];
  function ManagePaymentMethodsSrv(
      $http,
      $q,
      $location,
      $filter,
      $window,
      $timeout,
      $rootScope,
      ConfigurationFac,
      DepositInitialDataFac,
      Utilities
    ) {
    var payMethods;

    function _baseUrl() {
      var protocol;

      if ($rootScope.useAbsoluteRequests ||
        ConfigurationFac.absoluteRequests()) {
        protocol = ConfigurationFac
          .getBaseUrlForApplicationContext('protocol') ?
          ConfigurationFac.getBaseUrlForApplicationContext('protocol') : '//';

        return protocol + ConfigurationFac
            .getBaseUrlForApplicationContext('deposit') +
          '/deposit/api/v1.0/';
      }

      return '/deposit/api/v1.0/';
    }

    function _addHeaders() {
      var context = angular.toJson(ConfigurationFac.getApplicationContext());
      return { 'x-tvgcontext': context };
    }

    payMethods = {
      getPayMethodsInitialData: function () {
        var deferred = $q.defer();
        var url = _baseUrl() + 'managePaymentsInitialData';
        var headers = angular.extend({
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }, _addHeaders());

        $http.get(url, { headers: headers })
          .success(function (data) {
            var cmsConfig;
            var response;
            var initialData;

            var depositConfigAvailableOptions = Utilities.attempt(
              function () {
                return angular.fromJson(
                  $filter('CMSValue')('depositConfigAvailableOptions'));
              },
              function () {
                return ['IBC', 'CC', 'ACH'];
              }
            );

            var paymentManagementConfigAvailableOptions = Utilities.attempt(
              function () {
                return angular.fromJson(
                  $filter('CMSValue')('paymentManagementConfigAvailableOptions'));
              },
              function () {
                return ['IBC', 'CC'];
              }
            );

            if (data && data.status === 'success') {
              cmsConfig = depositConfigAvailableOptions.filter(function (el) {
                return paymentManagementConfigAvailableOptions.indexOf(el) > -1;
              });

              response = data.response;

              initialData = DepositInitialDataFac.buildPaymentInitialData(
                response,
                cmsConfig
              );

              response.paymentMethodsOptions = initialData.depositOptions;

              deferred.resolve(response);
            } else {
              deferred.reject(data);
            }
          }).error(function (data) {
            deferred.reject(data);
          });

        return deferred.promise;
      },
      addCard: function (cardDataModel) {
        var deferred = $q.defer();

        $http({
          method: 'POST',
          url: _baseUrl() + 'addNewCard',
          data: {
            cardNumber: cardDataModel.cardNumber,
            bankName: cardDataModel.bankName,
            cardTypeId: cardDataModel.selectedCardType.cardTypeId,
            expirationMonthYear: cardDataModel.ExpirationMonthYear
          },
          headers: _addHeaders()
        }).success(function (data) {
          if (data && data.status === 'success') {
            deferred.resolve(data.response);
          } else {
            deferred.reject(data.response);
          }
        }).error(function (response) {
          deferred.reject(response);
        });

        return deferred.promise;
      },
      updateCard: function (cardDataModel, accountNumber) {
        var deferred = $q.defer();
        var accountId = $rootScope.user && $rootScope.user.accountNumber || accountNumber;
        var url = ConfigurationFac.getBaseServiceUrl() + '/ccp/v1/users/' + accountId + '/bankCards/' + cardDataModel.cardID;
        var payload = {
          bankName: cardDataModel.bankName,
          expirationMonth: cardDataModel.ExpirationMonthYear.split('/')[0],
          expirationYear: cardDataModel.ExpirationMonthYear.split('/')[1]
        };
        var method = 'PUT';

        $http({
          method: method,
          url: url,
          data: payload,
          headers: _addHeaders()
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (response) {
          deferred.reject(response);
        });

        return deferred.promise;
      },
      removeCard: function (cardID, accountNumber) {
        var accountId = $rootScope.user && $rootScope.user.accountNumber || accountNumber;
        var deferred = $q.defer();
        var url = ConfigurationFac.getBaseServiceUrl() + '/ccp/v1/users/' + accountId + '/bankCards/' + cardID;

        $http({
          method: 'DELETE',
          url: url,
          headers: _addHeaders()
        }).success(function (data) {
          deferred.resolve(data);
        }).error(function (response) {
          deferred.reject(response);
        });

        return deferred.promise;
      },
      updateLimit: function (
          depositTypeId,
          depositLimitIntervalId,
          maxLimit,
          accountNumber
        ) {
        var mapCardType = {
          2: 'CC',
          3: 'DEB',
          5: 'CCS',
          6: 'DEBS'
        };
        var deferred = $q.defer();
        var method = 'POST';
        var url = _baseUrl() + 'updateLimit';
        var payload = {
          depositTypeId: depositTypeId,
          depositLimitIntervalId: depositLimitIntervalId,
          maxLimit: maxLimit
        };
        var accountId = $rootScope.user && $rootScope.user.accountNumber || accountNumber;
        var isAchOrIbc = depositTypeId === 1 ||
        depositTypeId === 4;
        var isCC = depositTypeId === 2 || depositTypeId === 3 ||
          depositTypeId === 5 || depositTypeId === 6;
        var isApplePay = depositTypeId === 7;
        var walletEndpoint = Utilities.endpoint('uwt');

        if (isApplePay) {
          method = 'PUT';

          url = walletEndpoint('users') + '/' + accountId + '/limits/APPL/user';
          payload = {
            dailyLimit: maxLimit.daily
              ? parseFloat(maxLimit.daily)
                .toFixed(2)
                .toString()
              : null,
            weeklyLimit: maxLimit.weekly
              ? parseFloat(maxLimit.weekly)
                .toFixed(2)
                .toString()
              : null,
            monthlyLimit: maxLimit.monthly
              ? parseFloat(maxLimit.monthly)
                .toFixed(2)
                .toString()
              : null
          };
        }

        if (isAchOrIbc) {
          method = 'PUT';
          if ($rootScope.activeFeatures.useUwtForDepositLimitsOnDma) {
            url = walletEndpoint('users') + '/' + accountId + '/limits/ACH/user';
            payload = {
              dailyLimit: maxLimit.daily
                ? parseFloat(maxLimit.daily)
                    .toFixed(2)
                    .toString()
                : null,
              weeklyLimit: maxLimit.weekly
                ? parseFloat(maxLimit.weekly)
                    .toFixed(2)
                    .toString()
                : null,
              monthlyLimit: maxLimit.monthly
                ? parseFloat(maxLimit.monthly)
                    .toFixed(2)
                    .toString()
                : null
            };
          } else {
            url =
              ConfigurationFac.getBaseServiceUrl() + '/ach/v1/users/' + accountId + '/deposit/limits/user';
            payload = {
              dailyDepositLimit: maxLimit.daily ?
                parseFloat(maxLimit.daily).toFixed(2).toString() : null,
              weeklyDepositLimit: maxLimit.weekly ?
                parseFloat(maxLimit.weekly).toFixed(2).toString() : null,
              monthlyDepositLimit: maxLimit.monthly ?
                parseFloat(maxLimit.monthly).toFixed(2).toString() : null
            };
          }
        }

        if (isCC) {
          method = 'PUT';
          if ($rootScope.activeFeatures.useUwtForDepositLimitsOnDma) {
            url = walletEndpoint('users') + '/' + accountId + '/limits/' + mapCardType[depositTypeId] + '/user';
            payload = {
              dailyLimit: maxLimit.daily
                ? parseFloat(maxLimit.daily)
                    .toFixed(2)
                    .toString()
                : null,
              weeklyLimit: maxLimit.weekly
                ? parseFloat(maxLimit.weekly)
                    .toFixed(2)
                    .toString()
                : null,
              monthlyLimit: maxLimit.monthly
                ? parseFloat(maxLimit.monthly)
                    .toFixed(2)
                    .toString()
                : null
            };
          } else {
            url = ConfigurationFac.getBaseServiceUrl() + '/ccp/v1/users/' + accountId + '/deposits/limits/user?cardType=' + mapCardType[depositTypeId];
            payload = {
              dailyDepositLimit: maxLimit.daily ?
                parseFloat(maxLimit.daily).toFixed(2).toString() : null,
              weeklyDepositLimit: maxLimit.weekly ?
                parseFloat(maxLimit.weekly).toFixed(2).toString() : null,
              monthlyDepositLimit: maxLimit.monthly ?
                parseFloat(maxLimit.monthly).toFixed(2).toString() : null
            };
          }
        }

        $http({
          method: method,
          url: url,
          data: payload,
          headers: _addHeaders()
        }).success(function (data) {
          if (isAchOrIbc || isCC || isApplePay) {
            deferred.resolve(data);
          }
          if (data.status === 'success') {
            deferred.resolve(data.response);
          } else {
            deferred.reject(data);
          }
        }).error(function (response) {
          deferred.reject(response);
        });

        return deferred.promise;
      },
      getPaymentForms: function () {
        return {
          NEW: {
            CC: [
              'card-type-selector',
              'card-number-input',
              'card-exp-date'
            ],
            IBC: [
              'bank-routing-number',
              'bank-account-number',
              'bank-name',
              'driver-license-number',
              'driver-license-state',
              'account-pin-pwd'
            ]
          },
          EDIT: {
            CC: [
              'card-type-selector',
              'card-number-input',
              'card-exp-date'
            ]
          }
        };
      }
    };
    return payMethods;
  }

  angular.module('TVG.ManagePaymentMethods')
    .factory('ManagePaymentMethodsSrv', ManagePaymentMethodsSrv);
}());

(function () {
  'use strict';

  notificationService.$inject = ['$compile', '$rootScope', '$q', '$document', '$window'];
  function notificationService($compile, $rootScope, $q, $document, $window) {
    var TEMPLATE = '<banner data-message="message" data-callback="callback" data-type="type" class="banner"></banner>';
    var notify = {};

    function buildArgs(title, message, elementBeforeBanner, callback, scroll) {
      return {
        title: title,
        message: message,
        elementBeforeBanner: elementBeforeBanner,
        callback: callback,
        scroll: scroll
      };
    }

    function closeExistingBanner() {
      $document.find('banner').remove();
    }

    function scrollTop() {
      var elem = $document[0].querySelectorAll('.banner')[0];
      if (elem) {
        if ([
          'touch3',
          'ios2',
          'fdrmobile',
          'fdrios',
          'fdrandroid',
          'androidwrapper',
          'tvgandroid'
        ].indexOf($window.productContext) >= 0) {
          // prevent scroll to on ios iframe
          return;
        }

        elem.scrollIntoView(false);
      }
    }

    notify.buildDialog = function (args, type) {
      var scope = $rootScope.$new();
      var templateElement;

      args.type = type;
      angular.extend(scope, args);

      templateElement = $compile(TEMPLATE)(scope);

      // Append to element
      if (args.elementBeforeBanner && args.elementBeforeBanner !== '') {
        if ($rootScope.isQuickDeposit) {
          angular.element($document[0].querySelector(args.elementBeforeBanner))
            .prepend(templateElement);
        }
        if ($rootScope.isFdrApp) {
          angular.element($document[0].querySelector('withdraw-type-selector'))
            .after(templateElement);
        } else {
          angular.element($document[0].querySelector(args.elementBeforeBanner))
            .after(templateElement);
        }
      } else {
        angular.element(
            $document[0].querySelector('deposit .tvg-deposit .deposit-form .methods-wrapper'))
          .prepend(templateElement);
      }

      if ([
        'touch3',
        'ios2',
        'fdrmobile',
        'fdrios',
        'fdrandroid',
        'androidwrapper',
        'tvgandroid'
      ].indexOf($window.productContext) < 0) {
        // prevent scroll to on ios iframe
        scrollTop();
      }

      return $q.when(scope);
    };

    notify.clearBanner = closeExistingBanner;

    /**
     * @param {String} title THIS VALUE IS NOT BEING USED. IT'S HERE JUST TO AVOID COMPATIBILITY ISSUES.
     * @param {String} message The banner's body message.
     * @param {String} elementBeforeBanner The element that is going to be the left sibling of the banner.
     * @param {function, optional} callback
     * @returns {Promise} promise resolved with the scope object used to create the banner element.
     */
    notify.success = function (title, message, elementBeforeBanner, callback, scroll) {
      var successOptions = buildArgs(title, message, elementBeforeBanner, callback, scroll);
      closeExistingBanner();
      return this.buildDialog(successOptions, 'success');
    };

    /**
     * @param {String} title THIS VALUE IS NOT BEING USED. IT'S HERE JUST TO AVOID COMPATIBILITY ISSUES.
     * @param {String} message The banner's body message.
     * @param {String} elementBeforeBanner The element that is going to be the left sibling of the banner.
     * @param {function, optional} callback
     * @returns {Promise} promise resolved with the scope object used to create the banner element.
     */
    notify.error = function (title, message, elementBeforeBanner, callback, scroll) {
      var errorOptions = buildArgs(title, message, elementBeforeBanner, callback, scroll);
      closeExistingBanner();
      return this.buildDialog(errorOptions, 'error');
    };

    /**
     * @param {String} title THIS VALUE IS NOT BEING USED. IT'S HERE JUST TO AVOID COMPATIBILITY ISSUES.
     * @param {String} message The banner's body message.
     * @param {String} elementBeforeBanner The element that is going to be the left sibling of the banner.
     * @param {function, optional} callback
     * @returns {Promise} promise resolved with the scope object used to create the banner element.
     */
    notify.cancel = function (title, message, elementBeforeBanner, callback, scroll) {
      var cancelOptions = buildArgs(title, message, elementBeforeBanner, callback, scroll);
      closeExistingBanner();
      return this.buildDialog(cancelOptions, 'cancel');
    };

    /**
     * @param {String} title THIS VALUE IS NOT BEING USED. IT'S HERE JUST TO AVOID COMPATIBILITY ISSUES.
     * @param {String} message The banner's body message.
     * @param {String} elementBeforeBanner The element that is going to be the left sibling of the banner.
     * @param {function, optional} callback
     * @returns {Promise} promise resolved with the scope object used to create the banner element.
     */
    notify.confirm = function (title, message, elementBeforeBanner, callback, scroll) {
      var confirmOptions = buildArgs(title, message, elementBeforeBanner, callback, scroll);
      closeExistingBanner();
      return this.buildDialog(confirmOptions, 'confirm');
    };

    notify.warning = function (title, message, elementBeforeBanner, callback, scroll) {
      var confirmOptions = buildArgs(title, message, elementBeforeBanner, callback, scroll);
      closeExistingBanner();
      return this.buildDialog(confirmOptions, 'warning');
    };

    return notify;
  }

  angular
    .module('TVG.Deposit')
    .factory('NotificationService', notificationService);
}());

(function () {
  'use strict';

  PayNearMeFac.$inject = ['$http', '$q', 'ConfigurationFac'];
  function PayNearMeFac($http, $q, ConfigurationFac) {
    var url = ConfigurationFac.getBaseServiceUrl();

    /**
     * @returns {Object} [Headers object. App context, Caching Headers]
     * @private
     */
    function _addHeaders() {
      var context = angular.toJson(ConfigurationFac.getApplicationContext());
      return {
        'x-tvgcontext': context,
        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache'
      };
    }

    /**
     * Get PNM Id
     * @param accountNumber
     * @returns {*}
     * @private
     */
    function _getPayNearMeId(accountNumber) {
      return $http({
        method: 'GET',
        url: url + '/pnm/v1/users/' + accountNumber + '/id',
        params: {},
        headers: _addHeaders()
      });
    }


    /**
     * Create PNM ID
     * @param accountNumber
     * @returns {*}
     * @private
     */
    function _createPayNearMeId(accountNumber) {
      return $http({
        method: 'POST',
        url: url + '/pnm/v1/users/' + accountNumber + '/id',
        data: {},
        headers: _addHeaders()
      });
    }

    return {
      getPayNearMeId: _getPayNearMeId,
      createPayNearMeId: _createPayNearMeId
    };
  }

  angular.module('TVG.Deposit').factory('PayNearMeFac', PayNearMeFac);
}());

(function () {
  'use strict';

  SightlineSrv.$inject = ['$http', '$q', 'Utilities', 'DepositPath', 'ConfigurationFac', '$location', '$window', 'RequestContextHeaders', '$log', '$rootScope'];
  function SightlineSrv(
      $http,
      $q,
      Utilities,
      DepositPath,
      ConfigurationFac,
      $location,
      $window,
      RequestContextHeaders,
      $log,
      $rootScope
    ) {
    var _isRedirectingToSightlineAddFunds = false;
    var _accountId = '';

    /**
     * Create an API error instance
     * @param  {Object} response  HTTP Response with nested errors
     * @return {Object}           Extracted errors
     */
    var createApiError = function (response) {
      var apiError = new ApiError();
      var responseError = response.data.errors[0];

      apiError.uri = response.config.url;
      apiError.message = responseError.message;
      apiError.code = responseError.code;

      return apiError;
    };

    /**
     * Create an API error instance from new HTTP code errors
     * @param  {Object} response  HTTP Response with nested errors
     * @return {Object}           Extracted errors
     */
    var createApiErrorFromHttpError = function (response, customData) {
      var apiError = new ApiError();
      var responseError = response.data || {};

      apiError.uri = (response.config || {}).url;
      apiError.message = responseError.message;
      apiError.code = responseError.exception || responseError.code;
      apiError.status = responseError.status;
      apiError.name = customData || undefined;

      return apiError;
    };

    /**
     * createSightlineAccount
     * @param  {object} user
     * @param  {object} user.accountNumber
     * @param  {object} user.firstName
     * @param  {object} user.lastName
     * @param  {object} user.ssn
     * @return {SightlineAccount}
     */
    var createSightlineAccount = function (user) {
      var account = new SightlineAccount(user);
      return account;
    };

    var createMerchant = function (merchantInfo) {
      return new Merchant(merchantInfo);
    };

    /**
     * endpoint
     * Give the endpoint resources, build the final URI.
     * @param {string} service being used to create URL
     * @return {string} URI
     */
    var endpoint = function (service) {
      return function (/* resources */) {
        var separator = '/';
        var resources = [].slice.call(arguments, 0);
        var baseUrl = ConfigurationFac.getServiceApiUrl(service) || '';
        var version = '/v1';

        if (service === 'slp') {
          version = '/v2';
          baseUrl = baseUrl.replace('/v1', version);
        }

        if (!baseUrl || baseUrl === 'false') {
          baseUrl = '/' + service + version;
        }

        if (service === 'slp' && baseUrl.indexOf(_accountId) !== 1) {
          return [baseUrl].concat(resources).concat(_accountId).join(separator);
        }
        return [baseUrl].concat(resources).join(separator);
      };
    };

    var sightlineEndpoint = endpoint('slp');
    var walletEndpoint = endpoint('uwt');

    /**
     * checkTransaction
     * Check if the transaction failed, although the request did not return
     * any error status code.
     *
     * @param  {$httpResponse} response the response object from the $http call
     * @return {Promise}
     * @FIXME angular doesn't respect the Promise A+ standard
     */
    var checkTransaction = function (response) {
      return $q(function (resolve, reject) {
        if (Utilities.prop('data.errors', response)) {
          return reject(createApiError(response));
        }

        return resolve(response);
      });
    };

    /**
     * request
     * @param  {Object} data
     * @param  {string} data.url
     * @param  {string} data.method
     * @param  {string} data.headers
     * @param  {Object} data.data
     *
     * @return {Promise}
     */
    var request = function (data, fullResponse, customData) {
      if (data) {
        data.headers = prepareHeaders(data.headers);
      }

      return $http(data)
        .then(checkTransaction)
        .then(function (response) { return fullResponse ? response : response.data; })
        .catch(function (err) {
          return $q.reject(createApiErrorFromHttpError(err, customData));
        });
    };

    /**
     * Add default headers if needed
     * @param  {Object} headers  Headers to send
     * @return {Object}          Headers with defaults
     */
    var prepareHeaders = function (headers) {
      var defaultHeaders = {};
      var xTvgContext = RequestContextHeaders[$window.clientApp + '_' + $window.locationContext];

      defaultHeaders['Content-Type'] = 'application/json';
      defaultHeaders['x-tvg-context'] = xTvgContext;

      return _.defaults(headers || {}, defaultHeaders);
    };

    /**
     * Return the merchant name, ID and application for the current environment
     *
     * @return {Promise} $http
     */
    var getMerchantInformation = Utilities.memoize(function () {
      var preUrl = sightlineEndpoint('merchant');
      var url = preUrl.substring(0, preUrl.indexOf('merchant') + 8);
      return request({
        url: url,
        method: 'GET'
      }).then(createMerchant);
    });

    var getBaseUrl = function (replaceState) {
      var product = ConfigurationFac.getApplicationContextItem('product');
      var location = ConfigurationFac.getApplicationContextItem('location');
      var wrapper = ConfigurationFac.getApplicationContextItem('wrapper');
      var callback = $location.search().callback && decodeURIComponent($location.search().callback);
      var path = (!replaceState && !wrapper) ? DepositPath[product] : $window.location.pathname;
      var qs = {
        njx: '?location=nj&product=njx',
        ios: '?product=ios',
        ios2: '?wrapper=true&product=ios2&location=' + location +
          '&callback=' + callback,
        touch3: '?wrapper=true&product=touch3&location=' + location +
          '&callback=' + callback,
        fdrmobile: '?wrapper=true&product=fdrmobile&location=' + location +
          '&callback=' + callback,
        fdrios: '?wrapper=true&product=fdrios&location=' + location +
          '&callback=' + callback,
        fdrandroid: '?wrapper=true&product=fdrandroid&location=' + location +
          '&callback=' + callback,
        androidwrapper: '?wrapper=true&product=androidwrapper&location=' + location +
          '&callback=' + callback,
        tvgandroid: '?wrapper=true&product=tvgandroid&location=' + location +
          '&callback=' + callback
      };
      var finalUrl;

      if ($rootScope.fullPage && path.indexOf('/registration') > -1) {
        path = path.replace('/registration', '/deposit/deposit');
      }

      finalUrl = Utilities.supplant('{protocol}://{host}{port}{path}', {
        protocol: $location.protocol(),
        host: !replaceState && callback ? callback.split('/')[0] : $location.host(),
        port: !replaceState && callback ? '' : ':' + $location.port(),
        path: (replaceState && _.has(qs, product)) ?
          path.concat(qs[product]) : path
      });

      $log.info(finalUrl);
      return finalUrl;
    };

    /**
     *
     * Sightline User Type
     * @typedef {Object} SightlineUser
     * @property {string} memberName
     * @property {string} firstName
     * @property {string} lastName
     * @property {string} email
     * @property {string} address
     * @property {string} city
     * @property {string} state
     * @property {string} country
     * @property {string} postalCode
     * @property {string} identityToken
     */

    /**
     * Sightline Account Type
     * @typedef {Object} SightlineAccount
     * @property  {string} sightlineAccount    Use the Member Number here
     * @property  {string} firstName
     * @property  {string} lastName
     */
    function SightlineAccount(user) {
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.sightlineAccount = user.accountNumber;
    }

    /**
     * Sightline Transaction Type
     * @typedef {Object} SightlineTransaction
     * @property {string} merchantTransactionId
     * @property {string} paymentProcessorTransactionId
     */

    /**
     * Merchant Type
     * @typedef {Object} Merchant
     * @property {string} merchantId,
     * @property {string} merchantApplication
     * @property {string} merchantTransactionId
     * @property {string} merchantName
     */
    function Merchant(data) {
      this.merchantId = data.merchantId;
      this.merchantName = data.merchantName;
      this.merchantApplication = data.merchantApplication;
      this.merchantTransactionId = Utilities.uuid().replace(/-/g, '').slice(0, 30);
    }

    /**
     * @class ApiError
     * @extends Error
     */
    function ApiError() {
      this.uri = '';
      this.name = '';
      this.message = '';
      this.code = '';
      this.status = '';
      Error.apply(this, [].slice.call(arguments, 0));
    }

    ApiError.prototype = Object.create(Error.prototype);
    ApiError.prototype.constructor = ApiError;

    /**
     * @class
     * @constructor
     * @param {Object} data
     * @param {string} [data.accountNumber='']
     * @param {string} data.firstName
     * @param {string} data.lastName
     * @param {string} data.phoneNumber
     * @param {string} data.emailAddress
     * @param {string} data.Address1
     * @param {string} data.City
     * @param {string} data.StateAbbr
     * @param {string} [data.country='US']
     * @param {string} data.Zip
     * @param {string} data.identityToken
     */
    function SightlineUser(data) {
      var originTab = data.originTab || '';
      var wrapper = ConfigurationFac.getApplicationContextItem('wrapper') ? '&wrapper=true' : '';

      this.memberNumber = data.accountNumber || '';
      this.firstName = data.firstName || null;
      this.lastName = data.lastName || null;
      this.phoneNumber = data.phoneNumber || null;
      this.email = data.emailAddress || null;
      this.address = [
        Utilities.prop('homeAddress.streetNumber', data),
        Utilities.prop('homeAddress.address1', data),
        Utilities.prop('homeAddress.address2', data)
      ].filter(Boolean).join(' ') || null;
      this.city = data.homeAddress.city || data.homeAddress.City || null;
      this.state = data.homeAddress.state || data.homeAddress.StateAbbr || null;
      this.country = data.country || 'US';
      this.postalCode = data.homeAddress.zipCode || data.homeAddress.Zip || null;
      this.identityToken = data.identityToken;
      this.returnURL = getBaseUrl(false).concat(Utilities.returnToTab('sightline+' + originTab)) +
          ($rootScope.fullPage ? '&wrapper=true&fullPage=true&callback='
          + $rootScope.returnUrl : wrapper);
      this.merchantId = data.merchantId;
      this.merchantApplication = data.merchantApplication;
      this.merchantTransactionId = data.merchantTransactionId;
      this.merchantName = data.merchantName;
    }

    function depositErrorHandler(error) {
      var apiError = new ApiError();
      if (error.status === 500) {
        apiError.uri = error.uri;
        apiError.code = error.code;
        apiError.status = error.status;
        apiError.name = 'depositStatusPoller';

        if (error.code === 'SLP_WITHDRAW_FROM_SLP_DECLINED') {
          apiError.message = 'scenario1';
        } else if (error.code === 'SLP_TOTE_DEPOSIT_FAILED') {
          apiError.message = 'scenario3a';
        }
      }
      throw apiError;
    }

    return {
      createSightlineAccount: createSightlineAccount,

      /**
       * Check if the TVG user has enrolled a sightline card
       * @param {SightlineAccount} sightlineAccount
       * @return {Promise}
       */
      isSightlineUser: function (sightlineAccount) {
        return request({
          url: sightlineEndpoint('user') + '/account-info',
          method: 'GET',
          headers: prepareHeaders(),
          data: sightlineAccount
        }).then(Utilities.pick([
          'enrolled',
          'balance',
          'last4SSN'
        ]));
      },

      /**
       * Enroll user's sightline card with TVG
       * @return {Promise}
       */
      enrollSightlineUser: function (termsAccepted) {
        var data = {
          termsAccepted: termsAccepted || 0
        };
        return request({
          url: sightlineEndpoint('user') + '/enroll',
          method: 'POST',
          data: data
        });
      },

      /**
       * getToken
       * @param  {string} [id=''] Account Identifier
       * @return {Promise<SightlineUser, Error>}    $http
       */
      getToken: function (user, originTab) {
        var activeMenuTab = '+'.concat(originTab);
        var userObj = user || {};
        var fetchToken = function (accountNumber) {
          return request({
            url: sightlineEndpoint('user') + '/token',
            method: 'POST',
            data: { sightlineAccount: accountNumber || '' }
          })
          .then(Utilities.pick('identityToken'));
        };

        return $q.all([
          getMerchantInformation(),
          fetchToken(userObj.accountNumber)
        ])
        .then(function (data) {
          var merchant = data[0];
          var token = data[1];

          return new SightlineUser(angular.extend(
            {},
            userObj,
            merchant,
            token,
            { originTab: activeMenuTab }
          ));
        });
      },

      /**
       * Return the balance available in the card.
       *
       * @param  {SightlineAccount} account
       * @return {Promise<Number, Error>} $http
       */
      getBalance: function (account) {
        return request({
          url: sightlineEndpoint('balance'),
          method: 'POST',
          data: account
        })
          .then(Utilities.prop('balance'));
      },

      /**
       * Return the balance available in the card.
       *
       * @param  {string} id  The id of the transaction
       * @return {Promise} $http
       * @TODO Check response format with Tiago Costa
       */
      getTransactionStatus: function (id) {
        return request({
          url: sightlineEndpoint('transaction', id, 'status'),
          method: 'GET'
        })
        .then(Utilities.pick([
          'friendlyMessage',
          'transactionStatus'
        ]));
      },

          /**
       * transferToSightline
       * @param  {SightlineAccount} account [description]
       * @param  {Number} amount [description]
       * @return {Promise}
       */
      transferToSightline: function (amount) {
        var baseUrl = sightlineEndpoint('users').indexOf(_accountId) === -1 ? sightlineEndpoint('users') + '/' + _accountId : sightlineEndpoint('users');
        var url = baseUrl + '/withdrawal';
        return $http({
          method: 'POST',
          url: url,
          data: { amount: amount },
          headers: prepareHeaders()
        });
      },

      /**
       * transferToTVG
       * @param  {SightlineAccount} account [description]
       * @param  {Number} amount [description]
       * @return {Promise}
       */
      transferToTVG: Utilities.curry(function (account, amount) {
        var baseUrl = sightlineEndpoint('user').indexOf(_accountId) === -1 ? sightlineEndpoint('user') + '/' + _accountId : sightlineEndpoint('user');
        var url = baseUrl + '/deposit';

        return request({
          url: url,
          method: 'POST',
          data: angular.extend({}, account, {
            tvgAccount: account.sightlineAccount,
            amount: amount
          }, true)
        }, true)
        .then(function (res) {
          return res;
        })
        .then(function (data) {
          data.requestedAmount = amount;
          data.depositAvailableDate = 'immediately';
          return data;
        });
      }),

      fundAndTransferToTVG: function (depositData) {
        var fundUrl = sightlineEndpoint('user') + '/funding/' + depositData.selectedCardType.id;
        return request({
          url: fundUrl,
          method: 'POST',
          data: {
            amount: +depositData.amount + depositData.sightlineUser_v2.depositFee,
            paymentCard: {
              id: depositData.selectedCardType.id,
              securityNumber: depositData.cardSecurityNumber
            }
          }
        }, true, 'fundingError')
          // fund success  --> deposit
          .then(function () {
            return request({
              url: sightlineEndpoint('user') + '/deposit',
              method: 'POST',
              data: {
                amount: depositData.amount
              }
            }, true, 'fundSuccessDepositFail');
          })
        // fund or deposit error
        .catch(function (error) {
          // if fund error --> try deposit
          if (error.name === 'fundingError') {
            return request({
              url: sightlineEndpoint('user') + '/deposit',
              method: 'POST',
              data: {
                amount: depositData.amount
              }
            }, true, 'depositFailFundFail').catch(function (depError) {
              return depositErrorHandler(depError);
            });
          }
          throw error;
        });
      },


      cancelWithdrawal: function (withdrawalId) {
        return request({
          url: walletEndpoint('withdrawal', withdrawalId, 'cancel'),
          method: 'POST'
        });
      },

      setInfo: function (accountId) {
        if (accountId && accountId !== _accountId) {
          _accountId = accountId;
        }
      },

      /**
       * Get/set the "_isRedirectingToSightlineAddFunds" flag
       * (used because of TVG3 not having the same rootScope as TVG4)
       *
       * @param {Boolean} [val]  New redirecting flag value
       * @return {Boolean}       Whether is redirecting
       */
      isRedirectingToSightlineAddFunds: function (val) {
        if (typeof val === 'boolean') {
          _isRedirectingToSightlineAddFunds = val;
        }

        return _isRedirectingToSightlineAddFunds;
      },

      getSightlineFlowVersion: function (accountId) {
        var deferred = $q.defer();
        var headers = prepareHeaders();
        var userEndpoint;
        var baseUrl;

        _accountId = accountId;

        userEndpoint = sightlineEndpoint('user');
        baseUrl = userEndpoint.indexOf(accountId) > -1 ? userEndpoint : userEndpoint + '/' + accountId;

        /* eslint-disable */
        $http.get(baseUrl + '/version', { headers: headers }).success(function (data) {
          deferred.resolve(data.versionName);
        }).error(function (error) {
          deferred.resolve('SLN version error');
        });

        return deferred.promise;
      }

    };
  }

  /* eslint-disable */
  angular
    .module('TVG.Deposit')
    .service('SightlineSrv', SightlineSrv);
  /* eslint-enable */
}());

(function () {
  'use strict';

  TransferSrv.$inject = ['$http', '$q', '$location', '$filter', '$window', '$timeout', '$rootScope', 'ConfigurationFac', 'Utilities'];
  function TransferSrv($http,
            $q,
            $location,
            $filter,
            $window,
            $timeout,
            $rootScope,
            ConfigurationFac,
            Utilities) {
    var _optionsAccounts = [ // --> Temp.
      {
        id: 1,
        name: 'Tote',
        label: '4NJBETS',
        availableAmount: 0
      },
      {
        id: 2,
        name: 'NJExchange',
        label: 'NJExchange',
        availableAmount: 0
      }
    ];

    var transfer;
    var _accountId = '';
    var usaEndpoint = Utilities.endpoint('usa');
    var exwEndpoint = Utilities.endpoint('exw');
    var _failedExchange = true;
    var _failedSession = false;
    var _failedContext = true;

    function _addHeaders(token) {
      var context = angular.toJson(ConfigurationFac.getApplicationContext());
      return {
        'x-tvgcontext': context,
        userToken: token
      };
    }

    function getContext(token) {
      var deferred = $q.defer();
      $http.get(usaEndpoint('session') + '/context', { headers: _addHeaders(token) })
        .success(function (data) {
          if (data.accountNumber) {
            _accountId = data.accountNumber;
          }
          _failedContext = false;
          deferred.resolve(data.accountNumber);
        })
        .catch(function (err) {
          if (err.status && err.status === 401) {
            _failedSession = true;
          }
          _failedContext = true;
          deferred.resolve(err);
        });
      return deferred.promise;
    }

    function getExchangeId(token) {
      var deferred = $q.defer();
      if (_failedSession || _failedContext) {
        deferred.resolve({});
        return deferred.promise;
      }
      $http.get(exwEndpoint('users') + '/' + _accountId, { headers: _addHeaders(token) })
        .success(function (data) {
          _failedExchange = false;
          deferred.resolve(data);
        })
        .catch(function (err) {
          _failedExchange = true;
          deferred.resolve(err);
        });
      return deferred.promise;
    }

    function _getTransferInitialData(token) {
      return getContext(token).then(function () {
        return getExchangeId(token);
      });
    }

    function _makeTransfer(transferData, token) {
      var deferred = $q.defer();
      var end = transferData.destination === 'Tote' ? 'deposit' : 'withdrawal';

      $http({
        method: 'POST',
        url: exwEndpoint('users') + '/' + _accountId + '/' + end,
        headers: _addHeaders(token),
        data: {
          amount: transferData.amount.toString()
        }
      }).success(function (data, status) {
        deferred.resolve({ response: data, status: status });
      }).error(function (data) {
        deferred.reject(data);
      });

      return deferred.promise;
    }

    transfer = {
      failedSession: function () { return _failedSession; },
      failedContext: function () { return _failedContext; },
      failedExchange: function () { return _failedExchange; },
      getTransferInitialData: function () {
        var deferred = $q.defer();
        var currentUserSession;

        if (ConfigurationFac.getApplicationContextItem('product') !== 'njx') {
          _.attempt(function () {
            if ($window.document.domain === $window.parent.document.domain) {
              currentUserSession = $window.parent.getCurrentUserSession;
            }
          });
        }

        if (currentUserSession) {
          $window.parent.getCurrentUserSession(
            function (data) { // --> Success to get Token
              var token = data ? data.sessionToken : undefined;
              _getTransferInitialData(token).then(
                function (response) {
                  deferred.resolve(response);
                },
                function (err) {
                  deferred.resolve(err);
                });
            },
            function () {
              _getTransferInitialData().then(
                function (response) {
                  deferred.resolve(response);
                },
                function (data) {
                  deferred.resolve(data);
                });
            });
        } else { // --> No function to get Token
          _getTransferInitialData().then(
            function (response) {
              deferred.resolve(response);
            },
            function (data) {
              deferred.resolve(data);
            });
        }

        return deferred.promise;
      },
      makeTransfer: function (transferData) {
        var deferred = $q.defer();
        var currentUserSession;

        _.attempt(function () {
          currentUserSession = $window.parent.getCurrentUserSession;
        });

        if (currentUserSession) {
          $window.parent.getCurrentUserSession(
            function (data) { // --> Success to get Token
              var token = data ? data.sessionToken : undefined;

              _makeTransfer(transferData, token).then(
                function (response) {
                  deferred.resolve(response);
                },
                function (err) {
                  deferred.reject(err);
                });
            },
            function () { // --> Failure to get Token
              _makeTransfer(transferData).then(
                function (response) {
                  deferred.resolve(response);
                },
                function (err) {
                  deferred.reject(err);
                });
            });
        } else { // --> No function to get Token
          _makeTransfer(transferData).then(
            function (response) {
              deferred.resolve(response);
            },
            function (err) {
              deferred.reject(err);
            });
        }

        return deferred.promise;
      },
      getOptionsAccounts: function () {
        return _optionsAccounts;
      }
    };
    return transfer;
  }

  angular.module('TVG.Transfer').factory('TransferSrv', TransferSrv);
}());

(function () {
  'use strict';

  UserFactory.$inject = ['Utilities'];
  function UserFactory(Utilities) {
    var pickAndLowerFirst = Utilities.compose(
      Utilities.pick([
        'accountNumber',
        'dateOfBirth',
        'emailAddress',
        'exchangeSubAccountNumber',
        'firstName',
        'gender',
        'homeAddress',
        'lastName',
        'mailingAddress',
        'primaryPhone',
        'secondaryPhone',
        'signalProviderID',
        'transportID',
        'username',
        'userName',
        'wageringStatus'
      ]),
      Utilities.mapKeys(Utilities.lowerFirst)
    );

    var isSet = function (value) {
      return (angular.isDefined(value) && value !== null);
    };

    var setOrDefault = Utilities.curry(function (defaultValue, value) {
      return (isSet(value)) ? value : defaultValue;
    });

    var setOrNull = setOrDefault(null);

    function User(props) {
      var data = props || {}; // avoid breaking and fail silently

      this.accountNumber = setOrNull(data.accountNumber);
      this.dateOfBirth = setOrNull(data.dateOfBirth);
      this.emailAddress = setOrNull(data.emailAddress);
      this.exchangeSubAccountNumber = setOrNull(data.exchangeSubAccountNumber);
      this.firstName = setOrNull(data.firstName);
      this.gender = setOrNull(data.gender);
      this.homeAddress = setOrNull(data.homeAddress);
      this.lastName = setOrNull(data.lastName);
      this.mailingAddress = setOrNull(data.mailingAddress);
      this.phoneNumber = setOrNull(data.primaryPhone);
      this.secondaryPhone = setOrNull(data.secondaryPhone);
      this.signalProviderID = setOrNull(data.signalProviderID);
      this.transportID = setOrNull(data.transportID);
      this.username = setOrNull(data.username) || setOrNull(data.userName);
      this.wageringStatus = setOrNull(data.wageringStatus);
    }

    User.prototype = {

      constructor: User, // Restore the constructor reference

      /**
       * has
       * Check if the instance has the given property
       * Note: if a property is `false` the result is still `true`
       * since it *has* the property
       *
       * @param  {string}  prop Object property or property path
       * @return {Boolean}
       */
      has: function (prop) {
        var value = Utilities.prop(prop, this);
        return isSet(value);
      },
      /**
       * get
       * Return the specified property. If no arguments are given, return the
       * saved data
       *
       * @param  {string} [prop]
       * @return {mixed}
       */
      get: function (prop) {
        if (!prop) {
          return this;
        }
        return Utilities.prop(prop, this);
      },

      /**
       * set
       * Set properties to the user object
       *
       * @param {string} prop Name of the property to be set
       * @param {mixed} data Data to be saved
       * @return {object}
       */
      set: function (prop, data) {
        this[prop] = data;
        return this.data;
      }
    };

    User.build = function (data) {
      return new User(pickAndLowerFirst(data || {}));
    };

    return User;
  }

  angular
    .module('TVG.Deposit')
    .factory('UserFactory', UserFactory);
}());

'use strict';

angular
  .module('TVG.Withdraw')
  .constant('SightlineConfig', {
    id: 'SLN',
    name: 'TVG Pre Paid Card',
    min: 10,
    max: 25000
  })
  .constant('PaypalConfig', {
    id: 'PAY',
    name: 'PayPal',
    min: 10,
    max: 25000
  })
  .constant('CreditCardConfig', {
    id: 'DEBIT_CARD',
    name: 'Debit Card',
    min: 10,
    max: 10000
  })
  .constant('BetCashConfig', {
    id: 'BETCASH',
    name: 'eCheck',
    min: 10,
    max: 10000
  })
  .constant('CheckRequestConfig', {
    id: 'CHECK',
    name: 'Check Request',
    min: 10,
    max: 10000
  });

(function () {
  'use strict';

  WithdrawFac.$inject = ['$http', '$q', 'ConfigurationFac', 'SightlineConfig', 'PaypalConfig', 'SightlineSrv', 'CreditCardConfig', 'CheckRequestConfig', 'BetCashConfig', 'paypalService', 'Utilities', '$rootScope', '$window', 'RequestContextHeaders', '$timeout'];
  function WithdrawFac($http,
                       $q,
                       ConfigurationFac,
                       SightlineConfig,
                       PaypalConfig,
                       SightlineSrv,
                       CreditCardConfig,
                       CheckRequestConfig,
                       BetCashConfig,
                       paypalService,
                       Utilities,
                       $rootScope,
                       $window,
                       RequestContextHeaders,
                       $timeout) {
    var _accountId = '';
    var ccpEndpoint = Utilities.endpoint('ccp');

    /**
     * Returns available forms
     * @returns
     * {{CHECK: {HOME: string[], MAIL: string[]}, DIRECT: {DIRECT: string[]}}}
     * @private
     */
    function _getForms() {
      return {
        CHECK: [
          'withdraw-account-info',
          'withdraw-home-mail-selector',
          'withdraw-amount-input'
        ],
        DEBIT_CARD: [
          'withdraw-account-info',
          'withdraw-card-selector',
          'withdraw-amount-input',
          'withdraw-total-cost'
        ],
        BETCASH: [
          'withdraw-account-info',
          'withdraw-betcash-selector',
          'withdraw-amount-input'
        ],
        SLN: [
          'withdraw-account-info',
          'withdraw-amount-input'
        ],
        PAY: [
          'withdraw-account-info',
          'withdraw-amount-input',
          'withdraw-provider-email'
        ]
      };
    }

    //eslint-disable-next-line
    var usaEndpoint = Utilities.endpoint('usa');
    //eslint-disable-next-line
    var walletEndpoint = Utilities.endpoint('uwt');


    function _getWithdrawOptions(opts) {
      var config = {
        SLN: SightlineConfig,
        PAY: PaypalConfig,
        DEBIT_CARD: CreditCardConfig,
        CHECK: CheckRequestConfig,
        BETCASH: BetCashConfig
      };
      if ($rootScope.isFdrApp) {
        BetCashConfig.name = 'eCheck';
        SightlineConfig.name = 'FanDuel Pre Paid';
      }

      return opts.map(function (opt) {
        return config[opt];
      }).filter(Boolean);
    }

    /**
     * Fetches withdraw initial data
     * @returns promise
     * @private
     */
    function _getData() {
      return _makeGETRequest(_baseUrl() +
        'withdrawalInitialData', _initialDataParser);
    }

    function _getWithdrawalProfile() {
      _accountId = '';
      return _getAccountBalance().then(function (response) {
        var url = '/uam/v1/users/' + _accountId + '/profile';
        url = ConfigurationFac.getBaseServiceUrl() + url;
        return $http({
          method: 'GET',
          url: url,
          headers: _addHeaders()
        }).then(function (res) {
          return response ?
           Object.assign(response, res.data) : res.data;
        })
        .catch(function () {
          return { response: response, failure: true };
        });
      });
    }

     /**
       * Get user account number incase it's not previously loaded
       */
    function _getAccountNumber() {
      return $http({
        url: usaEndpoint('session') + '/context',
        method: 'GET',
        headers: _addHeaders()
      }).then(function (data) {
        if (data.data.accountNumber) {
          _accountId = data.data.accountNumber;
        }
        return data.data.accountNumber;
      }).catch(function (err) {
        return err;
      });
    }

    function _getAccountId() {
      var deferred = $q.defer();
      return !_accountId ? _getAccountNumber() : $timeout(function () {
        deferred.resolve(_accountId);
        return deferred.promise;
      }, 200);
    }

    function _getPlainAccountId() {
      return _accountId;
    }

    function _getAccountBalance() {
      return _getAccountId().then(function (accountId) {
        return $http({
          url: walletEndpoint('users') + '/' + accountId + '/withdrawal/balance',
          method: 'GET',
          headers: _addHeaders()
        }).then(function (data) {
          return data.data;
        }).catch(function (err) {
          return err;
        });
      });
    }

    /**
     * Withdraws a specified amount using betCash payment method
     * @param amount - amount to withdraw
     * @param achId - betCash account id
     * @returns promise
     * @private
     */
    function _withdrawBetCash(amount, achId) {
      return _makeGETRequest(_baseUrl() +
        'withdrawalAch?amount=' +
        amount +
        '&achId=' +
        achId, undefined);
    }

    function _withdrawNewDepositFlow(amount, accountId, paymentType) {
      var url = '/uwt/v1/users/' + accountId + '/withdrawal';
      url = ConfigurationFac.getBaseServiceUrl() + url;
      return $http({
        method: 'POST',
        url: url,
        data: { amount: amount, paymentType: paymentType },
        headers: _addHeaders()
      });
    }

    function _withdrawBetcashNewDepositFlow(amount, accountId, achId) {
      var url = '/ach/v1/users/' + accountId + '/withdrawals';
      url = ConfigurationFac.getBaseServiceUrl() + url;
      return $http({
        method: 'POST',
        url: url,
        data: { amount: amount, achId: achId },
        headers: _addHeaders()
      });
    }

    function _withdrawDebitCard(amount, accountId, ccid) {
      var url = '/ccp/v1/users/' + accountId + '/bankCard/' + ccid + '/withdrawal';
      url = ConfigurationFac.getBaseServiceUrl() + url;
      return $http({
        method: 'POST',
        url: url,
        data: { amount: amount },
        headers: _addHeaders()
      });
    }

    /**
     * Withdraws a specified amount using check payment method
     * @param amount - amount to withdraw
     * @param accountNumber - accountNumber
     * @param locationCode - MAILING or RESIDENTIAL
     * @returns promise
     * @private
     */
    function _withdrawCheck(amount, accountNumber, locationCode) {
      return $http({
        method: 'POST',
        url: ConfigurationFac.getBaseServiceUrl() + '/chk/v1/users/' + accountNumber + '/withdrawal',
        data: {
          amount: amount.toString(),
          address: locationCode
        },
        headers: _addHeaders()
      });
    }

    /**
     * Get list of pending Withdraws
     * @returns promise
     * @private
     */
    function _withdrawPendingList() {
      var options = {
        headers: _addHeaders({ cache: true })
      };

      var url = '/uwt/v1/users/' + _accountId + '/withdrawals/pending';

      url = ConfigurationFac.getBaseServiceUrl() + url;

      return $http.get(url, options)
        .then(Utilities.prop('data.pendingWithdrawalsList'));
    }

    function _withdrawCancel(withdrawId) {
      return $http({
        method: 'DELETE',
        url: ConfigurationFac.getBaseServiceUrl() + '/uwt/v1/users/' + _accountId + '/withdrawals/' + withdrawId,
        headers: _addHeaders()
      });
    }

    /**
     * Withdraw data parser
     * @param response - response from server
     * @returns {{locationTypes: *, achAccounts: *, accountInfo: *}}
     * @private
     */
    function _initialDataParser(response) {
      _accountId = response.accountInfo.accountNumber;

      SightlineSrv.setInfo(_accountId);

      return {
        locationTypes: _locationTypeParser(response.locationTypes,
          response.accountInfo || {
            homeAddress: {},
            mailingAddress: {}
          }
        ),
        achAccounts: _betCashAccountsParser(response.achOnFile.AchAccounts),
        accountInfo: _accountInfoParser(response.accountInfo || {}),
        responseData: response
      };
    }

    /**
     * Location types parser
     * @param locationTypes - location types from server
     * @param accountInfo - account info from server
     * @returns {Array} - array of location types
     * @private
     */
    function _locationTypeParser(locationTypes, accountInfo) {
      var locationTypeList = [];
      var addressObj = {
        home: _buildAddressText(accountInfo.homeAddress),
        mail: _buildAddressText(accountInfo.mailingAddress)
      };

      angular.forEach(locationTypes, function (locationType) {
        var address;

        if (locationType.Id === 0) {
          address = addressObj.home;
        } else if (locationType.Id === 1) {
          address = addressObj.mail;
        }

        if (locationType.Id === 0 || locationType.Id === 1) {
          locationTypeList.push({
            id: locationType.Id,
            name: locationType.Name,
            address: address
          });
        }
      });

      return locationTypeList;
    }


    /**
     * Build address text
     * @param address - available in account info object from server
     * @returns {string} - parsed address or empty string if
     * argument is undefined
     * @private
     */
    function _buildAddressText(address) {
      var trimmedObj = {
        StreetNumber: '',
        Address1: '',
        Address2: '',
        City: '',
        StateAbbr: '',
        Zip: ''
      };

      angular.forEach(address, function (value, key) {
        if (angular.isString(value)) {
          trimmedObj[key] = value.trim() + ' ';
        }
      });

      return (
        trimmedObj.StreetNumber +
        trimmedObj.Address1 +
        trimmedObj.Address2 +
        trimmedObj.City +
        trimmedObj.StateAbbr +
        trimmedObj.Zip
      ).trim();
    }

    /**
     * BetCash accounts parser
     * @param response - response from server
     * @returns {Array} - array of betCash account objects
     * @private
     */
    function _betCashAccountsParser(response) {
      var achAccountList = [];
      angular.forEach(response, function (achAccount) {
        var name = '(*****' + achAccount.BankAcctNumber.substr(achAccount.BankAcctNumber.length - 4)
          + ') ' + achAccount.BankName;

        achAccountList.push({
          name: name,
          achId: achAccount.AppAchId,
          bankName: achAccount.BankName
        });
      });
      return achAccountList;
    }

    /**
     * Parses account info data
     * @param accountInfo - account info from server
     * @private
     */
    function _accountInfoParser(accountInfo) {
      return {
        avBalance: accountInfo.availableWithdrawAmount,
        balance: accountInfo.currentBalance,
        accountNumber: accountInfo.accountNumber,
        minWithdraw: accountInfo.minWithdraw,
        user: accountInfo
      };
    }

    /**
     * Returns the base url for all the http requests based on location host
     * @returns {string} - base URL
     * @private
     */
    function _baseUrl() {
      var protocol;

      if ($rootScope.useAbsoluteRequests ||
        ConfigurationFac.absoluteRequests()) {
        protocol = ConfigurationFac
          .getBaseUrlForApplicationContext('protocol') ?
          ConfigurationFac.getBaseUrlForApplicationContext('protocol') : '//';

        return protocol +
          ConfigurationFac.getBaseUrlForApplicationContext('deposit') +
          '/deposit/api/v1.0/';
      }

      return '/deposit/api/v1.0/';
    }

    /**
     * Make GET requests
     * @param url - URL to request
     * @param parser - optional function to execute if success response
     * @returns {Deferred.promise|*}
     * @private
     */
    function _makeGETRequest(url, parser) {
      var deferred = $q.defer();
      var headers = _addHeaders({
        cache: true
      });

      $http.get(url, { headers: headers }).success(function (data) {
        if (data.status === 'success') {
          if (parser && angular.isFunction(parser)) {
            deferred.resolve(parser(data.response));
          } else {
            deferred.resolve(data.response);
          }
        } else {
          deferred.reject(data.response);
        }
      }).error(function (data) {
        var rsp;
        if (data) {
          rsp = data.response;
        }
        deferred.reject(rsp);
      });

      return deferred.promise;
    }

    function _addHeaders(options) {
      var headers = {
        'x-tvgcontext': angular.toJson(ConfigurationFac.getApplicationContext()),
        'x-tvg-context': RequestContextHeaders[
          $window.productContext + '_' + $window.locationContext
        ]
      };

      if (options && options.cache) {
        angular.extend(headers, {
          'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        });
      }

      return headers;
    }

    /**
     * Get cards on file for withdraw
     * @param accountId
     * @private
     */
    function _getCardsOnFile(accountId) {
      var deferred = $q.defer();
      var headers = _addHeaders({ cache: true });
      var url = ccpEndpoint('users') + '/' + accountId + '/bankCards?filterAvailable=true&filterWithdrawalAllowed=true';

      $http.get(url,
        { headers: headers })
        .success(function (data) {
          deferred.resolve(data);
        }).error(function (data) {
          deferred.reject(data);
        });

      return deferred.promise;
    }

    /**
     * Public interface
     */
    return {
      getData: _getData,
      getAccountNumber: _getAccountNumber,
      getAccountId: _getAccountId,
      getAccountBalance: _getAccountBalance,
      getWithdrawalProfile: _getWithdrawalProfile,
      getPlainAccountId: _getPlainAccountId,
      withdrawBetCash: _withdrawBetCash,
      withdrawCheck: _withdrawCheck,
      withdrawBetcashNewDepositFlow: _withdrawBetcashNewDepositFlow,
      withdrawNewDepositFlow: _withdrawNewDepositFlow,
      withdrawPaypal: paypalService.withdraw,
      withdrawDebitCard: _withdrawDebitCard,
      withdrawPendingList: _withdrawPendingList,
      withdrawCancel: _withdrawCancel,
      getForms: _getForms,
      getWithdrawOptions: _getWithdrawOptions,
      getCardsOnFile: _getCardsOnFile
    };
  }

  angular.module('TVG.Withdraw').factory('WithdrawFac', WithdrawFac);
}());

define("Deposit", ["angular"], function(){});

